// this file is automatically generated :) as jake for details
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const SWIconNodeSVGCategories = [
    "accessibility",
    "account",
    "animals",
    "arrows",
    "brands",
    "buildings",
    "charts",
    "communication",
    "connectivity",
    "currency",
    "cursors",
    "design",
    "development",
    "devices",
    "emoji",
    "files",
    "food-beverage",
    "furniture",
    "gaming",
    "home",
    "layout",
    "mail",
    "maps",
    "maths",
    "medical",
    "money",
    "multimedia",
    "nature",
    "navigation",
    "notifications",
    "people",
    "photography",
    "science",
    "seasons",
    "security",
    "shapes",
    "shopping",
    "social",
    "sports",
    "sustainability",
    "text",
    "time",
    "tools",
    "transportation",
    "travel",
    "weather"
];
const SVG = ({ style, width = 24, height = 24, strokeColor = "currentColor", strokeWidth = 2.0, strokeLinecap = "round", strokeLinejoin = "round", id, dataId, children })=>{
    return /*#__PURE__*/ _jsx("svg", {
        id: id,
        "data-sw-id": dataId,
        width: width,
        height: height,
        stroke: strokeColor,
        style: style,
        strokeWidth: strokeWidth,
        strokeLinecap: strokeLinecap,
        strokeLinejoin: strokeLinejoin,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "none",
        children: children
    });
};
const AArrowDown = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3.5 13h6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m2 16 4.5-9 4.5 9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 7v9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m14 12 4 4 4-4"
            })
        ]
    }));
};
const AArrowUp = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3.5 13h6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m2 16 4.5-9 4.5 9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 16V7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m14 11 4-4 4 4"
            })
        ]
    }));
};
const ALargeSmall = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M21 14h-5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 16v-3.5a2.5 2.5 0 0 1 5 0V16"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4.5 13h6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m3 16 4.5-9 4.5 9"
            })
        ]
    }));
};
const Accessibility = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "16",
                cy: "4",
                r: "1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m18 19 1-7-6 1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m5 8 3-3 5.5 3-2.36 3.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4.24 14.5a5 5 0 0 0 6.88 6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13.76 17.5a5 5 0 0 0-6.88-6"
            })
        ]
    }));
};
const ActivitySquare = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 12h-2l-2 5-2-10-2 5H7"
            })
        ]
    }));
};
const Activity = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M22 12h-4l-3 9L9 3l-3 9H2"
        })
    }));
};
const AirVent = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M6 12H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 8h12"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18.3 17.7a2.5 2.5 0 0 1-3.16 3.83 2.53 2.53 0 0 1-1.14-2V12"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.6 15.6A2 2 0 1 0 10 17v-5"
            })
        ]
    }));
};
const Airplay = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1"
            }),
            /*#__PURE__*/ _jsx("polygon", {
                points: "12 15 17 21 7 21 12 15"
            })
        ]
    }));
};
const AlarmClockCheck = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "13",
                r: "8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 3 2 6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m22 6-3-3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.38 18.7 4 21"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17.64 18.67 20 21"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9 13 2 2 4-4"
            })
        ]
    }));
};
const AlarmClockMinus = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "13",
                r: "8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 3 2 6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m22 6-3-3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.38 18.7 4 21"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17.64 18.67 20 21"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 13h6"
            })
        ]
    }));
};
const AlarmClockOff = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M6.87 6.87a8 8 0 1 0 11.26 11.26"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19.9 14.25a8 8 0 0 0-9.15-9.15"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m22 6-3-3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.26 18.67 4 21"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m2 2 20 20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 4 2 6"
            })
        ]
    }));
};
const AlarmClockPlus = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "13",
                r: "8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 3 2 6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m22 6-3-3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.38 18.7 4 21"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17.64 18.67 20 21"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 10v6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 13h6"
            })
        ]
    }));
};
const AlarmClock = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "13",
                r: "8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 9v4l2 2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 3 2 6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m22 6-3-3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.38 18.7 4 21"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17.64 18.67 20 21"
            })
        ]
    }));
};
const AlarmSmoke = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 8a2 2 0 0 1-2-2V3h20v3a2 2 0 0 1-2 2Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m19 8-.8 3c-.1.6-.6 1-1.2 1H7c-.6 0-1.1-.4-1.2-1L5 8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 21c0-2.5 2-2.5 2-5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11 21c0-2.5 2-2.5 2-5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 21c0-2.5 2-2.5 2-5"
            })
        ]
    }));
};
const Album = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2",
                ry: "2"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "11 3 11 11 14 8 17 11 17 3"
            })
        ]
    }));
};
const AlertCircle = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "12",
                y1: "8",
                y2: "12"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "12.01",
                y1: "16",
                y2: "16"
            })
        ]
    }));
};
const AlertOctagon = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("polygon", {
                points: "7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "12",
                y1: "8",
                y2: "12"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "12.01",
                y1: "16",
                y2: "16"
            })
        ]
    }));
};
const AlertTriangle = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 9v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 17h.01"
            })
        ]
    }));
};
const AlignCenterHorizontal = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2 12h20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 16v4a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 8V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 16v1a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 8V7c0-1.1.9-2 2-2h2a2 2 0 0 1 2 2v1"
            })
        ]
    }));
};
const AlignCenterVertical = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2v20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 10H4a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 10h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 20H7a2 2 0 0 1-2-2v-2c0-1.1.9-2 2-2h1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 14h1a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-1"
            })
        ]
    }));
};
const AlignCenter = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("line", {
                x1: "21",
                x2: "3",
                y1: "6",
                y2: "6"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "17",
                x2: "7",
                y1: "12",
                y2: "12"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "19",
                x2: "5",
                y1: "18",
                y2: "18"
            })
        ]
    }));
};
const AlignEndHorizontal = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "6",
                height: "16",
                x: "4",
                y: "2",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "6",
                height: "9",
                x: "14",
                y: "9",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 22H2"
            })
        ]
    }));
};
const AlignEndVertical = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "16",
                height: "6",
                x: "2",
                y: "4",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "9",
                height: "6",
                x: "9",
                y: "14",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 22V2"
            })
        ]
    }));
};
const AlignHorizontalDistributeCenter = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "6",
                height: "14",
                x: "4",
                y: "5",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "6",
                height: "10",
                x: "14",
                y: "7",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 22v-5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 7V2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 22v-3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 5V2"
            })
        ]
    }));
};
const AlignHorizontalDistributeEnd = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "6",
                height: "14",
                x: "4",
                y: "5",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "6",
                height: "10",
                x: "14",
                y: "7",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 2v20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 2v20"
            })
        ]
    }));
};
const AlignHorizontalDistributeStart = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "6",
                height: "14",
                x: "4",
                y: "5",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "6",
                height: "10",
                x: "14",
                y: "7",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 2v20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 2v20"
            })
        ]
    }));
};
const AlignHorizontalJustifyCenter = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "6",
                height: "14",
                x: "2",
                y: "5",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "6",
                height: "10",
                x: "16",
                y: "7",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2v20"
            })
        ]
    }));
};
const AlignHorizontalJustifyEnd = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "6",
                height: "14",
                x: "2",
                y: "5",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "6",
                height: "10",
                x: "12",
                y: "7",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 2v20"
            })
        ]
    }));
};
const AlignHorizontalJustifyStart = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "6",
                height: "14",
                x: "6",
                y: "5",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "6",
                height: "10",
                x: "16",
                y: "7",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 2v20"
            })
        ]
    }));
};
const AlignHorizontalSpaceAround = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "6",
                height: "10",
                x: "9",
                y: "7",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 22V2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 22V2"
            })
        ]
    }));
};
const AlignHorizontalSpaceBetween = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "6",
                height: "14",
                x: "3",
                y: "5",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "6",
                height: "10",
                x: "15",
                y: "7",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 2v20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 2v20"
            })
        ]
    }));
};
const AlignJustify = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("line", {
                x1: "3",
                x2: "21",
                y1: "6",
                y2: "6"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "3",
                x2: "21",
                y1: "12",
                y2: "12"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "3",
                x2: "21",
                y1: "18",
                y2: "18"
            })
        ]
    }));
};
const AlignLeft = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("line", {
                x1: "21",
                x2: "3",
                y1: "6",
                y2: "6"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "15",
                x2: "3",
                y1: "12",
                y2: "12"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "17",
                x2: "3",
                y1: "18",
                y2: "18"
            })
        ]
    }));
};
const AlignRight = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("line", {
                x1: "21",
                x2: "3",
                y1: "6",
                y2: "6"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "21",
                x2: "9",
                y1: "12",
                y2: "12"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "21",
                x2: "7",
                y1: "18",
                y2: "18"
            })
        ]
    }));
};
const AlignStartHorizontal = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "6",
                height: "16",
                x: "4",
                y: "6",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "6",
                height: "9",
                x: "14",
                y: "6",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 2H2"
            })
        ]
    }));
};
const AlignStartVertical = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "9",
                height: "6",
                x: "6",
                y: "14",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "16",
                height: "6",
                x: "6",
                y: "4",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 2v20"
            })
        ]
    }));
};
const AlignVerticalDistributeCenter = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "14",
                height: "6",
                x: "5",
                y: "14",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "10",
                height: "6",
                x: "7",
                y: "4",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 7h-5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 7H1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 17h-3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 17H2"
            })
        ]
    }));
};
const AlignVerticalDistributeEnd = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "14",
                height: "6",
                x: "5",
                y: "14",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "10",
                height: "6",
                x: "7",
                y: "4",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 20h20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 10h20"
            })
        ]
    }));
};
const AlignVerticalDistributeStart = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "14",
                height: "6",
                x: "5",
                y: "14",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "10",
                height: "6",
                x: "7",
                y: "4",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 14h20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 4h20"
            })
        ]
    }));
};
const AlignVerticalJustifyCenter = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "14",
                height: "6",
                x: "5",
                y: "16",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "10",
                height: "6",
                x: "7",
                y: "2",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 12h20"
            })
        ]
    }));
};
const AlignVerticalJustifyEnd = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "14",
                height: "6",
                x: "5",
                y: "12",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "10",
                height: "6",
                x: "7",
                y: "2",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 22h20"
            })
        ]
    }));
};
const AlignVerticalJustifyStart = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "14",
                height: "6",
                x: "5",
                y: "16",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "10",
                height: "6",
                x: "7",
                y: "6",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 2h20"
            })
        ]
    }));
};
const AlignVerticalSpaceAround = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "10",
                height: "6",
                x: "7",
                y: "9",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 20H2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 4H2"
            })
        ]
    }));
};
const AlignVerticalSpaceBetween = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "14",
                height: "6",
                x: "5",
                y: "15",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "10",
                height: "6",
                x: "7",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 21h20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 3h20"
            })
        ]
    }));
};
const Ambulance = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M10 10H6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19 18h2a1 1 0 0 0 1-1v-3.28a1 1 0 0 0-.684-.948l-1.923-.641a1 1 0 0 1-.578-.502l-1.539-3.076A1 1 0 0 0 16.382 8H14"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 8v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 18h6"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "17",
                cy: "18",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "7",
                cy: "18",
                r: "2"
            })
        ]
    }));
};
const Ampersand = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M17.5 12c0 4.4-3.6 8-8 8A4.5 4.5 0 0 1 5 15.5c0-6 8-4 8-8.5a3 3 0 1 0-6 0c0 3 2.5 8.5 12 13"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 12h3"
            })
        ]
    }));
};
const Ampersands = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M10 17c-5-3-7-7-7-9a2 2 0 0 1 4 0c0 2.5-5 2.5-5 6 0 1.7 1.3 3 3 3 2.8 0 5-2.2 5-5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 17c-5-3-7-7-7-9a2 2 0 0 1 4 0c0 2.5-5 2.5-5 6 0 1.7 1.3 3 3 3 2.8 0 5-2.2 5-5"
            })
        ]
    }));
};
const Anchor = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 22V8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 12H2a10 10 0 0 0 20 0h-3"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "5",
                r: "3"
            })
        ]
    }));
};
const Angry = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 16s-1.5-2-4-2-4 2-4 2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7.5 8 10 9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m14 9 2.5-1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 10h0"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 10h0"
            })
        ]
    }));
};
const Annoyed = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 15h8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 9h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 9h2"
            })
        ]
    }));
};
const Antenna = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2 12 7 2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m7 12 5-10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m12 12 5-10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m17 12 5-10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4.5 7h15"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 16v6"
            })
        ]
    }));
};
const Anvil = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M7 10H6a4 4 0 0 1-4-4 1 1 0 0 1 1-1h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 5a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1 7 7 0 0 1-7 7H8a1 1 0 0 1-1-1z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 12v5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 12v5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 20a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3 1 1 0 0 1-1 1H6a1 1 0 0 1-1-1"
            })
        ]
    }));
};
const Aperture = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m14.31 8 5.74 9.94"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.69 8h11.48"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m7.38 12 5.74-9.94"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.69 16 3.95 6.06"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14.31 16H2.83"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m16.62 12-5.74 9.94"
            })
        ]
    }));
};
const AppWindow = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                x: "2",
                y: "4",
                width: "20",
                height: "16",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 4v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 8h20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 4v4"
            })
        ]
    }));
};
const Apple = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 20.94c1.5 0 2.75 1.06 4 1.06 3 0 6-8 6-12.22A4.91 4.91 0 0 0 17 5c-2.22 0-4 1.44-5 2-1-.56-2.78-2-5-2a4.9 4.9 0 0 0-5 4.78C2 14 5 22 8 22c1.25 0 2.5-1.06 4-1.06Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 2c1 .5 2 2 2 5"
            })
        ]
    }));
};
const ArchiveRestore = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "20",
                height: "5",
                x: "2",
                y: "3",
                rx: "1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 8v11a2 2 0 0 0 2 2h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 8v11a2 2 0 0 1-2 2h-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9 15 3-3 3 3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 12v9"
            })
        ]
    }));
};
const ArchiveX = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "20",
                height: "5",
                x: "2",
                y: "3",
                rx: "1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9.5 17 5-5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9.5 12 5 5"
            })
        ]
    }));
};
const Archive = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "20",
                height: "5",
                x: "2",
                y: "3",
                rx: "1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 12h4"
            })
        ]
    }));
};
const AreaChart = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3 3v18h18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 12v5h12V8l-5 5-4-4Z"
            })
        ]
    }));
};
const Armchair = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M19 9V6a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 16a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-5a2 2 0 0 0-4 0v2H7v-2a2 2 0 0 0-4 0Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 18v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19 18v2"
            })
        ]
    }));
};
const ArrowBigDownDash = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M15 5H9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 9v3h4l-7 7-7-7h4V9z"
            })
        ]
    }));
};
const ArrowBigDown = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M15 6v6h4l-7 7-7-7h4V6h6z"
        })
    }));
};
const ArrowBigLeftDash = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M19 15V9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 15h-3v4l-7-7 7-7v4h3v6z"
            })
        ]
    }));
};
const ArrowBigLeft = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M18 15h-6v4l-7-7 7-7v4h6v6z"
        })
    }));
};
const ArrowBigRightDash = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M5 9v6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 9h3V5l7 7-7 7v-4H9V9z"
            })
        ]
    }));
};
const ArrowBigRight = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M6 9h6V5l7 7-7 7v-4H6V9z"
        })
    }));
};
const ArrowBigUpDash = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M9 19h6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 15v-3H5l7-7 7 7h-4v3H9z"
            })
        ]
    }));
};
const ArrowBigUp = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M9 18v-6H5l7-7 7 7h-4v6H9z"
        })
    }));
};
const ArrowDown01 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m3 16 4 4 4-4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 20V4"
            }),
            /*#__PURE__*/ _jsx("rect", {
                x: "15",
                y: "4",
                width: "4",
                height: "6",
                ry: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 20v-6h-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 20h4"
            })
        ]
    }));
};
const ArrowDown10 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m3 16 4 4 4-4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 20V4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 10V4h-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 10h4"
            }),
            /*#__PURE__*/ _jsx("rect", {
                x: "15",
                y: "14",
                width: "4",
                height: "6",
                ry: "2"
            })
        ]
    }));
};
const ArrowDownAZ = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m3 16 4 4 4-4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 20V4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 8h-5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 10V6.5a2.5 2.5 0 0 1 5 0V10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 14h5l-5 6h5"
            })
        ]
    }));
};
const ArrowDownCircle = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 8v8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m8 12 4 4 4-4"
            })
        ]
    }));
};
const ArrowDownFromLine = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M19 3H5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 21V7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m6 15 6 6 6-6"
            })
        ]
    }));
};
const ArrowDownLeftFromCircle = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2 12a10 10 0 1 1 10 10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m2 22 10-10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 22H2v-6"
            })
        ]
    }));
};
const ArrowDownLeftFromSquare = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M13 21h6a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m3 21 9-9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 21H3v-6"
            })
        ]
    }));
};
const ArrowDownLeftSquare = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m16 8-8 8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 16H8V8"
            })
        ]
    }));
};
const ArrowDownLeft = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M17 7 7 17"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 17H7V7"
            })
        ]
    }));
};
const ArrowDownNarrowWide = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m3 16 4 4 4-4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 20V4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11 4h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11 8h7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11 12h10"
            })
        ]
    }));
};
const ArrowDownRightFromCircle = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 22a10 10 0 1 1 10-10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 22 12 12"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 16v6h-6"
            })
        ]
    }));
};
const ArrowDownRightFromSquare = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M21 11V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m21 21-9-9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 15v6h-6"
            })
        ]
    }));
};
const ArrowDownRightSquare = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m8 8 8 8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 8v8H8"
            })
        ]
    }));
};
const ArrowDownRight = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m7 7 10 10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 7v10H7"
            })
        ]
    }));
};
const ArrowDownSquare = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 8v8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m8 12 4 4 4-4"
            })
        ]
    }));
};
const ArrowDownToDot = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2v14"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m19 9-7 7-7-7"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "21",
                r: "1"
            })
        ]
    }));
};
const ArrowDownToLine = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 17V3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m6 11 6 6 6-6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19 21H5"
            })
        ]
    }));
};
const ArrowDownUp = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m3 16 4 4 4-4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 20V4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m21 8-4-4-4 4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 4v16"
            })
        ]
    }));
};
const ArrowDownWideNarrow = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m3 16 4 4 4-4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 20V4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11 4h10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11 8h7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11 12h4"
            })
        ]
    }));
};
const ArrowDownZA = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m3 16 4 4 4-4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 4v16"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 4h5l-5 6h5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 20v-3.5a2.5 2.5 0 0 1 5 0V20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 18h-5"
            })
        ]
    }));
};
const ArrowDown = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 5v14"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m19 12-7 7-7-7"
            })
        ]
    }));
};
const ArrowLeftCircle = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 12H8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m12 8-4 4 4 4"
            })
        ]
    }));
};
const ArrowLeftFromLine = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m9 6-6 6 6 6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 12h14"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 19V5"
            })
        ]
    }));
};
const ArrowLeftRight = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M8 3 4 7l4 4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 7h16"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m16 21 4-4-4-4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 17H4"
            })
        ]
    }));
};
const ArrowLeftSquare = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m12 8-4 4 4 4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 12H8"
            })
        ]
    }));
};
const ArrowLeftToLine = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3 19V5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m13 6-6 6 6 6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 12h14"
            })
        ]
    }));
};
const ArrowLeft = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m12 19-7-7 7-7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19 12H5"
            })
        ]
    }));
};
const ArrowRightCircle = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 12h8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m12 16 4-4-4-4"
            })
        ]
    }));
};
const ArrowRightFromLine = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3 5v14"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 12H7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m15 18 6-6-6-6"
            })
        ]
    }));
};
const ArrowRightLeft = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m16 3 4 4-4 4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 7H4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m8 21-4-4 4-4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 17h16"
            })
        ]
    }));
};
const ArrowRightSquare = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 12h8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m12 16 4-4-4-4"
            })
        ]
    }));
};
const ArrowRightToLine = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M17 12H3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m11 18 6-6-6-6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 5v14"
            })
        ]
    }));
};
const ArrowRight = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M5 12h14"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m12 5 7 7-7 7"
            })
        ]
    }));
};
const ArrowUp01 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m3 8 4-4 4 4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 4v16"
            }),
            /*#__PURE__*/ _jsx("rect", {
                x: "15",
                y: "4",
                width: "4",
                height: "6",
                ry: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 20v-6h-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 20h4"
            })
        ]
    }));
};
const ArrowUp10 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m3 8 4-4 4 4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 4v16"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 10V4h-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 10h4"
            }),
            /*#__PURE__*/ _jsx("rect", {
                x: "15",
                y: "14",
                width: "4",
                height: "6",
                ry: "2"
            })
        ]
    }));
};
const ArrowUpAZ = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m3 8 4-4 4 4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 4v16"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 8h-5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 10V6.5a2.5 2.5 0 0 1 5 0V10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 14h5l-5 6h5"
            })
        ]
    }));
};
const ArrowUpCircle = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m16 12-4-4-4 4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 16V8"
            })
        ]
    }));
};
const ArrowUpDown = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m21 16-4 4-4-4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 20V4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m3 8 4-4 4 4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 4v16"
            })
        ]
    }));
};
const ArrowUpFromDot = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m5 9 7-7 7 7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 16V2"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "21",
                r: "1"
            })
        ]
    }));
};
const ArrowUpFromLine = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m18 9-6-6-6 6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 3v14"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 21h14"
            })
        ]
    }));
};
const ArrowUpLeftFromCircle = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2 8V2h6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m2 2 10 10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2A10 10 0 1 1 2 12"
            })
        ]
    }));
};
const ArrowUpLeftFromSquare = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M13 3h6a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m3 3 9 9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 9V3h6"
            })
        ]
    }));
};
const ArrowUpLeftSquare = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 16V8h8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 16 8 8"
            })
        ]
    }));
};
const ArrowUpLeft = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M7 17V7h10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 17 7 7"
            })
        ]
    }));
};
const ArrowUpNarrowWide = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m3 8 4-4 4 4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 4v16"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11 12h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11 16h7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11 20h10"
            })
        ]
    }));
};
const ArrowUpRightFromCircle = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M22 12A10 10 0 1 1 12 2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 2 12 12"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 2h6v6"
            })
        ]
    }));
};
const ArrowUpRightFromSquare = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M21 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m21 3-9 9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 3h6v6"
            })
        ]
    }));
};
const ArrowUpRightSquare = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 8h8v8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m8 16 8-8"
            })
        ]
    }));
};
const ArrowUpRight = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M7 7h10v10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 17 17 7"
            })
        ]
    }));
};
const ArrowUpSquare = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m16 12-4-4-4 4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 16V8"
            })
        ]
    }));
};
const ArrowUpToLine = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M5 3h14"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m18 13-6-6-6 6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 7v14"
            })
        ]
    }));
};
const ArrowUpWideNarrow = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m3 8 4-4 4 4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 4v16"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11 12h10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11 16h7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11 20h4"
            })
        ]
    }));
};
const ArrowUpZA = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m3 8 4-4 4 4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 4v16"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 4h5l-5 6h5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 20v-3.5a2.5 2.5 0 0 1 5 0V20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 18h-5"
            })
        ]
    }));
};
const ArrowUp = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m5 12 7-7 7 7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 19V5"
            })
        ]
    }));
};
const ArrowsUpFromLine = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m4 6 3-3 3 3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 17V3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m14 6 3-3 3 3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 17V3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 21h16"
            })
        ]
    }));
};
const AsteriskSquare = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 8v8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m8.5 14 7-4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m8.5 10 7 4"
            })
        ]
    }));
};
const Asterisk = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 6v12"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17.196 9 6.804 15"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m6.804 9 10.392 6"
            })
        ]
    }));
};
const AtSign = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-4 8"
            })
        ]
    }));
};
const Atom = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20.2 20.2c2.04-2.03.02-7.36-4.5-11.9-4.54-4.52-9.87-6.54-11.9-4.5-2.04 2.03-.02 7.36 4.5 11.9 4.54 4.52 9.87 6.54 11.9 4.5Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15.7 15.7c4.52-4.54 6.54-9.87 4.5-11.9-2.03-2.04-7.36-.02-11.9 4.5-4.52 4.54-6.54 9.87-4.5 11.9 2.03 2.04 7.36.02 11.9-4.5Z"
            })
        ]
    }));
};
const AudioLines = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2 10v3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 6v11"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 3v18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 8v7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 5v13"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 10v3"
            })
        ]
    }));
};
const AudioWaveform = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M2 13a2 2 0 0 0 2-2V7a2 2 0 0 1 4 0v13a2 2 0 0 0 4 0V4a2 2 0 0 1 4 0v13a2 2 0 0 0 4 0v-4a2 2 0 0 1 2-2"
        })
    }));
};
const Award = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "8",
                r: "6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15.477 12.89 17 22l-5-3-5 3 1.523-9.11"
            })
        ]
    }));
};
const Axe = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m14 12-8.5 8.5a2.12 2.12 0 1 1-3-3L11 9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 13 9 7l4-4 6 6h3a8 8 0 0 1-7 7z"
            })
        ]
    }));
};
const Axis3D = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 4v16h16"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m4 20 7-7"
            })
        ]
    }));
};
const Baby = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M9 12h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 12h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 16c.5.3 1.2.5 2 .5s1.5-.2 2-.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19 6.3a9 9 0 0 1 1.8 3.9 2 2 0 0 1 0 3.6 9 9 0 0 1-17.6 0 2 2 0 0 1 0-3.6A9 9 0 0 1 12 3c2 0 3.5 1.1 3.5 2.5s-.9 2.5-2 2.5c-.8 0-1.5-.4-1.5-1"
            })
        ]
    }));
};
const Backpack = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 10a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 21v-5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 10h8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 18h8"
            })
        ]
    }));
};
const BadgeAlert = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "12",
                y1: "8",
                y2: "12"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "12.01",
                y1: "16",
                y2: "16"
            })
        ]
    }));
};
const BadgeCent = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 7v10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15.4 10a4 4 0 1 0 0 4"
            })
        ]
    }));
};
const BadgeCheck = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9 12 2 2 4-4"
            })
        ]
    }));
};
const BadgeDollarSign = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 18V6"
            })
        ]
    }));
};
const BadgeEuro = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 12h5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 9.4a4 4 0 1 0 0 5.2"
            })
        ]
    }));
};
const BadgeHelp = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "12.01",
                y1: "17",
                y2: "17"
            })
        ]
    }));
};
const BadgeIndianRupee = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 8h8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 12h8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m13 17-5-1h1a4 4 0 0 0 0-8"
            })
        ]
    }));
};
const BadgeInfo = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "12",
                y1: "16",
                y2: "12"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "12.01",
                y1: "8",
                y2: "8"
            })
        ]
    }));
};
const BadgeJapaneseYen = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9 8 3 3v7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m12 11 3-3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 12h6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 16h6"
            })
        ]
    }));
};
const BadgeMinus = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "8",
                x2: "16",
                y1: "12",
                y2: "12"
            })
        ]
    }));
};
const BadgePercent = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m15 9-6 6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 9h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 15h.01"
            })
        ]
    }));
};
const BadgePlus = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "12",
                y1: "8",
                y2: "16"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "8",
                x2: "16",
                y1: "12",
                y2: "12"
            })
        ]
    }));
};
const BadgePoundSterling = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 12h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 16V9.5a2.5 2.5 0 0 1 5 0"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 16h7"
            })
        ]
    }));
};
const BadgeRussianRuble = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 16h5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 12h5a2 2 0 1 0 0-4h-3v9"
            })
        ]
    }));
};
const BadgeSwissFranc = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11 17V8h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11 12h3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 16h4"
            })
        ]
    }));
};
const BadgeX = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "15",
                x2: "9",
                y1: "9",
                y2: "15"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "9",
                x2: "15",
                y1: "9",
                y2: "15"
            })
        ]
    }));
};
const Badge = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"
        })
    }));
};
const BaggageClaim = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M22 18H6a2 2 0 0 1-2-2V7a2 2 0 0 0-2-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 14V4a2 2 0 0 0-2-2h-1a2 2 0 0 0-2 2v10"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "13",
                height: "8",
                x: "8",
                y: "6",
                rx: "1"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "18",
                cy: "20",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "9",
                cy: "20",
                r: "2"
            })
        ]
    }));
};
const Ban = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m4.9 4.9 14.2 14.2"
            })
        ]
    }));
};
const Banana = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 13c3.5-2 8-2 10 2a5.5 5.5 0 0 1 8 5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5.15 17.89c5.52-1.52 8.65-6.89 7-12C11.55 4 11.5 2 13 2c3.22 0 5 5.5 5 8 0 6.5-4.2 12-10.49 12C5.11 22 2 22 2 20c0-1.5 1.14-1.55 3.15-2.11Z"
            })
        ]
    }));
};
const Banknote = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "20",
                height: "12",
                x: "2",
                y: "6",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 12h.01M18 12h.01"
            })
        ]
    }));
};
const BarChart2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("line", {
                x1: "18",
                x2: "18",
                y1: "20",
                y2: "10"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "12",
                y1: "20",
                y2: "4"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "6",
                x2: "6",
                y1: "20",
                y2: "14"
            })
        ]
    }));
};
const BarChart3 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3 3v18h18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 17V9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13 17V5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 17v-3"
            })
        ]
    }));
};
const BarChart4 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3 3v18h18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13 17V9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 17V5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 17v-3"
            })
        ]
    }));
};
const BarChartBig = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3 3v18h18"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "4",
                height: "7",
                x: "7",
                y: "10",
                rx: "1"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "4",
                height: "12",
                x: "15",
                y: "5",
                rx: "1"
            })
        ]
    }));
};
const BarChartHorizontalBig = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3 3v18h18"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "12",
                height: "4",
                x: "7",
                y: "5",
                rx: "1"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "7",
                height: "4",
                x: "7",
                y: "13",
                rx: "1"
            })
        ]
    }));
};
const BarChartHorizontal = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3 3v18h18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 16h8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 11h12"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 6h3"
            })
        ]
    }));
};
const BarChart = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "12",
                y1: "20",
                y2: "10"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "18",
                x2: "18",
                y1: "20",
                y2: "4"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "6",
                x2: "6",
                y1: "20",
                y2: "16"
            })
        ]
    }));
};
const Barcode = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3 5v14"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 5v14"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 5v14"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 5v14"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 5v14"
            })
        ]
    }));
};
const Baseline = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 20h16"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m6 16 6-12 6 12"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 12h8"
            })
        ]
    }));
};
const Bath = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M9 6 6.5 3.5a1.5 1.5 0 0 0-1-.5C4.683 3 4 3.683 4 4.5V17a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-5"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "10",
                x2: "8",
                y1: "5",
                y2: "7"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "2",
                x2: "22",
                y1: "12",
                y2: "12"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "7",
                x2: "7",
                y1: "19",
                y2: "21"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "17",
                x2: "17",
                y1: "19",
                y2: "21"
            })
        ]
    }));
};
const BatteryCharging = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M15 7h1a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 7H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m11 7-3 5h4l-3 5"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "22",
                x2: "22",
                y1: "11",
                y2: "13"
            })
        ]
    }));
};
const BatteryFull = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "16",
                height: "10",
                x: "2",
                y: "7",
                rx: "2",
                ry: "2"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "22",
                x2: "22",
                y1: "11",
                y2: "13"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "6",
                x2: "6",
                y1: "11",
                y2: "13"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "10",
                x2: "10",
                y1: "11",
                y2: "13"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "14",
                x2: "14",
                y1: "11",
                y2: "13"
            })
        ]
    }));
};
const BatteryLow = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "16",
                height: "10",
                x: "2",
                y: "7",
                rx: "2",
                ry: "2"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "22",
                x2: "22",
                y1: "11",
                y2: "13"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "6",
                x2: "6",
                y1: "11",
                y2: "13"
            })
        ]
    }));
};
const BatteryMedium = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "16",
                height: "10",
                x: "2",
                y: "7",
                rx: "2",
                ry: "2"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "22",
                x2: "22",
                y1: "11",
                y2: "13"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "6",
                x2: "6",
                y1: "11",
                y2: "13"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "10",
                x2: "10",
                y1: "11",
                y2: "13"
            })
        ]
    }));
};
const BatteryWarning = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M14 7h2a2 2 0 0 1 2 2v6c0 1-1 2-2 2h-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 7H4a2 2 0 0 0-2 2v6c0 1 1 2 2 2h2"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "22",
                x2: "22",
                y1: "11",
                y2: "13"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "10",
                x2: "10",
                y1: "7",
                y2: "13"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "10",
                x2: "10",
                y1: "17",
                y2: "17.01"
            })
        ]
    }));
};
const Battery = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "16",
                height: "10",
                x: "2",
                y: "7",
                rx: "2",
                ry: "2"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "22",
                x2: "22",
                y1: "11",
                y2: "13"
            })
        ]
    }));
};
const Beaker = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4.5 3h15"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 3v16a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 14h12"
            })
        ]
    }));
};
const BeanOff = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M9 9c-.64.64-1.521.954-2.402 1.165A6 6 0 0 0 8 22a13.96 13.96 0 0 0 9.9-4.1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10.75 5.093A6 6 0 0 1 22 8c0 2.411-.61 4.68-1.683 6.66"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5.341 10.62a4 4 0 0 0 6.487 1.208M10.62 5.341a4.015 4.015 0 0 1 2.039 2.04"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "2",
                x2: "22",
                y1: "2",
                y2: "22"
            })
        ]
    }));
};
const Bean = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M10.165 6.598C9.954 7.478 9.64 8.36 9 9c-.64.64-1.521.954-2.402 1.165A6 6 0 0 0 8 22c7.732 0 14-6.268 14-14a6 6 0 0 0-11.835-1.402Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5.341 10.62a4 4 0 1 0 5.279-5.28"
            })
        ]
    }));
};
const BedDouble = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2 20v-8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 10V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 4v6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 18h20"
            })
        ]
    }));
};
const BedSingle = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3 20v-8a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 10V6a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 18h18"
            })
        ]
    }));
};
const Bed = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2 4v16"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 8h18a2 2 0 0 1 2 2v10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 17h20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 8v9"
            })
        ]
    }));
};
const Beef = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12.5",
                cy: "8.5",
                r: "2.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12.5 2a6.5 6.5 0 0 0-6.22 4.6c-1.1 3.13-.78 3.9-3.18 6.08A3 3 0 0 0 5 18c4 0 8.4-1.8 11.4-4.3A6.5 6.5 0 0 0 12.5 2Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m18.5 6 2.19 4.5a6.48 6.48 0 0 1 .31 2 6.49 6.49 0 0 1-2.6 5.2C15.4 20.2 11 22 7 22a3 3 0 0 1-2.68-1.66L2.4 16.5"
            })
        ]
    }));
};
const Beer = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M17 11h1a3 3 0 0 1 0 6h-1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 12v6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13 12v6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 7.5c-1 0-1.44.5-3 .5s-2-.5-3-.5-1.72.5-2.5.5a2.5 2.5 0 0 1 0-5c.78 0 1.57.5 2.5.5S9.44 2 11 2s2 1.5 3 1.5 1.72-.5 2.5-.5a2.5 2.5 0 0 1 0 5c-.78 0-1.5-.5-2.5-.5Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 8v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V8"
            })
        ]
    }));
};
const BellDot = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M19.4 14.9C20.2 16.4 21 17 21 17H3s3-2 3-9c0-3.3 2.7-6 6-6 .7 0 1.3.1 1.9.3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10.3 21a1.94 1.94 0 0 0 3.4 0"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "18",
                cy: "8",
                r: "3"
            })
        ]
    }));
};
const BellElectric = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M18.8 4A6.3 8.7 0 0 1 20 9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 9h.01"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "9",
                cy: "9",
                r: "7"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "10",
                height: "6",
                x: "4",
                y: "16",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 19c3 0 4.6-1.6 4.6-1.6"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "20",
                cy: "16",
                r: "2"
            })
        ]
    }));
};
const BellMinus = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M18.4 12c.8 3.8 2.6 5 2.6 5H3s3-2 3-9c0-3.3 2.7-6 6-6 1.8 0 3.4.8 4.5 2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10.3 21a1.94 1.94 0 0 0 3.4 0"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 8h6"
            })
        ]
    }));
};
const BellOff = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M8.7 3A6 6 0 0 1 18 8a21.3 21.3 0 0 0 .6 5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 17H3s3-2 3-9a4.67 4.67 0 0 1 .3-1.7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10.3 21a1.94 1.94 0 0 0 3.4 0"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m2 2 20 20"
            })
        ]
    }));
};
const BellPlus = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M19.3 14.8C20.1 16.4 21 17 21 17H3s3-2 3-9c0-3.3 2.7-6 6-6 1 0 1.9.2 2.8.7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10.3 21a1.94 1.94 0 0 0 3.4 0"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 8h6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 5v6"
            })
        ]
    }));
};
const BellRing = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10.3 21a1.94 1.94 0 0 0 3.4 0"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 2C2.8 3.7 2 5.7 2 8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 8c0-2.3-.8-4.3-2-6"
            })
        ]
    }));
};
const Bell = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10.3 21a1.94 1.94 0 0 0 3.4 0"
            })
        ]
    }));
};
const BetweenHorizontalEnd = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "13",
                height: "7",
                x: "3",
                y: "3",
                rx: "1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m22 15-3-3 3-3"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "13",
                height: "7",
                x: "3",
                y: "14",
                rx: "1"
            })
        ]
    }));
};
const BetweenHorizontalStart = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "13",
                height: "7",
                x: "8",
                y: "3",
                rx: "1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m2 9 3 3-3 3"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "13",
                height: "7",
                x: "8",
                y: "14",
                rx: "1"
            })
        ]
    }));
};
const BetweenVerticalEnd = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "7",
                height: "13",
                x: "3",
                y: "3",
                rx: "1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9 22 3-3 3 3"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "7",
                height: "13",
                x: "14",
                y: "3",
                rx: "1"
            })
        ]
    }));
};
const BetweenVerticalStart = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "7",
                height: "13",
                x: "3",
                y: "8",
                rx: "1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m15 2-3 3-3-3"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "7",
                height: "13",
                x: "14",
                y: "8",
                rx: "1"
            })
        ]
    }));
};
const Bike = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "18.5",
                cy: "17.5",
                r: "3.5"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "5.5",
                cy: "17.5",
                r: "3.5"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "15",
                cy: "5",
                r: "1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 17.5V14l-3-3 4-3 2 3h2"
            })
        ]
    }));
};
const Binary = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                x: "14",
                y: "14",
                width: "4",
                height: "6",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("rect", {
                x: "6",
                y: "4",
                width: "4",
                height: "6",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 20h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 10h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 14h2v6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 4h2v6"
            })
        ]
    }));
};
const Biohazard = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "11.9",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.7 3.4c-.9 2.5 0 5.2 2.2 6.7C6.5 9 3.7 9.6 2 11.6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m8.9 10.1 1.4.8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17.3 3.4c.9 2.5 0 5.2-2.2 6.7 2.4-1.2 5.2-.6 6.9 1.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m15.1 10.1-1.4.8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16.7 20.8c-2.6-.4-4.6-2.6-4.7-5.3-.2 2.6-2.1 4.8-4.7 5.2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 13.9v1.6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13.5 5.4c-1-.2-2-.2-3 0"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 16.4c.7-.7 1.2-1.6 1.5-2.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5.5 13.9c.3.9.8 1.8 1.5 2.5"
            })
        ]
    }));
};
const Bird = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M16 7h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3.4 18H12a8 8 0 0 0 8-8V7a4 4 0 0 0-7.28-2.3L2 20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m20 7 2 .5-2 .5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 18v3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 17.75V21"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 18a6 6 0 0 0 3.84-10.61"
            })
        ]
    }));
};
const Bitcoin = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M11.767 19.089c4.924.868 6.14-6.025 1.216-6.894m-1.216 6.894L5.86 18.047m5.908 1.042-.347 1.97m1.563-8.864c4.924.869 6.14-6.025 1.215-6.893m-1.215 6.893-3.94-.694m5.155-6.2L8.29 4.26m5.908 1.042.348-1.97M7.48 20.364l3.126-17.727"
        })
    }));
};
const Blend = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "9",
                cy: "9",
                r: "7"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "15",
                cy: "15",
                r: "7"
            })
        ]
    }));
};
const Blinds = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3 3h18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 7H8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 11H8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 19h10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 15h12"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 3v14"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "4",
                cy: "19",
                r: "2"
            })
        ]
    }));
};
const Blocks = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "7",
                height: "7",
                x: "14",
                y: "3",
                rx: "1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 21V8a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1H3"
            })
        ]
    }));
};
const BluetoothConnected = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m7 7 10 10-5 5V2l5 5L7 17"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "18",
                x2: "21",
                y1: "12",
                y2: "12"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "3",
                x2: "6",
                y1: "12",
                y2: "12"
            })
        ]
    }));
};
const BluetoothOff = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m17 17-5 5V12l-5 5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m2 2 20 20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14.5 9.5 17 7l-5-5v4.5"
            })
        ]
    }));
};
const BluetoothSearching = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m7 7 10 10-5 5V2l5 5L7 17"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20.83 14.83a4 4 0 0 0 0-5.66"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 12h.01"
            })
        ]
    }));
};
const Bluetooth = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "m7 7 10 10-5 5V2l5 5L7 17"
        })
    }));
};
const Bold = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M14 12a4 4 0 0 0 0-8H6v8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 20a4 4 0 0 0 0-8H6v8Z"
            })
        ]
    }));
};
const Bolt = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "4"
            })
        ]
    }));
};
const Bomb = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "11",
                cy: "13",
                r: "9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14.35 4.65 16.3 2.7a2.41 2.41 0 0 1 3.4 0l1.6 1.6a2.4 2.4 0 0 1 0 3.4l-1.95 1.95"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m22 2-1.5 1.5"
            })
        ]
    }));
};
const Bone = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M17 10c.7-.7 1.69 0 2.5 0a2.5 2.5 0 1 0 0-5 .5.5 0 0 1-.5-.5 2.5 2.5 0 1 0-5 0c0 .81.7 1.8 0 2.5l-7 7c-.7.7-1.69 0-2.5 0a2.5 2.5 0 0 0 0 5c.28 0 .5.22.5.5a2.5 2.5 0 1 0 5 0c0-.81-.7-1.8 0-2.5Z"
        })
    }));
};
const BookA = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m8 13 4-7 4 7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.1 11h5.7"
            })
        ]
    }));
};
const BookAudio = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 8v3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 6v7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 8v3"
            })
        ]
    }));
};
const BookCheck = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9 9.5 2 2 4-4"
            })
        ]
    }));
};
const BookCopy = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2 16V4a2 2 0 0 1 2-2h11"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 14H4a2 2 0 1 0 0 4h1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 18H11a2 2 0 1 0 0 4h11V6H11a2 2 0 0 0-2 2v12"
            })
        ]
    }));
};
const BookDashed = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M20 22h-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 15v2h-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 19.5V15"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 8v3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 2h2v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 11V9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 22h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 17h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 22H6.5a2.5 2.5 0 0 1 0-5H8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 5v-.5A2.5 2.5 0 0 1 6.5 2H8"
            })
        ]
    }));
};
const BookDown = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 13V7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9 10 3 3 3-3"
            })
        ]
    }));
};
const BookHeadphones = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "9",
                cy: "12",
                r: "1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 12v-2a4 4 0 0 1 8 0v2"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "15",
                cy: "12",
                r: "1"
            })
        ]
    }));
};
const BookHeart = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 8.2C16 7 15 6 13.8 6c-.8 0-1.4.3-1.8.9-.4-.6-1-.9-1.8-.9C9 6 8 7 8 8.2c0 .6.3 1.2.7 1.6h0C10 11.1 12 13 12 13s2-1.9 3.3-3.1h0c.4-.4.7-1 .7-1.7z"
            })
        ]
    }));
};
const BookImage = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "10",
                cy: "8",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m20 13.7-2.1-2.1c-.8-.8-2-.8-2.8 0L9.7 17"
            })
        ]
    }));
};
const BookKey = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H14"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 8v14H6.5a2.5 2.5 0 0 1 0-5H20"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "14",
                cy: "8",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m20 2-4.5 4.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m19 3 1 1"
            })
        ]
    }));
};
const BookLock = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 15v7H6.5a2.5 2.5 0 0 1 0-5H20"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "8",
                height: "5",
                x: "12",
                y: "6",
                rx: "1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 6V4a2 2 0 1 0-4 0v2"
            })
        ]
    }));
};
const BookMarked = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "10 2 10 10 13 7 16 10 16 2"
            })
        ]
    }));
};
const BookMinus = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 10h6"
            })
        ]
    }));
};
const BookOpenCheck = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M8 3H2v15h7c1.7 0 3 1.3 3 3V7c0-2.2-1.8-4-4-4Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m16 12 2 2 4-4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 6V3h-6c-2.2 0-4 1.8-4 4v14c0-1.7 1.3-3 3-3h7v-2.3"
            })
        ]
    }));
};
const BookOpenText = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 8h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 12h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 8h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 12h2"
            })
        ]
    }));
};
const BookOpen = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"
            })
        ]
    }));
};
const BookPlus = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 10h6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 7v6"
            })
        ]
    }));
};
const BookText = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 7h6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 11h8"
            })
        ]
    }));
};
const BookType = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 8V6H8v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 6v7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 13h4"
            })
        ]
    }));
};
const BookUp2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 2h2v20H6.5a2.5 2.5 0 0 1 0-5H20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 13V7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9 10 3-3 3 3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9 5 3-3 3 3"
            })
        ]
    }));
};
const BookUp = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 13V7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9 10 3-3 3 3"
            })
        ]
    }));
};
const BookUser = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "8",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 13a3 3 0 1 0-6 0"
            })
        ]
    }));
};
const BookX = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m14.5 7-5 5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9.5 7 5 5"
            })
        ]
    }));
};
const Book = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20"
        })
    }));
};
const BookmarkCheck = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9 10 2 2 4-4"
            })
        ]
    }));
};
const BookmarkMinus = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "15",
                x2: "9",
                y1: "10",
                y2: "10"
            })
        ]
    }));
};
const BookmarkPlus = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "12",
                y1: "7",
                y2: "13"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "15",
                x2: "9",
                y1: "10",
                y2: "10"
            })
        ]
    }));
};
const BookmarkX = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m14.5 7.5-5 5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9.5 7.5 5 5"
            })
        ]
    }));
};
const Bookmark = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z"
        })
    }));
};
const BoomBox = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 9V5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 8v1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 8v1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 8v1"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "20",
                height: "12",
                x: "2",
                y: "9",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "8",
                cy: "15",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "16",
                cy: "15",
                r: "2"
            })
        ]
    }));
};
const Bot = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 8V4H8"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "16",
                height: "12",
                x: "4",
                y: "8",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 14h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 14h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 13v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 13v2"
            })
        ]
    }));
};
const BoxSelect = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M5 3a2 2 0 0 0-2 2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19 3a2 2 0 0 1 2 2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 19a2 2 0 0 1-2 2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 21a2 2 0 0 1-2-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 3h1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 21h1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 3h1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 21h1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 9v1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 9v1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 14v1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 14v1"
            })
        ]
    }));
};
const Box = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m3.3 7 8.7 5 8.7-5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 22V12"
            })
        ]
    }));
};
const Boxes = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2.97 12.92A2 2 0 0 0 2 14.63v3.24a2 2 0 0 0 .97 1.71l3 1.8a2 2 0 0 0 2.06 0L12 19v-5.5l-5-3-4.03 2.42Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m7 16.5-4.74-2.85"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m7 16.5 5-3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 16.5v5.17"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 13.5V19l3.97 2.38a2 2 0 0 0 2.06 0l3-1.8a2 2 0 0 0 .97-1.71v-3.24a2 2 0 0 0-.97-1.71L17 10.5l-5 3Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m17 16.5-5-3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m17 16.5 4.74-2.85"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 16.5v5.17"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7.97 4.42A2 2 0 0 0 7 6.13v4.37l5 3 5-3V6.13a2 2 0 0 0-.97-1.71l-3-1.8a2 2 0 0 0-2.06 0l-3 1.8Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 8 7.26 5.15"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m12 8 4.74-2.85"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 13.5V8"
            })
        ]
    }));
};
const Braces = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M8 3H7a2 2 0 0 0-2 2v5a2 2 0 0 1-2 2 2 2 0 0 1 2 2v5c0 1.1.9 2 2 2h1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 21h1a2 2 0 0 0 2-2v-5c0-1.1.9-2 2-2a2 2 0 0 1-2-2V5a2 2 0 0 0-2-2h-1"
            })
        ]
    }));
};
const Brackets = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M16 3h3v18h-3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 21H5V3h3"
            })
        ]
    }));
};
const BrainCircuit = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 4.5a2.5 2.5 0 0 0-4.96-.46 2.5 2.5 0 0 0-1.98 3 2.5 2.5 0 0 0-1.32 4.24 3 3 0 0 0 .34 5.58 2.5 2.5 0 0 0 2.96 3.08 2.5 2.5 0 0 0 4.91.05L12 20V4.5Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 8V5c0-1.1.9-2 2-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 13h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 18h6a2 2 0 0 1 2 2v1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 8h8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20.5 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16.5 13a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20.5 21a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18.5 3a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
            })
        ]
    }));
};
const BrainCog = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 4.5a2.5 2.5 0 0 0-4.96-.46 2.5 2.5 0 0 0-1.98 3 2.5 2.5 0 0 0-1.32 4.24 3 3 0 0 0 .34 5.58 2.5 2.5 0 0 0 2.96 3.08A2.5 2.5 0 0 0 12 19.5a2.5 2.5 0 0 0 4.96.44 2.5 2.5 0 0 0 2.96-3.08 3 3 0 0 0 .34-5.58 2.5 2.5 0 0 0-1.32-4.24 2.5 2.5 0 0 0-1.98-3A2.5 2.5 0 0 0 12 4.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m15.7 10.4-.9.4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9.2 13.2-.9.4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m13.6 15.7-.4-.9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m10.8 9.2-.4-.9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m15.7 13.5-.9-.4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9.2 10.9-.9-.4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m10.5 15.7.4-.9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m13.1 9.2.4-.9"
            })
        ]
    }));
};
const Brain = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M9.5 2A2.5 2.5 0 0 1 12 4.5v15a2.5 2.5 0 0 1-4.96.44 2.5 2.5 0 0 1-2.96-3.08 3 3 0 0 1-.34-5.58 2.5 2.5 0 0 1 1.32-4.24 2.5 2.5 0 0 1 1.98-3A2.5 2.5 0 0 1 9.5 2Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14.5 2A2.5 2.5 0 0 0 12 4.5v15a2.5 2.5 0 0 0 4.96.44 2.5 2.5 0 0 0 2.96-3.08 3 3 0 0 0 .34-5.58 2.5 2.5 0 0 0-1.32-4.24 2.5 2.5 0 0 0-1.98-3A2.5 2.5 0 0 0 14.5 2Z"
            })
        ]
    }));
};
const BrickWall = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 9v6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 15v6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 3v6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 15h18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 9h18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 15v6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 3v6"
            })
        ]
    }));
};
const Briefcase = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "20",
                height: "14",
                x: "2",
                y: "7",
                rx: "2",
                ry: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"
            })
        ]
    }));
};
const BringToFront = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                x: "8",
                y: "8",
                width: "8",
                height: "8",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 10a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 20a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2"
            })
        ]
    }));
};
const Brush = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m9.06 11.9 8.07-8.06a2.85 2.85 0 1 1 4.03 4.03l-8.06 8.08"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7.07 14.94c-1.66 0-3 1.35-3 3.02 0 1.33-2.5 1.52-2 2.02 1.08 1.1 2.49 2.02 4 2.02 2.2 0 4-1.8 4-4.04a3.01 3.01 0 0 0-3-3.02z"
            })
        ]
    }));
};
const BugOff = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M15 7.13V6a3 3 0 0 0-5.14-2.1L8 2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14.12 3.88 16 2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 13h-4v-2a4 4 0 0 0-4-4h-1.3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20.97 5c0 2.1-1.6 3.8-3.5 4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m2 2 20 20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7.7 7.7A4 4 0 0 0 6 11v3a6 6 0 0 0 11.13 3.13"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 20v-8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 13H2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 21c0-2.1 1.7-3.9 3.8-4"
            })
        ]
    }));
};
const BugPlay = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m8 2 1.88 1.88"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14.12 3.88 16 2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 7.13v-1a3.003 3.003 0 1 1 6 0v1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 11a4 4 0 0 0-4-4h-4a4 4 0 0 0-4 4v3a6.1 6.1 0 0 0 2 4.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.53 9C4.6 8.8 3 7.1 3 5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 13H2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 21c0-2.1 1.7-3.9 3.8-4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20.97 5c0 2.1-1.6 3.8-3.5 4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m12 12 8 5-8 5Z"
            })
        ]
    }));
};
const Bug = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m8 2 1.88 1.88"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14.12 3.88 16 2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 7.13v-1a3.003 3.003 0 1 1 6 0v1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 20c-3.3 0-6-2.7-6-6v-3a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v3c0 3.3-2.7 6-6 6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 20v-9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.53 9C4.6 8.8 3 7.1 3 5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 13H2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 21c0-2.1 1.7-3.9 3.8-4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20.97 5c0 2.1-1.6 3.8-3.5 4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 13h-4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17.2 17c2.1.1 3.8 1.9 3.8 4"
            })
        ]
    }));
};
const Building2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 6h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 10h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 14h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 18h4"
            })
        ]
    }));
};
const Building = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "16",
                height: "20",
                x: "4",
                y: "2",
                rx: "2",
                ry: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 22v-4h6v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 6h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 6h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 6h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 10h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 14h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 10h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 14h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 10h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 14h.01"
            })
        ]
    }));
};
const BusFront = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 6 2 7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 6h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m22 7-2-1"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "16",
                height: "16",
                x: "4",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 11h16"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 15h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 15h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 19v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 21v-2"
            })
        ]
    }));
};
const Bus = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M8 6v6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 6v6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 12h19.6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 18h3s.5-1.7.8-2.8c.1-.4.2-.8.2-1.2 0-.4-.1-.8-.2-1.2l-1.4-5C20.1 6.8 19.1 6 18 6H4a2 2 0 0 0-2 2v10h3"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "7",
                cy: "18",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 18h5"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "16",
                cy: "18",
                r: "2"
            })
        ]
    }));
};
const CableCar = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M10 3h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 2h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m2 9 20-5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 12V6.5"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "16",
                height: "10",
                x: "4",
                y: "12",
                rx: "3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 12v5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 12v5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 17h16"
            })
        ]
    }));
};
const Cable = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 9a2 2 0 0 1-2-2V5h6v2a2 2 0 0 1-2 2Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 5V3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 5V3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19 15V6.5a3.5 3.5 0 0 0-7 0v11a3.5 3.5 0 0 1-7 0V9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 21v-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 21v-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 19h-6v-2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2Z"
            })
        ]
    }));
};
const CakeSlice = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "9",
                cy: "7",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7.2 7.9 3 11v9c0 .6.4 1 1 1h16c.6 0 1-.4 1-1v-9c0-2-3-6-7-8l-3.6 2.6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 13H3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 17H3"
            })
        ]
    }));
};
const Cake = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M20 21v-8a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 16s.5-1 2-1 2.5 2 4 2 2.5-2 4-2 2.5 2 4 2 2-1 2-1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 21h20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 8v3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 8v3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 8v3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 4h0.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 4h0.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 4h0.01"
            })
        ]
    }));
};
const Calculator = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "16",
                height: "20",
                x: "4",
                y: "2",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "8",
                x2: "16",
                y1: "6",
                y2: "6"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "16",
                x2: "16",
                y1: "14",
                y2: "18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 10h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 10h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 10h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 14h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 14h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 18h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 18h.01"
            })
        ]
    }));
};
const CalendarCheck2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M8 2v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 2v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 14V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 10h18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m16 20 2 2 4-4"
            })
        ]
    }));
};
const CalendarCheck = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M8 2v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 2v4"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "4",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 10h18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9 16 2 2 4-4"
            })
        ]
    }));
};
const CalendarClock = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M21 7.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h3.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 2v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 2v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 10h5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17.5 17.5 16 16.3V14"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "16",
                cy: "16",
                r: "6"
            })
        ]
    }));
};
const CalendarDays = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M8 2v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 2v4"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "4",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 10h18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 14h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 14h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 14h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 18h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 18h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 18h.01"
            })
        ]
    }));
};
const CalendarFold = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M8 2v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 2v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 17V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h11Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 10h18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 22v-4a2 2 0 0 1 2-2h4"
            })
        ]
    }));
};
const CalendarHeart = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3 10h18V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 2v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 2v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21.29 14.7a2.43 2.43 0 0 0-2.65-.52c-.3.12-.57.3-.8.53l-.34.34-.35-.34a2.43 2.43 0 0 0-2.65-.53c-.3.12-.56.3-.79.53-.95.94-1 2.53.2 3.74L17.5 22l3.6-3.55c1.2-1.21 1.14-2.8.19-3.74Z"
            })
        ]
    }));
};
const CalendarMinus2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M8 2v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 2v4"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "4",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 10h18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 16h4"
            })
        ]
    }));
};
const CalendarMinus = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M8 2v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 2v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 13V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 10h18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 19h6"
            })
        ]
    }));
};
const CalendarOff = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4.2 4.2A2 2 0 0 0 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 1.82-1.18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 15.5V6a2 2 0 0 0-2-2H9.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 2v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 10h7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 10h-5.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m2 2 20 20"
            })
        ]
    }));
};
const CalendarPlus2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M8 2v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 2v4"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "4",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 10h18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 16h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 14v4"
            })
        ]
    }));
};
const CalendarPlus = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M8 2v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 2v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 13V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 10h18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 19h6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19 16v6"
            })
        ]
    }));
};
const CalendarRange = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "4",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 2v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 10h18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 2v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 14h-6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13 18H7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 14h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 18h.01"
            })
        ]
    }));
};
const CalendarSearch = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M21 12V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 2v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 2v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 10h18"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "18",
                cy: "18",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m22 22-1.5-1.5"
            })
        ]
    }));
};
const CalendarX2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M8 2v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 2v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 13V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 10h18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m17 22 5-5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m17 17 5 5"
            })
        ]
    }));
};
const CalendarX = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M8 2v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 2v4"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "4",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 10h18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m14 14-4 4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m10 14 4 4"
            })
        ]
    }));
};
const Calendar = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M8 2v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 2v4"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "4",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 10h18"
            })
        ]
    }));
};
const CameraOff = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("line", {
                x1: "2",
                x2: "22",
                y1: "2",
                y2: "22"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.5 4h5L17 7h3a2 2 0 0 1 2 2v7.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14.121 15.121A3 3 0 1 1 9.88 10.88"
            })
        ]
    }));
};
const Camera = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "13",
                r: "3"
            })
        ]
    }));
};
const CandlestickChart = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M9 5v4"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "4",
                height: "6",
                x: "7",
                y: "9",
                rx: "1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 15v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 3v2"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "4",
                height: "8",
                x: "15",
                y: "5",
                rx: "1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 13v3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 3v18h18"
            })
        ]
    }));
};
const CandyCane = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M5.7 21a2 2 0 0 1-3.5-2l8.6-14a6 6 0 0 1 10.4 6 2 2 0 1 1-3.464-2 2 2 0 1 0-3.464-2Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17.75 7 15 2.1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10.9 4.8 13 9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m7.9 9.7 2 4.4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4.9 14.7 7 18.9"
            })
        ]
    }));
};
const CandyOff = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m8.5 8.5-1 1a4.95 4.95 0 0 0 7 7l1-1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11.843 6.187A4.947 4.947 0 0 1 16.5 7.5a4.947 4.947 0 0 1 1.313 4.657"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 16.5V14"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 6.5v1.843"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 10v7.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m16 7 1-5 1.367.683A3 3 0 0 0 19.708 3H21v1.292a3 3 0 0 0 .317 1.341L22 7l-5 1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m8 17-1 5-1.367-.683A3 3 0 0 0 4.292 21H3v-1.292a3 3 0 0 0-.317-1.341L2 17l5-1"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "2",
                x2: "22",
                y1: "2",
                y2: "22"
            })
        ]
    }));
};
const Candy = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m9.5 7.5-2 2a4.95 4.95 0 1 0 7 7l2-2a4.95 4.95 0 1 0-7-7Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 6.5v10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 7.5v10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m16 7 1-5 1.37.68A3 3 0 0 0 19.7 3H21v1.3c0 .46.1.92.32 1.33L22 7l-5 1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m8 17-1 5-1.37-.68A3 3 0 0 0 4.3 21H3v-1.3a3 3 0 0 0-.32-1.33L2 17l5-1"
            })
        ]
    }));
};
const CaptionsOff = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M10.5 5H19a2 2 0 0 1 2 2v8.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 11h-.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19 19H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m2 2 20 20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 11h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 15h2.5"
            })
        ]
    }));
};
const Captions = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "14",
                x: "3",
                y: "5",
                rx: "2",
                ry: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 15h4M15 15h2M7 11h2M13 11h4"
            })
        ]
    }));
};
const CarFront = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m21 8-2 2-1.5-3.7A2 2 0 0 0 15.646 5H8.4a2 2 0 0 0-1.903 1.257L5 10 3 8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 14h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 14h.01"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "8",
                x: "3",
                y: "10",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 18v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19 18v2"
            })
        ]
    }));
};
const CarTaxiFront = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M10 2h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m21 8-2 2-1.5-3.7A2 2 0 0 0 15.646 5H8.4a2 2 0 0 0-1.903 1.257L5 10 3 8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 14h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 14h.01"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "8",
                x: "3",
                y: "10",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 18v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19 18v2"
            })
        ]
    }));
};
const Car = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "7",
                cy: "17",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 17h6"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "17",
                cy: "17",
                r: "2"
            })
        ]
    }));
};
const Caravan = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "4",
                height: "4",
                x: "2",
                y: "9"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "4",
                height: "10",
                x: "10",
                y: "9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 19V9a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v8a2 2 0 0 0 2 2h2"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "8",
                cy: "19",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 19h12v-2"
            })
        ]
    }));
};
const Carrot = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2.27 21.7s9.87-3.5 12.73-6.36a4.5 4.5 0 0 0-6.36-6.37C5.77 11.84 2.27 21.7 2.27 21.7zM8.64 14l-2.05-2.04M15.34 15l-2.46-2.46"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 9s-1.33-2-3.5-2C16.86 7 15 9 15 9s1.33 2 3.5 2S22 9 22 9z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 2s-2 1.33-2 3.5S15 9 15 9s2-1.84 2-3.5C17 3.33 15 2 15 2z"
            })
        ]
    }));
};
const CaseLower = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "7",
                cy: "12",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 9v6"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "17",
                cy: "12",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 7v8"
            })
        ]
    }));
};
const CaseSensitive = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m3 15 4-8 4 8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 13h6"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "18",
                cy: "12",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 9v6"
            })
        ]
    }));
};
const CaseUpper = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m3 15 4-8 4 8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 13h6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 11h4.5a2 2 0 0 1 0 4H15V7h4a2 2 0 0 1 0 4"
            })
        ]
    }));
};
const CassetteTape = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "20",
                height: "16",
                x: "2",
                y: "4",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "8",
                cy: "10",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 12h8"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "16",
                cy: "10",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m6 20 .7-2.9A1.4 1.4 0 0 1 8.1 16h7.8a1.4 1.4 0 0 1 1.4 1l.7 3"
            })
        ]
    }));
};
const Cast = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2 8V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 12a9 9 0 0 1 8 8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 16a5 5 0 0 1 4 4"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "2",
                x2: "2.01",
                y1: "20",
                y2: "20"
            })
        ]
    }));
};
const Castle = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M22 20v-9H2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 11V4H6v7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 22v-4a3 3 0 0 0-3-3v0a3 3 0 0 0-3 3v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 11V9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 11V9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 4V2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 4V2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 4V2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 4V2"
            })
        ]
    }));
};
const Cat = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 5c.67 0 1.35.09 2 .26 1.78-2 5.03-2.84 6.42-2.26 1.4.58-.42 7-.42 7 .57 1.07 1 2.24 1 3.44C21 17.9 16.97 21 12 21s-9-3-9-7.56c0-1.25.5-2.4 1-3.44 0 0-1.89-6.42-.5-7 1.39-.58 4.72.23 6.5 2.23A9.04 9.04 0 0 1 12 5Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 14v.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 14v.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11.25 16.25h1.5L12 17l-.75-.75Z"
            })
        ]
    }));
};
const Cctv = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M7 9h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16.75 12H22l-3.5 7-3.09-4.32"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 9.5l-4 8-10.39-5.2a2.92 2.92 0 0 1-1.3-3.91L3.69 5.6a2.92 2.92 0 0 1 3.92-1.3Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 19h3.76a2 2 0 0 0 1.8-1.1L9 15"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 21v-4"
            })
        ]
    }));
};
const CheckCheck = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M18 6 7 17l-5-5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m22 10-7.5 7.5L13 16"
            })
        ]
    }));
};
const CheckCircle2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9 12 2 2 4-4"
            })
        ]
    }));
};
const CheckCircle = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M22 11.08V12a10 10 0 1 1-5.93-9.14"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9 11 3 3L22 4"
            })
        ]
    }));
};
const CheckSquare2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9 12 2 2 4-4"
            })
        ]
    }));
};
const CheckSquare = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m9 11 3 3L22 4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"
            })
        ]
    }));
};
const Check = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M20 6 9 17l-5-5"
        })
    }));
};
const ChefHat = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M6 13.87A4 4 0 0 1 7.41 6a5.11 5.11 0 0 1 1.05-1.54 5 5 0 0 1 7.08 0A5.11 5.11 0 0 1 16.59 6 4 4 0 0 1 18 13.87V21H6Z"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "6",
                x2: "18",
                y1: "17",
                y2: "17"
            })
        ]
    }));
};
const Cherry = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2 17a5 5 0 0 0 10 0c0-2.76-2.5-5-5-3-2.5-2-5 .24-5 3Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 17a5 5 0 0 0 10 0c0-2.76-2.5-5-5-3-2.5-2-5 .24-5 3Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 14c3.22-2.91 4.29-8.75 5-12 1.66 2.38 4.94 9 5 12"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 9c-4.29 0-7.14-2.33-10-7 5.71 0 10 4.67 10 7Z"
            })
        ]
    }));
};
const ChevronDownCircle = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m16 10-4 4-4-4"
            })
        ]
    }));
};
const ChevronDownSquare = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m16 10-4 4-4-4"
            })
        ]
    }));
};
const ChevronDown = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "m6 9 6 6 6-6"
        })
    }));
};
const ChevronFirst = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m17 18-6-6 6-6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 6v12"
            })
        ]
    }));
};
const ChevronLast = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m7 18 6-6-6-6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 6v12"
            })
        ]
    }));
};
const ChevronLeftCircle = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m14 16-4-4 4-4"
            })
        ]
    }));
};
const ChevronLeftSquare = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m14 16-4-4 4-4"
            })
        ]
    }));
};
const ChevronLeft = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "m15 18-6-6 6-6"
        })
    }));
};
const ChevronRightCircle = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m10 8 4 4-4 4"
            })
        ]
    }));
};
const ChevronRightSquare = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m10 8 4 4-4 4"
            })
        ]
    }));
};
const ChevronRight = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "m9 18 6-6-6-6"
        })
    }));
};
const ChevronUpCircle = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m8 14 4-4 4 4"
            })
        ]
    }));
};
const ChevronUpSquare = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m8 14 4-4 4 4"
            })
        ]
    }));
};
const ChevronUp = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "m18 15-6-6-6 6"
        })
    }));
};
const ChevronsDownUp = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m7 20 5-5 5 5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m7 4 5 5 5-5"
            })
        ]
    }));
};
const ChevronsDown = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m7 6 5 5 5-5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m7 13 5 5 5-5"
            })
        ]
    }));
};
const ChevronsLeftRight = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m9 7-5 5 5 5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m15 7 5 5-5 5"
            })
        ]
    }));
};
const ChevronsLeft = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m11 17-5-5 5-5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m18 17-5-5 5-5"
            })
        ]
    }));
};
const ChevronsRightLeft = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m20 17-5-5 5-5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m4 17 5-5-5-5"
            })
        ]
    }));
};
const ChevronsRight = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m6 17 5-5-5-5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m13 17 5-5-5-5"
            })
        ]
    }));
};
const ChevronsUpDown = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m7 15 5 5 5-5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m7 9 5-5 5 5"
            })
        ]
    }));
};
const ChevronsUp = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m17 11-5-5-5 5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m17 18-5-5-5 5"
            })
        ]
    }));
};
const Chrome = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "4"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "21.17",
                x2: "12",
                y1: "8",
                y2: "8"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "3.95",
                x2: "8.54",
                y1: "6.06",
                y2: "14"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "10.88",
                x2: "15.46",
                y1: "21.94",
                y2: "14"
            })
        ]
    }));
};
const Church = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m18 7 4 2v11a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9l4-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 22v-4a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 22V5l-6-3-6 3v17"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 7v5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 9h4"
            })
        ]
    }));
};
const CigaretteOff = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("line", {
                x1: "2",
                x2: "22",
                y1: "2",
                y2: "22"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 12H2v4h14"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 12v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 12h-.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 12v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 8c0-2.5-2-2.5-2-5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 8c0-2.5-2-2.5-2-5"
            })
        ]
    }));
};
const Cigarette = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M18 12H2v4h16"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 12v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 12v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 8c0-2.5-2-2.5-2-5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 8c0-2.5-2-2.5-2-5"
            })
        ]
    }));
};
const CircleDashed = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M10.1 2.182a10 10 0 0 1 3.8 0"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13.9 21.818a10 10 0 0 1-3.8 0"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17.609 3.721a10 10 0 0 1 2.69 2.7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2.182 13.9a10 10 0 0 1 0-3.8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20.279 17.609a10 10 0 0 1-2.7 2.69"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21.818 10.1a10 10 0 0 1 0 3.8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3.721 6.391a10 10 0 0 1 2.7-2.69"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.391 20.279a10 10 0 0 1-2.69-2.7"
            })
        ]
    }));
};
const CircleDollarSign = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 18V6"
            })
        ]
    }));
};
const CircleDotDashed = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M10.1 2.18a9.93 9.93 0 0 1 3.8 0"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17.6 3.71a9.95 9.95 0 0 1 2.69 2.7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21.82 10.1a9.93 9.93 0 0 1 0 3.8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20.29 17.6a9.95 9.95 0 0 1-2.7 2.69"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13.9 21.82a9.94 9.94 0 0 1-3.8 0"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.4 20.29a9.95 9.95 0 0 1-2.69-2.7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2.18 13.9a9.93 9.93 0 0 1 0-3.8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3.71 6.4a9.95 9.95 0 0 1 2.7-2.69"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "1"
            })
        ]
    }));
};
const CircleDot = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "1"
            })
        ]
    }));
};
const CircleEllipsis = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 12h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 12h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 12h.01"
            })
        ]
    }));
};
const CircleEqual = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M7 10h10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 14h10"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            })
        ]
    }));
};
const CircleFadingPlus = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2a10 10 0 0 1 7.38 16.75"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 8v8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 12H8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2.5 8.875a10 10 0 0 0-.5 3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2.83 16a10 10 0 0 0 2.43 3.4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4.636 5.235a10 10 0 0 1 .891-.857"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8.644 21.42a10 10 0 0 0 7.631-.38"
            })
        ]
    }));
};
const CircleOff = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m2 2 20 20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8.35 2.69A10 10 0 0 1 21.3 15.65"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19.08 19.08A10 10 0 1 1 4.92 4.92"
            })
        ]
    }));
};
const CircleSlash2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 2 2 22"
            })
        ]
    }));
};
const CircleSlash = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("line", {
                x1: "9",
                x2: "15",
                y1: "15",
                y2: "9"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            })
        ]
    }));
};
const CircleUserRound = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M18 20a6 6 0 0 0-12 0"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "10",
                r: "4"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            })
        ]
    }));
};
const CircleUser = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "10",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 20.662V19a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v1.662"
            })
        ]
    }));
};
const Circle = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("circle", {
            cx: "12",
            cy: "12",
            r: "10"
        })
    }));
};
const CircuitBoard = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11 9h4a2 2 0 0 0 2-2V3"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "9",
                cy: "9",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 21v-4a2 2 0 0 1 2-2h4"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "15",
                cy: "15",
                r: "2"
            })
        ]
    }));
};
const Citrus = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M21.66 17.67a1.08 1.08 0 0 1-.04 1.6A12 12 0 0 1 4.73 2.38a1.1 1.1 0 0 1 1.61-.04z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19.65 15.66A8 8 0 0 1 8.35 4.34"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m14 10-5.5 5.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 17.85V10H6.15"
            })
        ]
    }));
};
const Clapperboard = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M20.2 6 3 11l-.9-2.4c-.3-1.1.3-2.2 1.3-2.5l13.5-4c1.1-.3 2.2.3 2.5 1.3Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m6.2 5.3 3.1 3.9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m12.4 3.4 3.1 4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 11h18v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z"
            })
        ]
    }));
};
const ClipboardCheck = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "8",
                height: "4",
                x: "8",
                y: "2",
                rx: "1",
                ry: "1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9 14 2 2 4-4"
            })
        ]
    }));
};
const ClipboardCopy = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "8",
                height: "4",
                x: "8",
                y: "2",
                rx: "1",
                ry: "1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 4h2a2 2 0 0 1 2 2v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 14H11"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m15 10-4 4 4 4"
            })
        ]
    }));
};
const ClipboardList = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "8",
                height: "4",
                x: "8",
                y: "2",
                rx: "1",
                ry: "1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 11h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 16h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 11h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 16h.01"
            })
        ]
    }));
};
const ClipboardMinus = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "8",
                height: "4",
                x: "8",
                y: "2",
                rx: "1",
                ry: "1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 14h6"
            })
        ]
    }));
};
const ClipboardPaste = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M15 2H9a1 1 0 0 0-1 1v2c0 .6.4 1 1 1h6c.6 0 1-.4 1-1V3c0-.6-.4-1-1-1Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2M16 4h2a2 2 0 0 1 2 2v2M11 14h10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m17 10 4 4-4 4"
            })
        ]
    }));
};
const ClipboardPenLine = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "8",
                height: "4",
                x: "8",
                y: "2",
                rx: "1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 4h2a2 2 0 0 1 1.73 1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 18h1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18.4 9.6a2 2 0 0 1 3 3L17 17l-4 1 1-4Z"
            })
        ]
    }));
};
const ClipboardPen = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "8",
                height: "4",
                x: "8",
                y: "2",
                rx: "1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10.4 12.6a2 2 0 0 1 3 3L8 21l-4 1 1-4Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-5.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 13.5V6a2 2 0 0 1 2-2h2"
            })
        ]
    }));
};
const ClipboardPlus = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "8",
                height: "4",
                x: "8",
                y: "2",
                rx: "1",
                ry: "1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 14h6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 17v-6"
            })
        ]
    }));
};
const ClipboardType = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "8",
                height: "4",
                x: "8",
                y: "2",
                rx: "1",
                ry: "1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 12v-1h6v1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11 17h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 11v6"
            })
        ]
    }));
};
const ClipboardX = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "8",
                height: "4",
                x: "8",
                y: "2",
                rx: "1",
                ry: "1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m15 11-6 6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9 11 6 6"
            })
        ]
    }));
};
const Clipboard = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "8",
                height: "4",
                x: "8",
                y: "2",
                rx: "1",
                ry: "1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"
            })
        ]
    }));
};
const Clock1 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "12 6 12 12 14.5 8"
            })
        ]
    }));
};
const Clock10 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "12 6 12 12 8 10"
            })
        ]
    }));
};
const Clock11 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "12 6 12 12 9.5 8"
            })
        ]
    }));
};
const Clock12 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "12 6 12 12"
            })
        ]
    }));
};
const Clock2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "12 6 12 12 16 10"
            })
        ]
    }));
};
const Clock3 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "12 6 12 12 16.5 12"
            })
        ]
    }));
};
const Clock4 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "12 6 12 12 16 14"
            })
        ]
    }));
};
const Clock5 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "12 6 12 12 14.5 16"
            })
        ]
    }));
};
const Clock6 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "12 6 12 12 12 16.5"
            })
        ]
    }));
};
const Clock7 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "12 6 12 12 9.5 16"
            })
        ]
    }));
};
const Clock8 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "12 6 12 12 8 14"
            })
        ]
    }));
};
const Clock9 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "12 6 12 12 7.5 12"
            })
        ]
    }));
};
const Clock = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "12 6 12 12 16 14"
            })
        ]
    }));
};
const CloudCog = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "17",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4.2 15.1A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m15.7 18.4-.9-.3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9.2 15.9-.9-.3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m10.6 20.7.3-.9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m13.1 14.2.3-.9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m13.6 20.7-.4-1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m10.8 14.3-.4-1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m8.3 18.6 1-.4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m14.7 15.8 1-.4"
            })
        ]
    }));
};
const CloudDrizzle = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 19v1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 14v1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 19v1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 14v1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 21v1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 16v1"
            })
        ]
    }));
};
const CloudFog = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 17H7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 21H9"
            })
        ]
    }));
};
const CloudHail = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 14v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 14v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 20h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 20h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 16v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 22h.01"
            })
        ]
    }));
};
const CloudLightning = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M6 16.326A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 .5 8.973"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m13 12-3 5h4l-3 5"
            })
        ]
    }));
};
const CloudMoonRain = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M10.083 9A6.002 6.002 0 0 1 16 4a4.243 4.243 0 0 0 6 6c0 2.22-1.206 4.16-3 5.197"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 20a5 5 0 1 1 8.9-4H13a3 3 0 0 1 2 5.24"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11 20v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 19v2"
            })
        ]
    }));
};
const CloudMoon = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M13 16a3 3 0 1 1 0 6H7a5 5 0 1 1 4.9-6Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10.1 9A6 6 0 0 1 16 4a4.24 4.24 0 0 0 6 6 6 6 0 0 1-3 5.197"
            })
        ]
    }));
};
const CloudOff = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m2 2 20 20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5.782 5.782A7 7 0 0 0 9 19h8.5a4.5 4.5 0 0 0 1.307-.193"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21.532 16.5A4.5 4.5 0 0 0 17.5 10h-1.79A7.008 7.008 0 0 0 10 5.07"
            })
        ]
    }));
};
const CloudRainWind = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9.2 22 3-7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9 13-3 7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m17 13-3 7"
            })
        ]
    }));
};
const CloudRain = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 14v6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 14v6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 16v6"
            })
        ]
    }));
};
const CloudSnow = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 15h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 19h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 17h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 21h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 15h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 19h.01"
            })
        ]
    }));
};
const CloudSunRain = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m4.93 4.93 1.41 1.41"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 12h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m19.07 4.93-1.41 1.41"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15.947 12.65a4 4 0 0 0-5.925-4.128"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 20a5 5 0 1 1 8.9-4H13a3 3 0 0 1 2 5.24"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11 20v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 19v2"
            })
        ]
    }));
};
const CloudSun = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m4.93 4.93 1.41 1.41"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 12h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m19.07 4.93-1.41 1.41"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15.947 12.65a4 4 0 0 0-5.925-4.128"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13 22H7a5 5 0 1 1 4.9-6H13a3 3 0 0 1 0 6Z"
            })
        ]
    }));
};
const Cloud = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z"
        })
    }));
};
const Cloudy = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M17.5 21H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 10a3 3 0 0 0-3-3h-2.207a5.502 5.502 0 0 0-10.702.5"
            })
        ]
    }));
};
const Clover = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M16.17 7.83 2 22"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4.02 12a2.827 2.827 0 1 1 3.81-4.17A2.827 2.827 0 1 1 12 4.02a2.827 2.827 0 1 1 4.17 3.81A2.827 2.827 0 1 1 19.98 12a2.827 2.827 0 1 1-3.81 4.17A2.827 2.827 0 1 1 12 19.98a2.827 2.827 0 1 1-4.17-3.81A1 1 0 1 1 4 12"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m7.83 7.83 8.34 8.34"
            })
        ]
    }));
};
const Club = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M17.28 9.05a5.5 5.5 0 1 0-10.56 0A5.5 5.5 0 1 0 12 17.66a5.5 5.5 0 1 0 5.28-8.6Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 17.66L12 22"
            })
        ]
    }));
};
const Code2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m18 16 4-4-4-4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m6 8-4 4 4 4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m14.5 4-5 16"
            })
        ]
    }));
};
const CodeSquare = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m10 10-2 2 2 2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m14 14 2-2-2-2"
            })
        ]
    }));
};
const Code = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("polyline", {
                points: "16 18 22 12 16 6"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "8 6 2 12 8 18"
            })
        ]
    }));
};
const Codepen = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("polygon", {
                points: "12 2 22 8.5 22 15.5 12 22 2 15.5 2 8.5 12 2"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "12",
                y1: "22",
                y2: "15.5"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "22 8.5 12 15.5 2 8.5"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "2 15.5 12 8.5 22 15.5"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "12",
                y1: "2",
                y2: "8.5"
            })
        ]
    }));
};
const Codesandbox = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "7.5 4.21 12 6.81 16.5 4.21"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "7.5 19.79 7.5 14.6 3 12"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "21 12 16.5 14.6 16.5 19.79"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "3.27 6.96 12 12.01 20.73 6.96"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "12",
                y1: "22.08",
                y2: "12"
            })
        ]
    }));
};
const Coffee = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M17 8h1a4 4 0 1 1 0 8h-1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 8h14v9a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4Z"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "6",
                x2: "6",
                y1: "2",
                y2: "4"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "10",
                x2: "10",
                y1: "2",
                y2: "4"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "14",
                x2: "14",
                y1: "2",
                y2: "4"
            })
        ]
    }));
};
const Cog = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 22v-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m17 20.66-1-1.73"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11 10.27 7 3.34"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m20.66 17-1.73-1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m3.34 7 1.73 1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 12h8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 12h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m20.66 7-1.73 1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m3.34 17 1.73-1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m17 3.34-1 1.73"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m11 13.73-4 6.93"
            })
        ]
    }));
};
const Coins = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "8",
                cy: "8",
                r: "6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18.09 10.37A6 6 0 1 1 10.34 18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 6h1v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m16.71 13.88.7.71-2.82 2.82"
            })
        ]
    }));
};
const Columns2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 3v18"
            })
        ]
    }));
};
const Columns3 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 3v18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 3v18"
            })
        ]
    }));
};
const Columns4 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7.5 3v18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 3v18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16.5 3v18"
            })
        ]
    }));
};
const Combine = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "8",
                height: "8",
                x: "2",
                y: "2",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 2c1.1 0 2 .9 2 2v4c0 1.1-.9 2-2 2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 2c1.1 0 2 .9 2 2v4c0 1.1-.9 2-2 2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 18H5c-1.7 0-3-1.3-3-3v-1"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "7 21 10 18 7 15"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "8",
                height: "8",
                x: "14",
                y: "14",
                rx: "2"
            })
        ]
    }));
};
const Command = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M15 6v12a3 3 0 1 0 3-3H6a3 3 0 1 0 3 3V6a3 3 0 1 0-3 3h12a3 3 0 1 0-3-3"
        })
    }));
};
const Compass = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("polygon", {
                points: "16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"
            })
        ]
    }));
};
const Component = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M5.5 8.5 9 12l-3.5 3.5L2 12l3.5-3.5Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m12 2 3.5 3.5L12 9 8.5 5.5 12 2Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18.5 8.5 22 12l-3.5 3.5L15 12l3.5-3.5Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m12 15 3.5 3.5L12 22l-3.5-3.5L12 15Z"
            })
        ]
    }));
};
const Computer = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "14",
                height: "8",
                x: "5",
                y: "2",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "20",
                height: "8",
                x: "2",
                y: "14",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 18h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 18h6"
            })
        ]
    }));
};
const ConciergeBell = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3 20a1 1 0 0 1-1-1v-1a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v1a1 1 0 0 1-1 1Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 16a8 8 0 1 0-16 0"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 4v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 4h4"
            })
        ]
    }));
};
const Cone = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m20.9 18.55-8-15.98a1 1 0 0 0-1.8 0l-8 15.98"
            }),
            /*#__PURE__*/ _jsx("ellipse", {
                cx: "12",
                cy: "19",
                rx: "9",
                ry: "3"
            })
        ]
    }));
};
const Construction = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                x: "2",
                y: "6",
                width: "20",
                height: "8",
                rx: "1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 14v7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 14v7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 3v3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 3v3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 14 2.3 6.3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m14 6 7.7 7.7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m8 6 8 8"
            })
        ]
    }));
};
const Contact2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M16 18a4 4 0 0 0-8 0"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "11",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "4",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "8",
                x2: "8",
                y1: "2",
                y2: "4"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "16",
                x2: "16",
                y1: "2",
                y2: "4"
            })
        ]
    }));
};
const Contact = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M17 18a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "4",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "10",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "8",
                x2: "8",
                y1: "2",
                y2: "4"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "16",
                x2: "16",
                y1: "2",
                y2: "4"
            })
        ]
    }));
};
const Container = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M22 7.7c0-.6-.4-1.2-.8-1.5l-6.3-3.9a1.72 1.72 0 0 0-1.7 0l-10.3 6c-.5.2-.9.8-.9 1.4v6.6c0 .5.4 1.2.8 1.5l6.3 3.9a1.72 1.72 0 0 0 1.7 0l10.3-6c.5-.3.9-1 .9-1.5Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 21.9V14L2.1 9.1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m10 14 11.9-6.9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 19.8v-8.1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 17.5V9.4"
            })
        ]
    }));
};
const Contrast = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 18a6 6 0 0 0 0-12v12z"
            })
        ]
    }));
};
const Cookie = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2a10 10 0 1 0 10 10 4 4 0 0 1-5-5 4 4 0 0 1-5-5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8.5 8.5v.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 15.5v.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 12v.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11 17v.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 14v.01"
            })
        ]
    }));
};
const CookingPot = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2 12h20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 12v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m4 8 16-4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m8.86 6.78-.45-1.81a2 2 0 0 1 1.45-2.43l1.94-.48a2 2 0 0 1 2.43 1.46l.45 1.8"
            })
        ]
    }));
};
const CopyCheck = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m12 15 2 2 4-4"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "14",
                height: "14",
                x: "8",
                y: "8",
                rx: "2",
                ry: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"
            })
        ]
    }));
};
const CopyMinus = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "18",
                y1: "15",
                y2: "15"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "14",
                height: "14",
                x: "8",
                y: "8",
                rx: "2",
                ry: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"
            })
        ]
    }));
};
const CopyPlus = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("line", {
                x1: "15",
                x2: "15",
                y1: "12",
                y2: "18"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "18",
                y1: "15",
                y2: "15"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "14",
                height: "14",
                x: "8",
                y: "8",
                rx: "2",
                ry: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"
            })
        ]
    }));
};
const CopySlash = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "18",
                y1: "18",
                y2: "12"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "14",
                height: "14",
                x: "8",
                y: "8",
                rx: "2",
                ry: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"
            })
        ]
    }));
};
const CopyX = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "18",
                y1: "12",
                y2: "18"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "18",
                y1: "18",
                y2: "12"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "14",
                height: "14",
                x: "8",
                y: "8",
                rx: "2",
                ry: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"
            })
        ]
    }));
};
const Copy = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "14",
                height: "14",
                x: "8",
                y: "8",
                rx: "2",
                ry: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"
            })
        ]
    }));
};
const Copyleft = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.17 14.83a4 4 0 1 0 0-5.66"
            })
        ]
    }));
};
const Copyright = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14.83 14.83a4 4 0 1 1 0-5.66"
            })
        ]
    }));
};
const CornerDownLeft = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("polyline", {
                points: "9 10 4 15 9 20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 4v7a4 4 0 0 1-4 4H4"
            })
        ]
    }));
};
const CornerDownRight = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("polyline", {
                points: "15 10 20 15 15 20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 4v7a4 4 0 0 0 4 4h12"
            })
        ]
    }));
};
const CornerLeftDown = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("polyline", {
                points: "14 15 9 20 4 15"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 4h-7a4 4 0 0 0-4 4v12"
            })
        ]
    }));
};
const CornerLeftUp = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("polyline", {
                points: "14 9 9 4 4 9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 20h-7a4 4 0 0 1-4-4V4"
            })
        ]
    }));
};
const CornerRightDown = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("polyline", {
                points: "10 15 15 20 20 15"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 4h7a4 4 0 0 1 4 4v12"
            })
        ]
    }));
};
const CornerRightUp = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("polyline", {
                points: "10 9 15 4 20 9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 20h7a4 4 0 0 0 4-4V4"
            })
        ]
    }));
};
const CornerUpLeft = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("polyline", {
                points: "9 14 4 9 9 4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 20v-7a4 4 0 0 0-4-4H4"
            })
        ]
    }));
};
const CornerUpRight = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("polyline", {
                points: "15 14 20 9 15 4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 20v-7a4 4 0 0 1 4-4h12"
            })
        ]
    }));
};
const Cpu = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                x: "4",
                y: "4",
                width: "16",
                height: "16",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("rect", {
                x: "9",
                y: "9",
                width: "6",
                height: "6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 2v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 20v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 15h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 9h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 15h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 9h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 2v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 20v2"
            })
        ]
    }));
};
const CreativeCommons = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 9.3a2.8 2.8 0 0 0-3.5 1 3.1 3.1 0 0 0 0 3.4 2.7 2.7 0 0 0 3.5 1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 9.3a2.8 2.8 0 0 0-3.5 1 3.1 3.1 0 0 0 0 3.4 2.7 2.7 0 0 0 3.5 1"
            })
        ]
    }));
};
const CreditCard = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "20",
                height: "14",
                x: "2",
                y: "5",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "2",
                x2: "22",
                y1: "10",
                y2: "10"
            })
        ]
    }));
};
const Croissant = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m4.6 13.11 5.79-3.21c1.89-1.05 4.79 1.78 3.71 3.71l-3.22 5.81C8.8 23.16.79 15.23 4.6 13.11Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m10.5 9.5-1-2.29C9.2 6.48 8.8 6 8 6H4.5C2.79 6 2 6.5 2 8.5a7.71 7.71 0 0 0 2 4.83"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 6c0-1.55.24-4-2-4-2 0-2.5 2.17-2.5 4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m14.5 13.5 2.29 1c.73.3 1.21.7 1.21 1.5v3.5c0 1.71-.5 2.5-2.5 2.5a7.71 7.71 0 0 1-4.83-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 16c1.55 0 4-.24 4 2 0 2-2.17 2.5-4 2.5"
            })
        ]
    }));
};
const Crop = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M6 2v14a2 2 0 0 0 2 2h14"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 22V8a2 2 0 0 0-2-2H2"
            })
        ]
    }));
};
const Cross = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M11 2a2 2 0 0 0-2 2v5H4a2 2 0 0 0-2 2v2c0 1.1.9 2 2 2h5v5c0 1.1.9 2 2 2h2a2 2 0 0 0 2-2v-5h5a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2h-5V4a2 2 0 0 0-2-2h-2z"
        })
    }));
};
const Crosshair = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "22",
                x2: "18",
                y1: "12",
                y2: "12"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "6",
                x2: "2",
                y1: "12",
                y2: "12"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "12",
                y1: "6",
                y2: "2"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "12",
                y1: "22",
                y2: "18"
            })
        ]
    }));
};
const Crown = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "m2 4 3 12h14l3-12-6 7-4-7-4 7-6-7zm3 16h14"
        })
    }));
};
const Cuboid = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m21.12 6.4-6.05-4.06a2 2 0 0 0-2.17-.05L2.95 8.41a2 2 0 0 0-.95 1.7v5.82a2 2 0 0 0 .88 1.66l6.05 4.07a2 2 0 0 0 2.17.05l9.95-6.12a2 2 0 0 0 .95-1.7V8.06a2 2 0 0 0-.88-1.66Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 22v-8L2.25 9.15"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m10 14 11.77-6.87"
            })
        ]
    }));
};
const CupSoda = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m6 8 1.75 12.28a2 2 0 0 0 2 1.72h4.54a2 2 0 0 0 2-1.72L18 8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 8h14"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 15a6.47 6.47 0 0 1 5 0 6.47 6.47 0 0 0 5 0"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m12 8 1-6h2"
            })
        ]
    }));
};
const Currency = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "8"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "3",
                x2: "6",
                y1: "3",
                y2: "6"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "21",
                x2: "18",
                y1: "3",
                y2: "6"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "3",
                x2: "6",
                y1: "21",
                y2: "18"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "21",
                x2: "18",
                y1: "21",
                y2: "18"
            })
        ]
    }));
};
const Cylinder = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("ellipse", {
                cx: "12",
                cy: "5",
                rx: "9",
                ry: "3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 5v14a9 3 0 0 0 18 0V5"
            })
        ]
    }));
};
const DatabaseBackup = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("ellipse", {
                cx: "12",
                cy: "5",
                rx: "9",
                ry: "3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 12a9 3 0 0 0 5 2.69"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 9.3V5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 5v14a9 3 0 0 0 6.47 2.88"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 12v4h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13 20a5 5 0 0 0 9-3 4.5 4.5 0 0 0-4.5-4.5c-1.33 0-2.54.54-3.41 1.41L12 16"
            })
        ]
    }));
};
const DatabaseZap = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("ellipse", {
                cx: "12",
                cy: "5",
                rx: "9",
                ry: "3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 5V19A9 3 0 0 0 15 21.84"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 5V8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 12L18 17H22L19 22"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 12A9 3 0 0 0 14.59 14.87"
            })
        ]
    }));
};
const Database = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("ellipse", {
                cx: "12",
                cy: "5",
                rx: "9",
                ry: "3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 5V19A9 3 0 0 0 21 19V5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 12A9 3 0 0 0 21 12"
            })
        ]
    }));
};
const Delete = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M20 5H9l-7 7 7 7h11a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2Z"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "18",
                x2: "12",
                y1: "9",
                y2: "15"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "18",
                y1: "9",
                y2: "15"
            })
        ]
    }));
};
const Dessert = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "4",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10.2 3.2C5.5 4 2 8.1 2 13a2 2 0 0 0 4 0v-1a2 2 0 0 1 4 0v4a2 2 0 0 0 4 0v-4a2 2 0 0 1 4 0v1a2 2 0 0 0 4 0c0-4.9-3.5-9-8.2-9.8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3.2 14.8a9 9 0 0 0 17.6 0"
            })
        ]
    }));
};
const Diameter = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "19",
                cy: "19",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "5",
                cy: "5",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.48 3.66a10 10 0 0 1 13.86 13.86"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m6.41 6.41 11.18 11.18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3.66 6.48a10 10 0 0 0 13.86 13.86"
            })
        ]
    }));
};
const Diamond = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M2.7 10.3a2.41 2.41 0 0 0 0 3.41l7.59 7.59a2.41 2.41 0 0 0 3.41 0l7.59-7.59a2.41 2.41 0 0 0 0-3.41l-7.59-7.59a2.41 2.41 0 0 0-3.41 0Z"
        })
    }));
};
const Dice1 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2",
                ry: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 12h.01"
            })
        ]
    }));
};
const Dice2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2",
                ry: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 9h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 15h.01"
            })
        ]
    }));
};
const Dice3 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2",
                ry: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 8h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 12h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 16h.01"
            })
        ]
    }));
};
const Dice4 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2",
                ry: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 8h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 8h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 16h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 16h.01"
            })
        ]
    }));
};
const Dice5 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2",
                ry: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 8h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 8h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 16h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 16h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 12h.01"
            })
        ]
    }));
};
const Dice6 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2",
                ry: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 8h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 12h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 16h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 8h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 12h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 16h.01"
            })
        ]
    }));
};
const Dices = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "12",
                height: "12",
                x: "2",
                y: "10",
                rx: "2",
                ry: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m17.92 14 3.5-3.5a2.24 2.24 0 0 0 0-3l-5-4.92a2.24 2.24 0 0 0-3 0L10 6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 18h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 14h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 6h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 9h.01"
            })
        ]
    }));
};
const Diff = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 3v14"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 10h14"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 21h14"
            })
        ]
    }));
};
const Disc2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 12h.01"
            })
        ]
    }));
};
const Disc3 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 12c0-1.7.7-3.2 1.8-4.2"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 12c0 1.7-.7 3.2-1.8 4.2"
            })
        ]
    }));
};
const DiscAlbum = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 12h.01"
            })
        ]
    }));
};
const Disc = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "2"
            })
        ]
    }));
};
const DivideCircle = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("line", {
                x1: "8",
                x2: "16",
                y1: "12",
                y2: "12"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "12",
                y1: "16",
                y2: "16"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "12",
                y1: "8",
                y2: "8"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            })
        ]
    }));
};
const DivideSquare = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2",
                ry: "2"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "8",
                x2: "16",
                y1: "12",
                y2: "12"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "12",
                y1: "16",
                y2: "16"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "12",
                y1: "8",
                y2: "8"
            })
        ]
    }));
};
const Divide = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "6",
                r: "1"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "5",
                x2: "19",
                y1: "12",
                y2: "12"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "18",
                r: "1"
            })
        ]
    }));
};
const DnaOff = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M15 2c-1.35 1.5-2.092 3-2.5 4.5M9 22c1.35-1.5 2.092-3 2.5-4.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 15c3.333-3 6.667-3 10-3m10-3c-1.5 1.35-3 2.092-4.5 2.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m17 6-2.5-2.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m14 8-1.5-1.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m7 18 2.5 2.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m3.5 14.5.5.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m20 9 .5.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m6.5 12.5 1 1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m16.5 10.5 1 1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m10 16 1.5 1.5"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "2",
                x2: "22",
                y1: "2",
                y2: "22"
            })
        ]
    }));
};
const Dna = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2 15c6.667-6 13.333 0 20-6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 22c1.798-1.998 2.518-3.995 2.807-5.993"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 2c-1.798 1.998-2.518 3.995-2.807 5.993"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m17 6-2.5-2.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m14 8-1-1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m7 18 2.5 2.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m3.5 14.5.5.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m20 9 .5.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m6.5 12.5 1 1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m16.5 10.5 1 1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m10 16 1.5 1.5"
            })
        ]
    }));
};
const Dog = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M10 5.172C10 3.782 8.423 2.679 6.5 3c-2.823.47-4.113 6.006-4 7 .08.703 1.725 1.722 3.656 1 1.261-.472 1.96-1.45 2.344-2.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14.267 5.172c0-1.39 1.577-2.493 3.5-2.172 2.823.47 4.113 6.006 4 7-.08.703-1.725 1.722-3.656 1-1.261-.472-1.855-1.45-2.239-2.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 14v.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 14v.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11.25 16.25h1.5L12 17l-.75-.75Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4.42 11.247A13.152 13.152 0 0 0 4 14.556C4 18.728 7.582 21 12 21s8-2.272 8-6.444c0-1.061-.162-2.2-.493-3.309m-9.243-6.082A8.801 8.801 0 0 1 12 5c.78 0 1.5.108 2.161.306"
            })
        ]
    }));
};
const DollarSign = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "12",
                y1: "2",
                y2: "22"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"
            })
        ]
    }));
};
const Donut = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M20.5 10a2.5 2.5 0 0 1-2.4-3H18a2.95 2.95 0 0 1-2.6-4.4 10 10 0 1 0 6.3 7.1c-.3.2-.8.3-1.2.3"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "3"
            })
        ]
    }));
};
const DoorClosed = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M18 20V6a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v14"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 20h20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 12v.01"
            })
        ]
    }));
};
const DoorOpen = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M13 4h3a2 2 0 0 1 2 2v14"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 20h3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13 20h9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 12v.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13 4.562v16.157a1 1 0 0 1-1.242.97L5 20V5.562a2 2 0 0 1 1.515-1.94l4-1A2 2 0 0 1 13 4.561Z"
            })
        ]
    }));
};
const DotSquare = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "1"
            })
        ]
    }));
};
const Dot = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("circle", {
            cx: "12.1",
            cy: "12.1",
            r: "1"
        })
    }));
};
const DownloadCloud = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 12v9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m8 17 4 4 4-4"
            })
        ]
    }));
};
const Download = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "7 10 12 15 17 10"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "12",
                y1: "15",
                y2: "3"
            })
        ]
    }));
};
const DraftingCompass = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "5",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m3 21 8.02-14.26"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m12.99 6.74 1.93 3.44"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19 12c-3.87 4-10.13 4-14 0"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m21 21-2.16-3.84"
            })
        ]
    }));
};
const Drama = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M10 11h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 6h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 6h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.5 13.1h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 5c0 9-4 12-6 12s-6-3-6-12c0-2 2-3 6-3s6 1 6 3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17.4 9.9c-.8.8-2 .8-2.8 0"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10.1 7.1C9 7.2 7.7 7.7 6 8.6c-3.5 2-4.7 3.9-3.7 5.6 4.5 7.8 9.5 8.4 11.2 7.4.9-.5 1.9-2.1 1.9-4.7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.1 16.5c.3-1.1 1.4-1.7 2.4-1.4"
            })
        ]
    }));
};
const Dribbble = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19.13 5.09C15.22 9.14 10 10.44 2.25 10.94"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21.75 12.84c-6.62-1.41-12.14 1-16.38 6.32"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8.56 2.75c4.37 6 6 9.42 8 17.72"
            })
        ]
    }));
};
const Drill = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M14 9c0 .6-.4 1-1 1H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9c.6 0 1 .4 1 1Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 6h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 4h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m5 10-2 8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 10v3c0 .6-.4 1-1 1H8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m7 18 2-8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 22c-1.7 0-3-1.3-3-3 0-.6.4-1 1-1h7c.6 0 1 .4 1 1v2c0 .6-.4 1-1 1Z"
            })
        ]
    }));
};
const Droplet = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-6.5c-.5 2.5-2 4.9-4 6.5C6 11.1 5 13 5 15a7 7 0 0 0 7 7z"
        })
    }));
};
const Droplets = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M7 16.3c2.2 0 4-1.83 4-4.05 0-1.16-.57-2.26-1.71-3.19S7.29 6.75 7 5.3c-.29 1.45-1.14 2.84-2.29 3.76S3 11.1 3 12.25c0 2.22 1.8 4.05 4 4.05z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12.56 6.6A10.97 10.97 0 0 0 14 3.02c.5 2.5 2 4.9 4 6.5s3 3.5 3 5.5a6.98 6.98 0 0 1-11.91 4.97"
            })
        ]
    }));
};
const Drum = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m2 2 8 8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m22 2-8 8"
            }),
            /*#__PURE__*/ _jsx("ellipse", {
                cx: "12",
                cy: "9",
                rx: "10",
                ry: "5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 13.4v7.9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 14v8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 13.4v7.9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 9v8a10 5 0 0 0 20 0V9"
            })
        ]
    }));
};
const Drumstick = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M15.45 15.4c-2.13.65-4.3.32-5.7-1.1-2.29-2.27-1.76-6.5 1.17-9.42 2.93-2.93 7.15-3.46 9.43-1.18 1.41 1.41 1.74 3.57 1.1 5.71-1.4-.51-3.26-.02-4.64 1.36-1.38 1.38-1.87 3.23-1.36 4.63z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m11.25 15.6-2.16 2.16a2.5 2.5 0 1 1-4.56 1.73 2.49 2.49 0 0 1-1.41-4.24 2.5 2.5 0 0 1 3.14-.32l2.16-2.16"
            })
        ]
    }));
};
const Dumbbell = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m6.5 6.5 11 11"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m21 21-1-1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m3 3 1 1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m18 22 4-4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m2 6 4-4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m3 10 7-7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m14 21 7-7"
            })
        ]
    }));
};
const EarOff = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M6 18.5a3.5 3.5 0 1 0 7 0c0-1.57.92-2.52 2.04-3.46"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 8.5c0-.75.13-1.47.36-2.14"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8.8 3.15A6.5 6.5 0 0 1 19 8.5c0 1.63-.44 2.81-1.09 3.76"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12.5 6A2.5 2.5 0 0 1 15 8.5M10 13a2 2 0 0 0 1.82-1.18"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "2",
                x2: "22",
                y1: "2",
                y2: "22"
            })
        ]
    }));
};
const Ear = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M6 8.5a6.5 6.5 0 1 1 13 0c0 6-6 6-6 10a3.5 3.5 0 1 1-7 0"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 8.5a2.5 2.5 0 0 0-5 0v1a2 2 0 1 1 0 4"
            })
        ]
    }));
};
const Eclipse = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2a7 7 0 1 0 10 10"
            })
        ]
    }));
};
const EggFried = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "11.5",
                cy: "12.5",
                r: "3.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 8c0-3.5 2.5-6 6.5-6 5 0 4.83 3 7.5 5s5 2 5 6c0 4.5-2.5 6.5-7 6.5-2.5 0-2.5 2.5-6 2.5s-7-2-7-5.5c0-3 1.5-3 1.5-5C3.5 10 3 9 3 8Z"
            })
        ]
    }));
};
const EggOff = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M6.399 6.399C5.362 8.157 4.65 10.189 4.5 12c-.37 4.43 1.27 9.95 7.5 10 3.256-.026 5.259-1.547 6.375-3.625"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19.532 13.875A14.07 14.07 0 0 0 19.5 12c-.36-4.34-3.95-9.96-7.5-10-1.04.012-2.082.502-3.046 1.297"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "2",
                x2: "22",
                y1: "2",
                y2: "22"
            })
        ]
    }));
};
const Egg = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M12 22c6.23-.05 7.87-5.57 7.5-10-.36-4.34-3.95-9.96-7.5-10-3.55.04-7.14 5.66-7.5 10-.37 4.43 1.27 9.95 7.5 10z"
        })
    }));
};
const EqualNot = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("line", {
                x1: "5",
                x2: "19",
                y1: "9",
                y2: "9"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "5",
                x2: "19",
                y1: "15",
                y2: "15"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "19",
                x2: "5",
                y1: "5",
                y2: "19"
            })
        ]
    }));
};
const EqualSquare = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 10h10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 14h10"
            })
        ]
    }));
};
const Equal = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("line", {
                x1: "5",
                x2: "19",
                y1: "9",
                y2: "9"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "5",
                x2: "19",
                y1: "15",
                y2: "15"
            })
        ]
    }));
};
const Eraser = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m7 21-4.3-4.3c-1-1-1-2.5 0-3.4l9.6-9.6c1-1 2.5-1 3.4 0l5.6 5.6c1 1 1 2.5 0 3.4L13 21"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 21H7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m5 11 9 9"
            })
        ]
    }));
};
const Euro = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 10h12"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 14h9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19 6a7.7 7.7 0 0 0-5.2-2A7.9 7.9 0 0 0 6 12c0 4.4 3.5 8 7.8 8 2 0 3.8-.8 5.2-2"
            })
        ]
    }));
};
const Expand = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m21 21-6-6m6 6v-4.8m0 4.8h-4.8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 16.2V21m0 0h4.8M3 21l6-6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 7.8V3m0 0h-4.8M21 3l-6 6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 7.8V3m0 0h4.8M3 3l6 6"
            })
        ]
    }));
};
const ExternalLink = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M15 3h6v6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 14 21 3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
            })
        ]
    }));
};
const EyeOff = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M9.88 9.88a3 3 0 1 0 4.24 4.24"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "2",
                x2: "22",
                y1: "2",
                y2: "22"
            })
        ]
    }));
};
const Eye = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "3"
            })
        ]
    }));
};
const Facebook = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"
        })
    }));
};
const Factory = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2 20a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8l-7 5V8l-7 5V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 18h1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 18h1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 18h1"
            })
        ]
    }));
};
const Fan = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M10.827 16.379a6.082 6.082 0 0 1-8.618-7.002l5.412 1.45a6.082 6.082 0 0 1 7.002-8.618l-1.45 5.412a6.082 6.082 0 0 1 8.618 7.002l-5.412-1.45a6.082 6.082 0 0 1-7.002 8.618l1.45-5.412Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 12v.01"
            })
        ]
    }));
};
const FastForward = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("polygon", {
                points: "13 19 22 12 13 5 13 19"
            }),
            /*#__PURE__*/ _jsx("polygon", {
                points: "2 19 11 12 2 5 2 19"
            })
        ]
    }));
};
const Feather = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M20.24 12.24a6 6 0 0 0-8.49-8.49L5 10.5V19h8.5z"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "16",
                x2: "2",
                y1: "8",
                y2: "22"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "17.5",
                x2: "9",
                y1: "15",
                y2: "15"
            })
        ]
    }));
};
const Fence = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 3 2 5v15c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V5Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 8h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 18h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m12 3-2 2v15c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V5Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 8h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 18h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m20 3-2 2v15c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V5Z"
            })
        ]
    }));
};
const FerrisWheel = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m6.8 15-3.5 2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m20.7 7-3.5 2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.8 9 3.3 7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m20.7 17-3.5-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9 22 3-8 3 8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 22h8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 18.7a9 9 0 1 0-12 0"
            })
        ]
    }));
};
const Figma = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M5 5.5A3.5 3.5 0 0 1 8.5 2H12v7H8.5A3.5 3.5 0 0 1 5 5.5z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2h3.5a3.5 3.5 0 1 1 0 7H12V2z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 12.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 1 1-7 0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 19.5A3.5 3.5 0 0 1 8.5 16H12v3.5a3.5 3.5 0 1 1-7 0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 12.5A3.5 3.5 0 0 1 8.5 9H12v7H8.5A3.5 3.5 0 0 1 5 12.5z"
            })
        ]
    }));
};
const FileArchive = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M16 22h2a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 2v4a2 2 0 0 0 2 2h4"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "10",
                cy: "20",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 7V6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 12v-1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 18v-2"
            })
        ]
    }));
};
const FileAudio2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 2v4a2 2 0 0 0 2 2h4"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "3",
                cy: "17",
                r: "1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 17v-3a4 4 0 0 1 8 0v3"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "9",
                cy: "17",
                r: "1"
            })
        ]
    }));
};
const FileAudio = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M17.5 22h.5a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 2v4a2 2 0 0 0 2 2h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 19a2 2 0 1 1 4 0v1a2 2 0 1 1-4 0v-4a6 6 0 0 1 12 0v4a2 2 0 1 1-4 0v-1a2 2 0 1 1 4 0"
            })
        ]
    }));
};
const FileAxis3D = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 2v4a2 2 0 0 0 2 2h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m8 18 4-4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 10v8h8"
            })
        ]
    }));
};
const FileBadge2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "10",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 2v4a2 2 0 0 0 2 2h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m14 12.5 1 5.5-3-1-3 1 1-5.5"
            })
        ]
    }));
};
const FileBadge = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 22h6a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 2v4a2 2 0 0 0 2 2h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 17a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 16.5 8 22l-3-1-3 1 1-5.5"
            })
        ]
    }));
};
const FileBarChart2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 2v4a2 2 0 0 0 2 2h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 18v-1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 18v-6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 18v-3"
            })
        ]
    }));
};
const FileBarChart = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 2v4a2 2 0 0 0 2 2h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 18v-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 18v-4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 18v-6"
            })
        ]
    }));
};
const FileBox = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M14.5 22H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 2v4a2 2 0 0 0 2 2h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 13.1a2 2 0 0 0-1 1.76v3.24a2 2 0 0 0 .97 1.78L6 21.7a2 2 0 0 0 2.03.01L11 19.9a2 2 0 0 0 1-1.76V14.9a2 2 0 0 0-.97-1.78L8 11.3a2 2 0 0 0-2.03-.01Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 17v5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11.7 14.2 7 17l-4.7-2.8"
            })
        ]
    }));
};
const FileCheck2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 2v4a2 2 0 0 0 2 2h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m3 15 2 2 4-4"
            })
        ]
    }));
};
const FileCheck = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 2v4a2 2 0 0 0 2 2h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9 15 2 2 4-4"
            })
        ]
    }));
};
const FileClock = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M16 22h2a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 2v4a2 2 0 0 0 2 2h4"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "8",
                cy: "16",
                r: "6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.5 17.5 8 16.25V14"
            })
        ]
    }));
};
const FileCode2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 2v4a2 2 0 0 0 2 2h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m5 12-3 3 3 3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9 18 3-3-3-3"
            })
        ]
    }));
};
const FileCode = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 2v4a2 2 0 0 0 2 2h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m10 13-2 2 2 2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m14 17 2-2-2-2"
            })
        ]
    }));
};
const FileCog = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 2v4a2 2 0 0 0 2 2h4"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "6",
                cy: "14",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 10v1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 17v1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 14H9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 14H2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9 11-.88.88"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3.88 16.12 3 17"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9 17-.88-.88"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3.88 11.88 3 11"
            })
        ]
    }));
};
const FileDiff = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 10h6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 13V7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 17h6"
            })
        ]
    }));
};
const FileDigit = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 2v4a2 2 0 0 0 2 2h4"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "4",
                height: "6",
                x: "2",
                y: "12",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 12h2v6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 18h4"
            })
        ]
    }));
};
const FileDown = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 2v4a2 2 0 0 0 2 2h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 18v-6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9 15 3 3 3-3"
            })
        ]
    }));
};
const FileHeart = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 2v4a2 2 0 0 0 2 2h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10.29 10.7a2.43 2.43 0 0 0-2.66-.52c-.29.12-.56.3-.78.53l-.35.34-.35-.34a2.43 2.43 0 0 0-2.65-.53c-.3.12-.56.3-.79.53-.95.94-1 2.53.2 3.74L6.5 18l3.6-3.55c1.2-1.21 1.14-2.8.19-3.74Z"
            })
        ]
    }));
};
const FileImage = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 2v4a2 2 0 0 0 2 2h4"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "10",
                cy: "12",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m20 17-1.296-1.296a2.41 2.41 0 0 0-3.408 0L9 22"
            })
        ]
    }));
};
const FileInput = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 2v4a2 2 0 0 0 2 2h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 15h10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9 18 3-3-3-3"
            })
        ]
    }));
};
const FileJson2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 2v4a2 2 0 0 0 2 2h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 12a1 1 0 0 0-1 1v1a1 1 0 0 1-1 1 1 1 0 0 1 1 1v1a1 1 0 0 0 1 1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 18a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1 1 1 0 0 1-1-1v-1a1 1 0 0 0-1-1"
            })
        ]
    }));
};
const FileJson = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 2v4a2 2 0 0 0 2 2h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 12a1 1 0 0 0-1 1v1a1 1 0 0 1-1 1 1 1 0 0 1 1 1v1a1 1 0 0 0 1 1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 18a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1 1 1 0 0 1-1-1v-1a1 1 0 0 0-1-1"
            })
        ]
    }));
};
const FileKey2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 2v4a2 2 0 0 0 2 2h4"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "4",
                cy: "16",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m10 10-4.5 4.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9 11 1 1"
            })
        ]
    }));
};
const FileKey = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "10",
                cy: "16",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m16 10-4.5 4.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m15 11 1 1"
            })
        ]
    }));
};
const FileLineChart = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 2v4a2 2 0 0 0 2 2h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m16 13-3.5 3.5-2-2L8 17"
            })
        ]
    }));
};
const FileLock2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 2v4a2 2 0 0 0 2 2h4"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "8",
                height: "5",
                x: "2",
                y: "13",
                rx: "1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 13v-2a2 2 0 1 0-4 0v2"
            })
        ]
    }));
};
const FileLock = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "8",
                height: "6",
                x: "8",
                y: "12",
                rx: "1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 12v-2a2 2 0 1 1 4 0v2"
            })
        ]
    }));
};
const FileMinus2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 2v4a2 2 0 0 0 2 2h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 15h6"
            })
        ]
    }));
};
const FileMinus = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 2v4a2 2 0 0 0 2 2h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 15h6"
            })
        ]
    }));
};
const FileMusic = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "14",
                cy: "16",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "6",
                cy: "18",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 12.4V4a2 2 0 0 1 2-2h8.5L20 7.5V20a2 2 0 0 1-2 2h-7.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 18v-7.7L16 9v7"
            })
        ]
    }));
};
const FileOutput = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M14 2v4a2 2 0 0 0 2 2h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 7V4a2 2 0 0 1 2-2 2 2 0 0 0-2 2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4.063 20.999a2 2 0 0 0 2 1L18 22a2 2 0 0 0 2-2V7l-5-5H6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m5 11-3 3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m5 17-3-3h10"
            })
        ]
    }));
};
const FilePenLine = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m18 5-3-3H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 18h1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18.4 9.6a2 2 0 1 1 3 3L17 17l-4 1 1-4Z"
            })
        ]
    }));
};
const FilePen = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 22h6a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 2v4a2 2 0 0 0 2 2h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10.4 12.6a2 2 0 1 1 3 3L8 21l-4 1 1-4Z"
            })
        ]
    }));
};
const FilePieChart = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M16 22h2a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 2v4a2 2 0 0 0 2 2h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 11.5a6.02 6.02 0 1 0 8.5 8.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 16c0-3.3-2.7-6-6-6v6Z"
            })
        ]
    }));
};
const FilePlus2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 2v4a2 2 0 0 0 2 2h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 15h6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 12v6"
            })
        ]
    }));
};
const FilePlus = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 2v4a2 2 0 0 0 2 2h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 15h6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 18v-6"
            })
        ]
    }));
};
const FileQuestion = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 10.3c.2-.4.5-.8.9-1a2.1 2.1 0 0 1 2.6.4c.3.4.5.8.5 1.3 0 1.3-2 2-2 2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 17h.01"
            })
        ]
    }));
};
const FileScan = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M20 10V7l-5-5H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 2v4a2 2 0 0 0 2 2h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 14a2 2 0 0 0-2 2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 14a2 2 0 0 1 2 2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 22a2 2 0 0 0 2-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 22a2 2 0 0 1-2-2"
            })
        ]
    }));
};
const FileSearch2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 2v4a2 2 0 0 0 2 2h4"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "11.5",
                cy: "14.5",
                r: "2.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13.3 16.3 15 18"
            })
        ]
    }));
};
const FileSearch = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 2v4a2 2 0 0 0 2 2h4"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "5",
                cy: "14",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9 18-1.5-1.5"
            })
        ]
    }));
};
const FileSliders = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 2v4a2 2 0 0 0 2 2h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 12h8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 11v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 17h8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 16v2"
            })
        ]
    }));
};
const FileSpreadsheet = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 2v4a2 2 0 0 0 2 2h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 13h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 13h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 17h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 17h2"
            })
        ]
    }));
};
const FileStack = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M21 7h-3a2 2 0 0 1-2-2V2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 6v6.5c0 .8-.7 1.5-1.5 1.5h-7c-.8 0-1.5-.7-1.5-1.5v-9c0-.8.7-1.5 1.5-1.5H17Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 8v8.8c0 .3.2.6.4.8.2.2.5.4.8.4H15"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 12v8.8c0 .3.2.6.4.8.2.2.5.4.8.4H11"
            })
        ]
    }));
};
const FileSymlink = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m10 18 3-3-3-3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 2v4a2 2 0 0 0 2 2h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 11V4a2 2 0 0 1 2-2h9l5 5v13a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h7"
            })
        ]
    }));
};
const FileTerminal = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 2v4a2 2 0 0 0 2 2h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m8 16 2-2-2-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 18h4"
            })
        ]
    }));
};
const FileText = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 2v4a2 2 0 0 0 2 2h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 9H8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 13H8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 17H8"
            })
        ]
    }));
};
const FileType2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 2v4a2 2 0 0 0 2 2h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 13v-1h6v1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 12v6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 18h2"
            })
        ]
    }));
};
const FileType = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 2v4a2 2 0 0 0 2 2h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 13v-1h6v1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 12v6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11 18h2"
            })
        ]
    }));
};
const FileUp = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 2v4a2 2 0 0 0 2 2h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 12v6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m15 15-3-3-3 3"
            })
        ]
    }));
};
const FileVideo2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 2v4a2 2 0 0 0 2 2h4"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "8",
                height: "6",
                x: "2",
                y: "12",
                rx: "1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m10 15.5 4 2.5v-6l-4 2.5"
            })
        ]
    }));
};
const FileVideo = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 2v4a2 2 0 0 0 2 2h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m10 11 5 3-5 3v-6Z"
            })
        ]
    }));
};
const FileVolume2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 2v4a2 2 0 0 0 2 2h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 15h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11.5 13.5a2.5 2.5 0 0 1 0 3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 12a5 5 0 0 1 0 6"
            })
        ]
    }));
};
const FileVolume = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 2v4a2 2 0 0 0 2 2h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m7 10-3 2H2v4h2l3 2Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11 11a5 5 0 0 1 0 6"
            })
        ]
    }));
};
const FileWarning = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 9v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 17h.01"
            })
        ]
    }));
};
const FileX2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 2v4a2 2 0 0 0 2 2h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m8 12.5-5 5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m3 12.5 5 5"
            })
        ]
    }));
};
const FileX = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 2v4a2 2 0 0 0 2 2h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m14.5 12.5-5 5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9.5 12.5 5 5"
            })
        ]
    }));
};
const File = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 2v4a2 2 0 0 0 2 2h4"
            })
        ]
    }));
};
const Files = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M20 7h-3a2 2 0 0 1-2-2V2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 18a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h7l4 4v10a2 2 0 0 1-2 2Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 7.6v12.8A1.6 1.6 0 0 0 4.6 22h9.8"
            })
        ]
    }));
};
const Film = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 3v18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 7.5h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 12h18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 16.5h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 3v18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 7.5h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 16.5h4"
            })
        ]
    }));
};
const FilterX = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M13.013 3H2l8 9.46V19l4 2v-8.54l.9-1.055"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m22 3-5 5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m17 3 5 5"
            })
        ]
    }));
};
const Filter = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("polygon", {
            points: "22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"
        })
    }));
};
const Fingerprint = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2 12C2 6.5 6.5 2 12 2a10 10 0 0 1 8 4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 19.5C5.5 18 6 15 6 12c0-.7.12-1.37.34-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17.29 21.02c.12-.6.43-2.3.5-3.02"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 10a2 2 0 0 0-2 2c0 1.02-.1 2.51-.26 4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8.65 22c.21-.66.45-1.32.57-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 13.12c0 2.38 0 6.38-1 8.88"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 16h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21.8 16c.2-2 .131-5.354 0-6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 6.8a6 6 0 0 1 9 5.2c0 .47 0 1.17-.02 2"
            })
        ]
    }));
};
const FireExtinguisher = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M15 6.5V3a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v3.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 18h8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 3h-3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11 3a6 6 0 0 0-6 6v11"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 13h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 10a4 4 0 0 0-8 0v10a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2Z"
            })
        ]
    }));
};
const FishOff = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M18 12.47v.03m0-.5v.47m-.475 5.056A6.744 6.744 0 0 1 15 18c-3.56 0-7.56-2.53-8.5-6 .348-1.28 1.114-2.433 2.121-3.38m3.444-2.088A8.802 8.802 0 0 1 15 6c3.56 0 6.06 2.54 7 6-.309 1.14-.786 2.177-1.413 3.058"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 10.67C7 8 5.58 5.97 2.73 5.5c-1 1.5-1 5 .23 6.5-1.24 1.5-1.24 5-.23 6.5C5.58 18.03 7 16 7 13.33m7.48-4.372A9.77 9.77 0 0 1 16 6.07m0 11.86a9.77 9.77 0 0 1-1.728-3.618"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m16.01 17.93-.23 1.4A2 2 0 0 1 13.8 21H9.5a5.96 5.96 0 0 0 1.49-3.98M8.53 3h5.27a2 2 0 0 1 1.98 1.67l.23 1.4M2 2l20 20"
            })
        ]
    }));
};
const FishSymbol = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M2 16s9-15 20-4C11 23 2 8 2 8"
        })
    }));
};
const Fish = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M6.5 12c.94-3.46 4.94-6 8.5-6 3.56 0 6.06 2.54 7 6-.94 3.47-3.44 6-7 6s-7.56-2.53-8.5-6Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 12v.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 17.93a9.77 9.77 0 0 1 0-11.86"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 10.67C7 8 5.58 5.97 2.73 5.5c-1 1.5-1 5 .23 6.5-1.24 1.5-1.24 5-.23 6.5C5.58 18.03 7 16 7 13.33"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10.46 7.26C10.2 5.88 9.17 4.24 8 3h5.8a2 2 0 0 1 1.98 1.67l.23 1.4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m16.01 17.93-.23 1.4A2 2 0 0 1 13.8 21H9.5a5.96 5.96 0 0 0 1.49-3.98"
            })
        ]
    }));
};
const FlagOff = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M8 2c3 0 5 2 8 2s4-1 4-1v11"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 22V4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 15s1-1 4-1 5 2 8 2"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "2",
                x2: "22",
                y1: "2",
                y2: "22"
            })
        ]
    }));
};
const FlagTriangleLeft = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M17 22V2L7 7l10 5"
        })
    }));
};
const FlagTriangleRight = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M7 22V2l10 5-10 5"
        })
    }));
};
const Flag = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "4",
                x2: "4",
                y1: "22",
                y2: "15"
            })
        ]
    }));
};
const FlameKindling = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2c1 3 2.5 3.5 3.5 4.5A5 5 0 0 1 17 10a5 5 0 1 1-10 0c0-.3 0-.6.1-.9a2 2 0 1 0 3.3-2C8 4.5 11 2 12 2Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m5 22 14-4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m5 18 14 4"
            })
        ]
    }));
};
const Flame = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z"
        })
    }));
};
const FlashlightOff = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M16 16v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V10c0-2-2-2-2-4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 2h11v4c0 2-2 2-2 4v1"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "11",
                x2: "18",
                y1: "6",
                y2: "6"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "2",
                x2: "22",
                y1: "2",
                y2: "22"
            })
        ]
    }));
};
const Flashlight = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M18 6c0 2-2 2-2 4v10a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V10c0-2-2-2-2-4V2h12z"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "6",
                x2: "18",
                y1: "6",
                y2: "6"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "12",
                y1: "12",
                y2: "12"
            })
        ]
    }));
};
const FlaskConicalOff = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M10 10 4.72 20.55a1 1 0 0 0 .9 1.45h12.76a1 1 0 0 0 .9-1.45l-1.272-2.542"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 2v2.343"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 2v6.343"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8.5 2h7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 16h9"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "2",
                x2: "22",
                y1: "2",
                y2: "22"
            })
        ]
    }));
};
const FlaskConical = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M10 2v7.527a2 2 0 0 1-.211.896L4.72 20.55a1 1 0 0 0 .9 1.45h12.76a1 1 0 0 0 .9-1.45l-5.069-10.127A2 2 0 0 1 14 9.527V2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8.5 2h7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 16h10"
            })
        ]
    }));
};
const FlaskRound = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M10 2v7.31"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 9.3V1.99"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8.5 2h7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 9.3a6.5 6.5 0 1 1-4 0"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5.52 16h12.96"
            })
        ]
    }));
};
const FlipHorizontal2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m3 7 5 5-5 5V7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m21 7-5 5 5 5V7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 20v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 14v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 8v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2v2"
            })
        ]
    }));
};
const FlipHorizontal = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M8 3H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 3h3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 20v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 14v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 8v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2v2"
            })
        ]
    }));
};
const FlipVertical2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m17 3-5 5-5-5h10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m17 21-5-5-5 5h10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 12H2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 12H8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 12h-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 12h-2"
            })
        ]
    }));
};
const FlipVertical = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M21 8V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 16v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 12H2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 12H8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 12h-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 12h-2"
            })
        ]
    }));
};
const Flower2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 5a3 3 0 1 1 3 3m-3-3a3 3 0 1 0-3 3m3-3v1M9 8a3 3 0 1 0 3 3M9 8h1m5 0a3 3 0 1 1-3 3m3-3h-1m-2 3v-1"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "8",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 10v12"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 22c4.2 0 7-1.667 7-5-4.2 0-7 1.667-7 5Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 22c-4.2 0-7-1.667-7-5 4.2 0 7 1.667 7 5Z"
            })
        ]
    }));
};
const Flower = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 16.5A4.5 4.5 0 1 1 7.5 12 4.5 4.5 0 1 1 12 7.5a4.5 4.5 0 1 1 4.5 4.5 4.5 4.5 0 1 1-4.5 4.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 7.5V9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7.5 12H9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16.5 12H15"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 16.5V15"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m8 8 1.88 1.88"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14.12 9.88 16 8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m8 16 1.88-1.88"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14.12 14.12 16 16"
            })
        ]
    }));
};
const Focus = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 7V5a2 2 0 0 1 2-2h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 3h2a2 2 0 0 1 2 2v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 17v2a2 2 0 0 1-2 2h-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 21H5a2 2 0 0 1-2-2v-2"
            })
        ]
    }));
};
const FoldHorizontal = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2 12h6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 12h-6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 8v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 14v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 20v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m19 9-3 3 3 3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m5 15 3-3-3-3"
            })
        ]
    }));
};
const FoldVertical = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 22v-6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 8V2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 12H2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 12H8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 12h-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 12h-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m15 19-3-3-3 3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m15 5-3 3-3-3"
            })
        ]
    }));
};
const FolderArchive = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "15",
                cy: "19",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20.9 19.8A2 2 0 0 0 22 18V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h5.1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 11v-1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 17v-2"
            })
        ]
    }));
};
const FolderCheck = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9 13 2 2 4-4"
            })
        ]
    }));
};
const FolderClock = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "16",
                cy: "16",
                r: "6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 14v2l1 1"
            })
        ]
    }));
};
const FolderClosed = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 10h20"
            })
        ]
    }));
};
const FolderCog = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "18",
                cy: "18",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10.3 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v3.3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m21.7 19.4-.9-.3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m15.2 16.9-.9-.3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m16.6 21.7.3-.9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m19.1 15.2.3-.9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m19.6 21.7-.4-1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m16.8 15.3-.4-1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m14.3 19.6 1-.4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m20.7 16.8 1-.4"
            })
        ]
    }));
};
const FolderDot = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "13",
                r: "1"
            })
        ]
    }));
};
const FolderDown = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 10v6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m15 13-3 3-3-3"
            })
        ]
    }));
};
const FolderGit2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M9 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v5"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "13",
                cy: "12",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 19c-2.8 0-5-2.2-5-5v8"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "20",
                cy: "19",
                r: "2"
            })
        ]
    }));
};
const FolderGit = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "13",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 13h3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 13h3"
            })
        ]
    }));
};
const FolderHeart = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M11 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v1.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13.9 17.45c-1.2-1.2-1.14-2.8-.2-3.73a2.43 2.43 0 0 1 3.44 0l.36.34.34-.34a2.43 2.43 0 0 1 3.45-.01v0c.95.95 1 2.53-.2 3.74L17.5 21Z"
            })
        ]
    }));
};
const FolderInput = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2 9V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 13h10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9 16 3-3-3-3"
            })
        ]
    }));
};
const FolderKanban = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 10v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 10v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 10v6"
            })
        ]
    }));
};
const FolderKey = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "16",
                cy: "20",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m22 14-4.5 4.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m21 15 1 1"
            })
        ]
    }));
};
const FolderLock = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "8",
                height: "5",
                x: "14",
                y: "17",
                rx: "1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v2.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 17v-2a2 2 0 1 0-4 0v2"
            })
        ]
    }));
};
const FolderMinus = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M9 13h6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z"
            })
        ]
    }));
};
const FolderOpenDot = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m6 14 1.45-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.55 6a2 2 0 0 1-1.94 1.5H4a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h3.93a2 2 0 0 1 1.66.9l.82 1.2a2 2 0 0 0 1.66.9H18a2 2 0 0 1 2 2v2"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "14",
                cy: "15",
                r: "1"
            })
        ]
    }));
};
const FolderOpen = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "m6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2"
        })
    }));
};
const FolderOutput = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2 7.5V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-1.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 13h10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m5 10-3 3 3 3"
            })
        ]
    }));
};
const FolderPen = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M8.4 10.6a2 2 0 0 1 3 3L6 19l-4 1 1-4Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 11.5V5a2 2 0 0 1 2-2h3.9c.7 0 1.3.3 1.7.9l.8 1.2c.4.6 1 .9 1.7.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-9.5"
            })
        ]
    }));
};
const FolderPlus = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 10v6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 13h6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z"
            })
        ]
    }));
};
const FolderRoot = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "13",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 15v5"
            })
        ]
    }));
};
const FolderSearch2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "11.5",
                cy: "12.5",
                r: "2.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13.3 14.3 15 16"
            })
        ]
    }));
};
const FolderSearch = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "17",
                cy: "17",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10.7 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v4.1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m21 21-1.5-1.5"
            })
        ]
    }));
};
const FolderSymlink = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2 9V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m8 16 3-3-3-3"
            })
        ]
    }));
};
const FolderSync = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M9 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 10v4h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m12 14 1.535-1.605a5 5 0 0 1 8 1.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 22v-4h-4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m22 18-1.535 1.605a5 5 0 0 1-8-1.5"
            })
        ]
    }));
};
const FolderTree = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M20 10a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-2.5a1 1 0 0 1-.8-.4l-.9-1.2A1 1 0 0 0 15 3h-2a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 21a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-2.9a1 1 0 0 1-.88-.55l-.42-.85a1 1 0 0 0-.92-.6H13a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 5a2 2 0 0 0 2 2h3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 3v13a2 2 0 0 0 2 2h3"
            })
        ]
    }));
};
const FolderUp = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 10v6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9 13 3-3 3 3"
            })
        ]
    }));
};
const FolderX = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9.5 10.5 5 5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m14.5 10.5-5 5"
            })
        ]
    }));
};
const Folder = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z"
        })
    }));
};
const Folders = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M20 17a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3.9a2 2 0 0 1-1.69-.9l-.81-1.2a2 2 0 0 0-1.67-.9H8a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 8v11a2 2 0 0 0 2 2h14"
            })
        ]
    }));
};
const Footprints = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 16v-2.38C4 11.5 2.97 10.5 3 8c.03-2.72 1.49-6 4.5-6C9.37 2 10 3.8 10 5.5c0 3.11-2 5.66-2 8.68V16a2 2 0 1 1-4 0Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 20v-2.38c0-2.12 1.03-3.12 1-5.62-.03-2.72-1.49-6-4.5-6C14.63 6 14 7.8 14 9.5c0 3.11 2 5.66 2 8.68V20a2 2 0 1 0 4 0Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 17h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 13h4"
            })
        ]
    }));
};
const Forklift = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 12H5a2 2 0 0 0-2 2v5"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "13",
                cy: "19",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "5",
                cy: "19",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 19h3m5-17v17h6M6 12V7c0-1.1.9-2 2-2h3l5 5"
            })
        ]
    }));
};
const FormInput = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "20",
                height: "12",
                x: "2",
                y: "6",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 12h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 12h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 12h.01"
            })
        ]
    }));
};
const Forward = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("polyline", {
                points: "15 17 20 12 15 7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 18v-2a4 4 0 0 1 4-4h12"
            })
        ]
    }));
};
const Frame = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("line", {
                x1: "22",
                x2: "2",
                y1: "6",
                y2: "6"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "22",
                x2: "2",
                y1: "18",
                y2: "18"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "6",
                x2: "6",
                y1: "2",
                y2: "22"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "18",
                x2: "18",
                y1: "2",
                y2: "22"
            })
        ]
    }));
};
const Framer = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M5 16V9h14V2H5l14 14h-7m-7 0 7 7v-7m-7 0h7"
        })
    }));
};
const Frown = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 16s-1.5-2-4-2-4 2-4 2"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "9",
                x2: "9.01",
                y1: "9",
                y2: "9"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "15",
                x2: "15.01",
                y1: "9",
                y2: "9"
            })
        ]
    }));
};
const Fuel = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("line", {
                x1: "3",
                x2: "15",
                y1: "22",
                y2: "22"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "4",
                x2: "14",
                y1: "9",
                y2: "9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 22V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 13h2a2 2 0 0 1 2 2v2a2 2 0 0 0 2 2h0a2 2 0 0 0 2-2V9.83a2 2 0 0 0-.59-1.42L18 5"
            })
        ]
    }));
};
const Fullscreen = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3 7V5a2 2 0 0 1 2-2h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 3h2a2 2 0 0 1 2 2v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 17v2a2 2 0 0 1-2 2h-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 21H5a2 2 0 0 1-2-2v-2"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "10",
                height: "8",
                x: "7",
                y: "8",
                rx: "1"
            })
        ]
    }));
};
const FunctionSquare = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2",
                ry: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 17c2 0 2.8-1 2.8-2.8V10c0-2 1-3.3 3.2-3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 11.2h5.7"
            })
        ]
    }));
};
const GalleryHorizontalEnd = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2 7v10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 5v14"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "12",
                height: "18",
                x: "10",
                y: "3",
                rx: "2"
            })
        ]
    }));
};
const GalleryHorizontal = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2 3v18"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "12",
                height: "18",
                x: "6",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 3v18"
            })
        ]
    }));
};
const GalleryThumbnails = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "14",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 21h1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 21h1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 21h1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19 21h1"
            })
        ]
    }));
};
const GalleryVerticalEnd = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M7 2h10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 6h14"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "12",
                x: "3",
                y: "10",
                rx: "2"
            })
        ]
    }));
};
const GalleryVertical = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3 2h18"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "12",
                x: "3",
                y: "6",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 22h18"
            })
        ]
    }));
};
const Gamepad2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("line", {
                x1: "6",
                x2: "10",
                y1: "11",
                y2: "11"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "8",
                x2: "8",
                y1: "9",
                y2: "13"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "15",
                x2: "15.01",
                y1: "12",
                y2: "12"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "18",
                x2: "18.01",
                y1: "10",
                y2: "10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17.32 5H6.68a4 4 0 0 0-3.978 3.59c-.006.052-.01.101-.017.152C2.604 9.416 2 14.456 2 16a3 3 0 0 0 3 3c1 0 1.5-.5 2-1l1.414-1.414A2 2 0 0 1 9.828 16h4.344a2 2 0 0 1 1.414.586L17 18c.5.5 1 1 2 1a3 3 0 0 0 3-3c0-1.545-.604-6.584-.685-7.258-.007-.05-.011-.1-.017-.151A4 4 0 0 0 17.32 5z"
            })
        ]
    }));
};
const Gamepad = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("line", {
                x1: "6",
                x2: "10",
                y1: "12",
                y2: "12"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "8",
                x2: "8",
                y1: "10",
                y2: "14"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "15",
                x2: "15.01",
                y1: "13",
                y2: "13"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "18",
                x2: "18.01",
                y1: "11",
                y2: "11"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "20",
                height: "12",
                x: "2",
                y: "6",
                rx: "2"
            })
        ]
    }));
};
const GanttChartSquare = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 8h7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 12h6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11 16h5"
            })
        ]
    }));
};
const GanttChart = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M8 6h10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 12h9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11 18h7"
            })
        ]
    }));
};
const GaugeCircle = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M15.6 2.7a10 10 0 1 0 5.7 5.7"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13.4 10.6 19 5"
            })
        ]
    }));
};
const Gauge = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m12 14 4-4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3.34 19a10 10 0 1 1 17.32 0"
            })
        ]
    }));
};
const Gavel = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m14.5 12.5-8 8a2.119 2.119 0 1 1-3-3l8-8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m16 16 6-6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m8 8 6-6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9 7 8 8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m21 11-8-8"
            })
        ]
    }));
};
const Gem = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M6 3h12l4 6-10 13L2 9Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11 3 8 9l4 13 4-13-3-6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 9h20"
            })
        ]
    }));
};
const Ghost = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M9 10h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 10h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2a8 8 0 0 0-8 8v12l3-3 2.5 2.5L12 19l2.5 2.5L17 19l3 3V10a8 8 0 0 0-8-8z"
            })
        ]
    }));
};
const Gift = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                x: "3",
                y: "8",
                width: "18",
                height: "4",
                rx: "1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 8v13"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5"
            })
        ]
    }));
};
const GitBranchPlus = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M6 3v12"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 21a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 6a9 9 0 0 0-9 9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 15v6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 18h-6"
            })
        ]
    }));
};
const GitBranch = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("line", {
                x1: "6",
                x2: "6",
                y1: "3",
                y2: "15"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "18",
                cy: "6",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "6",
                cy: "18",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 9a9 9 0 0 1-9 9"
            })
        ]
    }));
};
const GitCommitHorizontal = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "3",
                x2: "9",
                y1: "12",
                y2: "12"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "15",
                x2: "21",
                y1: "12",
                y2: "12"
            })
        ]
    }));
};
const GitCommitVertical = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 3v6"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 15v6"
            })
        ]
    }));
};
const GitCompareArrows = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "5",
                cy: "6",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 6h5a2 2 0 0 1 2 2v7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m15 9-3-3 3-3"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "19",
                cy: "18",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 18H7a2 2 0 0 1-2-2V9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9 15 3 3-3 3"
            })
        ]
    }));
};
const GitCompare = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "18",
                cy: "18",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "6",
                cy: "6",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13 6h3a2 2 0 0 1 2 2v7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11 18H8a2 2 0 0 1-2-2V9"
            })
        ]
    }));
};
const GitFork = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "18",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "6",
                cy: "6",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "18",
                cy: "6",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 9v2c0 .6-.4 1-1 1H7c-.6 0-1-.4-1-1V9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 12v3"
            })
        ]
    }));
};
const GitGraph = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "5",
                cy: "6",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 9v6"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "5",
                cy: "18",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 3v18"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "19",
                cy: "6",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 15.7A9 9 0 0 0 19 9"
            })
        ]
    }));
};
const GitMerge = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "18",
                cy: "18",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "6",
                cy: "6",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 21V9a9 9 0 0 0 9 9"
            })
        ]
    }));
};
const GitPullRequestArrow = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "5",
                cy: "6",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 9v12"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "19",
                cy: "18",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m15 9-3-3 3-3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 6h5a2 2 0 0 1 2 2v7"
            })
        ]
    }));
};
const GitPullRequestClosed = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "6",
                cy: "6",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 9v12"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m21 3-6 6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m21 9-6-6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 11.5V15"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "18",
                cy: "18",
                r: "3"
            })
        ]
    }));
};
const GitPullRequestCreateArrow = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "5",
                cy: "6",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 9v12"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m15 9-3-3 3-3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 6h5a2 2 0 0 1 2 2v3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19 15v6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 18h-6"
            })
        ]
    }));
};
const GitPullRequestCreate = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "6",
                cy: "6",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 9v12"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13 6h3a2 2 0 0 1 2 2v3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 15v6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 18h-6"
            })
        ]
    }));
};
const GitPullRequestDraft = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "18",
                cy: "18",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "6",
                cy: "6",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 6V5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 11v-1"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "6",
                x2: "6",
                y1: "9",
                y2: "21"
            })
        ]
    }));
};
const GitPullRequest = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "18",
                cy: "18",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "6",
                cy: "6",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13 6h3a2 2 0 0 1 2 2v7"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "6",
                x2: "6",
                y1: "9",
                y2: "21"
            })
        ]
    }));
};
const Github = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M15 22v-4a4.8 4.8 0 0 0-1-3.5c3 0 6-2 6-5.5.08-1.25-.27-2.48-1-3.5.28-1.15.28-2.35 0-3.5 0 0-1 0-3 1.5-2.64-.5-5.36-.5-8 0C6 2 5 2 5 2c-.3 1.15-.3 2.35 0 3.5A5.403 5.403 0 0 0 4 9c0 3.5 3 5.5 6 5.5-.39.49-.68 1.05-.85 1.65-.17.6-.22 1.23-.15 1.85v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 18c-4.51 2-5-2-7-2"
            })
        ]
    }));
};
const Gitlab = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "m22 13.29-3.33-10a.42.42 0 0 0-.14-.18.38.38 0 0 0-.22-.11.39.39 0 0 0-.23.07.42.42 0 0 0-.14.18l-2.26 6.67H8.32L6.1 3.26a.42.42 0 0 0-.1-.18.38.38 0 0 0-.26-.08.39.39 0 0 0-.23.07.42.42 0 0 0-.14.18L2 13.29a.74.74 0 0 0 .27.83L12 21l9.69-6.88a.71.71 0 0 0 .31-.83Z"
        })
    }));
};
const GlassWater = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M15.2 22H8.8a2 2 0 0 1-2-1.79L5 3h14l-1.81 17.21A2 2 0 0 1 15.2 22Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 12a5 5 0 0 1 6 0 5 5 0 0 0 6 0"
            })
        ]
    }));
};
const Glasses = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "6",
                cy: "15",
                r: "4"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "18",
                cy: "15",
                r: "4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 15a2 2 0 0 0-2-2 2 2 0 0 0-2 2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2.5 13 5 7c.7-1.3 1.4-2 3-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21.5 13 19 7c-.7-1.3-1.5-2-3-2"
            })
        ]
    }));
};
const Globe2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M21.54 15H17a2 2 0 0 0-2 2v4.54"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 3.34V5a3 3 0 0 0 3 3v0a2 2 0 0 1 2 2v0c0 1.1.9 2 2 2v0a2 2 0 0 0 2-2v0c0-1.1.9-2 2-2h3.17"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11 21.95V18a2 2 0 0 0-2-2v0a2 2 0 0 1-2-2v-1a2 2 0 0 0-2-2H2.05"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            })
        ]
    }));
};
const Globe = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 12h20"
            })
        ]
    }));
};
const Goal = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 13V2l8 4-8 4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20.55 10.23A9 9 0 1 1 8 4.94"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 10a5 5 0 1 0 8.9 2.02"
            })
        ]
    }));
};
const Grab = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M18 11.5V9a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v1.4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 10V8a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 9.9V9a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 14v0a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v0"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 11v0a2 2 0 1 1 4 0v3a8 8 0 0 1-8 8h-4a8 8 0 0 1-8-8 2 2 0 1 1 4 0"
            })
        ]
    }));
};
const GraduationCap = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M21.42 10.922a1 1 0 0 0-.019-1.838L12.83 5.18a2 2 0 0 0-1.66 0L2.6 9.08a1 1 0 0 0 0 1.832l8.57 3.908a2 2 0 0 0 1.66 0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 10v6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 12.5V16a6 3 0 0 0 12 0v-3.5"
            })
        ]
    }));
};
const Grape = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M22 5V2l-5.89 5.89"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "16.6",
                cy: "15.89",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "8.11",
                cy: "7.4",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12.35",
                cy: "11.65",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "13.91",
                cy: "5.85",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "18.15",
                cy: "10.09",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "6.56",
                cy: "13.2",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "10.8",
                cy: "17.44",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "5",
                cy: "19",
                r: "3"
            })
        ]
    }));
};
const Grid2X2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 12h18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 3v18"
            })
        ]
    }));
};
const Grid3X3 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 9h18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 15h18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 3v18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 3v18"
            })
        ]
    }));
};
const GripHorizontal = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "9",
                r: "1"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "19",
                cy: "9",
                r: "1"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "5",
                cy: "9",
                r: "1"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "15",
                r: "1"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "19",
                cy: "15",
                r: "1"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "5",
                cy: "15",
                r: "1"
            })
        ]
    }));
};
const GripVertical = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "9",
                cy: "12",
                r: "1"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "9",
                cy: "5",
                r: "1"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "9",
                cy: "19",
                r: "1"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "15",
                cy: "12",
                r: "1"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "15",
                cy: "5",
                r: "1"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "15",
                cy: "19",
                r: "1"
            })
        ]
    }));
};
const Grip = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "5",
                r: "1"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "19",
                cy: "5",
                r: "1"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "5",
                cy: "5",
                r: "1"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "1"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "19",
                cy: "12",
                r: "1"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "5",
                cy: "12",
                r: "1"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "19",
                r: "1"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "19",
                cy: "19",
                r: "1"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "5",
                cy: "19",
                r: "1"
            })
        ]
    }));
};
const Group = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3 7V5c0-1.1.9-2 2-2h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 3h2c1.1 0 2 .9 2 2v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 17v2c0 1.1-.9 2-2 2h-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 21H5c-1.1 0-2-.9-2-2v-2"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "7",
                height: "5",
                x: "7",
                y: "7",
                rx: "1"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "7",
                height: "5",
                x: "10",
                y: "12",
                rx: "1"
            })
        ]
    }));
};
const Guitar = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m20 7 1.7-1.7a1 1 0 0 0 0-1.4l-1.6-1.6a1 1 0 0 0-1.4 0L17 4v3Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m17 7-5.1 5.1"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "11.5",
                cy: "12.5",
                r: ".5",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 12a2 2 0 0 0 1.8-1.2l.4-.9C8.7 8.8 9.8 8 11 8c2.8 0 5 2.2 5 5 0 1.2-.8 2.3-1.9 2.8l-.9.4A2 2 0 0 0 12 18a4 4 0 0 1-4 4c-3.3 0-6-2.7-6-6a4 4 0 0 1 4-4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m6 16 2 2"
            })
        ]
    }));
};
const Hammer = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m15 12-8.373 8.373a1 1 0 1 1-3-3L12 9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m18 15 4-4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m21.5 11.5-1.914-1.914A2 2 0 0 1 19 8.172V7l-2.26-2.26a6 6 0 0 0-4.202-1.756L9 2.96l.92.82A6.18 6.18 0 0 1 12 8.4V10l2 2h1.172a2 2 0 0 1 1.414.586L18.5 14.5"
            })
        ]
    }));
};
const HandCoins = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M11 15h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 17"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m7 21 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m2 16 6 6"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "16",
                cy: "9",
                r: "2.9"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "6",
                cy: "5",
                r: "3"
            })
        ]
    }));
};
const HandHeart = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M11 14h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 16"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m7 20 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m2 15 6 6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19.5 8.5c.7-.7 1.5-1.6 1.5-2.7A2.73 2.73 0 0 0 16 4a2.78 2.78 0 0 0-5 1.8c0 1.2.8 2 1.5 2.8L16 12Z"
            })
        ]
    }));
};
const HandHelping = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M11 12h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 14"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m7 18 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m2 13 6 6"
            })
        ]
    }));
};
const HandMetal = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M18 12.5V10a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v1.4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 11V9a2 2 0 1 0-4 0v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 10.5V5a2 2 0 1 0-4 0v9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m7 15-1.76-1.76a2 2 0 0 0-2.83 2.82l3.6 3.6C7.5 21.14 9.2 22 12 22h2a8 8 0 0 0 8-8V7a2 2 0 1 0-4 0v5"
            })
        ]
    }));
};
const HandPlatter = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 3V2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 10a7.1 7.1 0 0 1 14 0"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 10h16"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 14h12a2 2 0 1 1 0 4h-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m15.4 17.4 3.2-2.8a2 2 0 0 1 2.8 2.9l-3.6 3.3c-.7.8-1.7 1.2-2.8 1.2h-4c-1.1 0-2.1-.4-2.8-1.2L5 18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 14v7H2"
            })
        ]
    }));
};
const Hand = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M18 11V6a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v0"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 10V4a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 10.5V6a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 8a2 2 0 1 1 4 0v6a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15"
            })
        ]
    }));
};
const Handshake = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m11 17 2 2a1 1 0 1 0 3-3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m21 3 1 11h-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 3 2 14l6.5 6.5a1 1 0 1 0 3-3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 4h8"
            })
        ]
    }));
};
const HardDriveDownload = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2v8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m16 6-4 4-4-4"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "20",
                height: "8",
                x: "2",
                y: "14",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 18h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 18h.01"
            })
        ]
    }));
};
const HardDriveUpload = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m16 6-4-4-4 4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2v8"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "20",
                height: "8",
                x: "2",
                y: "14",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 18h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 18h.01"
            })
        ]
    }));
};
const HardDrive = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("line", {
                x1: "22",
                x2: "2",
                y1: "12",
                y2: "12"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "6",
                x2: "6.01",
                y1: "16",
                y2: "16"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "10",
                x2: "10.01",
                y1: "16",
                y2: "16"
            })
        ]
    }));
};
const HardHat = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2 18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v2z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 10V5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 15v-3a6 6 0 0 1 6-6h0"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 6h0a6 6 0 0 1 6 6v3"
            })
        ]
    }));
};
const Hash = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("line", {
                x1: "4",
                x2: "20",
                y1: "9",
                y2: "9"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "4",
                x2: "20",
                y1: "15",
                y2: "15"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "10",
                x2: "8",
                y1: "3",
                y2: "21"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "16",
                x2: "14",
                y1: "3",
                y2: "21"
            })
        ]
    }));
};
const Haze = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m5.2 6.2 1.4 1.4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 13h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 13h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m17.4 7.6 1.4-1.4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 17H2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 21H2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 13a4 4 0 0 0-8 0"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 5V2.5"
            })
        ]
    }));
};
const HdmiPort = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M22 9a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h1l2 2h12l2-2h1a1 1 0 0 0 1-1Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7.5 12h9"
            })
        ]
    }));
};
const Heading1 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 12h8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 18V6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 18V6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m17 12 3-2v8"
            })
        ]
    }));
};
const Heading2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 12h8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 18V6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 18V6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 18h-4c0-4 4-3 4-6 0-1.5-2-2.5-4-1"
            })
        ]
    }));
};
const Heading3 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 12h8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 18V6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 18V6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17.5 10.5c1.7-1 3.5 0 3.5 1.5a2 2 0 0 1-2 2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 17.5c2 1.5 4 .3 4-1.5a2 2 0 0 0-2-2"
            })
        ]
    }));
};
const Heading4 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 12h8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 18V6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 18V6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 10v4h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 10v8"
            })
        ]
    }));
};
const Heading5 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 12h8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 18V6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 18V6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 13v-3h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 17.7c.4.2.8.3 1.3.3 1.5 0 2.7-1.1 2.7-2.5S19.8 13 18.3 13H17"
            })
        ]
    }));
};
const Heading6 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 12h8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 18V6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 18V6"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "19",
                cy: "16",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 10c-2 2-3 3.5-3 6"
            })
        ]
    }));
};
const Heading = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M6 12h12"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 20V4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 20V4"
            })
        ]
    }));
};
const Headphones = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M3 14h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a9 9 0 0 1 18 0v7a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3"
        })
    }));
};
const Headset = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3 11h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-5Zm0 0a9 9 0 1 1 18 0m0 0v5a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 16v2a4 4 0 0 1-4 4h-5"
            })
        ]
    }));
};
const HeartCrack = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m12 13-1-1 2-2-3-3 2-2"
            })
        ]
    }));
};
const HeartHandshake = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 5 9.04 7.96a2.17 2.17 0 0 0 0 3.08v0c.82.82 2.13.85 3 .07l2.07-1.9a2.82 2.82 0 0 1 3.79 0l2.96 2.66"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m18 15-2-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m15 18-2-2"
            })
        ]
    }));
};
const HeartOff = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("line", {
                x1: "2",
                y1: "2",
                x2: "22",
                y2: "22"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16.5 16.5 12 21l-7-7c-1.5-1.45-3-3.2-3-5.5a5.5 5.5 0 0 1 2.14-4.35"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8.76 3.1c1.15.22 2.13.78 3.24 1.9 1.5-1.5 2.74-2 4.5-2A5.5 5.5 0 0 1 22 8.5c0 2.12-1.3 3.78-2.67 5.17"
            })
        ]
    }));
};
const HeartPulse = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3.22 12H9.5l.5-1 2 4.5 2-7 1.5 3.5h5.27"
            })
        ]
    }));
};
const Heart = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"
        })
    }));
};
const Heater = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M11 8c2-3-2-3 0-6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15.5 8c2-3-2-3 0-6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 10h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 14h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 16v-4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 16v-4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 16v-4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 6a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 20v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19 20v2"
            })
        ]
    }));
};
const HelpCircle = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 17h.01"
            })
        ]
    }));
};
const Hexagon = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"
        })
    }));
};
const Highlighter = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m9 11-6 6v3h9l3-3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m22 12-4.6 4.6a2 2 0 0 1-2.8 0l-5.2-5.2a2 2 0 0 1 0-2.8L14 4"
            })
        ]
    }));
};
const History = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 3v5h5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 7v5l4 2"
            })
        ]
    }));
};
const Home = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "9 22 9 12 15 12 15 22"
            })
        ]
    }));
};
const HopOff = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M10.82 16.12c1.69.6 3.91.79 5.18.85.28.01.53-.09.7-.27"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11.14 20.57c.52.24 2.44 1.12 4.08 1.37.46.06.86-.25.9-.71.12-1.52-.3-3.43-.5-4.28"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16.13 21.05c1.65.63 3.68.84 4.87.91a.9.9 0 0 0 .7-.26"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17.99 5.52a20.83 20.83 0 0 1 3.15 4.5.8.8 0 0 1-.68 1.13c-1.17.1-2.5.02-3.9-.25"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20.57 11.14c.24.52 1.12 2.44 1.37 4.08.04.3-.08.59-.31.75"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4.93 4.93a10 10 0 0 0-.67 13.4c.35.43.96.4 1.17-.12.69-1.71 1.07-5.07 1.07-6.71 1.34.45 3.1.9 4.88.62a.85.85 0 0 0 .48-.24"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5.52 17.99c1.05.95 2.91 2.42 4.5 3.15a.8.8 0 0 0 1.13-.68c.2-2.34-.33-5.3-1.57-8.28"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8.35 2.68a10 10 0 0 1 9.98 1.58c.43.35.4.96-.12 1.17-1.5.6-4.3.98-6.07 1.05"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m2 2 20 20"
            })
        ]
    }));
};
const Hop = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M10.82 16.12c1.69.6 3.91.79 5.18.85.55.03 1-.42.97-.97-.06-1.27-.26-3.5-.85-5.18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11.5 6.5c1.64 0 5-.38 6.71-1.07.52-.2.55-.82.12-1.17A10 10 0 0 0 4.26 18.33c.35.43.96.4 1.17-.12.69-1.71 1.07-5.07 1.07-6.71 1.34.45 3.1.9 4.88.62a.88.88 0 0 0 .73-.74c.3-2.14-.15-3.5-.61-4.88"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15.62 16.95c.2.85.62 2.76.5 4.28a.77.77 0 0 1-.9.7 16.64 16.64 0 0 1-4.08-1.36"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16.13 21.05c1.65.63 3.68.84 4.87.91a.9.9 0 0 0 .96-.96 17.68 17.68 0 0 0-.9-4.87"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16.94 15.62c.86.2 2.77.62 4.29.5a.77.77 0 0 0 .7-.9 16.64 16.64 0 0 0-1.36-4.08"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17.99 5.52a20.82 20.82 0 0 1 3.15 4.5.8.8 0 0 1-.68 1.13c-2.33.2-5.3-.32-8.27-1.57"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4.93 4.93 3 3a.7.7 0 0 1 0-1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.58 12.18c1.24 2.98 1.77 5.95 1.57 8.28a.8.8 0 0 1-1.13.68 20.82 20.82 0 0 1-4.5-3.15"
            })
        ]
    }));
};
const Hotel = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M18 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9 16 .348-.24c1.465-1.013 3.84-1.013 5.304 0L15 16"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 7h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 7h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 7h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 11h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 11h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 11h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 22v-6.5m4 0V22"
            })
        ]
    }));
};
const Hourglass = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M5 22h14"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 2h14"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 22v-4.172a2 2 0 0 0-.586-1.414L12 12l-4.414 4.414A2 2 0 0 0 7 17.828V22"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 2v4.172a2 2 0 0 0 .586 1.414L12 12l4.414-4.414A2 2 0 0 0 17 6.172V2"
            })
        ]
    }));
};
const IceCream2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 17c5 0 8-2.69 8-6H4c0 3.31 3 6 8 6Zm-4 4h8m-4-3v3M5.14 11a3.5 3.5 0 1 1 6.71 0"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12.14 11a3.5 3.5 0 1 1 6.71 0"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15.5 6.5a3.5 3.5 0 1 0-7 0"
            })
        ]
    }));
};
const IceCream = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m7 11 4.08 10.35a1 1 0 0 0 1.84 0L17 11"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 7A5 5 0 0 0 7 7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 7a2 2 0 0 1 0 4H7a2 2 0 0 1 0-4"
            })
        ]
    }));
};
const ImageDown = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M10.3 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10l-3.1-3.1a2 2 0 0 0-2.814.014L6 21"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m14 19 3 3v-5.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m17 22 3-3"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "9",
                cy: "9",
                r: "2"
            })
        ]
    }));
};
const ImageMinus = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M21 9v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "16",
                x2: "22",
                y1: "5",
                y2: "5"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "9",
                cy: "9",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"
            })
        ]
    }));
};
const ImageOff = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("line", {
                x1: "2",
                x2: "22",
                y1: "2",
                y2: "22"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10.41 10.41a2 2 0 1 1-2.83-2.83"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "13.5",
                x2: "6",
                y1: "13.5",
                y2: "21"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "18",
                x2: "21",
                y1: "12",
                y2: "15"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3.59 3.59A1.99 1.99 0 0 0 3 5v14a2 2 0 0 0 2 2h14c.55 0 1.052-.22 1.41-.59"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 15V5a2 2 0 0 0-2-2H9"
            })
        ]
    }));
};
const ImagePlus = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "16",
                x2: "22",
                y1: "5",
                y2: "5"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "19",
                x2: "19",
                y1: "2",
                y2: "8"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "9",
                cy: "9",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"
            })
        ]
    }));
};
const ImageUp = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M10.3 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10l-3.1-3.1a2 2 0 0 0-2.814.014L6 21"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m14 19.5 3-3 3 3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 22v-5.5"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "9",
                cy: "9",
                r: "2"
            })
        ]
    }));
};
const Image = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2",
                ry: "2"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "9",
                cy: "9",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"
            })
        ]
    }));
};
const Images = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M18 22H4a2 2 0 0 1-2-2V6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m22 13-1.296-1.296a2.41 2.41 0 0 0-3.408 0L11 18"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "8",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "16",
                height: "16",
                x: "6",
                y: "2",
                rx: "2"
            })
        ]
    }));
};
const Import = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 3v12"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m8 11 4 4 4-4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 5H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-4"
            })
        ]
    }));
};
const Inbox = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("polyline", {
                points: "22 12 16 12 14 15 10 15 8 12 2 12"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"
            })
        ]
    }));
};
const Indent = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("polyline", {
                points: "3 8 7 12 3 16"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "21",
                x2: "11",
                y1: "12",
                y2: "12"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "21",
                x2: "11",
                y1: "6",
                y2: "6"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "21",
                x2: "11",
                y1: "18",
                y2: "18"
            })
        ]
    }));
};
const IndianRupee = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M6 3h12"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 8h12"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m6 13 8.5 8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 13h3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 13c6.667 0 6.667-10 0-10"
            })
        ]
    }));
};
const Infinity = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M12 12c-2-2.67-4-4-6-4a4 4 0 1 0 0 8c2 0 4-1.33 6-4Zm0 0c2 2.67 4 4 6 4a4 4 0 0 0 0-8c-2 0-4 1.33-6 4Z"
        })
    }));
};
const Info = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 16v-4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 8h.01"
            })
        ]
    }));
};
const InspectionPanel = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 7h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 7h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 17h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 17h.01"
            })
        ]
    }));
};
const Instagram = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "20",
                height: "20",
                x: "2",
                y: "2",
                rx: "5",
                ry: "5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "17.5",
                x2: "17.51",
                y1: "6.5",
                y2: "6.5"
            })
        ]
    }));
};
const Italic = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("line", {
                x1: "19",
                x2: "10",
                y1: "4",
                y2: "4"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "14",
                x2: "5",
                y1: "20",
                y2: "20"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "15",
                x2: "9",
                y1: "4",
                y2: "20"
            })
        ]
    }));
};
const IterationCcw = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M20 10c0-4.4-3.6-8-8-8s-8 3.6-8 8 3.6 8 8 8h8"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "16 14 20 18 16 22"
            })
        ]
    }));
};
const IterationCw = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 10c0-4.4 3.6-8 8-8s8 3.6 8 8-3.6 8-8 8H4"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "8 22 4 18 8 14"
            })
        ]
    }));
};
const JapaneseYen = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 9.5V21m0-11.5L6 3m6 6.5L18 3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 15h12"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 11h12"
            })
        ]
    }));
};
const Joystick = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M21 17a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-2Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 15v-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 15V9"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "6",
                r: "3"
            })
        ]
    }));
};
const KanbanSquareDashed = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M8 7v7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 7v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 7v9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 3a2 2 0 0 0-2 2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 3h1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 3h1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19 3a2 2 0 0 1 2 2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 9v1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 14v1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 19a2 2 0 0 1-2 2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 21h1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 21h1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 21a2 2 0 0 1-2-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 14v1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 9v1"
            })
        ]
    }));
};
const KanbanSquare = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 7v7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 7v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 7v9"
            })
        ]
    }));
};
const Kanban = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M6 5v11"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 5v6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 5v14"
            })
        ]
    }));
};
const KeyRound = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2 18v3c0 .6.4 1 1 1h4v-3h3v-3h2l1.4-1.4a6.5 6.5 0 1 0-4-4Z"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "16.5",
                cy: "7.5",
                r: ".5",
                fill: "currentColor"
            })
        ]
    }));
};
const KeySquare = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12.4 2.7c.9-.9 2.5-.9 3.4 0l5.5 5.5c.9.9.9 2.5 0 3.4l-3.7 3.7c-.9.9-2.5.9-3.4 0L8.7 9.8c-.9-.9-.9-2.5 0-3.4Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m14 7 3 3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.4 10.6 2 18v3c0 .6.4 1 1 1h4v-3h3v-3h2l1.4-1.4"
            })
        ]
    }));
};
const Key = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "7.5",
                cy: "15.5",
                r: "5.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m21 2-9.6 9.6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m15.5 7.5 3 3L22 7l-3-3"
            })
        ]
    }));
};
const KeyboardMusic = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "20",
                height: "16",
                x: "2",
                y: "4",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 8h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 8h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 8h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 12h20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 12v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 12v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 12v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 12v4"
            })
        ]
    }));
};
const Keyboard = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "20",
                height: "16",
                x: "2",
                y: "4",
                rx: "2",
                ry: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 8h.001"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 8h.001"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 8h.001"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 8h.001"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 12h.001"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 12h.001"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 12h.001"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 16h10"
            })
        ]
    }));
};
const LampCeiling = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2v5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 7h12l4 9H2l4-9Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.17 16a3 3 0 1 0 5.66 0"
            })
        ]
    }));
};
const LampDesk = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m14 5-3 3 2 7 8-8-7-2Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m14 5-3 3-3-3 3-3 3 3Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.5 6.5 4 12l3 6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 22v-2c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v2H3Z"
            })
        ]
    }));
};
const LampFloor = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M9 2h6l3 7H6l3-7Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 9v13"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 22h6"
            })
        ]
    }));
};
const LampWallDown = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M11 13h6l3 7H8l3-7Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 13V8a2 2 0 0 0-2-2H8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 9h2a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H4v6Z"
            })
        ]
    }));
};
const LampWallUp = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M11 4h6l3 7H8l3-7Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 11v5a2 2 0 0 1-2 2H8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 15h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H4v-6Z"
            })
        ]
    }));
};
const Lamp = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M8 2h8l4 10H4L8 2Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 12v6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 22v-2c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v2H8Z"
            })
        ]
    }));
};
const LandPlot = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m12 8 6-3-6-3v10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m8 11.99-5.5 3.14a1 1 0 0 0 0 1.74l8.5 4.86a2 2 0 0 0 2 0l8.5-4.86a1 1 0 0 0 0-1.74L16 12"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m6.49 12.85 11.02 6.3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17.51 12.85 6.5 19.15"
            })
        ]
    }));
};
const Landmark = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("line", {
                x1: "3",
                x2: "21",
                y1: "22",
                y2: "22"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "6",
                x2: "6",
                y1: "18",
                y2: "11"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "10",
                x2: "10",
                y1: "18",
                y2: "11"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "14",
                x2: "14",
                y1: "18",
                y2: "11"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "18",
                x2: "18",
                y1: "18",
                y2: "11"
            }),
            /*#__PURE__*/ _jsx("polygon", {
                points: "12 2 20 7 4 7"
            })
        ]
    }));
};
const Languages = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m5 8 6 6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m4 14 6-6 2-3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 5h12"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 2h1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m22 22-5-10-5 10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 18h6"
            })
        ]
    }));
};
const Laptop2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "12",
                x: "3",
                y: "4",
                rx: "2",
                ry: "2"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "2",
                x2: "22",
                y1: "20",
                y2: "20"
            })
        ]
    }));
};
const Laptop = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M20 16V7a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v9m16 0H4m16 0 1.28 2.55a1 1 0 0 1-.9 1.45H3.62a1 1 0 0 1-.9-1.45L4 16"
        })
    }));
};
const LassoSelect = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M7 22a5 5 0 0 1-2-4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 16.93c.96.43 1.96.74 2.99.91"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3.34 14A6.8 6.8 0 0 1 2 10c0-4.42 4.48-8 10-8s10 3.58 10 8a7.19 7.19 0 0 1-.33 2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14.33 22h-.09a.35.35 0 0 1-.24-.32v-10a.34.34 0 0 1 .33-.34c.08 0 .15.03.21.08l7.34 6a.33.33 0 0 1-.21.59h-4.49l-2.57 3.85a.35.35 0 0 1-.28.14v0z"
            })
        ]
    }));
};
const Lasso = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M7 22a5 5 0 0 1-2-4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3.3 14A6.8 6.8 0 0 1 2 10c0-4.4 4.5-8 10-8s10 3.6 10 8-4.5 8-10 8a12 12 0 0 1-5-1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"
            })
        ]
    }));
};
const Laugh = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 13a6 6 0 0 1-6 5 6 6 0 0 1-6-5h12Z"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "9",
                x2: "9.01",
                y1: "9",
                y2: "9"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "15",
                x2: "15.01",
                y1: "9",
                y2: "9"
            })
        ]
    }));
};
const Layers2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m16.02 12 5.48 3.13a1 1 0 0 1 0 1.74L13 21.74a2 2 0 0 1-2 0l-8.5-4.87a1 1 0 0 1 0-1.74L7.98 12"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13 13.74a2 2 0 0 1-2 0L2.5 8.87a1 1 0 0 1 0-1.74L11 2.26a2 2 0 0 1 2 0l8.5 4.87a1 1 0 0 1 0 1.74Z"
            })
        ]
    }));
};
const Layers3 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m6.08 9.5-3.5 1.6a1 1 0 0 0 0 1.81l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9a1 1 0 0 0 0-1.83l-3.5-1.59"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m6.08 14.5-3.5 1.6a1 1 0 0 0 0 1.81l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9a1 1 0 0 0 0-1.83l-3.5-1.59"
            })
        ]
    }));
};
const Layers = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m22 17.65-9.17 4.16a2 2 0 0 1-1.66 0L2 17.65"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m22 12.65-9.17 4.16a2 2 0 0 1-1.66 0L2 12.65"
            })
        ]
    }));
};
const LayoutDashboard = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "7",
                height: "9",
                x: "3",
                y: "3",
                rx: "1"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "7",
                height: "5",
                x: "14",
                y: "3",
                rx: "1"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "7",
                height: "9",
                x: "14",
                y: "12",
                rx: "1"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "7",
                height: "5",
                x: "3",
                y: "16",
                rx: "1"
            })
        ]
    }));
};
const LayoutGrid = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "7",
                height: "7",
                x: "3",
                y: "3",
                rx: "1"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "7",
                height: "7",
                x: "14",
                y: "3",
                rx: "1"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "7",
                height: "7",
                x: "14",
                y: "14",
                rx: "1"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "7",
                height: "7",
                x: "3",
                y: "14",
                rx: "1"
            })
        ]
    }));
};
const LayoutList = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "7",
                height: "7",
                x: "3",
                y: "3",
                rx: "1"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "7",
                height: "7",
                x: "3",
                y: "14",
                rx: "1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 4h7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 9h7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 15h7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 20h7"
            })
        ]
    }));
};
const LayoutPanelLeft = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "7",
                height: "18",
                x: "3",
                y: "3",
                rx: "1"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "7",
                height: "7",
                x: "14",
                y: "3",
                rx: "1"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "7",
                height: "7",
                x: "14",
                y: "14",
                rx: "1"
            })
        ]
    }));
};
const LayoutPanelTop = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "7",
                x: "3",
                y: "3",
                rx: "1"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "7",
                height: "7",
                x: "3",
                y: "14",
                rx: "1"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "7",
                height: "7",
                x: "14",
                y: "14",
                rx: "1"
            })
        ]
    }));
};
const LayoutTemplate = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "7",
                x: "3",
                y: "3",
                rx: "1"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "9",
                height: "7",
                x: "3",
                y: "14",
                rx: "1"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "5",
                height: "7",
                x: "16",
                y: "14",
                rx: "1"
            })
        ]
    }));
};
const Leaf = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12"
            })
        ]
    }));
};
const LeafyGreen = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2 22c1.25-.987 2.27-1.975 3.9-2.2a5.56 5.56 0 0 1 3.8 1.5 4 4 0 0 0 6.187-2.353 3.5 3.5 0 0 0 3.69-5.116A3.5 3.5 0 0 0 20.95 8 3.5 3.5 0 1 0 16 3.05a3.5 3.5 0 0 0-5.831 1.373 3.5 3.5 0 0 0-5.116 3.69 4 4 0 0 0-2.348 6.155C3.499 15.42 4.409 16.712 4.2 18.1 3.926 19.743 3.014 20.732 2 22"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 22 17 7"
            })
        ]
    }));
};
const LibraryBig = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "8",
                height: "18",
                x: "3",
                y: "3",
                rx: "1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 3v18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20.4 18.9c.2.5-.1 1.1-.6 1.3l-1.9.7c-.5.2-1.1-.1-1.3-.6L11.1 5.1c-.2-.5.1-1.1.6-1.3l1.9-.7c.5-.2 1.1.1 1.3.6Z"
            })
        ]
    }));
};
const LibrarySquare = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 7v10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11 7v10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m15 7 2 10"
            })
        ]
    }));
};
const Library = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m16 6 4 14"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 6v14"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 8v12"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 4v16"
            })
        ]
    }));
};
const LifeBuoy = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m4.93 4.93 4.24 4.24"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m14.83 9.17 4.24-4.24"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m14.83 14.83 4.24 4.24"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9.17 14.83-4.24 4.24"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "4"
            })
        ]
    }));
};
const Ligature = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M8 20V8c0-2.2 1.8-4 4-4 1.5 0 2.8.8 3.5 2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 12h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 12h2v8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 20h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 20h4"
            })
        ]
    }));
};
const LightbulbOff = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M16.8 11.2c.8-.9 1.2-2 1.2-3.2a6 6 0 0 0-9.3-5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m2 2 20 20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.3 6.3a4.67 4.67 0 0 0 1.2 5.2c.7.7 1.3 1.5 1.5 2.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 18h6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 22h4"
            })
        ]
    }));
};
const Lightbulb = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 18h6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 22h4"
            })
        ]
    }));
};
const LineChart = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3 3v18h18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m19 9-5 5-4-4-3 3"
            })
        ]
    }));
};
const Link2Off = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M9 17H7A5 5 0 0 1 7 7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 7h2a5 5 0 0 1 4 8"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "8",
                x2: "12",
                y1: "12",
                y2: "12"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "2",
                x2: "22",
                y1: "2",
                y2: "22"
            })
        ]
    }));
};
const Link2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M9 17H7A5 5 0 0 1 7 7h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 7h2a5 5 0 1 1 0 10h-2"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "8",
                x2: "16",
                y1: "12",
                y2: "12"
            })
        ]
    }));
};
const Link = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"
            })
        ]
    }));
};
const Linkedin = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "4",
                height: "12",
                x: "2",
                y: "9"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "4",
                cy: "4",
                r: "2"
            })
        ]
    }));
};
const ListChecks = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m3 17 2 2 4-4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m3 7 2 2 4-4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13 6h8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13 12h8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13 18h8"
            })
        ]
    }));
};
const ListCollapse = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m3 10 2.5-2.5L3 5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m3 19 2.5-2.5L3 14"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 6h11"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 12h11"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 18h11"
            })
        ]
    }));
};
const ListEnd = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M16 12H3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 6H3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 18H3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 6v10a2 2 0 0 1-2 2h-5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m16 16-2 2 2 2"
            })
        ]
    }));
};
const ListFilter = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3 6h18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 12h10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 18h4"
            })
        ]
    }));
};
const ListMinus = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M11 12H3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 6H3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 18H3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 12h-6"
            })
        ]
    }));
};
const ListMusic = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M21 15V6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18.5 18a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 12H3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 6H3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 18H3"
            })
        ]
    }));
};
const ListOrdered = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("line", {
                x1: "10",
                x2: "21",
                y1: "6",
                y2: "6"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "10",
                x2: "21",
                y1: "12",
                y2: "12"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "10",
                x2: "21",
                y1: "18",
                y2: "18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 6h1v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 10h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 18H4c0-1 2-2 2-3s-1-1.5-2-1"
            })
        ]
    }));
};
const ListPlus = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M11 12H3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 6H3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 18H3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 9v6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 12h-6"
            })
        ]
    }));
};
const ListRestart = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M21 6H3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 12H3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 18H3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 18a5 5 0 0 0 9-3 4.5 4.5 0 0 0-4.5-4.5c-1.33 0-2.54.54-3.41 1.41L11 14"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11 10v4h4"
            })
        ]
    }));
};
const ListStart = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M16 12H3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 18H3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 6H3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 18V8a2 2 0 0 0-2-2h-5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m16 8-2-2 2-2"
            })
        ]
    }));
};
const ListTodo = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                x: "3",
                y: "5",
                width: "6",
                height: "6",
                rx: "1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m3 17 2 2 4-4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13 6h8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13 12h8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13 18h8"
            })
        ]
    }));
};
const ListTree = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M21 12h-8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 6H8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 18h-8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 6v4c0 1.1.9 2 2 2h3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 10v6c0 1.1.9 2 2 2h3"
            })
        ]
    }));
};
const ListVideo = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 12H3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 6H3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 18H3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m16 12 5 3-5 3v-6Z"
            })
        ]
    }));
};
const ListX = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M11 12H3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 6H3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 18H3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m19 10-4 4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m15 10 4 4"
            })
        ]
    }));
};
const List = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("line", {
                x1: "8",
                x2: "21",
                y1: "6",
                y2: "6"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "8",
                x2: "21",
                y1: "12",
                y2: "12"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "8",
                x2: "21",
                y1: "18",
                y2: "18"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "3",
                x2: "3.01",
                y1: "6",
                y2: "6"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "3",
                x2: "3.01",
                y1: "12",
                y2: "12"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "3",
                x2: "3.01",
                y1: "18",
                y2: "18"
            })
        ]
    }));
};
const Loader2 = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M21 12a9 9 0 1 1-6.219-8.56"
        })
    }));
};
const Loader = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "12",
                y1: "2",
                y2: "6"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "12",
                y1: "18",
                y2: "22"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "4.93",
                x2: "7.76",
                y1: "4.93",
                y2: "7.76"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "16.24",
                x2: "19.07",
                y1: "16.24",
                y2: "19.07"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "2",
                x2: "6",
                y1: "12",
                y2: "12"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "18",
                x2: "22",
                y1: "12",
                y2: "12"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "4.93",
                x2: "7.76",
                y1: "19.07",
                y2: "16.24"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "16.24",
                x2: "19.07",
                y1: "7.76",
                y2: "4.93"
            })
        ]
    }));
};
const LocateFixed = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("line", {
                x1: "2",
                x2: "5",
                y1: "12",
                y2: "12"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "19",
                x2: "22",
                y1: "12",
                y2: "12"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "12",
                y1: "2",
                y2: "5"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "12",
                y1: "19",
                y2: "22"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "7"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "3"
            })
        ]
    }));
};
const LocateOff = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("line", {
                x1: "2",
                x2: "5",
                y1: "12",
                y2: "12"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "19",
                x2: "22",
                y1: "12",
                y2: "12"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "12",
                y1: "2",
                y2: "5"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "12",
                y1: "19",
                y2: "22"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7.11 7.11C5.83 8.39 5 10.1 5 12c0 3.87 3.13 7 7 7 1.9 0 3.61-.83 4.89-2.11"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18.71 13.96c.19-.63.29-1.29.29-1.96 0-3.87-3.13-7-7-7-.67 0-1.33.1-1.96.29"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "2",
                x2: "22",
                y1: "2",
                y2: "22"
            })
        ]
    }));
};
const Locate = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("line", {
                x1: "2",
                x2: "5",
                y1: "12",
                y2: "12"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "19",
                x2: "22",
                y1: "12",
                y2: "12"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "12",
                y1: "2",
                y2: "5"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "12",
                y1: "19",
                y2: "22"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "7"
            })
        ]
    }));
};
const LockKeyhole = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "16",
                r: "1"
            }),
            /*#__PURE__*/ _jsx("rect", {
                x: "3",
                y: "10",
                width: "18",
                height: "12",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 10V7a5 5 0 0 1 10 0v3"
            })
        ]
    }));
};
const Lock = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "11",
                x: "3",
                y: "11",
                rx: "2",
                ry: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 11V7a5 5 0 0 1 10 0v4"
            })
        ]
    }));
};
const LogIn = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "10 17 15 12 10 7"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "15",
                x2: "3",
                y1: "12",
                y2: "12"
            })
        ]
    }));
};
const LogOut = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "16 17 21 12 16 7"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "21",
                x2: "9",
                y1: "12",
                y2: "12"
            })
        ]
    }));
};
const Lollipop = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "11",
                cy: "11",
                r: "8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m21 21-4.3-4.3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11 11a2 2 0 0 0 4 0 4 4 0 0 0-8 0 6 6 0 0 0 12 0"
            })
        ]
    }));
};
const Luggage = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M6 20h0a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h0"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 18V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v14"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 20h4"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "16",
                cy: "20",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "8",
                cy: "20",
                r: "2"
            })
        ]
    }));
};
const MSquare = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 16V8l4 4 4-4v8"
            })
        ]
    }));
};
const Magnet = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m6 15-4-4 6.75-6.77a7.79 7.79 0 0 1 11 11L13 22l-4-4 6.39-6.36a2.14 2.14 0 0 0-3-3L6 15"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m5 8 4 4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m12 15 4 4"
            })
        ]
    }));
};
const MailCheck = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M22 13V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m16 19 2 2 4-4"
            })
        ]
    }));
};
const MailMinus = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M22 15V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 19h6"
            })
        ]
    }));
};
const MailOpen = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M21.2 8.4c.5.38.8.97.8 1.6v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V10a2 2 0 0 1 .8-1.6l8-6a2 2 0 0 1 2.4 0l8 6Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m22 10-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 10"
            })
        ]
    }));
};
const MailPlus = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M22 13V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19 16v6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 19h6"
            })
        ]
    }));
};
const MailQuestion = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M22 10.5V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h12.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 15.28c.2-.4.5-.8.9-1a2.1 2.1 0 0 1 2.6.4c.3.4.5.8.5 1.3 0 1.3-2 2-2 2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 22v.01"
            })
        ]
    }));
};
const MailSearch = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M22 12.5V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h7.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 21a3 3 0 1 0 0-6 3 3 0 0 0 0 6v0Z"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "18",
                cy: "18",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m22 22-1.5-1.5"
            })
        ]
    }));
};
const MailWarning = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M22 10.5V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h12.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 14v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 22v.01"
            })
        ]
    }));
};
const MailX = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M22 13V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m17 17 4 4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m21 17-4 4"
            })
        ]
    }));
};
const Mail = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "20",
                height: "16",
                x: "2",
                y: "4",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"
            })
        ]
    }));
};
const Mailbox = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M22 17a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9.5C2 7 4 5 6.5 5H18c2.2 0 4 1.8 4 4v8Z"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "15,9 18,9 18,11"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.5 5C9 5 11 7 11 9.5V17a2 2 0 0 1-2 2v0"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "6",
                x2: "7",
                y1: "10",
                y2: "10"
            })
        ]
    }));
};
const Mails = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "16",
                height: "13",
                x: "6",
                y: "4",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m22 7-7.1 3.78c-.57.3-1.23.3-1.8 0L6 7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 8v11c0 1.1.9 2 2 2h14"
            })
        ]
    }));
};
const MapPinOff = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M5.43 5.43A8.06 8.06 0 0 0 4 10c0 6 8 12 8 12a29.94 29.94 0 0 0 5-5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19.18 13.52A8.66 8.66 0 0 0 20 10a8 8 0 0 0-8-8 7.88 7.88 0 0 0-3.52.82"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.13 9.13A2.78 2.78 0 0 0 9 10a3 3 0 0 0 3 3 2.78 2.78 0 0 0 .87-.13"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14.9 9.25a3 3 0 0 0-2.15-2.16"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "2",
                x2: "22",
                y1: "2",
                y2: "22"
            })
        ]
    }));
};
const MapPin = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "10",
                r: "3"
            })
        ]
    }));
};
const MapPinned = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M18 8c0 4.5-6 9-6 9s-6-4.5-6-9a6 6 0 0 1 12 0"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "8",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8.835 14H5a1 1 0 0 0-.9.7l-2 6c-.1.1-.1.2-.1.3 0 .6.4 1 1 1h18c.6 0 1-.4 1-1 0-.1 0-.2-.1-.3l-2-6a1 1 0 0 0-.9-.7h-3.835"
            })
        ]
    }));
};
const Map = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("polygon", {
                points: "3 6 9 3 15 6 21 3 21 18 15 21 9 18 3 21"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "9",
                x2: "9",
                y1: "3",
                y2: "18"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "15",
                x2: "15",
                y1: "6",
                y2: "21"
            })
        ]
    }));
};
const Martini = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M8 22h8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 11v11"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m19 3-7 8-7-8Z"
            })
        ]
    }));
};
const Maximize2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("polyline", {
                points: "15 3 21 3 21 9"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "9 21 3 21 3 15"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "21",
                x2: "14",
                y1: "3",
                y2: "10"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "3",
                x2: "10",
                y1: "21",
                y2: "14"
            })
        ]
    }));
};
const Maximize = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M8 3H5a2 2 0 0 0-2 2v3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 8V5a2 2 0 0 0-2-2h-3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 16v3a2 2 0 0 0 2 2h3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 21h3a2 2 0 0 0 2-2v-3"
            })
        ]
    }));
};
const Medal = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M7.21 15 2.66 7.14a2 2 0 0 1 .13-2.2L4.4 2.8A2 2 0 0 1 6 2h12a2 2 0 0 1 1.6.8l1.6 2.14a2 2 0 0 1 .14 2.2L16.79 15"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11 12 5.12 2.2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m13 12 5.88-9.8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 7h8"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "17",
                r: "5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 18v-2h-.5"
            })
        ]
    }));
};
const MegaphoneOff = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M9.26 9.26 3 11v3l14.14 3.14"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 15.34V6l-7.31 2.03"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11.6 16.8a3 3 0 1 1-5.8-1.6"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "2",
                x2: "22",
                y1: "2",
                y2: "22"
            })
        ]
    }));
};
const Megaphone = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m3 11 18-5v12L3 14v-3z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11.6 16.8a3 3 0 1 1-5.8-1.6"
            })
        ]
    }));
};
const Meh = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "8",
                x2: "16",
                y1: "15",
                y2: "15"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "9",
                x2: "9.01",
                y1: "9",
                y2: "9"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "15",
                x2: "15.01",
                y1: "9",
                y2: "9"
            })
        ]
    }));
};
const MemoryStick = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M6 19v-3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 19v-3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 19v-3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 19v-3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 11V9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 11V9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 11V9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 15h20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 7a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v1.1a2 2 0 0 0 0 3.837V17a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-5.1a2 2 0 0 0 0-3.837Z"
            })
        ]
    }));
};
const MenuSquare = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 8h10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 12h10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 16h10"
            })
        ]
    }));
};
const Menu = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("line", {
                x1: "4",
                x2: "20",
                y1: "12",
                y2: "12"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "4",
                x2: "20",
                y1: "6",
                y2: "6"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "4",
                x2: "20",
                y1: "18",
                y2: "18"
            })
        ]
    }));
};
const Merge = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m8 6 4-4 4 4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2v10.3a4 4 0 0 1-1.172 2.872L4 22"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m20 22-5-5"
            })
        ]
    }));
};
const MessageCircleCode = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m10 10-2 2 2 2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m14 10 2 2-2 2"
            })
        ]
    }));
};
const MessageCircleDashed = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M13.5 3.1c-.5 0-1-.1-1.5-.1s-1 .1-1.5.1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19.3 6.8a10.45 10.45 0 0 0-2.1-2.1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20.9 13.5c.1-.5.1-1 .1-1.5s-.1-1-.1-1.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17.2 19.3a10.45 10.45 0 0 0 2.1-2.1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10.5 20.9c.5.1 1 .1 1.5.1s1-.1 1.5-.1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3.5 17.5 2 22l4.5-1.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3.1 10.5c0 .5-.1 1-.1 1.5s.1 1 .1 1.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.8 4.7a10.45 10.45 0 0 0-2.1 2.1"
            })
        ]
    }));
};
const MessageCircleHeart = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15.8 9.2a2.5 2.5 0 0 0-3.5 0l-.3.4-.35-.3a2.42 2.42 0 1 0-3.2 3.6l3.6 3.5 3.6-3.5c1.2-1.2 1.1-2.7.2-3.7"
            })
        ]
    }));
};
const MessageCircleMore = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 12h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 12h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 12h.01"
            })
        ]
    }));
};
const MessageCircleOff = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M20.5 14.9A9 9 0 0 0 9.1 3.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m2 2 20 20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5.6 5.6C3 8.3 2.2 12.5 4 16l-2 6 6-2c3.4 1.8 7.6 1.1 10.3-1.7"
            })
        ]
    }));
};
const MessageCirclePlus = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 12h8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 8v8"
            })
        ]
    }));
};
const MessageCircleQuestion = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 17h.01"
            })
        ]
    }));
};
const MessageCircleReply = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m10 15-3-3 3-3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 12h7a2 2 0 0 1 2 2v1"
            })
        ]
    }));
};
const MessageCircleWarning = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 8v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 16h.01"
            })
        ]
    }));
};
const MessageCircleX = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m15 9-6 6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9 9 6 6"
            })
        ]
    }));
};
const MessageCircle = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z"
        })
    }));
};
const MessageSquareCode = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m10 8-2 2 2 2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m14 8 2 2-2 2"
            })
        ]
    }));
};
const MessageSquareDashed = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3 6V5c0-1.1.9-2 2-2h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11 3h3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 3h1c1.1 0 2 .9 2 2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 9v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 15c0 1.1-.9 2-2 2h-1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 17h-3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m7 17-4 4v-5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 12v-2"
            })
        ]
    }));
};
const MessageSquareDiff = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m5 19-2 2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 10h6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 7v6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 17h6"
            })
        ]
    }));
};
const MessageSquareDot = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M11.7 3H5a2 2 0 0 0-2 2v16l4-4h12a2 2 0 0 0 2-2v-2.7"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "18",
                cy: "6",
                r: "3"
            })
        ]
    }));
};
const MessageSquareHeart = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14.8 7.5a1.84 1.84 0 0 0-2.6 0l-.2.3-.3-.3a1.84 1.84 0 1 0-2.4 2.8L12 13l2.7-2.7c.9-.9.8-2.1.1-2.8"
            })
        ]
    }));
};
const MessageSquareMore = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 10h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 10h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 10h.01"
            })
        ]
    }));
};
const MessageSquareOff = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M21 15V5a2 2 0 0 0-2-2H9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m2 2 20 20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3.6 3.6c-.4.3-.6.8-.6 1.4v16l4-4h10"
            })
        ]
    }));
};
const MessageSquarePlus = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 7v6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 10h6"
            })
        ]
    }));
};
const MessageSquareQuote = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 12a2 2 0 0 0 2-2V8H8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 12a2 2 0 0 0 2-2V8h-2"
            })
        ]
    }));
};
const MessageSquareReply = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m10 7-3 3 3 3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 13v-1a2 2 0 0 0-2-2H7"
            })
        ]
    }));
};
const MessageSquareShare = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M21 12v3a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 3h5v5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m16 8 5-5"
            })
        ]
    }));
};
const MessageSquareText = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13 8H7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 12H7"
            })
        ]
    }));
};
const MessageSquareWarning = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 7v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 13h.01"
            })
        ]
    }));
};
const MessageSquareX = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m14.5 7.5-5 5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9.5 7.5 5 5"
            })
        ]
    }));
};
const MessageSquare = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
        })
    }));
};
const MessagesSquare = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M14 9a2 2 0 0 1-2 2H6l-4 4V4c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v5Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 9h2a2 2 0 0 1 2 2v11l-4-4h-6a2 2 0 0 1-2-2v-1"
            })
        ]
    }));
};
const Mic2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m12 8-9.04 9.06a2.82 2.82 0 1 0 3.98 3.98L16 12"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "17",
                cy: "7",
                r: "5"
            })
        ]
    }));
};
const MicOff = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("line", {
                x1: "2",
                x2: "22",
                y1: "2",
                y2: "22"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18.89 13.23A7.12 7.12 0 0 0 19 12v-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 10v2a7 7 0 0 0 12 5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 9.34V5a3 3 0 0 0-5.68-1.33"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 9v3a3 3 0 0 0 5.12 2.12"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "12",
                y1: "19",
                y2: "22"
            })
        ]
    }));
};
const Mic = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19 10v2a7 7 0 0 1-14 0v-2"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "12",
                y1: "19",
                y2: "22"
            })
        ]
    }));
};
const Microscope = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M6 18h8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 22h18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 22a7 7 0 1 0 0-14h-1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 14h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 12a2 2 0 0 1-2-2V6h6v4a2 2 0 0 1-2 2Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 6V3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v3"
            })
        ]
    }));
};
const Microwave = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "20",
                height: "15",
                x: "2",
                y: "4",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "8",
                height: "7",
                x: "6",
                y: "8",
                rx: "1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 8v7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 19v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 19v2"
            })
        ]
    }));
};
const Milestone = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M18 6H5a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h13l4-3.5L18 6Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 13v8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 3v3"
            })
        ]
    }));
};
const MilkOff = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M8 2h8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 2v1.343M15 2v2.789a4 4 0 0 0 .672 2.219l.656.984a4 4 0 0 1 .672 2.22v1.131M7.8 7.8l-.128.192A4 4 0 0 0 7 10.212V20a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 15a6.47 6.47 0 0 1 5 0 6.472 6.472 0 0 0 3.435.435"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "2",
                x2: "22",
                y1: "2",
                y2: "22"
            })
        ]
    }));
};
const Milk = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M8 2h8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 2v2.789a4 4 0 0 1-.672 2.219l-.656.984A4 4 0 0 0 7 10.212V20a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-9.789a4 4 0 0 0-.672-2.219l-.656-.984A4 4 0 0 1 15 4.788V2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 15a6.472 6.472 0 0 1 5 0 6.47 6.47 0 0 0 5 0"
            })
        ]
    }));
};
const Minimize2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("polyline", {
                points: "4 14 10 14 10 20"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "20 10 14 10 14 4"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "14",
                x2: "21",
                y1: "10",
                y2: "3"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "3",
                x2: "10",
                y1: "21",
                y2: "14"
            })
        ]
    }));
};
const Minimize = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M8 3v3a2 2 0 0 1-2 2H3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 8h-3a2 2 0 0 1-2-2V3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 16h3a2 2 0 0 1 2 2v3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 21v-3a2 2 0 0 1 2-2h3"
            })
        ]
    }));
};
const MinusCircle = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 12h8"
            })
        ]
    }));
};
const MinusSquare = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 12h8"
            })
        ]
    }));
};
const Minus = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M5 12h14"
        })
    }));
};
const MonitorCheck = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m9 10 2 2 4-4"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "20",
                height: "14",
                x: "2",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 17v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 21h8"
            })
        ]
    }));
};
const MonitorDot = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "19",
                cy: "6",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 12v3a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 17v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 21h8"
            })
        ]
    }));
};
const MonitorDown = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 13V7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m15 10-3 3-3-3"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "20",
                height: "14",
                x: "2",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 17v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 21h8"
            })
        ]
    }));
};
const MonitorOff = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M17 17H4a2 2 0 0 1-2-2V5c0-1.5 1-2 1-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 15V5a2 2 0 0 0-2-2H9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 21h8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 17v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m2 2 20 20"
            })
        ]
    }));
};
const MonitorPause = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M10 13V7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 13V7"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "20",
                height: "14",
                x: "2",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 17v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 21h8"
            })
        ]
    }));
};
const MonitorPlay = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m10 7 5 3-5 3Z"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "20",
                height: "14",
                x: "2",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 17v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 21h8"
            })
        ]
    }));
};
const MonitorSmartphone = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M18 8V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 19v-3.96 3.15"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 19h5"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "6",
                height: "10",
                x: "16",
                y: "12",
                rx: "2"
            })
        ]
    }));
};
const MonitorSpeaker = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M5.5 20H8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 9h.01"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "10",
                height: "16",
                x: "12",
                y: "4",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 6H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h4"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "17",
                cy: "15",
                r: "1"
            })
        ]
    }));
};
const MonitorStop = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                x: "9",
                y: "7",
                width: "6",
                height: "6"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "20",
                height: "14",
                x: "2",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 17v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 21h8"
            })
        ]
    }));
};
const MonitorUp = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m9 10 3-3 3 3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 13V7"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "20",
                height: "14",
                x: "2",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 17v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 21h8"
            })
        ]
    }));
};
const MonitorX = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m14.5 12.5-5-5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9.5 12.5 5-5"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "20",
                height: "14",
                x: "2",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 17v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 21h8"
            })
        ]
    }));
};
const Monitor = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "20",
                height: "14",
                x: "2",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "8",
                x2: "16",
                y1: "21",
                y2: "21"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "12",
                y1: "17",
                y2: "21"
            })
        ]
    }));
};
const MoonStar = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19 3v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 5h-4"
            })
        ]
    }));
};
const Moon = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z"
        })
    }));
};
const MoreHorizontal = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "1"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "19",
                cy: "12",
                r: "1"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "5",
                cy: "12",
                r: "1"
            })
        ]
    }));
};
const MoreVertical = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "1"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "5",
                r: "1"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "19",
                r: "1"
            })
        ]
    }));
};
const MountainSnow = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m8 3 4 8 5-5 5 15H2L8 3z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4.14 15.08c2.62-1.57 5.24-1.43 7.86.42 2.74 1.94 5.49 2 8.23.19"
            })
        ]
    }));
};
const Mountain = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "m8 3 4 8 5-5 5 15H2L8 3z"
        })
    }));
};
const MousePointer2 = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "m4 4 7.07 17 2.51-7.39L21 11.07z"
        })
    }));
};
const MousePointerClick = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m9 9 5 12 1.8-5.2L21 14Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7.2 2.2 8 5.1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m5.1 8-2.9-.8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 4.1 12 6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m6 12-1.9 2"
            })
        ]
    }));
};
const MousePointerSquareDashed = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M5 3a2 2 0 0 0-2 2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19 3a2 2 0 0 1 2 2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m12 12 4 10 1.7-4.3L22 16Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 21a2 2 0 0 1-2-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 3h1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 21h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 3h1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 9v1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 9v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 14v1"
            })
        ]
    }));
};
const MousePointerSquare = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M21 11V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m12 12 4 10 1.7-4.3L22 16Z"
            })
        ]
    }));
};
const MousePointer = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m3 3 7.07 16.97 2.51-7.39 7.39-2.51L3 3z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m13 13 6 6"
            })
        ]
    }));
};
const Mouse = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                x: "5",
                y: "2",
                width: "14",
                height: "20",
                rx: "7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 6v4"
            })
        ]
    }));
};
const Move3D = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M5 3v16h16"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m5 19 6-6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m2 6 3-3 3 3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m18 16 3 3-3 3"
            })
        ]
    }));
};
const MoveDiagonal2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("polyline", {
                points: "5 11 5 5 11 5"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "19 13 19 19 13 19"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "5",
                x2: "19",
                y1: "5",
                y2: "19"
            })
        ]
    }));
};
const MoveDiagonal = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("polyline", {
                points: "13 5 19 5 19 11"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "11 19 5 19 5 13"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "19",
                x2: "5",
                y1: "5",
                y2: "19"
            })
        ]
    }));
};
const MoveDownLeft = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M11 19H5V13"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19 5L5 19"
            })
        ]
    }));
};
const MoveDownRight = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M19 13V19H13"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 5L19 19"
            })
        ]
    }));
};
const MoveDown = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M8 18L12 22L16 18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2V22"
            })
        ]
    }));
};
const MoveHorizontal = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("polyline", {
                points: "18 8 22 12 18 16"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "6 8 2 12 6 16"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "2",
                x2: "22",
                y1: "12",
                y2: "12"
            })
        ]
    }));
};
const MoveLeft = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M6 8L2 12L6 16"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 12H22"
            })
        ]
    }));
};
const MoveRight = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M18 8L22 12L18 16"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 12H22"
            })
        ]
    }));
};
const MoveUpLeft = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M5 11V5H11"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 5L19 19"
            })
        ]
    }));
};
const MoveUpRight = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M13 5H19V11"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19 5L5 19"
            })
        ]
    }));
};
const MoveUp = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M8 6L12 2L16 6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2V22"
            })
        ]
    }));
};
const MoveVertical = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("polyline", {
                points: "8 18 12 22 16 18"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "8 6 12 2 16 6"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "12",
                y1: "2",
                y2: "22"
            })
        ]
    }));
};
const Move = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("polyline", {
                points: "5 9 2 12 5 15"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "9 5 12 2 15 5"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "15 19 12 22 9 19"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "19 9 22 12 19 15"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "2",
                x2: "22",
                y1: "12",
                y2: "12"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "12",
                y1: "2",
                y2: "22"
            })
        ]
    }));
};
const Music2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "8",
                cy: "18",
                r: "4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 18V2l7 4"
            })
        ]
    }));
};
const Music3 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "18",
                r: "4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 18V2"
            })
        ]
    }));
};
const Music4 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M9 18V5l12-2v13"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9 9 12-2"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "6",
                cy: "18",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "18",
                cy: "16",
                r: "3"
            })
        ]
    }));
};
const Music = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M9 18V5l12-2v13"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "6",
                cy: "18",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "18",
                cy: "16",
                r: "3"
            })
        ]
    }));
};
const Navigation2Off = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M9.31 9.31 5 21l7-4 7 4-1.17-3.17"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14.53 8.88 12 2l-1.17 3.17"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "2",
                x2: "22",
                y1: "2",
                y2: "22"
            })
        ]
    }));
};
const Navigation2 = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("polygon", {
            points: "12 2 19 21 12 17 5 21 12 2"
        })
    }));
};
const NavigationOff = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M8.43 8.43 3 11l8 2 2 8 2.57-5.43"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17.39 11.73 22 2l-9.73 4.61"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "2",
                x2: "22",
                y1: "2",
                y2: "22"
            })
        ]
    }));
};
const Navigation = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("polygon", {
            points: "3 11 22 2 13 21 11 13 3 11"
        })
    }));
};
const Network = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                x: "16",
                y: "16",
                width: "6",
                height: "6",
                rx: "1"
            }),
            /*#__PURE__*/ _jsx("rect", {
                x: "2",
                y: "16",
                width: "6",
                height: "6",
                rx: "1"
            }),
            /*#__PURE__*/ _jsx("rect", {
                x: "9",
                y: "2",
                width: "6",
                height: "6",
                rx: "1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 12V8"
            })
        ]
    }));
};
const Newspaper = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 1-2 2Zm0 0a2 2 0 0 1-2-2v-9c0-1.1.9-2 2-2h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 14h-8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 18h-5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 6h8v4h-8V6Z"
            })
        ]
    }));
};
const Nfc = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M6 8.32a7.43 7.43 0 0 1 0 7.36"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.46 6.21a11.76 11.76 0 0 1 0 11.58"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12.91 4.1a15.91 15.91 0 0 1 .01 15.8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16.37 2a20.16 20.16 0 0 1 0 20"
            })
        ]
    }));
};
const NotebookPen = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M13.4 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-7.4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 6h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 10h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 14h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 18h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18.4 2.6a2.17 2.17 0 0 1 3 3L16 11l-4 1 1-4Z"
            })
        ]
    }));
};
const NotebookTabs = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2 6h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 10h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 14h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 18h4"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "16",
                height: "20",
                x: "4",
                y: "2",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 2v20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 7h5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 12h5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 17h5"
            })
        ]
    }));
};
const NotebookText = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2 6h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 10h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 14h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 18h4"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "16",
                height: "20",
                x: "4",
                y: "2",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.5 8h5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.5 12H16"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.5 16H14"
            })
        ]
    }));
};
const Notebook = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2 6h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 10h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 14h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 18h4"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "16",
                height: "20",
                x: "4",
                y: "2",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 2v20"
            })
        ]
    }));
};
const NotepadTextDashed = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M8 2v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 2v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 4h2a2 2 0 0 1 2 2v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 12v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 18v2a2 2 0 0 1-2 2h-1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13 22h-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 22H6a2 2 0 0 1-2-2v-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 14v-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 8V6a2 2 0 0 1 2-2h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 10h6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 14h8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 18h5"
            })
        ]
    }));
};
const NotepadText = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M8 2v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 2v4"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "16",
                height: "18",
                x: "4",
                y: "4",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 10h6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 14h8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 18h5"
            })
        ]
    }));
};
const NutOff = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 4V2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 10v4a7.004 7.004 0 0 0 5.277 6.787c.412.104.802.292 1.102.592L12 22l.621-.621c.3-.3.69-.488 1.102-.592a7.01 7.01 0 0 0 4.125-2.939"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19 10v3.343"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 12c-1.349-.573-1.905-1.005-2.5-2-.546.902-1.048 1.353-2.5 2-1.018-.644-1.46-1.08-2-2-1.028.71-1.69.918-3 1 1.081-1.048 1.757-2.03 2-3 .194-.776.84-1.551 1.79-2.21m11.654 5.997c.887-.457 1.28-.891 1.556-1.787 1.032.916 1.683 1.157 3 1-1.297-1.036-1.758-2.03-2-3-.5-2-4-4-8-4-.74 0-1.461.068-2.15.192"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "2",
                x2: "22",
                y1: "2",
                y2: "22"
            })
        ]
    }));
};
const Nut = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 4V2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 10v4a7.004 7.004 0 0 0 5.277 6.787c.412.104.802.292 1.102.592L12 22l.621-.621c.3-.3.69-.488 1.102-.592A7.003 7.003 0 0 0 19 14v-4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 4C8 4 4.5 6 4 8c-.243.97-.919 1.952-2 3 1.31-.082 1.972-.29 3-1 .54.92.982 1.356 2 2 1.452-.647 1.954-1.098 2.5-2 .595.995 1.151 1.427 2.5 2 1.31-.621 1.862-1.058 2.5-2 .629.977 1.162 1.423 2.5 2 1.209-.548 1.68-.967 2-2 1.032.916 1.683 1.157 3 1-1.297-1.036-1.758-2.03-2-3-.5-2-4-4-8-4Z"
            })
        ]
    }));
};
const Octagon = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("polygon", {
            points: "7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"
        })
    }));
};
const Option = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3 3h6l6 18h6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 3h7"
            })
        ]
    }));
};
const Orbit = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "19",
                cy: "5",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "5",
                cy: "19",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10.4 21.9a10 10 0 0 0 9.941-15.416"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13.5 2.1a10 10 0 0 0-9.841 15.416"
            })
        ]
    }));
};
const Outdent = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("polyline", {
                points: "7 8 3 12 7 16"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "21",
                x2: "11",
                y1: "12",
                y2: "12"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "21",
                x2: "11",
                y1: "6",
                y2: "6"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "21",
                x2: "11",
                y1: "18",
                y2: "18"
            })
        ]
    }));
};
const Package2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3 9h18v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m3 9 2.45-4.9A2 2 0 0 1 7.24 3h9.52a2 2 0 0 1 1.8 1.1L21 9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 3v6"
            })
        ]
    }));
};
const PackageCheck = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m16 16 2 2 4-4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m7.5 4.27 9 5.15"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "3.29 7 12 12 20.71 7"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "12",
                y1: "22",
                y2: "12"
            })
        ]
    }));
};
const PackageMinus = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M16 16h6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m7.5 4.27 9 5.15"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "3.29 7 12 12 20.71 7"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "12",
                y1: "22",
                y2: "12"
            })
        ]
    }));
};
const PackageOpen = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 22v-9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15.17 2.21a1.67 1.67 0 0 1 1.63 0L21 4.57a1.93 1.93 0 0 1 0 3.36L8.82 14.79a1.655 1.655 0 0 1-1.64 0L3 12.43a1.93 1.93 0 0 1 0-3.36z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 13v3.87a2.06 2.06 0 0 1-1.11 1.83l-6 3.08a1.93 1.93 0 0 1-1.78 0l-6-3.08A2.06 2.06 0 0 1 4 16.87V13"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 12.43a1.93 1.93 0 0 0 0-3.36L8.83 2.2a1.64 1.64 0 0 0-1.63 0L3 4.57a1.93 1.93 0 0 0 0 3.36l12.18 6.86a1.636 1.636 0 0 0 1.63 0z"
            })
        ]
    }));
};
const PackagePlus = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M16 16h6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19 13v6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m7.5 4.27 9 5.15"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "3.29 7 12 12 20.71 7"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "12",
                y1: "22",
                y2: "12"
            })
        ]
    }));
};
const PackageSearch = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m7.5 4.27 9 5.15"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "3.29 7 12 12 20.71 7"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "12",
                y1: "22",
                y2: "12"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "18.5",
                cy: "15.5",
                r: "2.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20.27 17.27 22 19"
            })
        ]
    }));
};
const PackageX = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m7.5 4.27 9 5.15"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "3.29 7 12 12 20.71 7"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "12",
                y1: "22",
                y2: "12"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m17 13 5 5m-5 0 5-5"
            })
        ]
    }));
};
const Package = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m7.5 4.27 9 5.15"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m3.3 7 8.7 5 8.7-5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 22V12"
            })
        ]
    }));
};
const PaintBucket = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m19 11-8-8-8.6 8.6a2 2 0 0 0 0 2.8l5.2 5.2c.8.8 2 .8 2.8 0L19 11Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m5 2 5 5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 13h15"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 20a2 2 0 1 1-4 0c0-1.6 1.7-2.4 2-4 .3 1.6 2 2.4 2 4Z"
            })
        ]
    }));
};
const PaintRoller = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "16",
                height: "6",
                x: "2",
                y: "2",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 16v-2a2 2 0 0 1 2-2h8a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "4",
                height: "6",
                x: "8",
                y: "16",
                rx: "1"
            })
        ]
    }));
};
const Paintbrush2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M14 19.9V16h3a2 2 0 0 0 2-2v-2H5v2c0 1.1.9 2 2 2h3v3.9a2 2 0 1 0 4 0Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 12V2h12v10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 2v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 2v2"
            })
        ]
    }));
};
const Paintbrush = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M18.37 2.63 14 7l-1.59-1.59a2 2 0 0 0-2.82 0L8 7l9 9 1.59-1.59a2 2 0 0 0 0-2.82L17 10l4.37-4.37a2.12 2.12 0 1 0-3-3Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 8c-2 3-4 3.5-7 4l8 10c2-1 6-5 6-7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14.5 17.5 4.5 15"
            })
        ]
    }));
};
const Palette = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "13.5",
                cy: "6.5",
                r: ".5",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "17.5",
                cy: "10.5",
                r: ".5",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "8.5",
                cy: "7.5",
                r: ".5",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "6.5",
                cy: "12.5",
                r: ".5",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z"
            })
        ]
    }));
};
const Palmtree = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M13 8c0-2.76-2.46-5-5.5-5S2 5.24 2 8h2l1-1 1 1h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13 7.14A5.82 5.82 0 0 1 16.5 6c3.04 0 5.5 2.24 5.5 5h-3l-1-1-1 1h-3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5.89 9.71c-2.15 2.15-2.3 5.47-.35 7.43l4.24-4.25.7-.7.71-.71 2.12-2.12c-1.95-1.96-5.27-1.8-7.42.35z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11 15.5c.5 2.5-.17 4.5-1 6.5h4c2-5.5-.5-12-1-14"
            })
        ]
    }));
};
const PanelBottomClose = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 15h18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m15 8-3 3-3-3"
            })
        ]
    }));
};
const PanelBottomDashed = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 15h1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19 15h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 15h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 15h1"
            })
        ]
    }));
};
const PanelBottomOpen = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 15h18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9 10 3-3 3 3"
            })
        ]
    }));
};
const PanelBottom = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 15h18"
            })
        ]
    }));
};
const PanelLeftClose = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 3v18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m16 15-3-3 3-3"
            })
        ]
    }));
};
const PanelLeftDashed = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 14v1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 19v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 3v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 9v1"
            })
        ]
    }));
};
const PanelLeftOpen = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 3v18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m14 9 3 3-3 3"
            })
        ]
    }));
};
const PanelLeft = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 3v18"
            })
        ]
    }));
};
const PanelRightClose = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 3v18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m8 9 3 3-3 3"
            })
        ]
    }));
};
const PanelRightDashed = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 14v1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 19v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 3v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 9v1"
            })
        ]
    }));
};
const PanelRightOpen = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 3v18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m10 15-3-3 3-3"
            })
        ]
    }));
};
const PanelRight = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 3v18"
            })
        ]
    }));
};
const PanelTopClose = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 9h18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9 16 3-3 3 3"
            })
        ]
    }));
};
const PanelTopDashed = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 9h1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19 9h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 9h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 9h1"
            })
        ]
    }));
};
const PanelTopOpen = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 9h18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m15 14-3 3-3-3"
            })
        ]
    }));
};
const PanelTop = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 9h18"
            })
        ]
    }));
};
const PanelsLeftBottom = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 3v18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 15h12"
            })
        ]
    }));
};
const PanelsRightBottom = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 15h12"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 3v18"
            })
        ]
    }));
};
const PanelsTopLeft = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 9h18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 21V9"
            })
        ]
    }));
};
const Paperclip = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "m21.44 11.05-9.19 9.19a6 6 0 0 1-8.49-8.49l8.57-8.57A4 4 0 1 1 18 8.84l-8.59 8.57a2 2 0 0 1-2.83-2.83l8.49-8.48"
        })
    }));
};
const Parentheses = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M8 21s-4-3-4-9 4-9 4-9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 3s4 3 4 9-4 9-4 9"
            })
        ]
    }));
};
const ParkingCircleOff = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m5 5 14 14"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13 13a3 3 0 1 0 0-6H9v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 17v-2.34"
            })
        ]
    }));
};
const ParkingCircle = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 17V7h4a3 3 0 0 1 0 6H9"
            })
        ]
    }));
};
const ParkingMeter = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M9 9a3 3 0 1 1 6 0"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 12v3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11 15h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19 9a7 7 0 1 0-13.6 2.3C6.4 14.4 8 19 8 19h8s1.6-4.6 2.6-7.7c.3-.8.4-1.5.4-2.3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 19v3"
            })
        ]
    }));
};
const ParkingSquareOff = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3.6 3.6A2 2 0 0 1 5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-.59 1.41"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 8.7V19a2 2 0 0 0 2 2h10.3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m2 2 20 20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13 13a3 3 0 1 0 0-6H9v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 17v-2.3"
            })
        ]
    }));
};
const ParkingSquare = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 17V7h4a3 3 0 0 1 0 6H9"
            })
        ]
    }));
};
const PartyPopper = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M5.8 11.3 2 22l10.7-3.79"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 3h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 8h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 2h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 20h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m22 2-2.24.75a2.9 2.9 0 0 0-1.96 3.12v0c.1.86-.57 1.63-1.45 1.63h-.38c-.86 0-1.6.6-1.76 1.44L14 10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m22 13-.82-.33c-.86-.34-1.82.2-1.98 1.11v0c-.11.7-.72 1.22-1.43 1.22H17"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m11 2 .33.82c.34.86-.2 1.82-1.11 1.98v0C9.52 4.9 9 5.52 9 6.23V7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11 13c1.93 1.93 2.83 4.17 2 5-.83.83-3.07-.07-5-2-1.93-1.93-2.83-4.17-2-5 .83-.83 3.07.07 5 2Z"
            })
        ]
    }));
};
const PauseCircle = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "10",
                x2: "10",
                y1: "15",
                y2: "9"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "14",
                x2: "14",
                y1: "15",
                y2: "9"
            })
        ]
    }));
};
const PauseOctagon = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M10 15V9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 15V9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7.714 2h8.572L22 7.714v8.572L16.286 22H7.714L2 16.286V7.714L7.714 2z"
            })
        ]
    }));
};
const Pause = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "4",
                height: "16",
                x: "6",
                y: "4"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "4",
                height: "16",
                x: "14",
                y: "4"
            })
        ]
    }));
};
const PawPrint = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "11",
                cy: "4",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "18",
                cy: "8",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "20",
                cy: "16",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 10a5 5 0 0 1 5 5v3.5a3.5 3.5 0 0 1-6.84 1.045Q6.52 17.48 4.46 16.84A3.5 3.5 0 0 1 5.5 10Z"
            })
        ]
    }));
};
const PcCase = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "14",
                height: "20",
                x: "5",
                y: "2",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 14h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 6h6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 10h6"
            })
        ]
    }));
};
const PenLine = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 20h9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z"
            })
        ]
    }));
};
const PenTool = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m12 19 7-7 3 3-7 7-3-3z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m18 13-1.5-7.5L2 2l3.5 14.5L13 18l5-5z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m2 2 7.586 7.586"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "11",
                cy: "11",
                r: "2"
            })
        ]
    }));
};
const Pen = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z"
        })
    }));
};
const PencilLine = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 20h9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m15 5 3 3"
            })
        ]
    }));
};
const PencilRuler = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m15 5 4 4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13 7 8.7 2.7a2.41 2.41 0 0 0-3.4 0L2.7 5.3a2.41 2.41 0 0 0 0 3.4L7 13"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m8 6 2-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m2 22 5.5-1.5L21.17 6.83a2.82 2.82 0 0 0-4-4L3.5 16.5Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m18 16 2-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m17 11 4.3 4.3c.94.94.94 2.46 0 3.4l-2.6 2.6c-.94.94-2.46.94-3.4 0L11 17"
            })
        ]
    }));
};
const Pencil = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m15 5 4 4"
            })
        ]
    }));
};
const Pentagon = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M3.5 8.7c-.7.5-1 1.4-.7 2.2l2.8 8.7c.3.8 1 1.4 1.9 1.4h9.1c.9 0 1.6-.6 1.9-1.4l2.8-8.7c.3-.8 0-1.7-.7-2.2l-7.4-5.3a2.1 2.1 0 0 0-2.4 0Z"
        })
    }));
};
const PercentCircle = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m15 9-6 6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 9h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 15h.01"
            })
        ]
    }));
};
const PercentDiamond = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2.7 10.3a2.41 2.41 0 0 0 0 3.41l7.59 7.59a2.41 2.41 0 0 0 3.41 0l7.59-7.59a2.41 2.41 0 0 0 0-3.41L13.7 2.71a2.41 2.41 0 0 0-3.41 0Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.2 9.2h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m14.5 9.5-5 5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14.7 14.8h.01"
            })
        ]
    }));
};
const PercentSquare = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m15 9-6 6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 9h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 15h.01"
            })
        ]
    }));
};
const Percent = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("line", {
                x1: "19",
                x2: "5",
                y1: "5",
                y2: "19"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "6.5",
                cy: "6.5",
                r: "2.5"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "17.5",
                cy: "17.5",
                r: "2.5"
            })
        ]
    }));
};
const PersonStanding = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "5",
                r: "1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9 20 3-6 3 6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m6 8 6 2 6-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 10v4"
            })
        ]
    }));
};
const PhoneCall = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14.05 2a9 9 0 0 1 8 7.94"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14.05 6A5 5 0 0 1 18 10"
            })
        ]
    }));
};
const PhoneForwarded = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("polyline", {
                points: "18 2 22 6 18 10"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "14",
                x2: "22",
                y1: "6",
                y2: "6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
            })
        ]
    }));
};
const PhoneIncoming = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("polyline", {
                points: "16 2 16 8 22 8"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "22",
                x2: "16",
                y1: "2",
                y2: "8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
            })
        ]
    }));
};
const PhoneMissed = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("line", {
                x1: "22",
                x2: "16",
                y1: "2",
                y2: "8"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "16",
                x2: "22",
                y1: "2",
                y2: "8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
            })
        ]
    }));
};
const PhoneOff = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M10.68 13.31a16 16 0 0 0 3.41 2.6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7 2 2 0 0 1 1.72 2v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.42 19.42 0 0 1-3.33-2.67m-2.67-3.34a19.79 19.79 0 0 1-3.07-8.63A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "22",
                x2: "2",
                y1: "2",
                y2: "22"
            })
        ]
    }));
};
const PhoneOutgoing = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("polyline", {
                points: "22 8 22 2 16 2"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "16",
                x2: "22",
                y1: "8",
                y2: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
            })
        ]
    }));
};
const Phone = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
        })
    }));
};
const PiSquare = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 7h10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 7v10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 17a2 2 0 0 1-2-2V7"
            })
        ]
    }));
};
const Pi = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("line", {
                x1: "9",
                x2: "9",
                y1: "4",
                y2: "20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 7c0-1.7 1.3-3 3-3h13"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 20c-1.7 0-3-1.3-3-3V4"
            })
        ]
    }));
};
const Piano = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M18.5 8c-1.4 0-2.6-.8-3.2-2A6.87 6.87 0 0 0 2 9v11a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-8.5C22 9.6 20.4 8 18.5 8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 14h20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 14v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 14v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 14v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 14v4"
            })
        ]
    }));
};
const Pickaxe = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M14.531 12.469 6.619 20.38a1 1 0 1 1-3-3l7.912-7.912"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15.686 4.314A12.5 12.5 0 0 0 5.461 2.958 1 1 0 0 0 5.58 4.71a22 22 0 0 1 6.318 3.393"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17.7 3.7a1 1 0 0 0-1.4 0l-4.6 4.6a1 1 0 0 0 0 1.4l2.6 2.6a1 1 0 0 0 1.4 0l4.6-4.6a1 1 0 0 0 0-1.4z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19.686 8.314a12.501 12.501 0 0 1 1.356 10.225 1 1 0 0 1-1.751-.119 22 22 0 0 0-3.393-6.319"
            })
        ]
    }));
};
const PictureInPicture2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M21 9V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h4"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "10",
                height: "7",
                x: "12",
                y: "13",
                rx: "2"
            })
        ]
    }));
};
const PictureInPicture = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M8 4.5v5H3m-1-6 6 6m13 0v-3c0-1.16-.84-2-2-2h-7m-9 9v2c0 1.05.95 2 2 2h3"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "10",
                height: "7",
                x: "12",
                y: "13.5",
                ry: "2"
            })
        ]
    }));
};
const PieChart = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M21.21 15.89A10 10 0 1 1 8 2.83"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 12A10 10 0 0 0 12 2v10z"
            })
        ]
    }));
};
const PiggyBank = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M19 5c-1.5 0-2.8 1.4-3 2-3.5-1.5-11-.3-11 5 0 1.8 0 3 2 4.5V20h4v-2h3v2h4v-4c1-.5 1.7-1 2-2h2v-4h-2c0-1-.5-1.5-1-2h0V5z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 9v1c0 1.1.9 2 2 2h1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 11h0"
            })
        ]
    }));
};
const PilcrowSquare = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 12H9.5a2.5 2.5 0 0 1 0-5H17"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 7v10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 7v10"
            })
        ]
    }));
};
const Pilcrow = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M13 4v16"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 4v16"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19 4H9.5a4.5 4.5 0 0 0 0 9H13"
            })
        ]
    }));
};
const Pill = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m10.5 20.5 10-10a4.95 4.95 0 1 0-7-7l-10 10a4.95 4.95 0 1 0 7 7Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m8.5 8.5 7 7"
            })
        ]
    }));
};
const PinOff = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("line", {
                x1: "2",
                x2: "22",
                y1: "2",
                y2: "22"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "12",
                y1: "17",
                y2: "22"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 9v1.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V17h12"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 9.34V6h1a2 2 0 0 0 0-4H7.89"
            })
        ]
    }));
};
const Pin = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "12",
                y1: "17",
                y2: "22"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 17h14v-1.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V6h1a2 2 0 0 0 0-4H8a2 2 0 0 0 0 4h1v4.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24Z"
            })
        ]
    }));
};
const Pipette = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m2 22 1-1h3l9-9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 21v-3l9-9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m15 6 3.4-3.4a2.1 2.1 0 1 1 3 3L18 9l.4.4a2.1 2.1 0 1 1-3 3l-3.8-3.8a2.1 2.1 0 1 1 3-3l.4.4Z"
            })
        ]
    }));
};
const Pizza = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M15 11h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11 15h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 16h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m2 16 20 6-6-20A20 20 0 0 0 2 16"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5.71 17.11a17.04 17.04 0 0 1 11.4-11.4"
            })
        ]
    }));
};
const PlaneLanding = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2 22h20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3.77 10.77 2 9l2-4.5 1.1.55c.55.28.9.84.9 1.45s.35 1.17.9 1.45L8 8.5l3-6 1.05.53a2 2 0 0 1 1.09 1.52l.72 5.4a2 2 0 0 0 1.09 1.52l4.4 2.2c.42.22.78.55 1.01.96l.6 1.03c.49.88-.06 1.98-1.06 2.1l-1.18.15c-.47.06-.95-.02-1.37-.24L4.29 11.15a2 2 0 0 1-.52-.38Z"
            })
        ]
    }));
};
const PlaneTakeoff = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2 22h20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.36 17.4 4 17l-2-4 1.1-.55a2 2 0 0 1 1.8 0l.17.1a2 2 0 0 0 1.8 0L8 12 5 6l.9-.45a2 2 0 0 1 2.09.2l4.02 3a2 2 0 0 0 2.1.2l4.19-2.06a2.41 2.41 0 0 1 1.73-.17L21 7a1.4 1.4 0 0 1 .87 1.99l-.38.76c-.23.46-.6.84-1.07 1.08L7.58 17.2a2 2 0 0 1-1.22.18Z"
            })
        ]
    }));
};
const Plane = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z"
        })
    }));
};
const PlayCircle = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("polygon", {
                points: "10 8 16 12 10 16 10 8"
            })
        ]
    }));
};
const PlaySquare = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9 8 6 4-6 4Z"
            })
        ]
    }));
};
const Play = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("polygon", {
            points: "5 3 19 12 5 21 5 3"
        })
    }));
};
const Plug2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M9 2v6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 2v6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 17v5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 8h14"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 11V8h12v3a6 6 0 1 1-12 0v0Z"
            })
        ]
    }));
};
const PlugZap2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m13 2-2 2.5h3L12 7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 14v-3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 14v-3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11 19c-1.7 0-3-1.3-3-3v-2h8v2c0 1.7-1.3 3-3 3Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 22v-3"
            })
        ]
    }));
};
const PlugZap = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M6.3 20.3a2.4 2.4 0 0 0 3.4 0L12 18l-6-6-2.3 2.3a2.4 2.4 0 0 0 0 3.4Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m2 22 3-3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7.5 13.5 10 11"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10.5 16.5 13 14"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m18 3-4 4h6l-4 4"
            })
        ]
    }));
};
const Plug = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 22v-5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 8V2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 8V2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 8v5a4 4 0 0 1-4 4h-4a4 4 0 0 1-4-4V8Z"
            })
        ]
    }));
};
const PlusCircle = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 12h8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 8v8"
            })
        ]
    }));
};
const PlusSquare = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 12h8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 8v8"
            })
        ]
    }));
};
const Plus = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M5 12h14"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 5v14"
            })
        ]
    }));
};
const PocketKnife = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3 2v1c0 1 2 1 2 2S3 6 3 7s2 1 2 2-2 1-2 2 2 1 2 2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 6h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 18h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20.83 8.83a4 4 0 0 0-5.66-5.66l-12 12a4 4 0 1 0 5.66 5.66Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 11.66V22a4 4 0 0 0 4-4V6"
            })
        ]
    }));
};
const Pocket = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 3h16a2 2 0 0 1 2 2v6a10 10 0 0 1-10 10A10 10 0 0 1 2 11V5a2 2 0 0 1 2-2z"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "8 10 12 14 16 10"
            })
        ]
    }));
};
const Podcast = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "11",
                r: "1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11 17a1 1 0 0 1 2 0c0 .5-.34 3-.5 4.5a.5.5 0 0 1-1 0c-.16-1.5-.5-4-.5-4.5Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 14a5 5 0 1 1 8 0"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 18.5a9 9 0 1 0-10 0"
            })
        ]
    }));
};
const PointerOff = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M10 4.5V4a2 2 0 0 0-2.41-1.957"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13.9 8.4a2 2 0 0 0-1.26-1.295"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21.7 16.2A8 8 0 0 0 22 14v-3a2 2 0 1 0-4 0v-1a2 2 0 0 0-3.63-1.158"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m7 15-1.8-1.8a2 2 0 0 0-2.79 2.86L6 19.7a7.74 7.74 0 0 0 6 2.3h2a8 8 0 0 0 5.657-2.343"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 6v8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m2 2 20 20"
            })
        ]
    }));
};
const Pointer = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M22 14a8 8 0 0 1-8 8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 11v-1a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v0"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 10V9a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 9.5V4a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 11a2 2 0 1 1 4 0v3a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15"
            })
        ]
    }));
};
const Popcorn = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M18 8a2 2 0 0 0 0-4 2 2 0 0 0-4 0 2 2 0 0 0-4 0 2 2 0 0 0-4 0 2 2 0 0 0 0 4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 22 9 8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m14 22 1-14"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 8c.5 0 .9.4.8 1l-2.6 12c-.1.5-.7 1-1.2 1H7c-.6 0-1.1-.4-1.2-1L3.2 9c-.1-.6.3-1 .8-1Z"
            })
        ]
    }));
};
const Popsicle = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M18.6 14.4c.8-.8.8-2 0-2.8l-8.1-8.1a4.95 4.95 0 1 0-7.1 7.1l8.1 8.1c.9.7 2.1.7 2.9-.1Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m22 22-5.5-5.5"
            })
        ]
    }));
};
const PoundSterling = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M18 7c0-5.333-8-5.333-8 0"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 7v14"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 21h12"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 13h10"
            })
        ]
    }));
};
const PowerCircle = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 12V6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 7.5A6.1 6.1 0 0 0 12 18a6 6 0 0 0 4-10.5"
            })
        ]
    }));
};
const PowerOff = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M18.36 6.64A9 9 0 0 1 20.77 15"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.16 6.16a9 9 0 1 0 12.68 12.68"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m2 2 20 20"
            })
        ]
    }));
};
const PowerSquare = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 7v5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 9a5.14 5.14 0 0 0 4 8 4.95 4.95 0 0 0 4-8"
            })
        ]
    }));
};
const Power = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2v10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18.4 6.6a9 9 0 1 1-12.77.04"
            })
        ]
    }));
};
const Presentation = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2 3h20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 3v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m7 21 5-5 5 5"
            })
        ]
    }));
};
const Printer = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("polyline", {
                points: "6 9 6 2 18 2 18 9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "12",
                height: "8",
                x: "6",
                y: "14"
            })
        ]
    }));
};
const Projector = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M5 7 3 5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 6V3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m13 7 2-2"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "9",
                cy: "13",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11.83 12H20a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h2.17"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 16h2"
            })
        ]
    }));
};
const Puzzle = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M19.439 7.85c-.049.322.059.648.289.878l1.568 1.568c.47.47.706 1.087.706 1.704s-.235 1.233-.706 1.704l-1.611 1.611a.98.98 0 0 1-.837.276c-.47-.07-.802-.48-.968-.925a2.501 2.501 0 1 0-3.214 3.214c.446.166.855.497.925.968a.979.979 0 0 1-.276.837l-1.61 1.61a2.404 2.404 0 0 1-1.705.707 2.402 2.402 0 0 1-1.704-.706l-1.568-1.568a1.026 1.026 0 0 0-.877-.29c-.493.074-.84.504-1.02.968a2.5 2.5 0 1 1-3.237-3.237c.464-.18.894-.527.967-1.02a1.026 1.026 0 0 0-.289-.877l-1.568-1.568A2.402 2.402 0 0 1 1.998 12c0-.617.236-1.234.706-1.704L4.23 8.77c.24-.24.581-.353.917-.303.515.077.877.528 1.073 1.01a2.5 2.5 0 1 0 3.259-3.259c-.482-.196-.933-.558-1.01-1.073-.05-.336.062-.676.303-.917l1.525-1.525A2.402 2.402 0 0 1 12 1.998c.617 0 1.234.236 1.704.706l1.568 1.568c.23.23.556.338.877.29.493-.074.84-.504 1.02-.968a2.5 2.5 0 1 1 3.237 3.237c-.464.18-.894.527-.967 1.02Z"
        })
    }));
};
const Pyramid = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2.5 16.88a1 1 0 0 1-.32-1.43l9-13.02a1 1 0 0 1 1.64 0l9 13.01a1 1 0 0 1-.32 1.44l-8.51 4.86a2 2 0 0 1-1.98 0Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2v20"
            })
        ]
    }));
};
const QrCode = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "5",
                height: "5",
                x: "3",
                y: "3",
                rx: "1"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "5",
                height: "5",
                x: "16",
                y: "3",
                rx: "1"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "5",
                height: "5",
                x: "3",
                y: "16",
                rx: "1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 16h-3a2 2 0 0 0-2 2v3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 21v.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 7v3a2 2 0 0 1-2 2H7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 12h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 3h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 16v.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 12h1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 12v.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 21v-1"
            })
        ]
    }));
};
const Quote = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3 21c3 0 7-1 7-8V5c0-1.25-.756-2.017-2-2H4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2 1 0 1 0 1 1v1c0 1-1 2-2 2s-1 .008-1 1.031V20c0 1 0 1 1 1z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 21c3 0 7-1 7-8V5c0-1.25-.757-2.017-2-2h-4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2h.75c0 2.25.25 4-2.75 4v3c0 1 0 1 1 1z"
            })
        ]
    }));
};
const Rabbit = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M13 16a3 3 0 0 1 2.24 5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 12h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 21h-8a4 4 0 0 1-4-4 7 7 0 0 1 7-7h.2L9.6 6.4a1 1 0 1 1 2.8-2.8L15.8 7h.2c3.3 0 6 2.7 6 6v1a2 2 0 0 1-2 2h-1a3 3 0 0 0-3 3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 8.54V4a2 2 0 1 0-4 0v3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7.612 12.524a3 3 0 1 0-1.6 4.3"
            })
        ]
    }));
};
const Radar = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M19.07 4.93A10 10 0 0 0 6.99 3.34"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 6h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2.29 9.62A10 10 0 1 0 21.31 8.35"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16.24 7.76A6 6 0 1 0 8.23 16.67"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 18h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17.99 11.66A6 6 0 0 1 15.77 16.67"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m13.41 10.59 5.66-5.66"
            })
        ]
    }));
};
const Radiation = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 12h0.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7.5 4.2c-.3-.5-.9-.7-1.3-.4C3.9 5.5 2.3 8.1 2 11c-.1.5.4 1 1 1h5c0-1.5.8-2.8 2-3.4-1.1-1.9-2-3.5-2.5-4.4z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 12c.6 0 1-.4 1-1-.3-2.9-1.8-5.5-4.1-7.1-.4-.3-1.1-.2-1.3.3-.6.9-1.5 2.5-2.6 4.3 1.2.7 2 2 2 3.5h5z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7.5 19.8c-.3.5-.1 1.1.4 1.3 2.6 1.2 5.6 1.2 8.2 0 .5-.2.7-.8.4-1.3-.5-.9-1.4-2.5-2.5-4.3-1.2.7-2.8.7-4 0-1.1 1.8-2 3.4-2.5 4.3z"
            })
        ]
    }));
};
const Radical = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M3 12h4l3 9 4-17h7"
        })
    }));
};
const RadioReceiver = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M5 16v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19 16v2"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "20",
                height: "8",
                x: "2",
                y: "8",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 12h0"
            })
        ]
    }));
};
const RadioTower = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4.9 16.1C1 12.2 1 5.8 4.9 1.9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7.8 4.7a6.14 6.14 0 0 0-.8 7.5"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "9",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16.2 4.8c2 2 2.26 5.11.8 7.47"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19.1 1.9a9.96 9.96 0 0 1 0 14.1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.5 18h5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m8 22 4-11 4 11"
            })
        ]
    }));
};
const Radio = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4.9 19.1C1 15.2 1 8.8 4.9 4.9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7.8 16.2c-2.3-2.3-2.3-6.1 0-8.5"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16.2 7.8c2.3 2.3 2.3 6.1 0 8.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19.1 4.9C23 8.8 23 15.1 19.1 19"
            })
        ]
    }));
};
const Radius = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M20.34 17.52a10 10 0 1 0-2.82 2.82"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "19",
                cy: "19",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m13.41 13.41 4.18 4.18"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "2"
            })
        ]
    }));
};
const RailSymbol = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M5 15h14"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 9h14"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m14 20-5-5 6-6-5-5"
            })
        ]
    }));
};
const Rainbow = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M22 17a10 10 0 0 0-20 0"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 17a6 6 0 0 1 12 0"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 17a2 2 0 0 1 4 0"
            })
        ]
    }));
};
const Rat = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M17 5c0-1.7-1.3-3-3-3s-3 1.3-3 3c0 .8.3 1.5.8 2H11c-3.9 0-7 3.1-7 7v0c0 2.2 1.8 4 4 4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16.8 3.9c.3-.3.6-.5 1-.7 1.5-.6 3.3.1 3.9 1.6.6 1.5-.1 3.3-1.6 3.9l1.6 2.8c.2.3.2.7.2 1-.2.8-.9 1.2-1.7 1.1 0 0-1.6-.3-2.7-.6H17c-1.7 0-3 1.3-3 3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13.2 18a3 3 0 0 0-2.2-5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13 22H4a2 2 0 0 1 0-4h12"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 9h.01"
            })
        ]
    }));
};
const Ratio = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "12",
                height: "20",
                x: "6",
                y: "2",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "20",
                height: "12",
                x: "2",
                y: "6",
                rx: "2"
            })
        ]
    }));
};
const ReceiptCent = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 6.5v11"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 9.4a4 4 0 1 0 0 5.2"
            })
        ]
    }));
};
const ReceiptEuro = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 12h5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 9.5a4 4 0 1 0 0 5.2"
            })
        ]
    }));
};
const ReceiptIndianRupee = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 7h8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 17.5 8 15h1a4 4 0 0 0 0-8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 11h8"
            })
        ]
    }));
};
const ReceiptJapaneseYen = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m12 10 3-3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9 7 3 3v7.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 11h6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 15h6"
            })
        ]
    }));
};
const ReceiptPoundSterling = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 13h5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 17V9.5a2.5 2.5 0 0 1 5 0"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 17h7"
            })
        ]
    }));
};
const ReceiptRussianRuble = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 15h5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 11h5a2 2 0 1 0 0-4h-3v10"
            })
        ]
    }));
};
const ReceiptSwissFranc = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 17V7h5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 11h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 15h5"
            })
        ]
    }));
};
const ReceiptText = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 8H8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 12H8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13 16H8"
            })
        ]
    }));
};
const Receipt = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 17.5v-11"
            })
        ]
    }));
};
const RectangleHorizontal = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("rect", {
            width: "20",
            height: "12",
            x: "2",
            y: "6",
            rx: "2"
        })
    }));
};
const RectangleVertical = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("rect", {
            width: "12",
            height: "20",
            x: "6",
            y: "2",
            rx: "2"
        })
    }));
};
const Recycle = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M7 19H4.815a1.83 1.83 0 0 1-1.57-.881 1.785 1.785 0 0 1-.004-1.784L7.196 9.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11 19h8.203a1.83 1.83 0 0 0 1.556-.89 1.784 1.784 0 0 0 0-1.775l-1.226-2.12"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m14 16-3 3 3 3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8.293 13.596 7.196 9.5 3.1 10.598"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9.344 5.811 1.093-1.892A1.83 1.83 0 0 1 11.985 3a1.784 1.784 0 0 1 1.546.888l3.943 6.843"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m13.378 9.633 4.096 1.098 1.097-4.096"
            })
        ]
    }));
};
const Redo2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m15 14 5-5-5-5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 9H9.5A5.5 5.5 0 0 0 4 14.5v0A5.5 5.5 0 0 0 9.5 20H13"
            })
        ]
    }));
};
const RedoDot = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "17",
                r: "1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 7v6h-6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 17a9 9 0 0 1 9-9 9 9 0 0 1 6 2.3l3 2.7"
            })
        ]
    }));
};
const Redo = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M21 7v6h-6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 17a9 9 0 0 1 9-9 9 9 0 0 1 6 2.3l3 2.7"
            })
        ]
    }));
};
const RefreshCcwDot = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3 2v6h6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 12A9 9 0 0 0 6 5.3L3 8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 22v-6h-6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 12a9 9 0 0 0 15 6.7l3-2.7"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "1"
            })
        ]
    }));
};
const RefreshCcw = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 3v5h5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 16h5v5"
            })
        ]
    }));
};
const RefreshCwOff = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M21 8L18.74 5.74A9.75 9.75 0 0 0 12 3C11 3 10.03 3.16 9.13 3.47"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 16H3v5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 12C3 9.51 4 7.26 5.64 5.64"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m3 16 2.26 2.26A9.75 9.75 0 0 0 12 21c2.49 0 4.74-1 6.36-2.64"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 12c0 1-.16 1.97-.47 2.87"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 3v5h-5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 22 2 2"
            })
        ]
    }));
};
const RefreshCw = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 3v5h-5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 16H3v5"
            })
        ]
    }));
};
const Refrigerator = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M5 6a4 4 0 0 1 4-4h6a4 4 0 0 1 4 4v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 10h14"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 7v6"
            })
        ]
    }));
};
const Regex = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M17 3v10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m12.67 5.5 8.66 5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m12.67 10.5 8.66-5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 17a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-2z"
            })
        ]
    }));
};
const RemoveFormatting = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 7V4h16v3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 20h6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13 4 8 20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m15 15 5 5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m20 15-5 5"
            })
        ]
    }));
};
const Repeat1 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m17 2 4 4-4 4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 11v-1a4 4 0 0 1 4-4h14"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m7 22-4-4 4-4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 13v1a4 4 0 0 1-4 4H3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11 10h1v4"
            })
        ]
    }));
};
const Repeat2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m2 9 3-3 3 3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13 18H7a2 2 0 0 1-2-2V6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m22 15-3 3-3-3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11 6h6a2 2 0 0 1 2 2v10"
            })
        ]
    }));
};
const Repeat = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m17 2 4 4-4 4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 11v-1a4 4 0 0 1 4-4h14"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m7 22-4-4 4-4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 13v1a4 4 0 0 1-4 4H3"
            })
        ]
    }));
};
const ReplaceAll = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M14 4c0-1.1.9-2 2-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 2c1.1 0 2 .9 2 2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 8c0 1.1-.9 2-2 2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 10c-1.1 0-2-.9-2-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m3 7 3 3 3-3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 10V5c0-1.7 1.3-3 3-3h1"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "8",
                height: "8",
                x: "2",
                y: "14",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 14c1.1 0 2 .9 2 2v4c0 1.1-.9 2-2 2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 14c1.1 0 2 .9 2 2v4c0 1.1-.9 2-2 2"
            })
        ]
    }));
};
const Replace = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M14 4c0-1.1.9-2 2-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 2c1.1 0 2 .9 2 2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 8c0 1.1-.9 2-2 2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 10c-1.1 0-2-.9-2-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m3 7 3 3 3-3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 10V5c0-1.7 1.3-3 3-3h1"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "8",
                height: "8",
                x: "2",
                y: "14",
                rx: "2"
            })
        ]
    }));
};
const ReplyAll = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("polyline", {
                points: "7 17 2 12 7 7"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "12 17 7 12 12 7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 18v-2a4 4 0 0 0-4-4H7"
            })
        ]
    }));
};
const Reply = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("polyline", {
                points: "9 17 4 12 9 7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 18v-2a4 4 0 0 0-4-4H4"
            })
        ]
    }));
};
const Rewind = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("polygon", {
                points: "11 19 2 12 11 5 11 19"
            }),
            /*#__PURE__*/ _jsx("polygon", {
                points: "22 19 13 12 22 5 22 19"
            })
        ]
    }));
};
const Ribbon = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M17.75 9.01c-.52 2.08-1.83 3.64-3.18 5.49l-2.6 3.54-2.97 4-3.5-2.54 3.85-4.97c-1.86-2.61-2.8-3.77-3.16-5.44"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17.75 9.01A7 7 0 0 0 6.2 9.1C6.06 8.5 6 7.82 6 7c0-3.5 2.83-5 5.98-5C15.24 2 18 3.5 18 7c0 .73-.09 1.4-.25 2.01Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9.35 14.53 2.64-3.31"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m11.97 18.04 2.99 4 3.54-2.54-3.93-5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 8c0 1-1 2-2.01 3.22C11 10 10 9 10 8a2 2 0 1 1 4 0"
            })
        ]
    }));
};
const Rocket = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"
            })
        ]
    }));
};
const RockingChair = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("polyline", {
                points: "3.5 2 6.5 12.5 18 12.5"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "9.5",
                x2: "5.5",
                y1: "12.5",
                y2: "20"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "15",
                x2: "18.5",
                y1: "12.5",
                y2: "20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2.75 18a13 13 0 0 0 18.5 0"
            })
        ]
    }));
};
const RollerCoaster = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M6 19V5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 19V6.8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 19v-7.8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 5v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 19v-6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 19V9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 19V9a4 4 0 0 1 4-4c2 0 4 1.33 6 4s4 4 6 4a4 4 0 1 0-3-6.65"
            })
        ]
    }));
};
const Rotate3D = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M16.466 7.5C15.643 4.237 13.952 2 12 2 9.239 2 7 6.477 7 12s2.239 10 5 10c.342 0 .677-.069 1-.2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m15.194 13.707 3.814 1.86-1.86 3.814"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19 15.57c-1.804.885-4.274 1.43-7 1.43-5.523 0-10-2.239-10-5s4.477-5 10-5c4.838 0 8.873 1.718 9.8 4"
            })
        ]
    }));
};
const RotateCcw = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 3v5h5"
            })
        ]
    }));
};
const RotateCw = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 3v5h-5"
            })
        ]
    }));
};
const RouteOff = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "6",
                cy: "19",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 19h8.5c.4 0 .9-.1 1.3-.2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5.2 5.2A3.5 3.53 0 0 0 6.5 12H12"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m2 2 20 20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 15.3a3.5 3.5 0 0 0-3.3-3.3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 5h-4.3"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "18",
                cy: "5",
                r: "3"
            })
        ]
    }));
};
const Route = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "6",
                cy: "19",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 19h8.5a3.5 3.5 0 0 0 0-7h-11a3.5 3.5 0 0 1 0-7H15"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "18",
                cy: "5",
                r: "3"
            })
        ]
    }));
};
const Router = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "20",
                height: "8",
                x: "2",
                y: "14",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.01 18H6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10.01 18H10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 10v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17.84 7.17a4 4 0 0 0-5.66 0"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20.66 4.34a8 8 0 0 0-11.31 0"
            })
        ]
    }));
};
const Rows2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 12h18"
            })
        ]
    }));
};
const Rows3 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 9H3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 15H3"
            })
        ]
    }));
};
const Rows4 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 7.5H3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 12H3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 16.5H3"
            })
        ]
    }));
};
const Rss = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 11a9 9 0 0 1 9 9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 4a16 16 0 0 1 16 16"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "5",
                cy: "19",
                r: "1"
            })
        ]
    }));
};
const Ruler = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M21.3 15.3a2.4 2.4 0 0 1 0 3.4l-2.6 2.6a2.4 2.4 0 0 1-3.4 0L2.7 8.7a2.41 2.41 0 0 1 0-3.4l2.6-2.6a2.41 2.41 0 0 1 3.4 0Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m14.5 12.5 2-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m11.5 9.5 2-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m8.5 6.5 2-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m17.5 15.5 2-2"
            })
        ]
    }));
};
const RussianRuble = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M6 11h8a4 4 0 0 0 0-8H9v18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 15h8"
            })
        ]
    }));
};
const Sailboat = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M22 18H2a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 14 10 2 3 14h18Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 2v16"
            })
        ]
    }));
};
const Salad = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M7 21h10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 21a9 9 0 0 0 9-9H3a9 9 0 0 0 9 9Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11.38 12a2.4 2.4 0 0 1-.4-4.77 2.4 2.4 0 0 1 3.2-2.77 2.4 2.4 0 0 1 3.47-.63 2.4 2.4 0 0 1 3.37 3.37 2.4 2.4 0 0 1-1.1 3.7 2.51 2.51 0 0 1 .03 1.1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m13 12 4-4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10.9 7.25A3.99 3.99 0 0 0 4 10c0 .73.2 1.41.54 2"
            })
        ]
    }));
};
const Sandwich = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3 11v3a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 19H4a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-3.83"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m3 11 7.77-6.04a2 2 0 0 1 2.46 0L21 11H3Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12.97 19.77 7 15h12.5l-3.75 4.5a2 2 0 0 1-2.78.27Z"
            })
        ]
    }));
};
const SatelliteDish = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 10a7.31 7.31 0 0 0 10 10Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9 15 3-3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 13a6 6 0 0 0-6-6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 13A10 10 0 0 0 11 3"
            })
        ]
    }));
};
const Satellite = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M13 7 9 3 5 7l4 4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m17 11 4 4-4 4-4-4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m8 12 4 4 6-6-4-4Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m16 8 3-3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 21a6 6 0 0 0-6-6"
            })
        ]
    }));
};
const SaveAll = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M6 4a2 2 0 0 1 2-2h10l4 4v10.2a2 2 0 0 1-2 1.8H8a2 2 0 0 1-2-2Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 2v4h6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 18v-7h-8v7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 22H4a2 2 0 0 1-2-2V6"
            })
        ]
    }));
};
const Save = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "17 21 17 13 7 13 7 21"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "7 3 7 8 15 8"
            })
        ]
    }));
};
const Scale3D = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "19",
                cy: "19",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "5",
                cy: "5",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 7v12h12"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m5 19 6-6"
            })
        ]
    }));
};
const Scale = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m16 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m2 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 21h10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 3v18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 7h2c2 0 5-1 7-2 2 1 5 2 7 2h2"
            })
        ]
    }));
};
const Scaling = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 15H9v-5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 3h5v5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 3 9 15"
            })
        ]
    }));
};
const ScanBarcode = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3 7V5a2 2 0 0 1 2-2h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 3h2a2 2 0 0 1 2 2v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 17v2a2 2 0 0 1-2 2h-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 21H5a2 2 0 0 1-2-2v-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 7v10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 7v10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 7v10"
            })
        ]
    }));
};
const ScanEye = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3 7V5a2 2 0 0 1 2-2h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 3h2a2 2 0 0 1 2 2v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 17v2a2 2 0 0 1-2 2h-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 21H5a2 2 0 0 1-2-2v-2"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 12s2.5-5 7-5 7 5 7 5-2.5 5-7 5-7-5-7-5"
            })
        ]
    }));
};
const ScanFace = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3 7V5a2 2 0 0 1 2-2h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 3h2a2 2 0 0 1 2 2v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 17v2a2 2 0 0 1-2 2h-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 21H5a2 2 0 0 1-2-2v-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 14s1.5 2 4 2 4-2 4-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 9h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 9h.01"
            })
        ]
    }));
};
const ScanLine = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3 7V5a2 2 0 0 1 2-2h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 3h2a2 2 0 0 1 2 2v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 17v2a2 2 0 0 1-2 2h-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 21H5a2 2 0 0 1-2-2v-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 12h10"
            })
        ]
    }));
};
const ScanSearch = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3 7V5a2 2 0 0 1 2-2h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 3h2a2 2 0 0 1 2 2v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 17v2a2 2 0 0 1-2 2h-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 21H5a2 2 0 0 1-2-2v-2"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m16 16-1.9-1.9"
            })
        ]
    }));
};
const ScanText = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3 7V5a2 2 0 0 1 2-2h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 3h2a2 2 0 0 1 2 2v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 17v2a2 2 0 0 1-2 2h-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 21H5a2 2 0 0 1-2-2v-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 8h8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 12h10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 16h6"
            })
        ]
    }));
};
const Scan = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3 7V5a2 2 0 0 1 2-2h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 3h2a2 2 0 0 1 2 2v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 17v2a2 2 0 0 1-2 2h-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 21H5a2 2 0 0 1-2-2v-2"
            })
        ]
    }));
};
const ScatterChart = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "7.5",
                cy: "7.5",
                r: ".5",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "18.5",
                cy: "5.5",
                r: ".5",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "11.5",
                cy: "11.5",
                r: ".5",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "7.5",
                cy: "16.5",
                r: ".5",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "17.5",
                cy: "14.5",
                r: ".5",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 3v18h18"
            })
        ]
    }));
};
const School2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "10",
                r: "1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 20V8h-4l-6-4-6 4H2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 17v.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 13v.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 17v.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 13v.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 22v-5a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v5"
            })
        ]
    }));
};
const School = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M14 22v-4a2 2 0 1 0-4 0v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m18 10 4 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-8l4-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 5v17"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m4 6 8-4 8 4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 5v17"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "9",
                r: "2"
            })
        ]
    }));
};
const ScissorsLineDashed = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M5.42 9.42 8 12"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "4",
                cy: "8",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m14 6-8.58 8.58"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "4",
                cy: "16",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10.8 14.8 14 18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 12h-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 12h-2"
            })
        ]
    }));
};
const ScissorsSquareDashedBottom = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 22H8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 22h-2"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "8",
                cy: "8",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.414 9.414 12 12"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14.8 14.8 18 18"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "8",
                cy: "16",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m18 6-8.586 8.586"
            })
        ]
    }));
};
const ScissorsSquare = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "20",
                height: "20",
                x: "2",
                y: "2",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "8",
                cy: "8",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.414 9.414 12 12"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14.8 14.8 18 18"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "8",
                cy: "16",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m18 6-8.586 8.586"
            })
        ]
    }));
};
const Scissors = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "6",
                cy: "6",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8.12 8.12 12 12"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 4 8.12 15.88"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "6",
                cy: "18",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14.8 14.8 20 20"
            })
        ]
    }));
};
const ScreenShareOff = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M13 3H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 21h8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 17v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m22 3-5 5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m17 3 5 5"
            })
        ]
    }));
};
const ScreenShare = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M13 3H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 21h8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 17v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m17 8 5-5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 3h5v5"
            })
        ]
    }));
};
const ScrollText = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M8 21h12a2 2 0 0 0 2-2v-2H10v2a2 2 0 1 1-4 0V5a2 2 0 1 0-4 0v3h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19 17V5a2 2 0 0 0-2-2H4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 8h-5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 12h-5"
            })
        ]
    }));
};
const Scroll = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M8 21h12a2 2 0 0 0 2-2v-2H10v2a2 2 0 1 1-4 0V5a2 2 0 1 0-4 0v3h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19 17V5a2 2 0 0 0-2-2H4"
            })
        ]
    }));
};
const SearchCheck = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m8 11 2 2 4-4"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "11",
                cy: "11",
                r: "8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m21 21-4.3-4.3"
            })
        ]
    }));
};
const SearchCode = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m9 9-2 2 2 2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m13 13 2-2-2-2"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "11",
                cy: "11",
                r: "8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m21 21-4.3-4.3"
            })
        ]
    }));
};
const SearchSlash = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m13.5 8.5-5 5"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "11",
                cy: "11",
                r: "8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m21 21-4.3-4.3"
            })
        ]
    }));
};
const SearchX = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m13.5 8.5-5 5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m8.5 8.5 5 5"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "11",
                cy: "11",
                r: "8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m21 21-4.3-4.3"
            })
        ]
    }));
};
const Search = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "11",
                cy: "11",
                r: "8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m21 21-4.3-4.3"
            })
        ]
    }));
};
const SendHorizontal = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m3 3 3 9-3 9 19-9Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 12h16"
            })
        ]
    }));
};
const SendToBack = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                x: "14",
                y: "14",
                width: "8",
                height: "8",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("rect", {
                x: "2",
                y: "2",
                width: "8",
                height: "8",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 14v1a2 2 0 0 0 2 2h1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 7h1a2 2 0 0 1 2 2v1"
            })
        ]
    }));
};
const Send = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m22 2-7 20-4-9-9-4Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 2 11 13"
            })
        ]
    }));
};
const SeparatorHorizontal = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("line", {
                x1: "3",
                x2: "21",
                y1: "12",
                y2: "12"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "8 8 12 4 16 8"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "16 16 12 20 8 16"
            })
        ]
    }));
};
const SeparatorVertical = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "12",
                y1: "3",
                y2: "21"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "8 8 4 12 8 16"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "16 16 20 12 16 8"
            })
        ]
    }));
};
const ServerCog = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4.5 10H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4.5 14H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 6h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 18h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m15.7 13.4-.9-.3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9.2 10.9-.9-.3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m10.6 15.7.3-.9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m13.6 15.7-.4-1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m10.8 9.3-.4-1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m8.3 13.6 1-.4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m14.7 10.8 1-.4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m13.4 8.3-.3.9"
            })
        ]
    }));
};
const ServerCrash = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M6 10H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 14H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 6h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 18h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m13 6-4 6h6l-4 6"
            })
        ]
    }));
};
const ServerOff = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M7 2h13a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 10 2.5 2.5C2 2 2 2.5 2 5v3a2 2 0 0 0 2 2h6z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 17v-1a2 2 0 0 0-2-2h-1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 14a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16.5l1-.5.5.5-8-8H4z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 18h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m2 2 20 20"
            })
        ]
    }));
};
const Server = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "20",
                height: "8",
                x: "2",
                y: "2",
                rx: "2",
                ry: "2"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "20",
                height: "8",
                x: "2",
                y: "14",
                rx: "2",
                ry: "2"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "6",
                x2: "6.01",
                y1: "6",
                y2: "6"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "6",
                x2: "6.01",
                y1: "18",
                y2: "18"
            })
        ]
    }));
};
const Settings2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M20 7h-9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 17H5"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "17",
                cy: "17",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "7",
                cy: "7",
                r: "3"
            })
        ]
    }));
};
const Settings = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "3"
            })
        ]
    }));
};
const Shapes = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M8.3 10a.7.7 0 0 1-.626-1.079L11.4 3a.7.7 0 0 1 1.198-.043L16.3 8.9a.7.7 0 0 1-.572 1.1Z"
            }),
            /*#__PURE__*/ _jsx("rect", {
                x: "3",
                y: "14",
                width: "7",
                height: "7",
                rx: "1"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "17.5",
                cy: "17.5",
                r: "3.5"
            })
        ]
    }));
};
const Share2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "18",
                cy: "5",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "6",
                cy: "12",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "18",
                cy: "19",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "8.59",
                x2: "15.42",
                y1: "13.51",
                y2: "17.49"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "15.41",
                x2: "8.59",
                y1: "6.51",
                y2: "10.49"
            })
        ]
    }));
};
const Share = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "16 6 12 2 8 6"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "12",
                y1: "2",
                y2: "15"
            })
        ]
    }));
};
const Sheet = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2",
                ry: "2"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "3",
                x2: "21",
                y1: "9",
                y2: "9"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "3",
                x2: "21",
                y1: "15",
                y2: "15"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "9",
                x2: "9",
                y1: "9",
                y2: "21"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "15",
                x2: "15",
                y1: "9",
                y2: "21"
            })
        ]
    }));
};
const Shell = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M14 11a2 2 0 1 1-4 0 4 4 0 0 1 8 0 6 6 0 0 1-12 0 8 8 0 0 1 16 0 10 10 0 1 1-20 0 11.93 11.93 0 0 1 2.42-7.22 2 2 0 1 1 3.16 2.44"
        })
    }));
};
const ShieldAlert = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 8v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 16h.01"
            })
        ]
    }));
};
const ShieldBan = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m4.243 5.21 14.39 12.472"
            })
        ]
    }));
};
const ShieldCheck = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9 12 2 2 4-4"
            })
        ]
    }));
};
const ShieldEllipsis = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 12h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 12h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 12h.01"
            })
        ]
    }));
};
const ShieldHalf = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 22V2"
            })
        ]
    }));
};
const ShieldMinus = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 12h6"
            })
        ]
    }));
};
const ShieldOff = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m2 2 20 20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 5a1 1 0 0 0-1 1v7c0 5 3.5 7.5 7.67 8.94a1 1 0 0 0 .67.01c2.35-.82 4.48-1.97 5.9-3.71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.309 3.652A12.252 12.252 0 0 0 11.24 2.28a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1v7a9.784 9.784 0 0 1-.08 1.264"
            })
        ]
    }));
};
const ShieldPlus = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 12h6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 9v6"
            })
        ]
    }));
};
const ShieldQuestion = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.1 9a3 3 0 0 1 5.82 1c0 2-3 3-3 3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 17h.01"
            })
        ]
    }));
};
const ShieldX = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m14.5 9.5-5 5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9.5 9.5 5 5"
            })
        ]
    }));
};
const Shield = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
        })
    }));
};
const ShipWheel = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2v7.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m19 5-5.23 5.23"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 12h-7.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m19 19-5.23-5.23"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 14.5V22"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10.23 13.77 5 19"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.5 12H2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10.23 10.23 5 5"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "2.5"
            })
        ]
    }));
};
const Ship = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2 21c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1 .6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19.38 20A11.6 11.6 0 0 0 21 14l-9-4-9 4c0 2.9.94 5.34 2.81 7.76"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19 13V7a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 10v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2v3"
            })
        ]
    }));
};
const Shirt = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M20.38 3.46 16 2a4 4 0 0 1-8 0L3.62 3.46a2 2 0 0 0-1.34 2.23l.58 3.47a1 1 0 0 0 .99.84H6v10c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V10h2.15a1 1 0 0 0 .99-.84l.58-3.47a2 2 0 0 0-1.34-2.23z"
        })
    }));
};
const ShoppingBag = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 6h18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 10a4 4 0 0 1-8 0"
            })
        ]
    }));
};
const ShoppingBasket = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m15 11-1 9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m19 11-4-7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 11h20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m3.5 11 1.6 7.4a2 2 0 0 0 2 1.6h9.8a2 2 0 0 0 2-1.6l1.7-7.4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4.5 15.5h15"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m5 11 4-7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9 11 1 9"
            })
        ]
    }));
};
const ShoppingCart = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "8",
                cy: "21",
                r: "1"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "19",
                cy: "21",
                r: "1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"
            })
        ]
    }));
};
const Shovel = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2 22v-5l5-5 5 5-5 5z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.5 14.5 16 8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m17 2 5 5-.5.5a3.53 3.53 0 0 1-5 0s0 0 0 0a3.53 3.53 0 0 1 0-5L17 2"
            })
        ]
    }));
};
const ShowerHead = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m4 4 2.5 2.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13.5 6.5a4.95 4.95 0 0 0-7 7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 5 5 15"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 17v.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 16v.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13 13v.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 10v.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11 20v.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 14v.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 11v.01"
            })
        ]
    }));
};
const Shrink = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m15 15 6 6m-6-6v4.8m0-4.8h4.8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 19.8V15m0 0H4.2M9 15l-6 6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 4.2V9m0 0h4.8M15 9l6-6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 4.2V9m0 0H4.2M9 9 3 3"
            })
        ]
    }));
};
const Shrub = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 22v-7l-2-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 8v.8A6 6 0 0 1 13.8 20v0H10v0A6.5 6.5 0 0 1 7 8h0a5 5 0 0 1 10 0Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m14 14-2 2"
            })
        ]
    }));
};
const Shuffle = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2 18h1.4c1.3 0 2.5-.6 3.3-1.7l6.1-8.6c.7-1.1 2-1.7 3.3-1.7H22"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m18 2 4 4-4 4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 6h1.9c1.5 0 2.9.9 3.6 2.2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 18h-5.9c-1.3 0-2.6-.7-3.3-1.8l-.5-.8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m18 14 4 4-4 4"
            })
        ]
    }));
};
const SigmaSquare = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 8.9V7H8l4 5-4 5h8v-1.9"
            })
        ]
    }));
};
const Sigma = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M18 7V4H6l6 8-6 8h12v-3"
        })
    }));
};
const SignalHigh = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2 20h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 20v-4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 20v-8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 20V8"
            })
        ]
    }));
};
const SignalLow = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2 20h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 20v-4"
            })
        ]
    }));
};
const SignalMedium = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2 20h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 20v-4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 20v-8"
            })
        ]
    }));
};
const SignalZero = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M2 20h.01"
        })
    }));
};
const Signal = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2 20h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 20v-4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 20v-8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 20V8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 4v16"
            })
        ]
    }));
};
const SignpostBig = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M10 9H4L2 7l2-2h6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 5h6l2 2-2 2h-6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 22V4a2 2 0 1 1 4 0v18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 22h8"
            })
        ]
    }));
};
const Signpost = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 3v3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18.5 13h-13L2 9.5 5.5 6h13L22 9.5Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 13v8"
            })
        ]
    }));
};
const Siren = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M7 18v-6a5 5 0 1 1 10 0v6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 21a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-1a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 12h1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18.5 4.5 18 5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 12h1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2v1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m4.929 4.929.707.707"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 12v6"
            })
        ]
    }));
};
const SkipBack = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("polygon", {
                points: "19 20 9 12 19 4 19 20"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "5",
                x2: "5",
                y1: "19",
                y2: "5"
            })
        ]
    }));
};
const SkipForward = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("polygon", {
                points: "5 4 15 12 5 20 5 4"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "19",
                x2: "19",
                y1: "5",
                y2: "19"
            })
        ]
    }));
};
const Skull = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "9",
                cy: "12",
                r: "1"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "15",
                cy: "12",
                r: "1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 20v2h8v-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m12.5 17-.5-1-.5 1h1z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 20a2 2 0 0 0 1.56-3.25 8 8 0 1 0-11.12 0A2 2 0 0 0 8 20"
            })
        ]
    }));
};
const Slack = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "3",
                height: "8",
                x: "13",
                y: "2",
                rx: "1.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19 8.5V10h1.5A1.5 1.5 0 1 0 19 8.5"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "3",
                height: "8",
                x: "8",
                y: "14",
                rx: "1.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 15.5V14H3.5A1.5 1.5 0 1 0 5 15.5"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "8",
                height: "3",
                x: "14",
                y: "13",
                rx: "1.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15.5 19H14v1.5a1.5 1.5 0 1 0 1.5-1.5"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "8",
                height: "3",
                x: "2",
                y: "8",
                rx: "1.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8.5 5H10V3.5A1.5 1.5 0 1 0 8.5 5"
            })
        ]
    }));
};
const SlashSquare = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "9",
                x2: "15",
                y1: "15",
                y2: "9"
            })
        ]
    }));
};
const Slash = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M22 2 2 22"
        })
    }));
};
const Slice = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m8 14-6 6h9v-3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18.37 3.63 8 14l3 3L21.37 6.63a2.12 2.12 0 1 0-3-3Z"
            })
        ]
    }));
};
const SlidersHorizontal = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("line", {
                x1: "21",
                x2: "14",
                y1: "4",
                y2: "4"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "10",
                x2: "3",
                y1: "4",
                y2: "4"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "21",
                x2: "12",
                y1: "12",
                y2: "12"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "8",
                x2: "3",
                y1: "12",
                y2: "12"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "21",
                x2: "16",
                y1: "20",
                y2: "20"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "3",
                y1: "20",
                y2: "20"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "14",
                x2: "14",
                y1: "2",
                y2: "6"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "8",
                x2: "8",
                y1: "10",
                y2: "14"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "16",
                x2: "16",
                y1: "18",
                y2: "22"
            })
        ]
    }));
};
const Sliders = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("line", {
                x1: "4",
                x2: "4",
                y1: "21",
                y2: "14"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "4",
                x2: "4",
                y1: "10",
                y2: "3"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "12",
                y1: "21",
                y2: "12"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "12",
                y1: "8",
                y2: "3"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "20",
                x2: "20",
                y1: "21",
                y2: "16"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "20",
                x2: "20",
                y1: "12",
                y2: "3"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "2",
                x2: "6",
                y1: "14",
                y2: "14"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "10",
                x2: "14",
                y1: "8",
                y2: "8"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "18",
                x2: "22",
                y1: "16",
                y2: "16"
            })
        ]
    }));
};
const SmartphoneCharging = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "14",
                height: "20",
                x: "5",
                y: "2",
                rx: "2",
                ry: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12.667 8 10 12h4l-2.667 4"
            })
        ]
    }));
};
const SmartphoneNfc = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "7",
                height: "12",
                x: "2",
                y: "6",
                rx: "1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13 8.32a7.43 7.43 0 0 1 0 7.36"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16.46 6.21a11.76 11.76 0 0 1 0 11.58"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19.91 4.1a15.91 15.91 0 0 1 .01 15.8"
            })
        ]
    }));
};
const Smartphone = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "14",
                height: "20",
                x: "5",
                y: "2",
                rx: "2",
                ry: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 18h.01"
            })
        ]
    }));
};
const SmilePlus = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M22 11v1a10 10 0 1 1-9-10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 14s1.5 2 4 2 4-2 4-2"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "9",
                x2: "9.01",
                y1: "9",
                y2: "9"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "15",
                x2: "15.01",
                y1: "9",
                y2: "9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 5h6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19 2v6"
            })
        ]
    }));
};
const Smile = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 14s1.5 2 4 2 4-2 4-2"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "9",
                x2: "9.01",
                y1: "9",
                y2: "9"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "15",
                x2: "15.01",
                y1: "9",
                y2: "9"
            })
        ]
    }));
};
const Snail = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2 13a6 6 0 1 0 12 0 4 4 0 1 0-8 0 2 2 0 0 0 4 0"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "10",
                cy: "13",
                r: "8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 21h12c4.4 0 8-3.6 8-8V7a2 2 0 1 0-4 0v6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 3 19.1 5.2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 3 20.9 5.2"
            })
        ]
    }));
};
const Snowflake = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("line", {
                x1: "2",
                x2: "22",
                y1: "12",
                y2: "12"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "12",
                y1: "2",
                y2: "22"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m20 16-4-4 4-4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m4 8 4 4-4 4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m16 4-4 4-4-4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m8 20 4-4 4 4"
            })
        ]
    }));
};
const Sofa = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M20 9V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 11v5a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-5a2 2 0 0 0-4 0v2H6v-2a2 2 0 0 0-4 0Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 18v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 18v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 4v9"
            })
        ]
    }));
};
const Soup = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 21a9 9 0 0 0 9-9H3a9 9 0 0 0 9 9Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 21h10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19.5 12 22 6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16.25 3c.27.1.8.53.75 1.36-.06.83-.93 1.2-1 2.02-.05.78.34 1.24.73 1.62"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11.25 3c.27.1.8.53.74 1.36-.05.83-.93 1.2-.98 2.02-.06.78.33 1.24.72 1.62"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.25 3c.27.1.8.53.75 1.36-.06.83-.93 1.2-1 2.02-.05.78.34 1.24.74 1.62"
            })
        ]
    }));
};
const Space = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M22 17v1c0 .5-.5 1-1 1H3c-.5 0-1-.5-1-1v-1"
        })
    }));
};
const Spade = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M5 9c-1.5 1.5-3 3.2-3 5.5A5.5 5.5 0 0 0 7.5 20c1.8 0 3-.5 4.5-2 1.5 1.5 2.7 2 4.5 2a5.5 5.5 0 0 0 5.5-5.5c0-2.3-1.5-4-3-5.5l-7-7-7 7Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 18v4"
            })
        ]
    }));
};
const Sparkle = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "m12 3-1.9 5.8a2 2 0 0 1-1.287 1.288L3 12l5.8 1.9a2 2 0 0 1 1.288 1.287L12 21l1.9-5.8a2 2 0 0 1 1.287-1.288L21 12l-5.8-1.9a2 2 0 0 1-1.288-1.287Z"
        })
    }));
};
const Sparkles = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 3v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19 17v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 5h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 19h4"
            })
        ]
    }));
};
const Speaker = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "16",
                height: "20",
                x: "4",
                y: "2",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 6h.01"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "14",
                r: "4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 14h.01"
            })
        ]
    }));
};
const Speech = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M8.8 20v-4.1l1.9.2a2.3 2.3 0 0 0 2.164-2.1V8.3A5.37 5.37 0 0 0 2 8.25c0 2.8.656 3.054 1 4.55a5.77 5.77 0 0 1 .029 2.758L2 20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19.8 17.8a7.5 7.5 0 0 0 .003-10.603"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 15a3.5 3.5 0 0 0-.025-4.975"
            })
        ]
    }));
};
const SpellCheck2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m6 16 6-12 6 12"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 12h8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 21c1.1 0 1.1-1 2.3-1s1.1 1 2.3 1c1.1 0 1.1-1 2.3-1 1.1 0 1.1 1 2.3 1 1.1 0 1.1-1 2.3-1 1.1 0 1.1 1 2.3 1 1.1 0 1.1-1 2.3-1"
            })
        ]
    }));
};
const SpellCheck = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m6 16 6-12 6 12"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 12h8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m16 20 2 2 4-4"
            })
        ]
    }));
};
const Spline = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "19",
                cy: "5",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "5",
                cy: "19",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 17A12 12 0 0 1 17 5"
            })
        ]
    }));
};
const SplitSquareHorizontal = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M8 19H5c-1 0-2-1-2-2V7c0-1 1-2 2-2h3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 5h3c1 0 2 1 2 2v10c0 1-1 2-2 2h-3"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "12",
                y1: "4",
                y2: "20"
            })
        ]
    }));
};
const SplitSquareVertical = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M5 8V5c0-1 1-2 2-2h10c1 0 2 1 2 2v3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19 16v3c0 1-1 2-2 2H7c-1 0-2-1-2-2v-3"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "4",
                x2: "20",
                y1: "12",
                y2: "12"
            })
        ]
    }));
};
const Split = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M16 3h5v5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 3H3v5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 22v-8.3a4 4 0 0 0-1.172-2.872L3 3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m15 9 6-6"
            })
        ]
    }));
};
const SprayCan = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3 3h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 5h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11 7h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 7h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 9h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 11h.01"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "4",
                height: "4",
                x: "15",
                y: "5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m19 9 2 2v10c0 .6-.4 1-1 1h-6c-.6 0-1-.4-1-1V11l2-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m13 14 8-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m13 19 8-2"
            })
        ]
    }));
};
const Sprout = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M7 20h10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 20c5.5-2.5.8-6.4 3-10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.5 9.4c1.1.8 1.8 2.2 2.3 3.7-2 .4-3.5.4-4.8-.3-1.2-.6-2.3-1.9-3-4.2 2.8-.5 4.4 0 5.5.8z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14.1 6a7 7 0 0 0-1.1 4c1.9-.1 3.3-.6 4.3-1.4 1-1 1.6-2.3 1.7-4.6-2.7.1-4 1-4.9 2z"
            })
        ]
    }));
};
const SquareDashedBottomCode = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m10 10-2 2 2 2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m14 14 2-2-2-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 21a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 21h1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 21h1"
            })
        ]
    }));
};
const SquareDashedBottom = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M5 21a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 21h1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 21h1"
            })
        ]
    }));
};
const SquarePen = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18.375 2.625a2.121 2.121 0 1 1 3 3L12 15l-4 1 1-4Z"
            })
        ]
    }));
};
const SquareRadical = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M7 12h2l2 5 2-10h4"
            }),
            /*#__PURE__*/ _jsx("rect", {
                x: "3",
                y: "3",
                width: "18",
                height: "18",
                rx: "2"
            })
        ]
    }));
};
const SquareStack = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 10c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 16c-1.1 0-2-.9-2-2v-4c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "8",
                height: "8",
                x: "14",
                y: "14",
                rx: "2"
            })
        ]
    }));
};
const SquareUserRound = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M18 21a6 6 0 0 0-12 0"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "11",
                r: "4"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            })
        ]
    }));
};
const SquareUser = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "10",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 21v-2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2"
            })
        ]
    }));
};
const Square = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("rect", {
            width: "18",
            height: "18",
            x: "3",
            y: "3",
            rx: "2"
        })
    }));
};
const Squircle = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9-9 9-9-1.8-9-9 1.8-9 9-9"
        })
    }));
};
const Squirrel = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M15.236 22a3 3 0 0 0-2.2-5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 20a3 3 0 0 1 3-3h1a2 2 0 0 0 2-2v-2a4 4 0 0 0-4-4V4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 13h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 6a4 4 0 0 0-4 4 7 7 0 0 0-7 7c0-5 4-5 4-10.5a4.5 4.5 0 1 0-9 0 2.5 2.5 0 0 0 5 0C7 10 3 11 3 17c0 2.8 2.2 5 5 5h10"
            })
        ]
    }));
};
const Stamp = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M5 22h14"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19.27 13.73A2.5 2.5 0 0 0 17.5 13h-11A2.5 2.5 0 0 0 4 15.5V17a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-1.5c0-.66-.26-1.3-.73-1.77Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 13V8.5C14 7 15 7 15 5a3 3 0 0 0-3-3c-1.66 0-3 1-3 3s1 2 1 3.5V13"
            })
        ]
    }));
};
const StarHalf = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M12 17.8 5.8 21 7 14.1 2 9.3l7-1L12 2"
        })
    }));
};
const StarOff = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M8.34 8.34 2 9.27l5 4.87L5.82 21 12 17.77 18.18 21l-.59-3.43"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18.42 12.76 22 9.27l-6.91-1L12 2l-1.44 2.91"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "2",
                x2: "22",
                y1: "2",
                y2: "22"
            })
        ]
    }));
};
const Star = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("polygon", {
            points: "12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"
        })
    }));
};
const StepBack = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("line", {
                x1: "18",
                x2: "18",
                y1: "20",
                y2: "4"
            }),
            /*#__PURE__*/ _jsx("polygon", {
                points: "14,20 4,12 14,4"
            })
        ]
    }));
};
const StepForward = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("line", {
                x1: "6",
                x2: "6",
                y1: "4",
                y2: "20"
            }),
            /*#__PURE__*/ _jsx("polygon", {
                points: "10,4 20,12 10,20"
            })
        ]
    }));
};
const Stethoscope = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4.8 2.3A.3.3 0 1 0 5 2H4a2 2 0 0 0-2 2v5a6 6 0 0 0 6 6v0a6 6 0 0 0 6-6V4a2 2 0 0 0-2-2h-1a.2.2 0 1 0 .3.3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 15v1a6 6 0 0 0 6 6v0a6 6 0 0 0 6-6v-4"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "20",
                cy: "10",
                r: "2"
            })
        ]
    }));
};
const Sticker = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M15.5 3H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h14a2 2 0 0 0 2-2V8.5L15.5 3Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 3v4a2 2 0 0 0 2 2h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 13h0"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 13h0"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 16s.8 1 2 1c1.3 0 2-1 2-1"
            })
        ]
    }));
};
const StickyNote = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M16 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 3v4a2 2 0 0 0 2 2h4"
            })
        ]
    }));
};
const StopCircle = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "6",
                height: "6",
                x: "9",
                y: "9"
            })
        ]
    }));
};
const Store = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m2 7 4.41-4.41A2 2 0 0 1 7.83 2h8.34a2 2 0 0 1 1.42.59L22 7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 22v-4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 7h20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 7v3a2 2 0 0 1-2 2v0a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 16 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 12 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 8 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 4 12v0a2 2 0 0 1-2-2V7"
            })
        ]
    }));
};
const StretchHorizontal = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "20",
                height: "6",
                x: "2",
                y: "4",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "20",
                height: "6",
                x: "2",
                y: "14",
                rx: "2"
            })
        ]
    }));
};
const StretchVertical = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "6",
                height: "20",
                x: "4",
                y: "2",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "6",
                height: "20",
                x: "14",
                y: "2",
                rx: "2"
            })
        ]
    }));
};
const Strikethrough = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M16 4H9a3 3 0 0 0-2.83 4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 12a4 4 0 0 1 0 8H6"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "4",
                x2: "20",
                y1: "12",
                y2: "12"
            })
        ]
    }));
};
const Subscript = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m4 5 8 8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m12 5-8 8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 19h-4c0-1.5.44-2 1.5-2.5S20 15.33 20 14c0-.47-.17-.93-.48-1.29a2.11 2.11 0 0 0-2.62-.44c-.42.24-.74.62-.9 1.07"
            })
        ]
    }));
};
const SunDim = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 4h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 12h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 20h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 12h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17.657 6.343h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17.657 17.657h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.343 17.657h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.343 6.343h.01"
            })
        ]
    }));
};
const SunMedium = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 3v1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 20v1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 12h1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 12h1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m18.364 5.636-.707.707"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m6.343 17.657-.707.707"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m5.636 5.636.707.707"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m17.657 17.657.707.707"
            })
        ]
    }));
};
const SunMoon = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 8a2.83 2.83 0 0 0 4 4 4 4 0 1 1-4-4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 20v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m4.9 4.9 1.4 1.4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m17.7 17.7 1.4 1.4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 12h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 12h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m6.3 17.7-1.4 1.4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m19.1 4.9-1.4 1.4"
            })
        ]
    }));
};
const SunSnow = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M10 9a3 3 0 1 0 0 6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 12h1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 21V3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 4V3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 21v-1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m3.64 18.36.7-.7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m4.34 6.34-.7-.7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 12h8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m17 4-3 3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m14 17 3 3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m21 15-3-3 3-3"
            })
        ]
    }));
};
const Sun = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 20v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m4.93 4.93 1.41 1.41"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m17.66 17.66 1.41 1.41"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 12h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 12h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m6.34 17.66-1.41 1.41"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m19.07 4.93-1.41 1.41"
            })
        ]
    }));
};
const Sunrise = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2v8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m4.93 10.93 1.41 1.41"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 18h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 18h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m19.07 10.93-1.41 1.41"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 22H2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m8 6 4-4 4 4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 18a4 4 0 0 0-8 0"
            })
        ]
    }));
};
const Sunset = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 10V2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m4.93 10.93 1.41 1.41"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 18h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 18h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m19.07 10.93-1.41 1.41"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 22H2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m16 6-4 4-4-4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 18a4 4 0 0 0-8 0"
            })
        ]
    }));
};
const Superscript = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m4 19 8-8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m12 19-8-8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 12h-4c0-1.5.442-2 1.5-2.5S20 8.334 20 7.002c0-.472-.17-.93-.484-1.29a2.105 2.105 0 0 0-2.617-.436c-.42.239-.738.614-.899 1.06"
            })
        ]
    }));
};
const SwatchBook = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M11 17a4 4 0 0 1-8 0V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16.7 13H19a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M 7 17h0.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m11 8 2.3-2.3a2.4 2.4 0 0 1 3.404.004L18.6 7.6a2.4 2.4 0 0 1 .026 3.434L9.9 19.8"
            })
        ]
    }));
};
const SwissFranc = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M10 21V3h8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 16h9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 9.5h7"
            })
        ]
    }));
};
const SwitchCamera = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M11 19H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13 5h7a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-5"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m18 22-3-3 3-3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m6 2 3 3-3 3"
            })
        ]
    }));
};
const Sword = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("polyline", {
                points: "14.5 17.5 3 6 3 3 6 3 17.5 14.5"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "13",
                x2: "19",
                y1: "19",
                y2: "13"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "16",
                x2: "20",
                y1: "16",
                y2: "20"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "19",
                x2: "21",
                y1: "21",
                y2: "19"
            })
        ]
    }));
};
const Swords = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("polyline", {
                points: "14.5 17.5 3 6 3 3 6 3 17.5 14.5"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "13",
                x2: "19",
                y1: "19",
                y2: "13"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "16",
                x2: "20",
                y1: "16",
                y2: "20"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "19",
                x2: "21",
                y1: "21",
                y2: "19"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "14.5 6.5 18 3 21 3 21 6 17.5 9.5"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "5",
                x2: "9",
                y1: "14",
                y2: "18"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "7",
                x2: "4",
                y1: "17",
                y2: "20"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "3",
                x2: "5",
                y1: "19",
                y2: "21"
            })
        ]
    }));
};
const Syringe = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m18 2 4 4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m17 7 3-3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19 9 8.7 19.3c-1 1-2.5 1-3.4 0l-.6-.6c-1-1-1-2.5 0-3.4L15 5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9 11 4 4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m5 19-3 3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m14 4 6 6"
            })
        ]
    }));
};
const Table2 = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2V9M9 21H5a2 2 0 0 1-2-2V9m0 0h18"
        })
    }));
};
const TableCellsMerge = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 21v-6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 9V3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 15h18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 9h18"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            })
        ]
    }));
};
const TableCellsSplit = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 15V9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 15h18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 9h18"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            })
        ]
    }));
};
const TableColumnsSplit = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M14 14v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 20v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 2v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 8v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 15h8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 3h6a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 9h8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 15h-4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 3h-2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 9h-4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 3v18"
            })
        ]
    }));
};
const TableProperties = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M15 3v18"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 9H3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 15H3"
            })
        ]
    }));
};
const TableRowsSplit = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M14 10h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 22v-8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 2v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 10h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 10h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 19h18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 22v-6a2 2 135 0 1 2-2h14a2 2 45 0 1 2 2v6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 2v2a2 2 45 0 0 2 2h14a2 2 135 0 0 2-2V2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 10h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 22v-8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 2v4"
            })
        ]
    }));
};
const Table = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 3v18"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 9h18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 15h18"
            })
        ]
    }));
};
const TabletSmartphone = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "10",
                height: "14",
                x: "3",
                y: "8",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2h-2.4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 18h.01"
            })
        ]
    }));
};
const Tablet = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "16",
                height: "20",
                x: "4",
                y: "2",
                rx: "2",
                ry: "2"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "12.01",
                y1: "18",
                y2: "18"
            })
        ]
    }));
};
const Tablets = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "7",
                cy: "7",
                r: "5"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "17",
                cy: "17",
                r: "5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 17h10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m3.46 10.54 7.08-7.08"
            })
        ]
    }));
};
const Tag = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "7.5",
                cy: "7.5",
                r: ".5",
                fill: "currentColor"
            })
        ]
    }));
};
const Tags = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m15 5 6.3 6.3a2.4 2.4 0 0 1 0 3.4L17 19"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.586 5.586A2 2 0 0 0 8.172 5H3a1 1 0 0 0-1 1v5.172a2 2 0 0 0 .586 1.414L8.29 18.29a2.426 2.426 0 0 0 3.42 0l3.58-3.58a2.426 2.426 0 0 0 0-3.42z"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "6.5",
                cy: "9.5",
                r: ".5",
                fill: "currentColor"
            })
        ]
    }));
};
const Tally1 = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M4 4v16"
        })
    }));
};
const Tally2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 4v16"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 4v16"
            })
        ]
    }));
};
const Tally3 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 4v16"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 4v16"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 4v16"
            })
        ]
    }));
};
const Tally4 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 4v16"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 4v16"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 4v16"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19 4v16"
            })
        ]
    }));
};
const Tally5 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 4v16"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 4v16"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 4v16"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19 4v16"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 6 2 18"
            })
        ]
    }));
};
const Tangent = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "17",
                cy: "4",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15.59 5.41 5.41 15.59"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "4",
                cy: "17",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 22s-4-9-1.5-11.5S22 12 22 12"
            })
        ]
    }));
};
const Target = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "6"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "2"
            })
        ]
    }));
};
const Telescope = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m10.065 12.493-6.18 1.318a.934.934 0 0 1-1.108-.702l-.537-2.15a1.07 1.07 0 0 1 .691-1.265l13.504-4.44"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m13.56 11.747 4.332-.924"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m16 21-3.105-6.21"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16.485 5.94a2 2 0 0 1 1.455-2.425l1.09-.272a1 1 0 0 1 1.212.727l1.515 6.06a1 1 0 0 1-.727 1.213l-1.09.272a2 2 0 0 1-2.425-1.455z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m6.158 8.633 1.114 4.456"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m8 21 3.105-6.21"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "13",
                r: "2"
            })
        ]
    }));
};
const TentTree = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "4",
                cy: "4",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m14 5 3-3 3 3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m14 10 3-3 3 3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 14V2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 14H7l-5 8h20Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 14v8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9 14 5 8"
            })
        ]
    }));
};
const Tent = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3.5 21 14 3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20.5 21 10 3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15.5 21 12 15l-3.5 6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 21h20"
            })
        ]
    }));
};
const TerminalSquare = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m7 11 2-2-2-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11 13h4"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2",
                ry: "2"
            })
        ]
    }));
};
const Terminal = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("polyline", {
                points: "4 17 10 11 4 5"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "20",
                y1: "19",
                y2: "19"
            })
        ]
    }));
};
const TestTube2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M21 7 6.82 21.18a2.83 2.83 0 0 1-3.99-.01v0a2.83 2.83 0 0 1 0-4L17 3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m16 2 6 6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 16H4"
            })
        ]
    }));
};
const TestTube = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M14.5 2v17.5c0 1.4-1.1 2.5-2.5 2.5h0c-1.4 0-2.5-1.1-2.5-2.5V2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8.5 2h7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14.5 16h-5"
            })
        ]
    }));
};
const TestTubes = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M9 2v17.5A2.5 2.5 0 0 1 6.5 22v0A2.5 2.5 0 0 1 4 19.5V2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 2v17.5a2.5 2.5 0 0 1-2.5 2.5v0a2.5 2.5 0 0 1-2.5-2.5V2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 2h7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 2h7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 16H4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 16h-5"
            })
        ]
    }));
};
const TextCursorInput = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M5 4h1a3 3 0 0 1 3 3 3 3 0 0 1 3-3h1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13 20h-1a3 3 0 0 1-3-3 3 3 0 0 1-3 3H5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 16H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13 8h7a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 7v10"
            })
        ]
    }));
};
const TextCursor = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M17 22h-1a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4h1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 22h1a4 4 0 0 0 4-4v-1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 2h1a4 4 0 0 1 4 4v1"
            })
        ]
    }));
};
const TextQuote = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M17 6H3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 12H8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 18H8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 12v6"
            })
        ]
    }));
};
const TextSearch = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M21 6H3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 12H3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 18H3"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "17",
                cy: "15",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m21 19-1.9-1.9"
            })
        ]
    }));
};
const TextSelect = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M5 3a2 2 0 0 0-2 2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19 3a2 2 0 0 1 2 2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 19a2 2 0 0 1-2 2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 21a2 2 0 0 1-2-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 3h1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 21h1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 3h1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 21h1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 9v1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 9v1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 14v1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 14v1"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "7",
                x2: "15",
                y1: "8",
                y2: "8"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "7",
                x2: "17",
                y1: "12",
                y2: "12"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "7",
                x2: "13",
                y1: "16",
                y2: "16"
            })
        ]
    }));
};
const Text = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M17 6.1H3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 12.1H3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15.1 18H3"
            })
        ]
    }));
};
const Theater = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2 10s3-3 3-8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 10s-3-3-3-8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 2c0 4.4-3.6 8-8 8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 2c0 4.4 3.6 8 8 8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 10s2 2 2 5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 10s-2 2-2 5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 15h8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 22v-1a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 22v-1a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1"
            })
        ]
    }));
};
const ThermometerSnowflake = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2 12h10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 4v16"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m3 9 3 3-3 3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 6 9 9 6 6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m6 18 3-3 1.5 1.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 4v10.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0Z"
            })
        ]
    }));
};
const ThermometerSun = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 9a4 4 0 0 0-2 7.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 3v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m6.6 18.4-1.4 1.4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 4v10.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 13H2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.34 7.34 4.93 5.93"
            })
        ]
    }));
};
const Thermometer = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M14 4v10.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0Z"
        })
    }));
};
const ThumbsDown = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M17 14V2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22h0a3.13 3.13 0 0 1-3-3.88Z"
            })
        ]
    }));
};
const ThumbsUp = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M7 10v12"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2h0a3.13 3.13 0 0 1 3 3.88Z"
            })
        ]
    }));
};
const TicketCheck = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9 12 2 2 4-4"
            })
        ]
    }));
};
const TicketMinus = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 12h6"
            })
        ]
    }));
};
const TicketPercent = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2 9a3 3 0 1 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 1 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 9h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m15 9-6 6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 15h.01"
            })
        ]
    }));
};
const TicketPlus = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 12h6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 9v6"
            })
        ]
    }));
};
const TicketSlash = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9.5 14.5 5-5"
            })
        ]
    }));
};
const TicketX = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9.5 14.5 5-5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9.5 9.5 5 5"
            })
        ]
    }));
};
const Ticket = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13 5v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13 17v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13 11v2"
            })
        ]
    }));
};
const TimerOff = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M10 2h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4.6 11a8 8 0 0 0 1.7 8.7 8 8 0 0 0 8.7 1.7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7.4 7.4a8 8 0 0 1 10.3 1 8 8 0 0 1 .9 10.2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m2 2 20 20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 12v-2"
            })
        ]
    }));
};
const TimerReset = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M10 2h4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 14v-4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 13a8 8 0 0 1 8-7 8 8 0 1 1-5.3 14L4 17.6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 17H4v5"
            })
        ]
    }));
};
const Timer = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("line", {
                x1: "10",
                x2: "14",
                y1: "2",
                y2: "2"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "15",
                y1: "14",
                y2: "11"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "14",
                r: "8"
            })
        ]
    }));
};
const ToggleLeft = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "20",
                height: "12",
                x: "2",
                y: "6",
                rx: "6",
                ry: "6"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "8",
                cy: "12",
                r: "2"
            })
        ]
    }));
};
const ToggleRight = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "20",
                height: "12",
                x: "2",
                y: "6",
                rx: "6",
                ry: "6"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "16",
                cy: "12",
                r: "2"
            })
        ]
    }));
};
const Tornado = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M21 4H3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 8H6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19 12H9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 16h-6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11 20H9"
            })
        ]
    }));
};
const Torus = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("ellipse", {
                cx: "12",
                cy: "11",
                rx: "3",
                ry: "2"
            }),
            /*#__PURE__*/ _jsx("ellipse", {
                cx: "12",
                cy: "12.5",
                rx: "10",
                ry: "8.5"
            })
        ]
    }));
};
const TouchpadOff = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 14h12"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 14h-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 20v-6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m2 2 20 20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 16V6a2 2 0 0 0-2-2H10"
            })
        ]
    }));
};
const Touchpad = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "20",
                height: "16",
                x: "2",
                y: "4",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 14h20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 20v-6"
            })
        ]
    }));
};
const TowerControl = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M18.2 12.27 20 6H4l1.8 6.27a1 1 0 0 0 .95.73h10.5a1 1 0 0 0 .96-.73Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 13v9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 22v-9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9 6 1 7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m15 6-1 7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 6V2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13 2h-2"
            })
        ]
    }));
};
const ToyBrick = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "12",
                x: "3",
                y: "8",
                rx: "1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 8V5c0-.6-.4-1-1-1H6a1 1 0 0 0-1 1v3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19 8V5c0-.6-.4-1-1-1h-3a1 1 0 0 0-1 1v3"
            })
        ]
    }));
};
const Tractor = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m10 11 11 .9c.6 0 .9.5.8 1.1l-.8 5h-1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 18h-5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 5a1 1 0 0 0-1 1v5.573"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 4h9l1 7.246"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 11V4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 15h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 10.1V4"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "18",
                cy: "18",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "7",
                cy: "15",
                r: "5"
            })
        ]
    }));
};
const TrafficCone = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M9.3 6.2a4.55 4.55 0 0 0 5.4 0"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7.9 10.7c.9.8 2.4 1.3 4.1 1.3s3.2-.5 4.1-1.3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13.9 3.5a1.93 1.93 0 0 0-3.8-.1l-3 10c-.1.2-.1.4-.1.6 0 1.7 2.2 3 5 3s5-1.3 5-3c0-.2 0-.4-.1-.5Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m7.5 12.2-4.7 2.7c-.5.3-.8.7-.8 1.1s.3.8.8 1.1l7.6 4.5c.9.5 2.1.5 3 0l7.6-4.5c.7-.3 1-.7 1-1.1s-.3-.8-.8-1.1l-4.7-2.8"
            })
        ]
    }));
};
const TrainFrontTunnel = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2 22V12a10 10 0 1 1 20 0v10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 6.8v1.4a3 2.8 0 1 1-6 0V6.8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 15h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 15h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 19a4 4 0 0 1-4-4v-3a6 6 0 1 1 12 0v3a4 4 0 0 1-4 4Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9 19-2 3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m15 19 2 3"
            })
        ]
    }));
};
const TrainFront = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M8 3.1V7a4 4 0 0 0 8 0V3.1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9 15-1-1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m15 15 1-1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 19c-2.8 0-5-2.2-5-5v-4a8 8 0 0 1 16 0v4c0 2.8-2.2 5-5 5Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m8 19-2 3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m16 19 2 3"
            })
        ]
    }));
};
const TrainTrack = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2 17 17 2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m2 14 8 8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m5 11 8 8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m8 8 8 8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m11 5 8 8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m14 2 8 8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 22 22 7"
            })
        ]
    }));
};
const TramFront = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "16",
                height: "16",
                x: "4",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 11h16"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 3v8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m8 19-2 3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m18 22-2-3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 15h0"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 15h0"
            })
        ]
    }));
};
const Trash2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3 6h18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "10",
                x2: "10",
                y1: "11",
                y2: "17"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "14",
                x2: "14",
                y1: "11",
                y2: "17"
            })
        ]
    }));
};
const Trash = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3 6h18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"
            })
        ]
    }));
};
const TreeDeciduous = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M8 19a4 4 0 0 1-2.24-7.32A3.5 3.5 0 0 1 9 6.03V6a3 3 0 1 1 6 0v.04a3.5 3.5 0 0 1 3.24 5.65A4 4 0 0 1 16 19Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 19v3"
            })
        ]
    }));
};
const TreePine = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m17 14 3 3.3a1 1 0 0 1-.7 1.7H4.7a1 1 0 0 1-.7-1.7L7 14h-.3a1 1 0 0 1-.7-1.7L9 9h-.2A1 1 0 0 1 8 7.3L12 3l4 4.3a1 1 0 0 1-.8 1.7H15l3 3.3a1 1 0 0 1-.7 1.7H17Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 22v-3"
            })
        ]
    }));
};
const Trees = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M10 10v.2A3 3 0 0 1 8.9 16v0H5v0h0a3 3 0 0 1-1-5.8V10a3 3 0 0 1 6 0Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 16v6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13 19v3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 19h8.3a1 1 0 0 0 .7-1.7L18 14h.3a1 1 0 0 0 .7-1.7L16 9h.2a1 1 0 0 0 .8-1.7L13 3l-1.4 1.5"
            })
        ]
    }));
};
const Trello = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2",
                ry: "2"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "3",
                height: "9",
                x: "7",
                y: "7"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "3",
                height: "5",
                x: "14",
                y: "7"
            })
        ]
    }));
};
const TrendingDown = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("polyline", {
                points: "22 17 13.5 8.5 8.5 13.5 2 7"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "16 17 22 17 22 11"
            })
        ]
    }));
};
const TrendingUp = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("polyline", {
                points: "22 7 13.5 15.5 8.5 10.5 2 17"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "16 7 22 7 22 13"
            })
        ]
    }));
};
const TriangleRight = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M22 18a2 2 0 0 1-2 2H3c-1.1 0-1.3-.6-.4-1.3L20.4 4.3c.9-.7 1.6-.4 1.6.7Z"
        })
    }));
};
const Triangle = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M13.73 4a2 2 0 0 0-3.46 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"
        })
    }));
};
const Trophy = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M6 9H4.5a2.5 2.5 0 0 1 0-5H6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 9h1.5a2.5 2.5 0 0 0 0-5H18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 22h16"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 2H6v7a6 6 0 0 0 12 0V2Z"
            })
        ]
    }));
};
const Truck = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 18H9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "17",
                cy: "18",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "7",
                cy: "18",
                r: "2"
            })
        ]
    }));
};
const Turtle = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m12 10 2 4v3a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-3a8 8 0 1 0-16 0v3a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-3l2-4h4Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4.82 7.9 8 10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15.18 7.9 12 10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16.93 10H20a2 2 0 0 1 0 4H2"
            })
        ]
    }));
};
const Tv2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M7 21h10"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "20",
                height: "14",
                x: "2",
                y: "3",
                rx: "2"
            })
        ]
    }));
};
const Tv = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "20",
                height: "15",
                x: "2",
                y: "7",
                rx: "2",
                ry: "2"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "17 2 12 7 7 2"
            })
        ]
    }));
};
const Twitch = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M21 2H3v16h5v4l4-4h5l4-4V2zm-10 9V7m5 4V7"
        })
    }));
};
const Twitter = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z"
        })
    }));
};
const Type = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("polyline", {
                points: "4 7 4 4 20 4 20 7"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "9",
                x2: "15",
                y1: "20",
                y2: "20"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "12",
                y1: "4",
                y2: "20"
            })
        ]
    }));
};
const UmbrellaOff = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2v1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15.5 21a1.85 1.85 0 0 1-3.5-1v-8H2a10 10 0 0 1 3.428-6.575"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17.5 12H22A10 10 0 0 0 9.004 3.455"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m2 2 20 20"
            })
        ]
    }));
};
const Umbrella = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M22 12a10.06 10.06 1 0 0-20 0Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 12v8a2 2 0 0 0 4 0"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2v1"
            })
        ]
    }));
};
const Underline = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M6 4v6a6 6 0 0 0 12 0V4"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "4",
                x2: "20",
                y1: "20",
                y2: "20"
            })
        ]
    }));
};
const Undo2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M9 14 4 9l5-5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5v0a5.5 5.5 0 0 1-5.5 5.5H11"
            })
        ]
    }));
};
const UndoDot = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "17",
                r: "1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 7v6h6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 17a9 9 0 0 0-9-9 9 9 0 0 0-6 2.3L3 13"
            })
        ]
    }));
};
const Undo = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3 7v6h6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 17a9 9 0 0 0-9-9 9 9 0 0 0-6 2.3L3 13"
            })
        ]
    }));
};
const UnfoldHorizontal = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M16 12h6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 12H2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 8v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 14v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 20v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m19 15 3-3-3-3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m5 9-3 3 3 3"
            })
        ]
    }));
};
const UnfoldVertical = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 22v-6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 8V2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4 12H2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 12H8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 12h-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 12h-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m15 19-3 3-3-3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m15 5-3-3-3 3"
            })
        ]
    }));
};
const Ungroup = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "8",
                height: "6",
                x: "5",
                y: "4",
                rx: "1"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "8",
                height: "6",
                x: "11",
                y: "14",
                rx: "1"
            })
        ]
    }));
};
const Unlink2 = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M15 7h2a5 5 0 0 1 0 10h-2m-6 0H7A5 5 0 0 1 7 7h2"
        })
    }));
};
const Unlink = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m18.84 12.25 1.72-1.71h-.02a5.004 5.004 0 0 0-.12-7.07 5.006 5.006 0 0 0-6.95 0l-1.72 1.71"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m5.17 11.75-1.71 1.71a5.004 5.004 0 0 0 .12 7.07 5.006 5.006 0 0 0 6.95 0l1.71-1.71"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "8",
                x2: "8",
                y1: "2",
                y2: "5"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "2",
                x2: "5",
                y1: "8",
                y2: "8"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "16",
                x2: "16",
                y1: "19",
                y2: "22"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "19",
                x2: "22",
                y1: "16",
                y2: "16"
            })
        ]
    }));
};
const UnlockKeyhole = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "16",
                r: "1"
            }),
            /*#__PURE__*/ _jsx("rect", {
                x: "3",
                y: "10",
                width: "18",
                height: "12",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 10V7a5 5 0 0 1 9.33-2.5"
            })
        ]
    }));
};
const Unlock = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "11",
                x: "3",
                y: "11",
                rx: "2",
                ry: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 11V7a5 5 0 0 1 9.9-1"
            })
        ]
    }));
};
const Unplug = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m19 5 3-3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m2 22 3-3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.3 20.3a2.4 2.4 0 0 0 3.4 0L12 18l-6-6-2.3 2.3a2.4 2.4 0 0 0 0 3.4Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7.5 13.5 10 11"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10.5 16.5 13 14"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m12 6 6 6 2.3-2.3a2.4 2.4 0 0 0 0-3.4l-2.6-2.6a2.4 2.4 0 0 0-3.4 0Z"
            })
        ]
    }));
};
const UploadCloud = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 12v9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m16 16-4-4-4 4"
            })
        ]
    }));
};
const Upload = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "17 8 12 3 7 8"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "12",
                x2: "12",
                y1: "3",
                y2: "15"
            })
        ]
    }));
};
const Usb = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "10",
                cy: "7",
                r: "1"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "4",
                cy: "20",
                r: "1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4.7 19.3 19 5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m21 3-3 1 2 2Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.26 7.68 5 12l2 5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m10 14 5 2 3.5-3.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m18 12 1-1 1 1-1 1Z"
            })
        ]
    }));
};
const UserCheck = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "9",
                cy: "7",
                r: "4"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "16 11 18 13 22 9"
            })
        ]
    }));
};
const UserCog = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "18",
                cy: "15",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "9",
                cy: "7",
                r: "4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 15H6a4 4 0 0 0-4 4v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m21.7 16.4-.9-.3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m15.2 13.9-.9-.3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m16.6 18.7.3-.9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m19.1 12.2.3-.9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m19.6 18.7-.4-1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m16.8 12.3-.4-1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m14.3 16.6 1-.4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m20.7 13.8 1-.4"
            })
        ]
    }));
};
const UserMinus = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "9",
                cy: "7",
                r: "4"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "22",
                x2: "16",
                y1: "11",
                y2: "11"
            })
        ]
    }));
};
const UserPlus = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "9",
                cy: "7",
                r: "4"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "19",
                x2: "19",
                y1: "8",
                y2: "14"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "22",
                x2: "16",
                y1: "11",
                y2: "11"
            })
        ]
    }));
};
const UserRoundCheck = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2 21a8 8 0 0 1 13.292-6"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "10",
                cy: "8",
                r: "5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m16 19 2 2 4-4"
            })
        ]
    }));
};
const UserRoundCog = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2 21a8 8 0 0 1 10.434-7.62"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "10",
                cy: "8",
                r: "5"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "18",
                cy: "18",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m19.5 14.3-.4.9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m16.9 20.8-.4.9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m21.7 19.5-.9-.4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m15.2 16.9-.9-.4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m21.7 16.5-.9.4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m15.2 19.1-.9.4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m19.5 21.7-.4-.9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m16.9 15.2-.4-.9"
            })
        ]
    }));
};
const UserRoundMinus = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2 21a8 8 0 0 1 13.292-6"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "10",
                cy: "8",
                r: "5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 19h-6"
            })
        ]
    }));
};
const UserRoundPlus = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2 21a8 8 0 0 1 13.292-6"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "10",
                cy: "8",
                r: "5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19 16v6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 19h-6"
            })
        ]
    }));
};
const UserRoundSearch = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "10",
                cy: "8",
                r: "5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 21a8 8 0 0 1 10.434-7.62"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "18",
                cy: "18",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m22 22-1.9-1.9"
            })
        ]
    }));
};
const UserRoundX = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2 21a8 8 0 0 1 11.873-7"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "10",
                cy: "8",
                r: "5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m17 17 5 5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m22 17-5 5"
            })
        ]
    }));
};
const UserRound = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "8",
                r: "5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 21a8 8 0 0 0-16 0"
            })
        ]
    }));
};
const UserSearch = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "10",
                cy: "7",
                r: "4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10.3 15H7a4 4 0 0 0-4 4v2"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "17",
                cy: "17",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m21 21-1.9-1.9"
            })
        ]
    }));
};
const UserX = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "9",
                cy: "7",
                r: "4"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "17",
                x2: "22",
                y1: "8",
                y2: "13"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "22",
                x2: "17",
                y1: "8",
                y2: "13"
            })
        ]
    }));
};
const User = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "7",
                r: "4"
            })
        ]
    }));
};
const UsersRound = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M18 21a8 8 0 0 0-16 0"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "10",
                cy: "8",
                r: "5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 20c0-3.37-2-6.5-4-8a5 5 0 0 0-.45-8.3"
            })
        ]
    }));
};
const Users = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "9",
                cy: "7",
                r: "4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 21v-2a4 4 0 0 0-3-3.87"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 3.13a4 4 0 0 1 0 7.75"
            })
        ]
    }));
};
const UtensilsCrossed = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m16 2-2.3 2.3a3 3 0 0 0 0 4.2l1.8 1.8a3 3 0 0 0 4.2 0L22 8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 15 3.3 3.3a4.2 4.2 0 0 0 0 6l7.3 7.3c.7.7 2 .7 2.8 0L15 15Zm0 0 7 7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m2.1 21.8 6.4-6.3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m19 5-7 7"
            })
        ]
    }));
};
const Utensils = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 2v20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 15V2v0a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7"
            })
        ]
    }));
};
const UtilityPole = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 2v20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 5h20"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 3v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 3v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 3v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 3v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m19 5-7 7-7-7"
            })
        ]
    }));
};
const Variable = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M8 21s-4-3-4-9 4-9 4-9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 3s4 3 4 9-4 9-4 9"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "15",
                x2: "9",
                y1: "9",
                y2: "15"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "9",
                x2: "15",
                y1: "9",
                y2: "15"
            })
        ]
    }));
};
const Vault = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "7.5",
                cy: "7.5",
                r: ".5",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m7.9 7.9 2.7 2.7"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "16.5",
                cy: "7.5",
                r: ".5",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m13.4 10.6 2.7-2.7"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "7.5",
                cy: "16.5",
                r: ".5",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m7.9 16.1 2.7-2.7"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "16.5",
                cy: "16.5",
                r: ".5",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m13.4 13.4 2.7 2.7"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "2"
            })
        ]
    }));
};
const Vegan = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2 2a26.6 26.6 0 0 1 10 20c.9-6.82 1.5-9.5 4-14"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 8c4 0 6-2 6-6-4 0-6 2-6 6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17.41 3.6a10 10 0 1 0 3 3"
            })
        ]
    }));
};
const VenetianMask = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2 12a5 5 0 0 0 5 5 8 8 0 0 1 5 2 8 8 0 0 1 5-2 5 5 0 0 0 5-5V7h-5a8 8 0 0 0-5 2 8 8 0 0 0-5-2H2Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 11c1.5 0 3 .5 3 2-2 0-3 0-3-2Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 11c-1.5 0-3 .5-3 2 2 0 3 0 3-2Z"
            })
        ]
    }));
};
const VibrateOff = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m2 8 2 2-2 2 2 2-2 2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m22 8-2 2 2 2-2 2 2 2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 8v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 10.34V6c0-.55-.45-1-1-1h-4.34"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "2",
                x2: "22",
                y1: "2",
                y2: "22"
            })
        ]
    }));
};
const Vibrate = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m2 8 2 2-2 2 2 2-2 2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m22 8-2 2 2 2-2 2 2 2"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "8",
                height: "14",
                x: "8",
                y: "5",
                rx: "1"
            })
        ]
    }));
};
const VideoOff = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M10.66 6H14a2 2 0 0 1 2 2v2.34l1 1L22 8v8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h2l10 10Z"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "2",
                x2: "22",
                y1: "2",
                y2: "22"
            })
        ]
    }));
};
const Video = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m22 8-6 4 6 4V8Z"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "14",
                height: "12",
                x: "2",
                y: "6",
                rx: "2",
                ry: "2"
            })
        ]
    }));
};
const Videotape = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "20",
                height: "16",
                x: "2",
                y: "4",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 8h20"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "8",
                cy: "14",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 12h8"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "16",
                cy: "14",
                r: "2"
            })
        ]
    }));
};
const View = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M5 12s2.545-5 7-5c4.454 0 7 5 7 5s-2.546 5-7 5c-4.455 0-7-5-7-5z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 17v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 7V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2"
            })
        ]
    }));
};
const Voicemail = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "6",
                cy: "12",
                r: "4"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "18",
                cy: "12",
                r: "4"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "6",
                x2: "18",
                y1: "16",
                y2: "16"
            })
        ]
    }));
};
const Volume1 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("polygon", {
                points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15.54 8.46a5 5 0 0 1 0 7.07"
            })
        ]
    }));
};
const Volume2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("polygon", {
                points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15.54 8.46a5 5 0 0 1 0 7.07"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19.07 4.93a10 10 0 0 1 0 14.14"
            })
        ]
    }));
};
const VolumeX = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("polygon", {
                points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "22",
                x2: "16",
                y1: "9",
                y2: "15"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "16",
                x2: "22",
                y1: "9",
                y2: "15"
            })
        ]
    }));
};
const Volume = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("polygon", {
            points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5"
        })
    }));
};
const Vote = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m9 12 2 2 4-4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 7c0-1.1.9-2 2-2h10a2 2 0 0 1 2 2v12H5V7Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 19H2"
            })
        ]
    }));
};
const Wallet2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M17 14h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 7h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14"
            })
        ]
    }));
};
const WalletCards = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 9a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 11h3c.8 0 1.6.3 2.1.9l1.1.9c1.6 1.6 4.1 1.6 5.7 0l1.1-.9c.5-.5 1.3-.9 2.1-.9H21"
            })
        ]
    }));
};
const Wallet = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M21 12V7H5a2 2 0 0 1 0-4h14v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 5v14a2 2 0 0 0 2 2h16v-5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 12a2 2 0 0 0 0 4h4v-4Z"
            })
        ]
    }));
};
const Wallpaper = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "8",
                cy: "9",
                r: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9 17 6.1-6.1a2 2 0 0 1 2.81.01L22 15V5a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 21h8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 17v4"
            })
        ]
    }));
};
const Wand2 = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m21.64 3.64-1.28-1.28a1.21 1.21 0 0 0-1.72 0L2.36 18.64a1.21 1.21 0 0 0 0 1.72l1.28 1.28a1.2 1.2 0 0 0 1.72 0L21.64 5.36a1.2 1.2 0 0 0 0-1.72Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m14 7 3 3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 6v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19 14v4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 2v2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 8H3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21 16h-4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11 3H9"
            })
        ]
    }));
};
const Wand = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M15 4V2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 16v-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 9h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 9h2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17.8 11.8 19 13"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 9h0"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17.8 6.2 19 5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m3 21 9-9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12.2 6.2 11 5"
            })
        ]
    }));
};
const Warehouse = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M22 8.35V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8.35A2 2 0 0 1 3.26 6.5l8-3.2a2 2 0 0 1 1.48 0l8 3.2A2 2 0 0 1 22 8.35Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 18h12"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 14h12"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "12",
                height: "12",
                x: "6",
                y: "10"
            })
        ]
    }));
};
const WashingMachine = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3 6h3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 6h.01"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "20",
                x: "3",
                y: "2",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "13",
                r: "5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 18a2.5 2.5 0 0 0 0-5 2.5 2.5 0 0 1 0-5"
            })
        ]
    }));
};
const Watch = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "6"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "12 10 12 12 13 13"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m16.13 7.66-.81-4.05a2 2 0 0 0-2-1.61h-2.68a2 2 0 0 0-2 1.61l-.78 4.05"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m7.88 16.36.8 4a2 2 0 0 0 2 1.61h2.72a2 2 0 0 0 2-1.61l.81-4.05"
            })
        ]
    }));
};
const Waves = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2 6c.6.5 1.2 1 2.5 1C7 7 7 5 9.5 5c2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 12c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 18c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"
            })
        ]
    }));
};
const Waypoints = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "4.5",
                r: "2.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m10.2 6.3-3.9 3.9"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "4.5",
                cy: "12",
                r: "2.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 12h10"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "19.5",
                cy: "12",
                r: "2.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m13.8 17.7 3.9-3.9"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "19.5",
                r: "2.5"
            })
        ]
    }));
};
const Webcam = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "10",
                r: "8"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "10",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 22h10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 22v-4"
            })
        ]
    }));
};
const WebhookOff = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M17 17h-5c-1.09-.02-1.94.92-2.5 1.9A3 3 0 1 1 2.57 15"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 3.4a4 4 0 0 1 6.52.66"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m6 17 3.1-5.8a2.5 2.5 0 0 0 .057-2.05"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20.3 20.3a4 4 0 0 1-2.3.7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18.6 13a4 4 0 0 1 3.357 3.414"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m12 6 .6 1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m2 2 20 20"
            })
        ]
    }));
};
const Webhook = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M18 16.98h-5.99c-1.1 0-1.95.94-2.48 1.9A4 4 0 0 1 2 17c.01-.7.2-1.4.57-2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m6 17 3.13-5.78c.53-.97.1-2.18-.5-3.1a4 4 0 1 1 6.89-4.06"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m12 6 3.13 5.73C15.66 12.7 16.9 13 18 13a4 4 0 0 1 0 8"
            })
        ]
    }));
};
const Weight = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "5",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.5 8a2 2 0 0 0-1.905 1.46L2.1 18.5A2 2 0 0 0 4 21h16a2 2 0 0 0 1.925-2.54L19.4 9.5A2 2 0 0 0 17.48 8Z"
            })
        ]
    }));
};
const WheatOff = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m2 22 10-10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m16 8-1.17 1.17"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3.47 12.53 5 11l1.53 1.53a3.5 3.5 0 0 1 0 4.94L5 19l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m8 8-.53.53a3.5 3.5 0 0 0 0 4.94L9 15l1.53-1.53c.55-.55.88-1.25.98-1.97"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10.91 5.26c.15-.26.34-.51.56-.73L13 3l1.53 1.53a3.5 3.5 0 0 1 .28 4.62"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 2h2v2a4 4 0 0 1-4 4h-2V6a4 4 0 0 1 4-4Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11.47 17.47 13 19l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L5 19l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m16 16-.53.53a3.5 3.5 0 0 1-4.94 0L9 15l1.53-1.53a3.49 3.49 0 0 1 1.97-.98"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18.74 13.09c.26-.15.51-.34.73-.56L21 11l-1.53-1.53a3.5 3.5 0 0 0-4.62-.28"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "2",
                x2: "22",
                y1: "2",
                y2: "22"
            })
        ]
    }));
};
const Wheat = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2 22 16 8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3.47 12.53 5 11l1.53 1.53a3.5 3.5 0 0 1 0 4.94L5 19l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7.47 8.53 9 7l1.53 1.53a3.5 3.5 0 0 1 0 4.94L9 15l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11.47 4.53 13 3l1.53 1.53a3.5 3.5 0 0 1 0 4.94L13 11l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 2h2v2a4 4 0 0 1-4 4h-2V6a4 4 0 0 1 4-4Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11.47 17.47 13 19l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L5 19l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15.47 13.47 17 15l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L9 15l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19.47 9.47 21 11l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L13 11l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z"
            })
        ]
    }));
};
const WholeWord = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "7",
                cy: "12",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 9v6"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "17",
                cy: "12",
                r: "3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 7v8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 17v1c0 .5-.5 1-1 1H3c-.5 0-1-.5-1-1v-1"
            })
        ]
    }));
};
const WifiOff = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 20h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8.5 16.429a5 5 0 0 1 7 0"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 12.859a10 10 0 0 1 5.17-2.69"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19 12.859a10 10 0 0 0-2.007-1.523"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 8.82a15 15 0 0 1 4.177-2.643"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 8.82a15 15 0 0 0-11.288-3.764"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m2 2 20 20"
            })
        ]
    }));
};
const Wifi = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 20h.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 8.82a15 15 0 0 1 20 0"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5 12.859a10 10 0 0 1 14 0"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8.5 16.429a5 5 0 0 1 7 0"
            })
        ]
    }));
};
const Wind = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M17.7 7.7a2.5 2.5 0 1 1 1.8 4.3H2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.6 4.6A2 2 0 1 1 11 8H2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12.6 19.4A2 2 0 1 0 14 16H2"
            })
        ]
    }));
};
const WineOff = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M8 22h8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 10h3m7 0h-1.343"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 15v7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7.307 7.307A12.33 12.33 0 0 0 7 10a5 5 0 0 0 7.391 4.391M8.638 2.981C8.75 2.668 8.872 2.34 9 2h6c1.5 4 2 6 2 8 0 .407-.05.809-.145 1.198"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "2",
                x2: "22",
                y1: "2",
                y2: "22"
            })
        ]
    }));
};
const Wine = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M8 22h8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 10h10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 15v7"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 15a5 5 0 0 0 5-5c0-2-.5-4-2-8H9c-1.5 4-2 6-2 8a5 5 0 0 0 5 5Z"
            })
        ]
    }));
};
const Workflow = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "8",
                height: "8",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 11v4a2 2 0 0 0 2 2h4"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "8",
                height: "8",
                x: "13",
                y: "13",
                rx: "2"
            })
        ]
    }));
};
const WrapText = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("line", {
                x1: "3",
                x2: "21",
                y1: "6",
                y2: "6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 12h15a3 3 0 1 1 0 6h-4"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "16 16 14 18 16 20"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "3",
                x2: "10",
                y1: "18",
                y2: "18"
            })
        ]
    }));
};
const Wrench = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"
        })
    }));
};
const XCircle = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m15 9-6 6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9 9 6 6"
            })
        ]
    }));
};
const XOctagon = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("polygon", {
                points: "7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m15 9-6 6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9 9 6 6"
            })
        ]
    }));
};
const XSquare = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2",
                ry: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m15 9-6 6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m9 9 6 6"
            })
        ]
    }));
};
const X = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M18 6 6 18"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m6 6 12 12"
            })
        ]
    }));
};
const Youtube = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2.5 17a24.12 24.12 0 0 1 0-10 2 2 0 0 1 1.4-1.4 49.56 49.56 0 0 1 16.2 0A2 2 0 0 1 21.5 7a24.12 24.12 0 0 1 0 10 2 2 0 0 1-1.4 1.4 49.55 49.55 0 0 1-16.2 0A2 2 0 0 1 2.5 17"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m10 15 5-3-5-3z"
            })
        ]
    }));
};
const ZapOff = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("polyline", {
                points: "12.41 6.75 13 2 10.57 4.92"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "18.57 12.91 21 10 15.66 10"
            }),
            /*#__PURE__*/ _jsx("polyline", {
                points: "8 8 3 14 12 14 11 22 16 16"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "2",
                x2: "22",
                y1: "2",
                y2: "22"
            })
        ]
    }));
};
const Zap = (props)=>{
    return /*#__PURE__*/ _jsx(SVG, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx("polygon", {
            points: "13 2 3 14 12 14 11 22 21 10 12 10 13 2"
        })
    }));
};
const ZoomIn = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "11",
                cy: "11",
                r: "8"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "21",
                x2: "16.65",
                y1: "21",
                y2: "16.65"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "11",
                x2: "11",
                y1: "8",
                y2: "14"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "8",
                x2: "14",
                y1: "11",
                y2: "11"
            })
        ]
    }));
};
const ZoomOut = (props)=>{
    return /*#__PURE__*/ _jsxs(SVG, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "11",
                cy: "11",
                r: "8"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "21",
                x2: "16.65",
                y1: "21",
                y2: "16.65"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "8",
                x2: "14",
                y1: "11",
                y2: "11"
            })
        ]
    }));
};
export const SWIconNodeSVGMap = {
    AArrowDown: {
        render: AArrowDown,
        tags: "a arrow down:text:design:letter:font size:text:formatting:smaller",
        categories: [
            "text",
            "design"
        ]
    },
    AArrowUp: {
        render: AArrowUp,
        tags: "a arrow up:text:design:letter:font size:text:formatting:larger:bigger",
        categories: [
            "text",
            "design"
        ]
    },
    ALargeSmall: {
        render: ALargeSmall,
        tags: "a large small:text:design:letter:font size:text:formatting",
        categories: [
            "text",
            "design"
        ]
    },
    Accessibility: {
        render: Accessibility,
        tags: "accessibility:accessibility:medical:disability:disabled:dda:wheelchair",
        categories: [
            "accessibility",
            "medical"
        ]
    },
    ActivitySquare: {
        render: ActivitySquare,
        tags: "activity square:medical:account:social:science:multimedia:shapes:pulse:action:motion:movement:exercise:fitness:healthcare:heart rate monitor:vital signs:vitals:emergency room:er:intensive care:hospital:defibrillator:earthquake:siesmic:magnitude:richter scale:aftershock:tremor:shockwave:audio:waveform:synthesizer:synthesiser:music",
        categories: [
            "medical",
            "account",
            "social",
            "science",
            "multimedia",
            "shapes"
        ]
    },
    Activity: {
        render: Activity,
        tags: "activity:medical:account:social:science:multimedia:pulse:action:motion:movement:exercise:fitness:healthcare:heart rate monitor:vital signs:vitals:emergency room:er:intensive care:hospital:defibrillator:earthquake:siesmic:magnitude:richter scale:aftershock:tremor:shockwave:audio:waveform:synthesizer:synthesiser:music",
        categories: [
            "medical",
            "account",
            "social",
            "science",
            "multimedia"
        ]
    },
    AirVent: {
        render: AirVent,
        tags: "air vent:home:air conditioner:ac:central air:cooling:climate-control",
        categories: [
            "home"
        ]
    },
    Airplay: {
        render: Airplay,
        tags: "airplay:multimedia:connectivity:devices:brands:stream:cast:mirroring:screen:monitor",
        categories: [
            "multimedia",
            "connectivity",
            "devices",
            "brands"
        ]
    },
    AlarmClockCheck: {
        render: AlarmClockCheck,
        tags: "alarm clock check:devices:notifications:time:done:todo:tick:complete:task",
        categories: [
            "devices",
            "notifications",
            "time"
        ]
    },
    AlarmClockMinus: {
        render: AlarmClockMinus,
        tags: "alarm clock minus:devices:notifications:time:remove",
        categories: [
            "devices",
            "notifications",
            "time"
        ]
    },
    AlarmClockOff: {
        render: AlarmClockOff,
        tags: "alarm clock off:devices:notifications:time:morning:turn-off",
        categories: [
            "devices",
            "notifications",
            "time"
        ]
    },
    AlarmClockPlus: {
        render: AlarmClockPlus,
        tags: "alarm clock plus:devices:notifications:time:add",
        categories: [
            "devices",
            "notifications",
            "time"
        ]
    },
    AlarmClock: {
        render: AlarmClock,
        tags: "alarm clock:devices:notifications:time:morning",
        categories: [
            "devices",
            "notifications",
            "time"
        ]
    },
    AlarmSmoke: {
        render: AlarmSmoke,
        tags: "alarm smoke:home:devices:travel:fire:alert:warning:detector:carbon monoxide:safety:equipment:amenities",
        categories: [
            "home",
            "devices",
            "travel"
        ]
    },
    Album: {
        render: Album,
        tags: "album:photography:multimedia:photo:book",
        categories: [
            "photography",
            "multimedia"
        ]
    },
    AlertCircle: {
        render: AlertCircle,
        tags: "alert circle:notifications:shapes:warning:alert:danger:exclamation mark",
        categories: [
            "notifications",
            "shapes"
        ]
    },
    AlertOctagon: {
        render: AlertOctagon,
        tags: "alert octagon:notifications:shapes:warning:alert:danger:exclamation mark",
        categories: [
            "notifications",
            "shapes"
        ]
    },
    AlertTriangle: {
        render: AlertTriangle,
        tags: "alert triangle:notifications:shapes:development:warning:alert:danger:exclamation mark:linter",
        categories: [
            "notifications",
            "shapes",
            "development"
        ]
    },
    AlignCenterHorizontal: {
        render: AlignCenterHorizontal,
        tags: "align center horizontal:layout:items:flex:justify",
        categories: [
            "layout"
        ]
    },
    AlignCenterVertical: {
        render: AlignCenterVertical,
        tags: "align center vertical:layout:items:flex:justify",
        categories: [
            "layout"
        ]
    },
    AlignCenter: {
        render: AlignCenter,
        tags: "align center:text:text:alignment:center",
        categories: [
            "text"
        ]
    },
    AlignEndHorizontal: {
        render: AlignEndHorizontal,
        tags: "align end horizontal:layout:items:bottom:flex:justify",
        categories: [
            "layout"
        ]
    },
    AlignEndVertical: {
        render: AlignEndVertical,
        tags: "align end vertical:layout:items:right:flex:justify",
        categories: [
            "layout"
        ]
    },
    AlignHorizontalDistributeCenter: {
        render: AlignHorizontalDistributeCenter,
        tags: "align horizontal distribute center:layout:items:flex:justify:space:evenly:around",
        categories: [
            "layout"
        ]
    },
    AlignHorizontalDistributeEnd: {
        render: AlignHorizontalDistributeEnd,
        tags: "align horizontal distribute end:layout:right:items:flex:justify",
        categories: [
            "layout"
        ]
    },
    AlignHorizontalDistributeStart: {
        render: AlignHorizontalDistributeStart,
        tags: "align horizontal distribute start:layout:left:items:flex:justify",
        categories: [
            "layout"
        ]
    },
    AlignHorizontalJustifyCenter: {
        render: AlignHorizontalJustifyCenter,
        tags: "align horizontal justify center:layout:center:items:flex:justify",
        categories: [
            "layout"
        ]
    },
    AlignHorizontalJustifyEnd: {
        render: AlignHorizontalJustifyEnd,
        tags: "align horizontal justify end:layout:right:items:flex:justify",
        categories: [
            "layout"
        ]
    },
    AlignHorizontalJustifyStart: {
        render: AlignHorizontalJustifyStart,
        tags: "align horizontal justify start:layout:left:items:flex:justify",
        categories: [
            "layout"
        ]
    },
    AlignHorizontalSpaceAround: {
        render: AlignHorizontalSpaceAround,
        tags: "align horizontal space around:layout:center:items:flex:justify:distribute:between",
        categories: [
            "layout"
        ]
    },
    AlignHorizontalSpaceBetween: {
        render: AlignHorizontalSpaceBetween,
        tags: "align horizontal space between:layout:around:items:bottom:flex:justify",
        categories: [
            "layout"
        ]
    },
    AlignJustify: {
        render: AlignJustify,
        tags: "align justify:text:text:alignment:justified:menu:list",
        categories: [
            "text"
        ]
    },
    AlignLeft: {
        render: AlignLeft,
        tags: "align left:text:text:alignment:left:list",
        categories: [
            "text"
        ]
    },
    AlignRight: {
        render: AlignRight,
        tags: "align right:text:text:alignment:right",
        categories: [
            "text"
        ]
    },
    AlignStartHorizontal: {
        render: AlignStartHorizontal,
        tags: "align start horizontal:layout:top:items:flex:justify",
        categories: [
            "layout"
        ]
    },
    AlignStartVertical: {
        render: AlignStartVertical,
        tags: "align start vertical:layout:left:items:flex:justify",
        categories: [
            "layout"
        ]
    },
    AlignVerticalDistributeCenter: {
        render: AlignVerticalDistributeCenter,
        tags: "align vertical distribute center:layout:items:flex:justify:space:evenly:around",
        categories: [
            "layout"
        ]
    },
    AlignVerticalDistributeEnd: {
        render: AlignVerticalDistributeEnd,
        tags: "align vertical distribute end:layout:bottom:items:flex:justify",
        categories: [
            "layout"
        ]
    },
    AlignVerticalDistributeStart: {
        render: AlignVerticalDistributeStart,
        tags: "align vertical distribute start:layout:top:items:flex:justify",
        categories: [
            "layout"
        ]
    },
    AlignVerticalJustifyCenter: {
        render: AlignVerticalJustifyCenter,
        tags: "align vertical justify center:layout:center:items:flex:justify:distribute:between",
        categories: [
            "layout"
        ]
    },
    AlignVerticalJustifyEnd: {
        render: AlignVerticalJustifyEnd,
        tags: "align vertical justify end:layout:bottom:items:flex:justify:distribute:between",
        categories: [
            "layout"
        ]
    },
    AlignVerticalJustifyStart: {
        render: AlignVerticalJustifyStart,
        tags: "align vertical justify start:layout:top:items:flex:justify:distribute:between",
        categories: [
            "layout"
        ]
    },
    AlignVerticalSpaceAround: {
        render: AlignVerticalSpaceAround,
        tags: "align vertical space around:layout:center:items:flex:justify:distribute:between",
        categories: [
            "layout"
        ]
    },
    AlignVerticalSpaceBetween: {
        render: AlignVerticalSpaceBetween,
        tags: "align vertical space between:layout:center:items:flex:justify:distribute:between",
        categories: [
            "layout"
        ]
    },
    Ambulance: {
        render: Ambulance,
        tags: "ambulance:medical:transportation:ambulance:emergency:medical:vehicle:siren:healthcare:transportation:rescue:urgent:first aid",
        categories: [
            "medical",
            "transportation"
        ]
    },
    Ampersand: {
        render: Ampersand,
        tags: "ampersand:text:development:and:typography:operator:join:concatenate:code:&",
        categories: [
            "text",
            "development"
        ]
    },
    Ampersands: {
        render: Ampersands,
        tags: "ampersands:text:development:and:operator:then:code:&&",
        categories: [
            "text",
            "development"
        ]
    },
    Anchor: {
        render: Anchor,
        tags: "anchor:transportation:text:maps:ship",
        categories: [
            "transportation",
            "text",
            "maps"
        ]
    },
    Angry: {
        render: Angry,
        tags: "angry:emoji:emoji:anger:face:emotion",
        categories: [
            "emoji"
        ]
    },
    Annoyed: {
        render: Annoyed,
        tags: "annoyed:emoji:emoji:nuisance:face:emotion",
        categories: [
            "emoji"
        ]
    },
    Antenna: {
        render: Antenna,
        tags: "antenna:devices:multimedia:communication:signal:connection:connectivity:tv:television:broadcast:live:frequency:tune:scan:channels:aerial:receiver:transmission:transducer:terrestrial:satellite:cable",
        categories: [
            "devices",
            "multimedia",
            "communication"
        ]
    },
    Anvil: {
        render: Anvil,
        tags: "anvil:buildings:tools:gaming:metal:iron:alloy:materials:heavy:weight:blacksmith:forge:acme",
        categories: [
            "buildings",
            "tools",
            "gaming"
        ]
    },
    Aperture: {
        render: Aperture,
        tags: "aperture:photography:camera:photo:pictures:shutter:exposure",
        categories: [
            "photography"
        ]
    },
    AppWindow: {
        render: AppWindow,
        tags: "app window:design:files:layout:application:executable",
        categories: [
            "design",
            "files",
            "layout"
        ]
    },
    Apple: {
        render: Apple,
        tags: "apple:food beverage:fruit:food",
        categories: [
            "food-beverage"
        ]
    },
    ArchiveRestore: {
        render: ArchiveRestore,
        tags: "archive restore:files:mail:unarchive:index:backup:box:storage:records",
        categories: [
            "files",
            "mail"
        ]
    },
    ArchiveX: {
        render: ArchiveX,
        tags: "archive x:files:mail:index:backup:box:storage:records:junk",
        categories: [
            "files",
            "mail"
        ]
    },
    Archive: {
        render: Archive,
        tags: "archive:files:mail:index:backup:box:storage:records",
        categories: [
            "files",
            "mail"
        ]
    },
    AreaChart: {
        render: AreaChart,
        tags: "area chart:charts:statistics:diagram:graph:area",
        categories: [
            "charts"
        ]
    },
    Armchair: {
        render: Armchair,
        tags: "armchair:furniture:sofa:furniture:leisure:lounge:loveseat:couch",
        categories: [
            "furniture"
        ]
    },
    ArrowBigDownDash: {
        render: ArrowBigDownDash,
        tags: "arrow big down dash:arrows:navigation:gaming:files:backwards:reverse:slow:direction:south:download",
        categories: [
            "arrows",
            "navigation",
            "gaming",
            "files"
        ]
    },
    ArrowBigDown: {
        render: ArrowBigDown,
        tags: "arrow big down:arrows:navigation:gaming:backwards:reverse:direction:south",
        categories: [
            "arrows",
            "navigation",
            "gaming"
        ]
    },
    ArrowBigLeftDash: {
        render: ArrowBigLeftDash,
        tags: "arrow big left dash:arrows:navigation:gaming:previous:back:direction:west:turn:corner",
        categories: [
            "arrows",
            "navigation",
            "gaming"
        ]
    },
    ArrowBigLeft: {
        render: ArrowBigLeft,
        tags: "arrow big left:arrows:navigation:gaming:previous:back:direction:west:indicate turn",
        categories: [
            "arrows",
            "navigation",
            "gaming"
        ]
    },
    ArrowBigRightDash: {
        render: ArrowBigRightDash,
        tags: "arrow big right dash:arrows:navigation:gaming:next:forward:direction:east:turn:corner",
        categories: [
            "arrows",
            "navigation",
            "gaming"
        ]
    },
    ArrowBigRight: {
        render: ArrowBigRight,
        tags: "arrow big right:arrows:navigation:gaming:next:forward:direction:east:indicate turn",
        categories: [
            "arrows",
            "navigation",
            "gaming"
        ]
    },
    ArrowBigUpDash: {
        render: ArrowBigUpDash,
        tags: "arrow big up dash:arrows:navigation:text:development:gaming:caps lock:capitals:keyboard:button:mac:forward:direction:north:faster:speed:boost",
        categories: [
            "arrows",
            "navigation",
            "text",
            "development",
            "gaming"
        ]
    },
    ArrowBigUp: {
        render: ArrowBigUp,
        tags: "arrow big up:arrows:navigation:text:development:gaming:shift:keyboard:button:mac:capitalize:capitalise:forward:direction:north",
        categories: [
            "arrows",
            "navigation",
            "text",
            "development",
            "gaming"
        ]
    },
    ArrowDown01: {
        render: ArrowDown01,
        tags: "arrow down 01:text:layout:arrows:filter:sort:ascending:numerical",
        categories: [
            "text",
            "layout",
            "arrows"
        ]
    },
    ArrowDown10: {
        render: ArrowDown10,
        tags: "arrow down 10:text:layout:arrows:filter:sort:descending:numerical",
        categories: [
            "text",
            "layout",
            "arrows"
        ]
    },
    ArrowDownAZ: {
        render: ArrowDownAZ,
        tags: "arrow down az:text:layout:arrows:filter:sort:ascending:alphabetical",
        categories: [
            "text",
            "layout",
            "arrows"
        ]
    },
    ArrowDownCircle: {
        render: ArrowDownCircle,
        tags: "arrow down circle:arrows:navigation:shapes:gaming:backwards:reverse:direction:south:sign:button",
        categories: [
            "arrows",
            "navigation",
            "shapes",
            "gaming"
        ]
    },
    ArrowDownFromLine: {
        render: ArrowDownFromLine,
        tags: "arrow down from line:arrows:navigation:files:backwards:reverse:direction:south:download:expand:fold:vertical",
        categories: [
            "arrows",
            "navigation",
            "files"
        ]
    },
    ArrowDownLeftFromCircle: {
        render: ArrowDownLeftFromCircle,
        tags: "arrow down left from circle:arrows:navigation:maps:outwards:direction:south-west:diagonal",
        categories: [
            "arrows",
            "navigation",
            "maps"
        ]
    },
    ArrowDownLeftFromSquare: {
        render: ArrowDownLeftFromSquare,
        tags: "arrow down left from square:arrows:navigation:outwards:direction:south-west:diagonal",
        categories: [
            "arrows",
            "navigation"
        ]
    },
    ArrowDownLeftSquare: {
        render: ArrowDownLeftSquare,
        tags: "arrow down left square:arrows:navigation:shapes:gaming:direction:south-west:diagonal:sign:turn:keyboard:button",
        categories: [
            "arrows",
            "navigation",
            "shapes",
            "gaming"
        ]
    },
    ArrowDownLeft: {
        render: ArrowDownLeft,
        tags: "arrow down left:arrows:navigation:direction:south-west:diagonal",
        categories: [
            "arrows",
            "navigation"
        ]
    },
    ArrowDownNarrowWide: {
        render: ArrowDownNarrowWide,
        tags: "arrow down narrow wide:text:layout:arrows:filter:sort:ascending",
        categories: [
            "text",
            "layout",
            "arrows"
        ]
    },
    ArrowDownRightFromCircle: {
        render: ArrowDownRightFromCircle,
        tags: "arrow down right from circle:arrows:navigation:maps:outwards:direction:south-east:diagonal",
        categories: [
            "arrows",
            "navigation",
            "maps"
        ]
    },
    ArrowDownRightFromSquare: {
        render: ArrowDownRightFromSquare,
        tags: "arrow down right from square:arrows:navigation:outwards:direction:south-east:diagonal",
        categories: [
            "arrows",
            "navigation"
        ]
    },
    ArrowDownRightSquare: {
        render: ArrowDownRightSquare,
        tags: "arrow down right square:arrows:navigation:shapes:gaming:direction:south-east:diagonal:sign:turn:keyboard:button",
        categories: [
            "arrows",
            "navigation",
            "shapes",
            "gaming"
        ]
    },
    ArrowDownRight: {
        render: ArrowDownRight,
        tags: "arrow down right:arrows:navigation:direction:south-east:diagonal",
        categories: [
            "arrows",
            "navigation"
        ]
    },
    ArrowDownSquare: {
        render: ArrowDownSquare,
        tags: "arrow down square:arrows:navigation:shapes:gaming:backwards:reverse:direction:south:sign:keyboard:button",
        categories: [
            "arrows",
            "navigation",
            "shapes",
            "gaming"
        ]
    },
    ArrowDownToDot: {
        render: ArrowDownToDot,
        tags: "arrow down to dot:arrows:navigation:maps:direction:south:waypoint:location:step:into",
        categories: [
            "arrows",
            "navigation",
            "maps"
        ]
    },
    ArrowDownToLine: {
        render: ArrowDownToLine,
        tags: "arrow down to line:arrows:navigation:files:development:behind:direction:south:download:save:git:version control:pull:collapse:fold:vertical",
        categories: [
            "arrows",
            "navigation",
            "files",
            "development"
        ]
    },
    ArrowDownUp: {
        render: ArrowDownUp,
        tags: "arrow down up:arrows:navigation:bidirectional:two-way:2-way:swap:switch:network:traffic:flow:mobile data:internet:sort:reorder:move",
        categories: [
            "arrows",
            "navigation"
        ]
    },
    ArrowDownWideNarrow: {
        render: ArrowDownWideNarrow,
        tags: "arrow down wide narrow:text:layout:arrows:filter:sort:descending",
        categories: [
            "text",
            "layout",
            "arrows"
        ]
    },
    ArrowDownZA: {
        render: ArrowDownZA,
        tags: "arrow down za:text:layout:arrows:filter:sort:descending:alphabetical:reverse",
        categories: [
            "text",
            "layout",
            "arrows"
        ]
    },
    ArrowDown: {
        render: ArrowDown,
        tags: "arrow down:arrows:navigation:backwards:reverse:direction:south",
        categories: [
            "arrows",
            "navigation"
        ]
    },
    ArrowLeftCircle: {
        render: ArrowLeftCircle,
        tags: "arrow left circle:arrows:navigation:shapes:gaming:previous:back:direction:west:sign:turn:button:<-",
        categories: [
            "arrows",
            "navigation",
            "shapes",
            "gaming"
        ]
    },
    ArrowLeftFromLine: {
        render: ArrowLeftFromLine,
        tags: "arrow left from line:arrows:navigation:previous:back:direction:west:expand:fold:horizontal:<-|",
        categories: [
            "arrows",
            "navigation"
        ]
    },
    ArrowLeftRight: {
        render: ArrowLeftRight,
        tags: "arrow left right:arrows:navigation:bidirectional:two-way:2-way:swap:switch:transaction:reorder:move:<-:->",
        categories: [
            "arrows",
            "navigation"
        ]
    },
    ArrowLeftSquare: {
        render: ArrowLeftSquare,
        tags: "arrow left square:arrows:navigation:shapes:previous:back:direction:west:sign:keyboard:button:<-",
        categories: [
            "arrows",
            "navigation",
            "shapes"
        ]
    },
    ArrowLeftToLine: {
        render: ArrowLeftToLine,
        tags: "arrow left to line:arrows:navigation:previous:back:direction:west:collapse:fold:horizontal:|<-",
        categories: [
            "arrows",
            "navigation"
        ]
    },
    ArrowLeft: {
        render: ArrowLeft,
        tags: "arrow left:arrows:navigation:previous:back:direction:west:<-",
        categories: [
            "arrows",
            "navigation"
        ]
    },
    ArrowRightCircle: {
        render: ArrowRightCircle,
        tags: "arrow right circle:arrows:navigation:shapes:gaming:next:forward:direction:east:sign:turn:button:->",
        categories: [
            "arrows",
            "navigation",
            "shapes",
            "gaming"
        ]
    },
    ArrowRightFromLine: {
        render: ArrowRightFromLine,
        tags: "arrow right from line:arrows:navigation:next:forward:direction:east:export:expand:fold:horizontal:|->",
        categories: [
            "arrows",
            "navigation"
        ]
    },
    ArrowRightLeft: {
        render: ArrowRightLeft,
        tags: "arrow right left:arrows:navigation:bidirectional:two-way:2-way:swap:switch:transaction:reorder:move:<-:->",
        categories: [
            "arrows",
            "navigation"
        ]
    },
    ArrowRightSquare: {
        render: ArrowRightSquare,
        tags: "arrow right square:arrows:navigation:shapes:next:forward:direction:west:sign:keyboard:button:->",
        categories: [
            "arrows",
            "navigation",
            "shapes"
        ]
    },
    ArrowRightToLine: {
        render: ArrowRightToLine,
        tags: "arrow right to line:arrows:navigation:development:next:forward:direction:east:tab:keyboard:mac:indent:collapse:fold:horizontal:->|",
        categories: [
            "arrows",
            "navigation",
            "development"
        ]
    },
    ArrowRight: {
        render: ArrowRight,
        tags: "arrow right:arrows:navigation:forward:next:direction:east:->",
        categories: [
            "arrows",
            "navigation"
        ]
    },
    ArrowUp01: {
        render: ArrowUp01,
        tags: "arrow up 01:text:layout:arrows:filter:sort:ascending:numerical",
        categories: [
            "text",
            "layout",
            "arrows"
        ]
    },
    ArrowUp10: {
        render: ArrowUp10,
        tags: "arrow up 10:text:layout:arrows:filter:sort:descending:numerical",
        categories: [
            "text",
            "layout",
            "arrows"
        ]
    },
    ArrowUpAZ: {
        render: ArrowUpAZ,
        tags: "arrow up az:text:layout:arrows:filter:sort:ascending:alphabetical",
        categories: [
            "text",
            "layout",
            "arrows"
        ]
    },
    ArrowUpCircle: {
        render: ArrowUpCircle,
        tags: "arrow up circle:arrows:navigation:shapes:gaming:forward:direction:north:sign:button",
        categories: [
            "arrows",
            "navigation",
            "shapes",
            "gaming"
        ]
    },
    ArrowUpDown: {
        render: ArrowUpDown,
        tags: "arrow up down:arrows:navigation:bidirectional:two-way:2-way:swap:switch:network:mobile data:internet:sort:reorder:move",
        categories: [
            "arrows",
            "navigation"
        ]
    },
    ArrowUpFromDot: {
        render: ArrowUpFromDot,
        tags: "arrow up from dot:arrows:navigation:maps:direction:north:step:out",
        categories: [
            "arrows",
            "navigation",
            "maps"
        ]
    },
    ArrowUpFromLine: {
        render: ArrowUpFromLine,
        tags: "arrow up from line:arrows:navigation:files:development:forward:direction:north:upload:git:version control:push:expand:fold:vertical",
        categories: [
            "arrows",
            "navigation",
            "files",
            "development"
        ]
    },
    ArrowUpLeftFromCircle: {
        render: ArrowUpLeftFromCircle,
        tags: "arrow up left from circle:arrows:navigation:maps:development:outwards:direction:north-west:diagonal:keyboard:button:escape",
        categories: [
            "arrows",
            "navigation",
            "maps",
            "development"
        ]
    },
    ArrowUpLeftFromSquare: {
        render: ArrowUpLeftFromSquare,
        tags: "arrow up left from square:arrows:navigation:outwards:direction:north-west:diagonal",
        categories: [
            "arrows",
            "navigation"
        ]
    },
    ArrowUpLeftSquare: {
        render: ArrowUpLeftSquare,
        tags: "arrow up left square:arrows:navigation:shapes:direction:north-west:diagonal:sign:keyboard:button",
        categories: [
            "arrows",
            "navigation",
            "shapes"
        ]
    },
    ArrowUpLeft: {
        render: ArrowUpLeft,
        tags: "arrow up left:arrows:navigation:direction:north-west:diagonal",
        categories: [
            "arrows",
            "navigation"
        ]
    },
    ArrowUpNarrowWide: {
        render: ArrowUpNarrowWide,
        tags: "arrow up narrow wide:text:layout:arrows:filter:sort:ascending",
        categories: [
            "text",
            "layout",
            "arrows"
        ]
    },
    ArrowUpRightFromCircle: {
        render: ArrowUpRightFromCircle,
        tags: "arrow up right from circle:arrows:navigation:maps:outwards:direction:north-east:diagonal",
        categories: [
            "arrows",
            "navigation",
            "maps"
        ]
    },
    ArrowUpRightFromSquare: {
        render: ArrowUpRightFromSquare,
        tags: "arrow up right from square:arrows:navigation:social:outwards:direction:north-east:diagonal:share:open:external",
        categories: [
            "arrows",
            "navigation",
            "social"
        ]
    },
    ArrowUpRightSquare: {
        render: ArrowUpRightSquare,
        tags: "arrow up right square:arrows:navigation:shapes:social:direction:north-east:diagonal:sign:keyboard:button:share",
        categories: [
            "arrows",
            "navigation",
            "shapes",
            "social"
        ]
    },
    ArrowUpRight: {
        render: ArrowUpRight,
        tags: "arrow up right:arrows:navigation:direction:north-east:diagonal",
        categories: [
            "arrows",
            "navigation"
        ]
    },
    ArrowUpSquare: {
        render: ArrowUpSquare,
        tags: "arrow up square:arrows:navigation:shapes:forward:direction:north:sign:keyboard:button",
        categories: [
            "arrows",
            "navigation",
            "shapes"
        ]
    },
    ArrowUpToLine: {
        render: ArrowUpToLine,
        tags: "arrow up to line:arrows:navigation:files:forward:direction:north:upload:collapse:fold:vertical",
        categories: [
            "arrows",
            "navigation",
            "files"
        ]
    },
    ArrowUpWideNarrow: {
        render: ArrowUpWideNarrow,
        tags: "arrow up wide narrow:text:layout:arrows:filter:sort:descending",
        categories: [
            "text",
            "layout",
            "arrows"
        ]
    },
    ArrowUpZA: {
        render: ArrowUpZA,
        tags: "arrow up za:text:layout:arrows:filter:sort:descending:alphabetical:reverse",
        categories: [
            "text",
            "layout",
            "arrows"
        ]
    },
    ArrowUp: {
        render: ArrowUp,
        tags: "arrow up:arrows:navigation:forward:direction:north",
        categories: [
            "arrows",
            "navigation"
        ]
    },
    ArrowsUpFromLine: {
        render: ArrowsUpFromLine,
        tags: "arrows up from line:arrows:transportation:mail:direction:orientation:this way up:vertical:package:box:fragile:postage:shipping",
        categories: [
            "arrows",
            "transportation",
            "mail"
        ]
    },
    AsteriskSquare: {
        render: AsteriskSquare,
        tags: "asterisk square:text:security:account:maths:development:password:secret:access:key:multiply:multiplication:glob pattern:wildcard:*",
        categories: [
            "text",
            "security",
            "account",
            "maths",
            "development"
        ]
    },
    Asterisk: {
        render: Asterisk,
        tags: "asterisk:text:maths:development:reference:times:multiply:multiplication:operator:code:glob pattern:wildcard:*",
        categories: [
            "text",
            "maths",
            "development"
        ]
    },
    AtSign: {
        render: AtSign,
        tags: "at sign:text:account:mention:at:email:message:@",
        categories: [
            "text",
            "account"
        ]
    },
    Atom: {
        render: Atom,
        tags: "atom:science:atomic:nuclear:physics:particle:element:molecule:electricity:energy:chemistry",
        categories: [
            "science"
        ]
    },
    AudioLines: {
        render: AudioLines,
        tags: "audio lines:multimedia:communication:graphic equaliser:sound:noise:listen:hearing:hertz:frequency:wavelength:vibrate:sine:synthesizer:synthesiser:levels:track:music:playback:radio:broadcast:airwaves:voice:vocals:singer:song",
        categories: [
            "multimedia",
            "communication"
        ]
    },
    AudioWaveform: {
        render: AudioWaveform,
        tags: "audio waveform:multimedia:communication:sound:noise:listen:hearing:hertz:frequency:wavelength:vibrate:sine:synthesizer:synthesiser:levels:track:music:playback:radio:broadcast:airwaves:voice:vocals:singer:song",
        categories: [
            "multimedia",
            "communication"
        ]
    },
    Award: {
        render: Award,
        tags: "award:account:sports:gaming:achievement:badge:rosette:prize:winner",
        categories: [
            "account",
            "sports",
            "gaming"
        ]
    },
    Axe: {
        render: Axe,
        tags: "axe:tools:gaming:hatchet:weapon:chop:sharp:equipment:fireman:firefighter:brigade:lumberjack:woodcutter:logger:forestry",
        categories: [
            "tools",
            "gaming"
        ]
    },
    Axis3D: {
        render: Axis3D,
        tags: "axis 3 d:design:gizmo:coordinates",
        categories: [
            "design"
        ]
    },
    Baby: {
        render: Baby,
        tags: "baby:accessibility:people:child:childproof:children",
        categories: [
            "accessibility",
            "people"
        ]
    },
    Backpack: {
        render: Backpack,
        tags: "backpack:gaming:photography:travel:bag:hiking:travel:camping:school:childhood",
        categories: [
            "gaming",
            "photography",
            "travel"
        ]
    },
    BadgeAlert: {
        render: BadgeAlert,
        tags: "badge alert:account:social:shapes:check:verified:unverified:security:safety:issue",
        categories: [
            "account",
            "social",
            "shapes"
        ]
    },
    BadgeCent: {
        render: BadgeCent,
        tags: "badge cent:shopping:money:currency:account:shapes:discount:offer:sale:voucher:tag:monetization:marketing:finance:financial:exchange:transaction:payment:cents:dollar:usd:$:¢",
        categories: [
            "shopping",
            "money",
            "currency",
            "account",
            "shapes"
        ]
    },
    BadgeCheck: {
        render: BadgeCheck,
        tags: "badge check:account:social:shapes:verified:check",
        categories: [
            "account",
            "social",
            "shapes"
        ]
    },
    BadgeDollarSign: {
        render: BadgeDollarSign,
        tags: "badge dollar sign:shopping:money:currency:account:shapes:discount:offer:sale:voucher:tag:monetization:marketing:finance:financial:exchange:transaction:payment:usd:$",
        categories: [
            "shopping",
            "money",
            "currency",
            "account",
            "shapes"
        ]
    },
    BadgeEuro: {
        render: BadgeEuro,
        tags: "badge euro:shopping:money:currency:account:shapes:discount:offer:sale:voucher:tag:monetization:marketing:finance:financial:exchange:transaction:payment:€",
        categories: [
            "shopping",
            "money",
            "currency",
            "account",
            "shapes"
        ]
    },
    BadgeHelp: {
        render: BadgeHelp,
        tags: "badge help:account:accessibility:social:shapes:verified:unverified:help",
        categories: [
            "account",
            "accessibility",
            "social",
            "shapes"
        ]
    },
    BadgeIndianRupee: {
        render: BadgeIndianRupee,
        tags: "badge indian rupee:shopping:money:currency:account:shapes:discount:offer:sale:voucher:tag:monetization:marketing:finance:financial:exchange:transaction:payment:inr:₹",
        categories: [
            "shopping",
            "money",
            "currency",
            "account",
            "shapes"
        ]
    },
    BadgeInfo: {
        render: BadgeInfo,
        tags: "badge info:account:accessibility:social:shapes:verified:unverified:help",
        categories: [
            "account",
            "accessibility",
            "social",
            "shapes"
        ]
    },
    BadgeJapaneseYen: {
        render: BadgeJapaneseYen,
        tags: "badge japanese yen:shopping:money:currency:account:shapes:discount:offer:sale:voucher:tag:monetization:marketing:finance:financial:exchange:transaction:payment:jpy:¥",
        categories: [
            "shopping",
            "money",
            "currency",
            "account",
            "shapes"
        ]
    },
    BadgeMinus: {
        render: BadgeMinus,
        tags: "badge minus:account:social:shapes:verified:unverified:delete:remove:erase",
        categories: [
            "account",
            "social",
            "shapes"
        ]
    },
    BadgePercent: {
        render: BadgePercent,
        tags: "badge percent:account:social:money:shopping:maths:shapes:verified:unverified:sale:discount:offer:marketing:sticker:price tag",
        categories: [
            "account",
            "social",
            "money",
            "shopping",
            "maths",
            "shapes"
        ]
    },
    BadgePlus: {
        render: BadgePlus,
        tags: "badge plus:account:social:shapes:verified:unverified:add:create:new",
        categories: [
            "account",
            "social",
            "shapes"
        ]
    },
    BadgePoundSterling: {
        render: BadgePoundSterling,
        tags: "badge pound sterling:shopping:money:currency:account:shapes:discount:offer:sale:voucher:tag:monetization:marketing:finance:financial:exchange:transaction:payment:british:gbp:£",
        categories: [
            "shopping",
            "money",
            "currency",
            "account",
            "shapes"
        ]
    },
    BadgeRussianRuble: {
        render: BadgeRussianRuble,
        tags: "badge russian ruble:shopping:money:currency:account:shapes:discount:offer:sale:voucher:tag:monetization:marketing:finance:financial:exchange:transaction:payment:rub:₽",
        categories: [
            "shopping",
            "money",
            "currency",
            "account",
            "shapes"
        ]
    },
    BadgeSwissFranc: {
        render: BadgeSwissFranc,
        tags: "badge swiss franc:shopping:money:currency:account:shapes:discount:offer:sale:voucher:tag:monetization:marketing:finance:financial:exchange:transaction:payment:chf:₣",
        categories: [
            "shopping",
            "money",
            "currency",
            "account",
            "shapes"
        ]
    },
    BadgeX: {
        render: BadgeX,
        tags: "badge x:account:social:shapes:verified:unverified:lost:delete:remove",
        categories: [
            "account",
            "social",
            "shapes"
        ]
    },
    Badge: {
        render: Badge,
        tags: "badge:account:social:shapes:check:verified:unverified",
        categories: [
            "account",
            "social",
            "shapes"
        ]
    },
    BaggageClaim: {
        render: BaggageClaim,
        tags: "baggage claim:transportation:travel:baggage:luggage:travel:cart:trolley:suitcase",
        categories: [
            "transportation",
            "travel"
        ]
    },
    Ban: {
        render: Ban,
        tags: "ban:account:cancel:no:stop:forbidden:prohibited:error:incorrect:mistake:wrong:failure:circle:slash:null:void",
        categories: [
            "account"
        ]
    },
    Banana: {
        render: Banana,
        tags: "banana:food beverage:fruit:food",
        categories: [
            "food-beverage"
        ]
    },
    Banknote: {
        render: Banknote,
        tags: "banknote:currency:money:currency:money:payment",
        categories: [
            "currency",
            "money"
        ]
    },
    BarChart2: {
        render: BarChart2,
        tags: "bar chart 2:charts:statistics:diagram:graph",
        categories: [
            "charts"
        ]
    },
    BarChart3: {
        render: BarChart3,
        tags: "bar chart 3:charts:statistics:diagram:graph",
        categories: [
            "charts"
        ]
    },
    BarChart4: {
        render: BarChart4,
        tags: "bar chart 4:charts:statistics:diagram:graph",
        categories: [
            "charts"
        ]
    },
    BarChartBig: {
        render: BarChartBig,
        tags: "bar chart big:charts:statistics:diagram:graph",
        categories: [
            "charts"
        ]
    },
    BarChartHorizontalBig: {
        render: BarChartHorizontalBig,
        tags: "bar chart horizontal big:charts:statistics:diagram:graph",
        categories: [
            "charts"
        ]
    },
    BarChartHorizontal: {
        render: BarChartHorizontal,
        tags: "bar chart horizontal:charts:statistics:diagram:graph",
        categories: [
            "charts"
        ]
    },
    BarChart: {
        render: BarChart,
        tags: "bar chart:charts:statistics:diagram:graph",
        categories: [
            "charts"
        ]
    },
    Barcode: {
        render: Barcode,
        tags: "barcode:shopping:scan:checkout:till:cart:transaction:purchase:buy:product:packaging:retail:consumer",
        categories: [
            "shopping"
        ]
    },
    Baseline: {
        render: Baseline,
        tags: "baseline:text:text:format:color",
        categories: [
            "text"
        ]
    },
    Bath: {
        render: Bath,
        tags: "bath:travel:amenities:services:bathroom:shower",
        categories: [
            "travel"
        ]
    },
    BatteryCharging: {
        render: BatteryCharging,
        tags: "battery charging:connectivity:devices:power:electricity:energy:accumulator:charge",
        categories: [
            "connectivity",
            "devices"
        ]
    },
    BatteryFull: {
        render: BatteryFull,
        tags: "battery full:connectivity:devices:power:electricity:energy:accumulator:charge",
        categories: [
            "connectivity",
            "devices"
        ]
    },
    BatteryLow: {
        render: BatteryLow,
        tags: "battery low:connectivity:devices:power:electricity:energy:accumulator:charge",
        categories: [
            "connectivity",
            "devices"
        ]
    },
    BatteryMedium: {
        render: BatteryMedium,
        tags: "battery medium:connectivity:devices:power:electricity:energy:accumulator:charge",
        categories: [
            "connectivity",
            "devices"
        ]
    },
    BatteryWarning: {
        render: BatteryWarning,
        tags: "battery warning:connectivity:devices:power:electricity:energy:accumulator:charge:exclamation mark",
        categories: [
            "connectivity",
            "devices"
        ]
    },
    Battery: {
        render: Battery,
        tags: "battery:connectivity:devices:power:electricity:energy:accumulator:charge",
        categories: [
            "connectivity",
            "devices"
        ]
    },
    Beaker: {
        render: Beaker,
        tags: "beaker:science:gaming:cup:lab:chemistry:experiment:test",
        categories: [
            "science",
            "gaming"
        ]
    },
    BeanOff: {
        render: BeanOff,
        tags: "bean off:food beverage:soy free:legume:soy:food:seed:allergy:intolerance:diet",
        categories: [
            "food-beverage"
        ]
    },
    Bean: {
        render: Bean,
        tags: "bean:food beverage:legume:soy:food:seed",
        categories: [
            "food-beverage"
        ]
    },
    BedDouble: {
        render: BedDouble,
        tags: "bed double:furniture:sleep:hotel:furniture",
        categories: [
            "furniture"
        ]
    },
    BedSingle: {
        render: BedSingle,
        tags: "bed single:furniture:sleep:hotel:furniture",
        categories: [
            "furniture"
        ]
    },
    Bed: {
        render: Bed,
        tags: "bed:furniture:sleep:hotel:furniture",
        categories: [
            "furniture"
        ]
    },
    Beef: {
        render: Beef,
        tags: "beef:food beverage:food:dish:restaurant:course:meal:meat:bbq:steak",
        categories: [
            "food-beverage"
        ]
    },
    Beer: {
        render: Beer,
        tags: "beer:food beverage:alcohol:bar:beverage:brewery:drink",
        categories: [
            "food-beverage"
        ]
    },
    BellDot: {
        render: BellDot,
        tags: "bell dot:account:notifications:alarm:notification:sound:reminder:unread",
        categories: [
            "account",
            "notifications"
        ]
    },
    BellElectric: {
        render: BellElectric,
        tags: "bell electric:devices:notifications:home:fire alarm:flames:smoke:firefighter:fireman:department:brigade:station:emergency:alert:safety:school bell:period break:recess:doorbell:entrance:entry:ring:reception",
        categories: [
            "devices",
            "notifications",
            "home"
        ]
    },
    BellMinus: {
        render: BellMinus,
        tags: "bell minus:notifications:alarm:notification:silent:reminder:delete:remove:erase",
        categories: [
            "notifications"
        ]
    },
    BellOff: {
        render: BellOff,
        tags: "bell off:notifications:alarm:notification:silent:reminder",
        categories: [
            "notifications"
        ]
    },
    BellPlus: {
        render: BellPlus,
        tags: "bell plus:notifications:notification:silent:reminder:add:create:new",
        categories: [
            "notifications"
        ]
    },
    BellRing: {
        render: BellRing,
        tags: "bell ring:notifications:alarm:notification:sound:reminder",
        categories: [
            "notifications"
        ]
    },
    Bell: {
        render: Bell,
        tags: "bell:account:notifications:alarm:notification:sound:reminder",
        categories: [
            "account",
            "notifications"
        ]
    },
    BetweenHorizontalEnd: {
        render: BetweenHorizontalEnd,
        tags: "between horizontal end:layout:design:tools:account:insert:add:left:slot:squeeze:space:vertical:grid:table:rows:cells:excel:spreadsheet:accountancy:data:enter:entry:entries:blocks:rectangles:chevron",
        categories: [
            "layout",
            "design",
            "tools",
            "account"
        ]
    },
    BetweenHorizontalStart: {
        render: BetweenHorizontalStart,
        tags: "between horizontal start:layout:design:tools:account:insert:add:right:slot:squeeze:space:vertical:grid:table:rows:cells:excel:spreadsheet:accountancy:data:enter:entry:entries:blocks:rectangles:chevron",
        categories: [
            "layout",
            "design",
            "tools",
            "account"
        ]
    },
    BetweenVerticalEnd: {
        render: BetweenVerticalEnd,
        tags: "between vertical end:layout:design:tools:insert:add:top:slot:squeeze:space:vertical:grid:table:columns:cells:data:enter:entry:entries:blocks:rectangles:chevron",
        categories: [
            "layout",
            "design",
            "tools"
        ]
    },
    BetweenVerticalStart: {
        render: BetweenVerticalStart,
        tags: "between vertical start:layout:design:tools:insert:add:bottom:slot:squeeze:space:vertical:grid:table:columns:cells:data:enter:entry:entries:blocks:rectangles:chevron",
        categories: [
            "layout",
            "design",
            "tools"
        ]
    },
    Bike: {
        render: Bike,
        tags: "bike:transportation:bicycle:transport:trip",
        categories: [
            "transportation"
        ]
    },
    Binary: {
        render: Binary,
        tags: "binary:text:development:code:digits:computer:zero:one:boolean",
        categories: [
            "text",
            "development"
        ]
    },
    Biohazard: {
        render: Biohazard,
        tags: "biohazard:science:fallout:waste:biology:chemistry:chemical:element",
        categories: [
            "science"
        ]
    },
    Bird: {
        render: Bird,
        tags: "bird:animals:peace:freedom:wing:avian:tweet",
        categories: [
            "animals"
        ]
    },
    Bitcoin: {
        render: Bitcoin,
        tags: "bitcoin:brands:currency:development:money:currency:money:payment",
        categories: [
            "brands",
            "currency",
            "development",
            "money"
        ]
    },
    Blend: {
        render: Blend,
        tags: "blend:design:photography:tools:development:mode:overlay:multiply:screen:opacity:transparency:alpha:filters:lenses:mixed:shades:tints:hues:saturation:brightness:overlap:colors:colours",
        categories: [
            "design",
            "photography",
            "tools",
            "development"
        ]
    },
    Blinds: {
        render: Blinds,
        tags: "blinds:home:shades:screen:curtain:shutter:roller blind:window:lighting:household:home",
        categories: [
            "home"
        ]
    },
    Blocks: {
        render: Blocks,
        tags: "blocks:development:shapes:addon:plugin:integration:extension:package:build:stack:toys:kids:children:learning",
        categories: [
            "development",
            "shapes"
        ]
    },
    BluetoothConnected: {
        render: BluetoothConnected,
        tags: "bluetooth connected:connectivity:devices:paired",
        categories: [
            "connectivity",
            "devices"
        ]
    },
    BluetoothOff: {
        render: BluetoothOff,
        tags: "bluetooth off:connectivity:devices:lost",
        categories: [
            "connectivity",
            "devices"
        ]
    },
    BluetoothSearching: {
        render: BluetoothSearching,
        tags: "bluetooth searching:connectivity:devices:pairing",
        categories: [
            "connectivity",
            "devices"
        ]
    },
    Bluetooth: {
        render: Bluetooth,
        tags: "bluetooth:connectivity:devices:wireless",
        categories: [
            "connectivity",
            "devices"
        ]
    },
    Bold: {
        render: Bold,
        tags: "bold:text:text:strong:format",
        categories: [
            "text"
        ]
    },
    Bolt: {
        render: Bolt,
        tags: "bolt:account:tools:home:nut:screw:settings:preferences:configuration:controls:edit:diy:fixed:build:contruction:parts",
        categories: [
            "account",
            "tools",
            "home"
        ]
    },
    Bomb: {
        render: Bomb,
        tags: "bomb:fatal:error:crash:blockbuster:mine:explosion:explode:explosive",
        categories: [
            ""
        ]
    },
    Bone: {
        render: Bone,
        tags: "bone:animals:medical:gaming:health:skeleton:skull:death:pets:dog",
        categories: [
            "animals",
            "medical",
            "gaming"
        ]
    },
    BookA: {
        render: BookA,
        tags: "book a:text:maps:gaming:dictionary:define:definition:thesaurus:encyclopedia:encyclopaedia:reading:booklet:magazine:leaflet:pamphlet:tome:library:writing:written:writer:author:story:script:fiction:novel:information:knowledge:education:high school:university:college:academy:student:study:learning:homework:research:language:translate:alphabetical:a-z:ordered",
        categories: [
            "text",
            "maps",
            "gaming"
        ]
    },
    BookAudio: {
        render: BookAudio,
        tags: "book audio:multimedia:text:audiobook:reading:listening:sound:story:fiction:novel:information:knowledge:education:student:study:learning:research",
        categories: [
            "multimedia",
            "text"
        ]
    },
    BookCheck: {
        render: BookCheck,
        tags: "book check:text:development:gaming:read:booklet:magazine:leaflet:pamphlet:library:written:authored:published:informed:knowledgeable:educated:schooled:homework:examined:tested:marked:passed:graduated:studied:learned:lesson:researched:documented:revealed:blank:plain language:true:truth:verified:corrected:task:todo:done:completed:finished:ticked",
        categories: [
            "text",
            "development",
            "gaming"
        ]
    },
    BookCopy: {
        render: BookCopy,
        tags: "book copy:development:text:gaming:code:coding:version control:git:repository:clone:fork:duplicate:multiple:books:library:copies:copied:plagiarism:plagiarised:plagiarized:reading list:information:informed:knowledge:knowledgeable:knowledgable:education:high school:university:college:academy:student:study:learning:research:smart:intelligent:intellectual",
        categories: [
            "development",
            "text",
            "gaming"
        ]
    },
    BookDashed: {
        render: BookDashed,
        tags: "book dashed:development:code:coding:version control:git:repository:template:draft:script:screenplay:writing:writer:author:unwritten:unpublished:untold",
        categories: [
            "development"
        ]
    },
    BookDown: {
        render: BookDown,
        tags: "book down:development:code:coding:version control:git:repository:pull",
        categories: [
            "development"
        ]
    },
    BookHeadphones: {
        render: BookHeadphones,
        tags: "book headphones:multimedia:text:audiobook:reading:listening:sound:story:fiction:novel:information:knowledge:education:student:study:learning:research",
        categories: [
            "multimedia",
            "text"
        ]
    },
    BookHeart: {
        render: BookHeart,
        tags: "book heart:social:text:communication:gaming:diary:romance:novel:journal:entry:entries:personal:private:secret:crush:like:love:emotion:feminine:girls:teens:teenager:therapy:theraputic:therapist:planner:organizer:organiser:notes:notepad:stationery:sketchbook:writing:written:reading:favorite:favourite:high school",
        categories: [
            "social",
            "text",
            "communication",
            "gaming"
        ]
    },
    BookImage: {
        render: BookImage,
        tags: "book image:photography:text:multimedia:files:social:shopping:travel:images:pictures:photos:album:collection:event:magazine:catalog:catalogue:brochure:browse:gallery",
        categories: [
            "photography",
            "text",
            "multimedia",
            "files",
            "social",
            "shopping",
            "travel"
        ]
    },
    BookKey: {
        render: BookKey,
        tags: "book key:development:security:gaming:code:coding:version control:git:repository:private:public:secret:unlocked:hidden:revealed:knowledge:learning",
        categories: [
            "development",
            "security",
            "gaming"
        ]
    },
    BookLock: {
        render: BookLock,
        tags: "book lock:development:security:gaming:code:coding:version control:git:repository:private:secret:hidden:knowledge",
        categories: [
            "development",
            "security",
            "gaming"
        ]
    },
    BookMarked: {
        render: BookMarked,
        tags: "book marked:text:development:gaming:dictionary:reading:booklet:magazine:leaflet:pamphlet:tome:library:writing:written:writer:author:story:script:fiction:novel:information:knowledge:education:high school:university:college:academy:student:study:learning:homework:research:documentation:saved:later:future:reference:index:code:coding:version control:git:repository",
        categories: [
            "text",
            "development",
            "gaming"
        ]
    },
    BookMinus: {
        render: BookMinus,
        tags: "book minus:development:text:gaming:code:coding:version control:git:repository:remove:delete:censor:cancel:forbid:prohibit:ban:uneducated:re-educate:unlearn:downgrade",
        categories: [
            "development",
            "text",
            "gaming"
        ]
    },
    BookOpenCheck: {
        render: BookOpenCheck,
        tags: "book open check:text:development:gaming:read:pages:booklet:magazine:leaflet:pamphlet:library:written:authored:published:informed:knowledgeable:educated:schooled:homework:examined:tested:marked:passed:graduated:studied:learned:lesson:researched:documented:revealed:blank:plain language:true:truth:verified:corrected:task:todo:done:completed:finished:ticked",
        categories: [
            "text",
            "development",
            "gaming"
        ]
    },
    BookOpenText: {
        render: BookOpenText,
        tags: "book open text:text:development:reading:pages:booklet:magazine:leaflet:pamphlet:library:writing:written:writer:author:story:script:fiction:novel:information:knowledge:education:high school:university:college:academy:student:study:learning:homework:research:documentation:revealed",
        categories: [
            "text",
            "development"
        ]
    },
    BookOpen: {
        render: BookOpen,
        tags: "book open:text:development:gaming:reading:pages:booklet:magazine:leaflet:pamphlet:library:writing:written:writer:author:story:script:screenplay:fiction:novel:information:knowledge:education:high school:university:college:academy:student:study:learning:homework:research:documentation:revealed:blank:plain",
        categories: [
            "text",
            "development",
            "gaming"
        ]
    },
    BookPlus: {
        render: BookPlus,
        tags: "book plus:development:text:gaming:code:coding:version control:git:repository:remove:delete:read:write:author:publish:inform:graduate:re-educate:study:learn:research:knowledge:improve:upgrade:level up",
        categories: [
            "development",
            "text",
            "gaming"
        ]
    },
    BookText: {
        render: BookText,
        tags: "book text:text:development:gaming:reading:booklet:magazine:leaflet:pamphlet:tome:library:writing:written:writer:author:story:script:fiction:novel:information:knowledge:education:high school:university:college:academy:student:study:learning:homework:research:documentation",
        categories: [
            "text",
            "development",
            "gaming"
        ]
    },
    BookType: {
        render: BookType,
        tags: "book type:text:design:gaming:thesaurus:synonym:reading:booklet:magazine:leaflet:pamphlet:tome:library:writing:written:writer:author:story:script:fiction:novel:information:knowledge:education:high school:university:college:academy:student:study:learning:homework:research:language:translate:typography:fonts:collection",
        categories: [
            "text",
            "design",
            "gaming"
        ]
    },
    BookUp2: {
        render: BookUp2,
        tags: "book up 2:development:code:coding:version control:git:repository:push:force",
        categories: [
            "development"
        ]
    },
    BookUp: {
        render: BookUp,
        tags: "book up:development:code:coding:version control:git:repository:push",
        categories: [
            "development"
        ]
    },
    BookUser: {
        render: BookUser,
        tags: "book user:account:connectivity:communication:social:person:people:family:friends:acquaintances:contacts:details:addresses:phone numbers:directory:listing:networking",
        categories: [
            "account",
            "connectivity",
            "communication",
            "social"
        ]
    },
    BookX: {
        render: BookX,
        tags: "book x:development:text:gaming:code:coding:version control:git:repository:remove:delete:reading:misinformation:disinformation:misinformed:charlatan:sophistry:false:lies:untruth:propaganda:censored:cancelled:forbidden:prohibited:banned:uneducated:re-education:unlearn",
        categories: [
            "development",
            "text",
            "gaming"
        ]
    },
    Book: {
        render: Book,
        tags: "book:text:development:gaming:reading:paperback:booklet:magazine:leaflet:pamphlet:tome:library:writing:written:writer:author:story:script:fiction:novel:information:knowledge:education:high school:university:college:academy:student:study:learning:homework:research:documentation",
        categories: [
            "text",
            "development",
            "gaming"
        ]
    },
    BookmarkCheck: {
        render: BookmarkCheck,
        tags: "bookmark check:account:read:finished:complete:clip:marker:tag:task:todo",
        categories: [
            "account"
        ]
    },
    BookmarkMinus: {
        render: BookmarkMinus,
        tags: "bookmark minus:account:delete:remove",
        categories: [
            "account"
        ]
    },
    BookmarkPlus: {
        render: BookmarkPlus,
        tags: "bookmark plus:account:add",
        categories: [
            "account"
        ]
    },
    BookmarkX: {
        render: BookmarkX,
        tags: "bookmark x:account:read:clip:marker:tag:cancel:close:delete:remove:clear",
        categories: [
            "account"
        ]
    },
    Bookmark: {
        render: Bookmark,
        tags: "bookmark:account:read:clip:marker:tag",
        categories: [
            "account"
        ]
    },
    BoomBox: {
        render: BoomBox,
        tags: "boom box:devices:multimedia:social:radio:speakers:audio:music:sound:broadcast:live:frequency",
        categories: [
            "devices",
            "multimedia",
            "social"
        ]
    },
    Bot: {
        render: Bot,
        tags: "bot:development:social:robot:ai:chat:assistant",
        categories: [
            "development",
            "social"
        ]
    },
    BoxSelect: {
        render: BoxSelect,
        tags: "box select:text:design:selection:square:rectangular:marquee:tool:dashed",
        categories: [
            "text",
            "design"
        ]
    },
    Box: {
        render: Box,
        tags: "box:shapes:gaming:development:maths:cube:package:container:storage:geometry:3d:isometric",
        categories: [
            "shapes",
            "gaming",
            "development",
            "maths"
        ]
    },
    Boxes: {
        render: Boxes,
        tags: "boxes:shapes:gaming:development:cubes:packages:parts:group:units:collection:cluster:geometry",
        categories: [
            "shapes",
            "gaming",
            "development"
        ]
    },
    Braces: {
        render: Braces,
        tags: "braces:development:files:json:code:token:curly brackets:data:{:}",
        categories: [
            "development",
            "files"
        ]
    },
    Brackets: {
        render: Brackets,
        tags: "brackets:development:files:code:token:array:list:square:[:]",
        categories: [
            "development",
            "files"
        ]
    },
    BrainCircuit: {
        render: BrainCircuit,
        tags: "brain circuit:science:development:mind:intellect:artificial intelligence:ai:deep learning:machine learning:computing",
        categories: [
            "science",
            "development"
        ]
    },
    BrainCog: {
        render: BrainCog,
        tags: "brain cog:science:development:mind:intellect:artificial intelligence:ai:deep learning:machine learning:computing",
        categories: [
            "science",
            "development"
        ]
    },
    Brain: {
        render: Brain,
        tags: "brain:medical:science:medical:mind:intellect:cerebral:consciousness:genius:artificial intelligence:ai",
        categories: [
            "medical",
            "science"
        ]
    },
    BrickWall: {
        render: BrickWall,
        tags: "brick wall:buildings:home:bricks:mortar:cement:materials:construction:builder:labourer:quantity surveyor:blocks:stone",
        categories: [
            "buildings",
            "home"
        ]
    },
    Briefcase: {
        render: Briefcase,
        tags: "briefcase:transportation:work:bag:baggage:folder",
        categories: [
            "transportation"
        ]
    },
    BringToFront: {
        render: BringToFront,
        tags: "bring to front:design:layout:bring:send:move:over:forward:front:overlap:layer:order",
        categories: [
            "design",
            "layout"
        ]
    },
    Brush: {
        render: Brush,
        tags: "brush:text:design:tools:draw:paint:color:artist",
        categories: [
            "text",
            "design",
            "tools"
        ]
    },
    BugOff: {
        render: BugOff,
        tags: "bug off:development:animals:debug:code:insect:kill:exterminate:pest control",
        categories: [
            "development",
            "animals"
        ]
    },
    BugPlay: {
        render: BugPlay,
        tags: "bug play:development:animals:debug:code:insect",
        categories: [
            "development",
            "animals"
        ]
    },
    Bug: {
        render: Bug,
        tags: "bug:development:animals:issue:report:debug:code:insect",
        categories: [
            "development",
            "animals"
        ]
    },
    Building2: {
        render: Building2,
        tags: "building 2:account:buildings:business:company:enterprise:skyscraper:organisation:organization",
        categories: [
            "account",
            "buildings"
        ]
    },
    Building: {
        render: Building,
        tags: "building:account:buildings:organisation:organization",
        categories: [
            "account",
            "buildings"
        ]
    },
    BusFront: {
        render: BusFront,
        tags: "bus front:transportation:coach:vehicle:trip:road",
        categories: [
            "transportation"
        ]
    },
    Bus: {
        render: Bus,
        tags: "bus:transportation:bus:vehicle:transport:trip",
        categories: [
            "transportation"
        ]
    },
    CableCar: {
        render: CableCar,
        tags: "cable car:transportation:travel:ski lift:winter holiday:alpine:resort:mountains",
        categories: [
            "transportation",
            "travel"
        ]
    },
    Cable: {
        render: Cable,
        tags: "cable:connectivity:devices:multimedia:cord:wire:connector:connection:link:signal:console:computer:equipment:electricity:energy:electronics:recharging:charger:power:supply:disconnected:unplugged:plugs:interface:input:output:audio video:av:rca:scart:tv:television:optical",
        categories: [
            "connectivity",
            "devices",
            "multimedia"
        ]
    },
    CakeSlice: {
        render: CakeSlice,
        tags: "cake slice:food beverage:social:birthday:birthdate:celebration:party:surprise:gateaux:dessert:candles:wish:fondant:icing sugar:sweet:baking",
        categories: [
            "food-beverage",
            "social"
        ]
    },
    Cake: {
        render: Cake,
        tags: "cake:food beverage:social:account:birthday:birthdate:celebration:party:surprise:gateaux:dessert:fondant:icing sugar:sweet:baking",
        categories: [
            "food-beverage",
            "social",
            "account"
        ]
    },
    Calculator: {
        render: Calculator,
        tags: "calculator:maths:devices:count:calculating machine",
        categories: [
            "maths",
            "devices"
        ]
    },
    CalendarCheck2: {
        render: CalendarCheck2,
        tags: "calendar check 2:time:date:day:month:year:event:confirm:subscribe:schedule:done:todo:tick:complete:task",
        categories: [
            "time"
        ]
    },
    CalendarCheck: {
        render: CalendarCheck,
        tags: "calendar check:time:date:day:month:year:event:confirm:subscribe:schedule:done:todo:tick:complete:task",
        categories: [
            "time"
        ]
    },
    CalendarClock: {
        render: CalendarClock,
        tags: "calendar clock:time:date:day:month:year:event:clock:hour",
        categories: [
            "time"
        ]
    },
    CalendarDays: {
        render: CalendarDays,
        tags: "calendar days:time:date:month:year:event",
        categories: [
            "time"
        ]
    },
    CalendarFold: {
        render: CalendarFold,
        tags: "calendar fold:time:files:date:month:year:event:birthday:birthdate:ics",
        categories: [
            "time",
            "files"
        ]
    },
    CalendarHeart: {
        render: CalendarHeart,
        tags: "calendar heart:time:date:month:year:event:heart:favourite:subscribe:valentines day",
        categories: [
            "time"
        ]
    },
    CalendarMinus2: {
        render: CalendarMinus2,
        tags: "calendar minus 2:time:date:day:month:year:event:delete:remove",
        categories: [
            "time"
        ]
    },
    CalendarMinus: {
        render: CalendarMinus,
        tags: "calendar minus:time:date:day:month:year:event:delete:remove",
        categories: [
            "time"
        ]
    },
    CalendarOff: {
        render: CalendarOff,
        tags: "calendar off:time:date:day:month:year:event:delete:remove",
        categories: [
            "time"
        ]
    },
    CalendarPlus2: {
        render: CalendarPlus2,
        tags: "calendar plus 2:time:date:day:month:year:event:add:subscribe:create:new",
        categories: [
            "time"
        ]
    },
    CalendarPlus: {
        render: CalendarPlus,
        tags: "calendar plus:time:date:day:month:year:event:add:subscribe:create:new",
        categories: [
            "time"
        ]
    },
    CalendarRange: {
        render: CalendarRange,
        tags: "calendar range:time:date:day:month:year:event:range:period",
        categories: [
            "time"
        ]
    },
    CalendarSearch: {
        render: CalendarSearch,
        tags: "calendar search:time:date:day:month:year:events:search",
        categories: [
            "time"
        ]
    },
    CalendarX2: {
        render: CalendarX2,
        tags: "calendar x 2:time:date:day:month:year:event:remove",
        categories: [
            "time"
        ]
    },
    CalendarX: {
        render: CalendarX,
        tags: "calendar x:time:date:day:month:year:event:remove:busy",
        categories: [
            "time"
        ]
    },
    Calendar: {
        render: Calendar,
        tags: "calendar:time:date:month:year:event:birthday:birthdate",
        categories: [
            "time"
        ]
    },
    CameraOff: {
        render: CameraOff,
        tags: "camera off:photography:devices:communication:photo:webcam:video",
        categories: [
            "photography",
            "devices",
            "communication"
        ]
    },
    Camera: {
        render: Camera,
        tags: "camera:photography:devices:communication:photo:webcam:video",
        categories: [
            "photography",
            "devices",
            "communication"
        ]
    },
    CandlestickChart: {
        render: CandlestickChart,
        tags: "candlestick chart:charts:money:trading:trader:financial:markets:portfolio:assets:prices:value:valuation:commodities:currencies:currency:exchange:hedge fund:statistics:diagram:graph",
        categories: [
            "charts",
            "money"
        ]
    },
    CandyCane: {
        render: CandyCane,
        tags: "candy cane:food beverage:sugar:food:sweet:christmas:xmas",
        categories: [
            "food-beverage"
        ]
    },
    CandyOff: {
        render: CandyOff,
        tags: "candy off:food beverage:sugar free:food:sweet:allergy:intolerance:diet",
        categories: [
            "food-beverage"
        ]
    },
    Candy: {
        render: Candy,
        tags: "candy:food beverage:sugar:food:sweet",
        categories: [
            "food-beverage"
        ]
    },
    CaptionsOff: {
        render: CaptionsOff,
        tags: "captions off:multimedia:closed captions:subtitles:subhead:transcription:transcribe:dialogue:accessibility",
        categories: [
            "multimedia"
        ]
    },
    Captions: {
        render: Captions,
        tags: "captions:multimedia:closed captions:subtitles:subhead:transcription:transcribe:dialogue:accessibility",
        categories: [
            "multimedia"
        ]
    },
    CarFront: {
        render: CarFront,
        tags: "car front:transportation:vehicle:drive:trip:journey",
        categories: [
            "transportation"
        ]
    },
    CarTaxiFront: {
        render: CarTaxiFront,
        tags: "car taxi front:transportation:cab:vehicle:drive:trip:journey",
        categories: [
            "transportation"
        ]
    },
    Car: {
        render: Car,
        tags: "car:transportation:vehicle:drive:trip:journey",
        categories: [
            "transportation"
        ]
    },
    Caravan: {
        render: Caravan,
        tags: "caravan:transportation:travel:nature:trailer:tow:camping:campsite:mobile home:holiday:nomadic:wilderness:outdoors",
        categories: [
            "transportation",
            "travel",
            "nature"
        ]
    },
    Carrot: {
        render: Carrot,
        tags: "carrot:food beverage:vegetable:food:eat",
        categories: [
            "food-beverage"
        ]
    },
    CaseLower: {
        render: CaseLower,
        tags: "case lower:text:text:letters:characters:font:typography",
        categories: [
            "text"
        ]
    },
    CaseSensitive: {
        render: CaseSensitive,
        tags: "case sensitive:text:text:letters:characters:font:typography",
        categories: [
            "text"
        ]
    },
    CaseUpper: {
        render: CaseUpper,
        tags: "case upper:text:text:letters:characters:font:typography",
        categories: [
            "text"
        ]
    },
    CassetteTape: {
        render: CassetteTape,
        tags: "cassette tape:connectivity:devices:multimedia:communication:files:audio:music:recording:play",
        categories: [
            "connectivity",
            "devices",
            "multimedia",
            "communication",
            "files"
        ]
    },
    Cast: {
        render: Cast,
        tags: "cast:devices:connectivity:chromecast:airplay:screen",
        categories: [
            "devices",
            "connectivity"
        ]
    },
    Castle: {
        render: Castle,
        tags: "castle:buildings:gaming:maps:fortress:stronghold:palace:chateau:building",
        categories: [
            "buildings",
            "gaming",
            "maps"
        ]
    },
    Cat: {
        render: Cat,
        tags: "cat:animals:animal:pet:kitten:feline",
        categories: [
            "animals"
        ]
    },
    Cctv: {
        render: Cctv,
        tags: "cctv:security:devices:communication:connectivity:photography:camera:surveillance:recording:film:videotape:crime:watching",
        categories: [
            "security",
            "devices",
            "communication",
            "connectivity",
            "photography"
        ]
    },
    CheckCheck: {
        render: CheckCheck,
        tags: "check check:notifications:done:received:double:todo:tick:complete:task",
        categories: [
            "notifications"
        ]
    },
    CheckCircle2: {
        render: CheckCircle2,
        tags: "check circle 2:notifications:shapes:done:todo:tick:complete:task",
        categories: [
            "notifications",
            "shapes"
        ]
    },
    CheckCircle: {
        render: CheckCircle,
        tags: "check circle:notifications:shapes:done:todo:tick:complete:task",
        categories: [
            "notifications",
            "shapes"
        ]
    },
    CheckSquare2: {
        render: CheckSquare2,
        tags: "check square 2:notifications:shapes:done:todo:tick:complete:task",
        categories: [
            "notifications",
            "shapes"
        ]
    },
    CheckSquare: {
        render: CheckSquare,
        tags: "check square:notifications:shapes:done:todo:tick:complete:task",
        categories: [
            "notifications",
            "shapes"
        ]
    },
    Check: {
        render: Check,
        tags: "check:notifications:done:todo:tick:complete:task",
        categories: [
            "notifications"
        ]
    },
    ChefHat: {
        render: ChefHat,
        tags: "chef hat:food beverage:cooking:food:kitchen:restaurant",
        categories: [
            "food-beverage"
        ]
    },
    Cherry: {
        render: Cherry,
        tags: "cherry:food beverage:fruit:food",
        categories: [
            "food-beverage"
        ]
    },
    ChevronDownCircle: {
        render: ChevronDownCircle,
        tags: "chevron down circle:arrows:navigation:shapes:back:menu",
        categories: [
            "arrows",
            "navigation",
            "shapes"
        ]
    },
    ChevronDownSquare: {
        render: ChevronDownSquare,
        tags: "chevron down square:arrows:navigation:shapes:back:menu:panel",
        categories: [
            "arrows",
            "navigation",
            "shapes"
        ]
    },
    ChevronDown: {
        render: ChevronDown,
        tags: "chevron down:arrows:navigation:gaming:backwards:reverse:slow:dropdown",
        categories: [
            "arrows",
            "navigation",
            "gaming"
        ]
    },
    ChevronFirst: {
        render: ChevronFirst,
        tags: "chevron first:arrows:multimedia:previous:music",
        categories: [
            "arrows",
            "multimedia"
        ]
    },
    ChevronLast: {
        render: ChevronLast,
        tags: "chevron last:arrows:multimedia:skip:next:music",
        categories: [
            "arrows",
            "multimedia"
        ]
    },
    ChevronLeftCircle: {
        render: ChevronLeftCircle,
        tags: "chevron left circle:arrows:navigation:shapes:back:previous:less than:fewer:menu:<",
        categories: [
            "arrows",
            "navigation",
            "shapes"
        ]
    },
    ChevronLeftSquare: {
        render: ChevronLeftSquare,
        tags: "chevron left square:arrows:navigation:shapes:back:previous:less than:fewer:menu:panel:button:keyboard:<",
        categories: [
            "arrows",
            "navigation",
            "shapes"
        ]
    },
    ChevronLeft: {
        render: ChevronLeft,
        tags: "chevron left:arrows:navigation:back:previous:less than:fewer:menu:<",
        categories: [
            "arrows",
            "navigation"
        ]
    },
    ChevronRightCircle: {
        render: ChevronRightCircle,
        tags: "chevron right circle:arrows:navigation:shapes:back:more than:greater:menu:>",
        categories: [
            "arrows",
            "navigation",
            "shapes"
        ]
    },
    ChevronRightSquare: {
        render: ChevronRightSquare,
        tags: "chevron right square:arrows:navigation:shapes:development:forward:next:more than:greater:menu:panel:code:coding:command line:terminal:prompt:shell:console:>",
        categories: [
            "arrows",
            "navigation",
            "shapes",
            "development"
        ]
    },
    ChevronRight: {
        render: ChevronRight,
        tags: "chevron right:arrows:navigation:maths:development:forward:next:more than:greater:menu:code:coding:command line:terminal:prompt:shell:>",
        categories: [
            "arrows",
            "navigation",
            "maths",
            "development"
        ]
    },
    ChevronUpCircle: {
        render: ChevronUpCircle,
        tags: "chevron up circle:arrows:navigation:shapes:caret:ahead:menu:^",
        categories: [
            "arrows",
            "navigation",
            "shapes"
        ]
    },
    ChevronUpSquare: {
        render: ChevronUpSquare,
        tags: "chevron up square:arrows:navigation:maths:shapes:caret:keyboard:button:mac:control:ctrl:superscript:exponential:power:ahead:menu:panel:^",
        categories: [
            "arrows",
            "navigation",
            "maths",
            "shapes"
        ]
    },
    ChevronUp: {
        render: ChevronUp,
        tags: "chevron up:arrows:navigation:maths:gaming:caret:keyboard:mac:control:ctrl:superscript:exponential:power:ahead:fast:^:dropdown",
        categories: [
            "arrows",
            "navigation",
            "maths",
            "gaming"
        ]
    },
    ChevronsDownUp: {
        render: ChevronsDownUp,
        tags: "chevrons down up:arrows:collapse:fold:vertical",
        categories: [
            "arrows"
        ]
    },
    ChevronsDown: {
        render: ChevronsDown,
        tags: "chevrons down:arrows:navigation:gaming:backwards:reverse:slower",
        categories: [
            "arrows",
            "navigation",
            "gaming"
        ]
    },
    ChevronsLeftRight: {
        render: ChevronsLeftRight,
        tags: "chevrons left right:arrows:expand:horizontal:unfold",
        categories: [
            "arrows"
        ]
    },
    ChevronsLeft: {
        render: ChevronsLeft,
        tags: "chevrons left:arrows:navigation:gaming:turn:corner",
        categories: [
            "arrows",
            "navigation",
            "gaming"
        ]
    },
    ChevronsRightLeft: {
        render: ChevronsRightLeft,
        tags: "chevrons right left:arrows:collapse:fold:horizontal",
        categories: [
            "arrows"
        ]
    },
    ChevronsRight: {
        render: ChevronsRight,
        tags: "chevrons right:arrows:navigation:gaming:turn:corner",
        categories: [
            "arrows",
            "navigation",
            "gaming"
        ]
    },
    ChevronsUpDown: {
        render: ChevronsUpDown,
        tags: "chevrons up down:arrows:expand:unfold:vertical",
        categories: [
            "arrows"
        ]
    },
    ChevronsUp: {
        render: ChevronsUp,
        tags: "chevrons up:arrows:navigation:gaming:forward:ahead:faster:speed:boost",
        categories: [
            "arrows",
            "navigation",
            "gaming"
        ]
    },
    Chrome: {
        render: Chrome,
        tags: "chrome:brands:browser:logo",
        categories: [
            "brands"
        ]
    },
    Church: {
        render: Church,
        tags: "church:buildings:maps:temple:building",
        categories: [
            "buildings",
            "maps"
        ]
    },
    CigaretteOff: {
        render: CigaretteOff,
        tags: "cigarette off:travel:transportation:medical:smoking:no-smoking",
        categories: [
            "travel",
            "transportation",
            "medical"
        ]
    },
    Cigarette: {
        render: Cigarette,
        tags: "cigarette:travel:transportation:medical:smoking",
        categories: [
            "travel",
            "transportation",
            "medical"
        ]
    },
    CircleDashed: {
        render: CircleDashed,
        tags: "circle dashed:development:shapes:pending:dot:progress:issue:draft:code:coding:version control",
        categories: [
            "development",
            "shapes"
        ]
    },
    CircleDollarSign: {
        render: CircleDollarSign,
        tags: "circle dollar sign:shapes:money:currency:monetization:marketing:currency:money:payment",
        categories: [
            "shapes",
            "money",
            "currency"
        ]
    },
    CircleDotDashed: {
        render: CircleDotDashed,
        tags: "circle dot dashed:development:shapes:pending:dot:progress:issue:draft:code:coding:version control",
        categories: [
            "development",
            "shapes"
        ]
    },
    CircleDot: {
        render: CircleDot,
        tags: "circle dot:development:shapes:pending:dot:progress:issue:code:coding:version control:choices:multiple choice:choose",
        categories: [
            "development",
            "shapes"
        ]
    },
    CircleEllipsis: {
        render: CircleEllipsis,
        tags: "circle ellipsis:shapes:pending:ellipsis:progress:…:...",
        categories: [
            "shapes"
        ]
    },
    CircleEqual: {
        render: CircleEqual,
        tags: "circle equal:maths:shapes:calculate:shape:=",
        categories: [
            "maths",
            "shapes"
        ]
    },
    CircleFadingPlus: {
        render: CircleFadingPlus,
        tags: "circle fading plus:communication:social:shapes:stories:social media:instagram:facebook:meta:snapchat:sharing:content",
        categories: [
            "communication",
            "social",
            "shapes"
        ]
    },
    CircleOff: {
        render: CircleOff,
        tags: "circle off:shapes:diameter:zero:Ø:nothing:null:void:cancel:ban:no:stop:forbidden:prohibited:error:incorrect:mistake:wrong:failure",
        categories: [
            "shapes"
        ]
    },
    CircleSlash2: {
        render: CircleSlash2,
        tags: "circle slash 2:shapes:maths:development:diameter:zero:Ø:nothing:null:void:ban:maths:divide:division:half:split:/",
        categories: [
            "shapes",
            "maths",
            "development"
        ]
    },
    CircleSlash: {
        render: CircleSlash,
        tags: "circle slash:shapes:development:maths:diameter:zero:Ø:nothing:null:void:cancel:ban:no:stop:forbidden:prohibited:error:incorrect:mistake:wrong:failure:divide:division:or:/",
        categories: [
            "shapes",
            "development",
            "maths"
        ]
    },
    CircleUserRound: {
        render: CircleUserRound,
        tags: "circle user round:account:shapes:person:account:contact",
        categories: [
            "account",
            "shapes"
        ]
    },
    CircleUser: {
        render: CircleUser,
        tags: "circle user:account:shapes:person:account:contact",
        categories: [
            "account",
            "shapes"
        ]
    },
    Circle: {
        render: Circle,
        tags: "circle:shapes:off:zero:record:shape",
        categories: [
            "shapes"
        ]
    },
    CircuitBoard: {
        render: CircuitBoard,
        tags: "circuit board:science:development:computing:electricity:electronics",
        categories: [
            "science",
            "development"
        ]
    },
    Citrus: {
        render: Citrus,
        tags: "citrus:food beverage:lemon:orange:grapefruit:fruit",
        categories: [
            "food-beverage"
        ]
    },
    Clapperboard: {
        render: Clapperboard,
        tags: "clapperboard:multimedia:movie:film:video:camera:cinema:cut:action:television:tv:show:entertainment",
        categories: [
            "multimedia"
        ]
    },
    ClipboardCheck: {
        render: ClipboardCheck,
        tags: "clipboard check:text:copied:pasted:done:todo:tick:complete:task",
        categories: [
            "text"
        ]
    },
    ClipboardCopy: {
        render: ClipboardCopy,
        tags: "clipboard copy:text:arrows:copy:paste",
        categories: [
            "text",
            "arrows"
        ]
    },
    ClipboardList: {
        render: ClipboardList,
        tags: "clipboard list:text:copy:paste:tasks",
        categories: [
            "text"
        ]
    },
    ClipboardMinus: {
        render: ClipboardMinus,
        tags: "clipboard minus:text:medical:copy:delete:remove:erase:document:medical:report:doctor",
        categories: [
            "text",
            "medical"
        ]
    },
    ClipboardPaste: {
        render: ClipboardPaste,
        tags: "clipboard paste:text:arrows:copy:paste",
        categories: [
            "text",
            "arrows"
        ]
    },
    ClipboardPenLine: {
        render: ClipboardPenLine,
        tags: "clipboard pen line:text:account:paste",
        categories: [
            "text",
            "account"
        ]
    },
    ClipboardPen: {
        render: ClipboardPen,
        tags: "clipboard pen:text:paste:signature",
        categories: [
            "text"
        ]
    },
    ClipboardPlus: {
        render: ClipboardPlus,
        tags: "clipboard plus:text:medical:copy:paste:add:create:new:document:medical:report:doctor",
        categories: [
            "text",
            "medical"
        ]
    },
    ClipboardType: {
        render: ClipboardType,
        tags: "clipboard type:text:paste:format:text",
        categories: [
            "text"
        ]
    },
    ClipboardX: {
        render: ClipboardX,
        tags: "clipboard x:text:copy:paste:discard:remove",
        categories: [
            "text"
        ]
    },
    Clipboard: {
        render: Clipboard,
        tags: "clipboard:text:copy:paste",
        categories: [
            "text"
        ]
    },
    Clock1: {
        render: Clock1,
        tags: "clock 1:time:time:watch:alarm",
        categories: [
            "time"
        ]
    },
    Clock10: {
        render: Clock10,
        tags: "clock 10:time:time:watch:alarm",
        categories: [
            "time"
        ]
    },
    Clock11: {
        render: Clock11,
        tags: "clock 11:time:time:watch:alarm",
        categories: [
            "time"
        ]
    },
    Clock12: {
        render: Clock12,
        tags: "clock 12:time:time:watch:alarm:noon:midnight",
        categories: [
            "time"
        ]
    },
    Clock2: {
        render: Clock2,
        tags: "clock 2:time:time:watch:alarm",
        categories: [
            "time"
        ]
    },
    Clock3: {
        render: Clock3,
        tags: "clock 3:time:time:watch:alarm",
        categories: [
            "time"
        ]
    },
    Clock4: {
        render: Clock4,
        tags: "clock 4:time:time:watch:alarm",
        categories: [
            "time"
        ]
    },
    Clock5: {
        render: Clock5,
        tags: "clock 5:time:time:watch:alarm",
        categories: [
            "time"
        ]
    },
    Clock6: {
        render: Clock6,
        tags: "clock 6:time:time:watch:alarm",
        categories: [
            "time"
        ]
    },
    Clock7: {
        render: Clock7,
        tags: "clock 7:time:time:watch:alarm",
        categories: [
            "time"
        ]
    },
    Clock8: {
        render: Clock8,
        tags: "clock 8:time:time:watch:alarm",
        categories: [
            "time"
        ]
    },
    Clock9: {
        render: Clock9,
        tags: "clock 9:time:time:watch:alarm",
        categories: [
            "time"
        ]
    },
    Clock: {
        render: Clock,
        tags: "clock:time:time:watch:alarm",
        categories: [
            "time"
        ]
    },
    CloudCog: {
        render: CloudCog,
        tags: "cloud cog:development:computing:ai:cluster:network",
        categories: [
            "development"
        ]
    },
    CloudDrizzle: {
        render: CloudDrizzle,
        tags: "cloud drizzle:weather:weather:shower",
        categories: [
            "weather"
        ]
    },
    CloudFog: {
        render: CloudFog,
        tags: "cloud fog:weather:weather:mist",
        categories: [
            "weather"
        ]
    },
    CloudHail: {
        render: CloudHail,
        tags: "cloud hail:weather:weather:rainfall",
        categories: [
            "weather"
        ]
    },
    CloudLightning: {
        render: CloudLightning,
        tags: "cloud lightning:weather:weather:bolt",
        categories: [
            "weather"
        ]
    },
    CloudMoonRain: {
        render: CloudMoonRain,
        tags: "cloud moon rain:weather:weather:partly:night:rainfall",
        categories: [
            "weather"
        ]
    },
    CloudMoon: {
        render: CloudMoon,
        tags: "cloud moon:weather:weather:night",
        categories: [
            "weather"
        ]
    },
    CloudOff: {
        render: CloudOff,
        tags: "cloud off:connectivity:weather:disconnect",
        categories: [
            "connectivity",
            "weather"
        ]
    },
    CloudRainWind: {
        render: CloudRainWind,
        tags: "cloud rain wind:weather:weather:rainfall",
        categories: [
            "weather"
        ]
    },
    CloudRain: {
        render: CloudRain,
        tags: "cloud rain:weather:weather:rainfall",
        categories: [
            "weather"
        ]
    },
    CloudSnow: {
        render: CloudSnow,
        tags: "cloud snow:weather:weather:blizzard",
        categories: [
            "weather"
        ]
    },
    CloudSunRain: {
        render: CloudSunRain,
        tags: "cloud sun rain:weather:weather:partly:rainfall",
        categories: [
            "weather"
        ]
    },
    CloudSun: {
        render: CloudSun,
        tags: "cloud sun:weather:weather:partly",
        categories: [
            "weather"
        ]
    },
    Cloud: {
        render: Cloud,
        tags: "cloud:weather:weather",
        categories: [
            "weather"
        ]
    },
    Cloudy: {
        render: Cloudy,
        tags: "cloudy:weather:weather:clouds",
        categories: [
            "weather"
        ]
    },
    Clover: {
        render: Clover,
        tags: "clover:gaming:leaf:luck:plant",
        categories: [
            "gaming"
        ]
    },
    Club: {
        render: Club,
        tags: "club:shapes:gaming:shape:suit:playing:cards",
        categories: [
            "shapes",
            "gaming"
        ]
    },
    Code2: {
        render: Code2,
        tags: "code 2:text:development:source:programming:html:xml",
        categories: [
            "text",
            "development"
        ]
    },
    CodeSquare: {
        render: CodeSquare,
        tags: "code square:text:development:gist:source:programming:html:xml:coding",
        categories: [
            "text",
            "development"
        ]
    },
    Code: {
        render: Code,
        tags: "code:text:development:source:programming:html:xml",
        categories: [
            "text",
            "development"
        ]
    },
    Codepen: {
        render: Codepen,
        tags: "codepen:brands:development:logo",
        categories: [
            "brands",
            "development"
        ]
    },
    Codesandbox: {
        render: Codesandbox,
        tags: "codesandbox:brands:development:logo",
        categories: [
            "brands",
            "development"
        ]
    },
    Coffee: {
        render: Coffee,
        tags: "coffee:food beverage:drink:cup:mug:tea:cafe:hot:beverage",
        categories: [
            "food-beverage"
        ]
    },
    Cog: {
        render: Cog,
        tags: "cog:account:computing:settings:cog:edit:gear:preferences",
        categories: [
            "account"
        ]
    },
    Coins: {
        render: Coins,
        tags: "coins:money:gaming:money:cash:finance:gamble",
        categories: [
            "money",
            "gaming"
        ]
    },
    Columns2: {
        render: Columns2,
        tags: "columns 2:layout:design:text:lines:list:queue:preview:panel:parallel:series:split:vertical:horizontal:half:center:middle:even:sidebar:drawer:gutter:fold:reflow:typography:pagination:pages",
        categories: [
            "layout",
            "design",
            "text"
        ]
    },
    Columns3: {
        render: Columns3,
        tags: "columns 3:layout:design:text:lines:list:queue:preview:parallel:series:split:vertical:horizontal:thirds:triple:center:middle:alignment:even:sidebars:drawers:gutters:fold:reflow:typography:pagination:pages",
        categories: [
            "layout",
            "design",
            "text"
        ]
    },
    Columns4: {
        render: Columns4,
        tags: "columns 4:layout:design:text:security:lines:list:queue:preview:parallel:series:split:vertical:horizontal:thirds:triple:center:middle:alignment:even:sidebars:drawers:gutters:fold:reflow:typography:pagination:pages:prison:jail:bars:sentence:police:cops:cell:crime:criminal:justice:law:enforcement:grill",
        categories: [
            "layout",
            "design",
            "text",
            "security"
        ]
    },
    Combine: {
        render: Combine,
        tags: "combine:shapes:development:files:cubes:packages:parts:units:collection:cluster:combine:gather:merge",
        categories: [
            "shapes",
            "development",
            "files"
        ]
    },
    Command: {
        render: Command,
        tags: "command:development:keyboard:key:mac:cmd:button",
        categories: [
            "development"
        ]
    },
    Compass: {
        render: Compass,
        tags: "compass:navigation:maps:travel:direction:north:east:south:west:safari:browser",
        categories: [
            "navigation",
            "maps",
            "travel"
        ]
    },
    Component: {
        render: Component,
        tags: "component:design:development:design:element:group:module:part:symbol",
        categories: [
            "design",
            "development"
        ]
    },
    Computer: {
        render: Computer,
        tags: "computer:devices:development:gaming:pc:chassis:codespaces:github",
        categories: [
            "devices",
            "development",
            "gaming"
        ]
    },
    ConciergeBell: {
        render: ConciergeBell,
        tags: "concierge bell:travel:reception:bell:porter",
        categories: [
            "travel"
        ]
    },
    Cone: {
        render: Cone,
        tags: "cone:shapes:maths:conical:triangle:triangular:geometry:filter:funnel:hopper:spotlight:searchlight",
        categories: [
            "shapes",
            "maths"
        ]
    },
    Construction: {
        render: Construction,
        tags: "construction:development:roadwork:maintenance:blockade:barricade",
        categories: [
            "development"
        ]
    },
    Contact2: {
        render: Contact2,
        tags: "contact 2:account:connectivity:communication:social:user:person:family:friend:acquaintance:listing:networking",
        categories: [
            "account",
            "connectivity",
            "communication",
            "social"
        ]
    },
    Contact: {
        render: Contact,
        tags: "contact:account:connectivity:communication:social:user:person:family:friend:acquaintance:listing:networking",
        categories: [
            "account",
            "connectivity",
            "communication",
            "social"
        ]
    },
    Container: {
        render: Container,
        tags: "container:development:transportation:mail:storage:shipping:freight:supply chain:docker:environment:devops:code:coding",
        categories: [
            "development",
            "transportation",
            "mail"
        ]
    },
    Contrast: {
        render: Contrast,
        tags: "contrast:photography:accessibility:design:display:accessibility",
        categories: [
            "photography",
            "accessibility",
            "design"
        ]
    },
    Cookie: {
        render: Cookie,
        tags: "cookie:account:food beverage:biscuit:privacy:legal:food",
        categories: [
            "account",
            "food-beverage"
        ]
    },
    CookingPot: {
        render: CookingPot,
        tags: "cooking pot:food beverage:home:pod:cooking:recipe:food:kitchen:chef:restaurant:dinner:lunch:breakfast:meal:eat",
        categories: [
            "food-beverage",
            "home"
        ]
    },
    CopyCheck: {
        render: CopyCheck,
        tags: "copy check:text:notifications:clone:duplicate:done:multiple",
        categories: [
            "text",
            "notifications"
        ]
    },
    CopyMinus: {
        render: CopyMinus,
        tags: "copy minus:text:maths:clone:duplicate:remove:delete:collapse:subtract:multiple:-",
        categories: [
            "text",
            "maths"
        ]
    },
    CopyPlus: {
        render: CopyPlus,
        tags: "copy plus:text:maths:clone:duplicate:add:multiple:expand:+",
        categories: [
            "text",
            "maths"
        ]
    },
    CopySlash: {
        render: CopySlash,
        tags: "copy slash:text:development:maths:clone:duplicate:cancel:ban:no:stop:forbidden:prohibited:error:multiple:divide:division:split:or:/",
        categories: [
            "text",
            "development",
            "maths"
        ]
    },
    CopyX: {
        render: CopyX,
        tags: "copy x:notifications:maths:cancel:close:delete:remove:clear:multiple:multiply:multiplication:times",
        categories: [
            "notifications",
            "maths"
        ]
    },
    Copy: {
        render: Copy,
        tags: "copy:text:clone:duplicate:multiple",
        categories: [
            "text"
        ]
    },
    Copyleft: {
        render: Copyleft,
        tags: "copyleft:licence",
        categories: [
            ""
        ]
    },
    Copyright: {
        render: Copyright,
        tags: "copyright:licence:license",
        categories: [
            ""
        ]
    },
    CornerDownLeft: {
        render: CornerDownLeft,
        tags: "corner down left:arrows:arrow:return",
        categories: [
            "arrows"
        ]
    },
    CornerDownRight: {
        render: CornerDownRight,
        tags: "corner down right:arrows:text:development:arrow:indent:tab",
        categories: [
            "arrows",
            "text",
            "development"
        ]
    },
    CornerLeftDown: {
        render: CornerLeftDown,
        tags: "corner left down:arrows:arrow",
        categories: [
            "arrows"
        ]
    },
    CornerLeftUp: {
        render: CornerLeftUp,
        tags: "corner left up:arrows:arrow",
        categories: [
            "arrows"
        ]
    },
    CornerRightDown: {
        render: CornerRightDown,
        tags: "corner right down:arrows:arrow",
        categories: [
            "arrows"
        ]
    },
    CornerRightUp: {
        render: CornerRightUp,
        tags: "corner right up:arrows:arrow",
        categories: [
            "arrows"
        ]
    },
    CornerUpLeft: {
        render: CornerUpLeft,
        tags: "corner up left:arrows:arrow",
        categories: [
            "arrows"
        ]
    },
    CornerUpRight: {
        render: CornerUpRight,
        tags: "corner up right:arrows:arrow",
        categories: [
            "arrows"
        ]
    },
    Cpu: {
        render: Cpu,
        tags: "cpu:devices:processor:cores:technology:computer:chip:circuit:memory:ram:specs:gigahertz:ghz",
        categories: [
            "devices"
        ]
    },
    CreativeCommons: {
        render: CreativeCommons,
        tags: "creative commons:licence:license",
        categories: [
            ""
        ]
    },
    CreditCard: {
        render: CreditCard,
        tags: "credit card:account:money:bank:purchase:payment:cc",
        categories: [
            "account",
            "money"
        ]
    },
    Croissant: {
        render: Croissant,
        tags: "croissant:food beverage:bakery:cooking:food:pastry",
        categories: [
            "food-beverage"
        ]
    },
    Crop: {
        render: Crop,
        tags: "crop:photography:design:photo:image",
        categories: [
            "photography",
            "design"
        ]
    },
    Cross: {
        render: Cross,
        tags: "cross:shapes:healthcare:first aid",
        categories: [
            "shapes"
        ]
    },
    Crosshair: {
        render: Crosshair,
        tags: "crosshair:photography:aim:target",
        categories: [
            "photography"
        ]
    },
    Crown: {
        render: Crown,
        tags: "crown:gaming:king:winner:favourite",
        categories: [
            "gaming"
        ]
    },
    Cuboid: {
        render: Cuboid,
        tags: "cuboid:shapes:maths:buildings:brick:block:container:storage:geometry:rectangular:hexahedron",
        categories: [
            "shapes",
            "maths",
            "buildings"
        ]
    },
    CupSoda: {
        render: CupSoda,
        tags: "cup soda:food beverage:beverage:cup:drink:soda:straw:water",
        categories: [
            "food-beverage"
        ]
    },
    Currency: {
        render: Currency,
        tags: "currency:currency:money:finance:money",
        categories: [
            "currency",
            "money"
        ]
    },
    Cylinder: {
        render: Cylinder,
        tags: "cylinder:shapes:design:maths:shape:elliptical:geometry:container:storage:tin:pot",
        categories: [
            "shapes",
            "design",
            "maths"
        ]
    },
    DatabaseBackup: {
        render: DatabaseBackup,
        tags: "database backup:devices:arrows:design:development:photography:storage:memory:bytes:servers:backup:timemachine:rotate:arrow:left",
        categories: [
            "devices",
            "arrows",
            "design",
            "development",
            "photography"
        ]
    },
    DatabaseZap: {
        render: DatabaseZap,
        tags: "database zap:devices:development:cache busting:storage:memory:bytes:servers:power:crash",
        categories: [
            "devices",
            "development"
        ]
    },
    Database: {
        render: Database,
        tags: "database:devices:development:storage:memory:container:tin:pot:bytes:servers",
        categories: [
            "devices",
            "development"
        ]
    },
    Delete: {
        render: Delete,
        tags: "delete:text:arrows:backspace:remove",
        categories: [
            "text",
            "arrows"
        ]
    },
    Dessert: {
        render: Dessert,
        tags: "dessert:food beverage:pudding:christmas:xmas:custard:iced bun:icing:fondant:cake:ice cream:gelato:sundae:scoop:dollop:sugar:food:sweet",
        categories: [
            "food-beverage"
        ]
    },
    Diameter: {
        render: Diameter,
        tags: "diameter:shapes:maths:design:tools:shape:circle:geometry:trigonometry:width:height:size:calculate:measure",
        categories: [
            "shapes",
            "maths",
            "design",
            "tools"
        ]
    },
    Diamond: {
        render: Diamond,
        tags: "diamond:shapes:gaming:square:rectangle:oblique:rhombus:shape:suit:playing:cards",
        categories: [
            "shapes",
            "gaming"
        ]
    },
    Dice1: {
        render: Dice1,
        tags: "dice 1:gaming:dice:random:tabletop:1:board:game",
        categories: [
            "gaming"
        ]
    },
    Dice2: {
        render: Dice2,
        tags: "dice 2:gaming:dice:random:tabletop:2:board:game",
        categories: [
            "gaming"
        ]
    },
    Dice3: {
        render: Dice3,
        tags: "dice 3:gaming:dice:random:tabletop:3:board:game",
        categories: [
            "gaming"
        ]
    },
    Dice4: {
        render: Dice4,
        tags: "dice 4:gaming:dice:random:tabletop:4:board:game",
        categories: [
            "gaming"
        ]
    },
    Dice5: {
        render: Dice5,
        tags: "dice 5:gaming:dice:random:tabletop:5:board:game",
        categories: [
            "gaming"
        ]
    },
    Dice6: {
        render: Dice6,
        tags: "dice 6:gaming:dice:random:tabletop:6:board:game",
        categories: [
            "gaming"
        ]
    },
    Dices: {
        render: Dices,
        tags: "dices:gaming:dice:random:tabletop:board:game",
        categories: [
            "gaming"
        ]
    },
    Diff: {
        render: Diff,
        tags: "diff:development:files:patch:difference:compare:plus:minus:plus-minus:maths",
        categories: [
            "development",
            "files"
        ]
    },
    Disc2: {
        render: Disc2,
        tags: "disc 2:devices:multimedia:album:music:vinyl:record:cd:dvd:format:dj:spin:rotate:rpm",
        categories: [
            "devices",
            "multimedia"
        ]
    },
    Disc3: {
        render: Disc3,
        tags: "disc 3:devices:multimedia:album:music:vinyl:record:cd:dvd:format:dj:spin:rotate:rpm",
        categories: [
            "devices",
            "multimedia"
        ]
    },
    DiscAlbum: {
        render: DiscAlbum,
        tags: "disc album:devices:multimedia:album:music:songs:format:cd:dvd:vinyl:sleeve:cover:platinum:compilation:ep:recording:playback:spin:rotate:rpm:dj",
        categories: [
            "devices",
            "multimedia"
        ]
    },
    Disc: {
        render: Disc,
        tags: "disc:devices:multimedia:album:music:songs:format:cd:dvd:vinyl:sleeve:cover:platinum:compilation:ep:recording:playback:spin:rotate:rpm:dj",
        categories: [
            "devices",
            "multimedia"
        ]
    },
    DivideCircle: {
        render: DivideCircle,
        tags: "divide circle:maths:shapes:calculate:maths:÷:/",
        categories: [
            "maths",
            "shapes"
        ]
    },
    DivideSquare: {
        render: DivideSquare,
        tags: "divide square:maths:shapes:calculate:maths:÷:/",
        categories: [
            "maths",
            "shapes"
        ]
    },
    Divide: {
        render: Divide,
        tags: "divide:maths:development:calculate:maths:division:operator:code:÷:/",
        categories: [
            "maths",
            "development"
        ]
    },
    DnaOff: {
        render: DnaOff,
        tags: "dna off:medical:food beverage:gene:gmo free:helix:heredity:chromosome:nucleic acid",
        categories: [
            "medical",
            "food-beverage"
        ]
    },
    Dna: {
        render: Dna,
        tags: "dna:medical:gene:gmo:helix:heredity:chromosome:nucleic acid",
        categories: [
            "medical"
        ]
    },
    Dog: {
        render: Dog,
        tags: "dog:animals:animal:pet:puppy:hound:canine",
        categories: [
            "animals"
        ]
    },
    DollarSign: {
        render: DollarSign,
        tags: "dollar sign:currency:money:currency:money:payment",
        categories: [
            "currency",
            "money"
        ]
    },
    Donut: {
        render: Donut,
        tags: "donut:food beverage:doughnut:sprinkles:topping:fast food:junk food:snack:treat:sweet:sugar:dessert:hollow:ring",
        categories: [
            "food-beverage"
        ]
    },
    DoorClosed: {
        render: DoorClosed,
        tags: "door closed:home:travel:furniture:security:entrance:entry:exit:ingress:egress:gate:gateway:emergency exit",
        categories: [
            "home",
            "travel",
            "furniture",
            "security"
        ]
    },
    DoorOpen: {
        render: DoorOpen,
        tags: "door open:home:travel:furniture:security:entrance:entry:exit:ingress:egress:gate:gateway:emergency exit",
        categories: [
            "home",
            "travel",
            "furniture",
            "security"
        ]
    },
    DotSquare: {
        render: DotSquare,
        tags: "dot square:shapes:development:git:diff:modified:.",
        categories: [
            "shapes",
            "development"
        ]
    },
    Dot: {
        render: Dot,
        tags: "dot:shapes:text:interpunct:interpoint:middot:step:punctuation:period:full stop:end:finish:final:characters:font:typography:type:center:.",
        categories: [
            "shapes",
            "text"
        ]
    },
    DownloadCloud: {
        render: DownloadCloud,
        tags: "download cloud:arrows:files:import",
        categories: [
            "arrows",
            "files"
        ]
    },
    Download: {
        render: Download,
        tags: "download:arrows:files:import:export:save",
        categories: [
            "arrows",
            "files"
        ]
    },
    DraftingCompass: {
        render: DraftingCompass,
        tags: "drafting compass:shapes:maths:design:tools:geometry:trigonometry:radius:diameter:circumference:calculate:measure:arc:curve:draw:sketch",
        categories: [
            "shapes",
            "maths",
            "design",
            "tools"
        ]
    },
    Drama: {
        render: Drama,
        tags: "drama:multimedia:drama:masks:theater:theatre:entertainment:show",
        categories: [
            "multimedia"
        ]
    },
    Dribbble: {
        render: Dribbble,
        tags: "dribbble:brands:social:design:design:social",
        categories: [
            "brands",
            "social",
            "design"
        ]
    },
    Drill: {
        render: Drill,
        tags: "drill:tools:home:devices:power:bit:head:hole:diy:toolbox:build:construction",
        categories: [
            "tools",
            "home",
            "devices"
        ]
    },
    Droplet: {
        render: Droplet,
        tags: "droplet:weather:gaming:water:weather",
        categories: [
            "weather",
            "gaming"
        ]
    },
    Droplets: {
        render: Droplets,
        tags: "droplets:weather:water:humidity:weather",
        categories: [
            "weather"
        ]
    },
    Drum: {
        render: Drum,
        tags: "drum:multimedia:devices:drummer:kit:sticks:instrument:beat:bang:bass:backing track:band:play:performance:concert:march:music:audio:sound:noise:loud",
        categories: [
            "multimedia",
            "devices"
        ]
    },
    Drumstick: {
        render: Drumstick,
        tags: "drumstick:food beverage:food:chicken:meat",
        categories: [
            "food-beverage"
        ]
    },
    Dumbbell: {
        render: Dumbbell,
        tags: "dumbbell:maps:sports:barbell:weight:workout:gym",
        categories: [
            "maps",
            "sports"
        ]
    },
    EarOff: {
        render: EarOff,
        tags: "ear off:medical:accessibility:hearing:hard of hearing:hearing loss:deafness:noise:silence:audio:accessibility",
        categories: [
            "medical",
            "accessibility"
        ]
    },
    Ear: {
        render: Ear,
        tags: "ear:medical:accessibility:hearing:noise:audio:accessibility",
        categories: [
            "medical",
            "accessibility"
        ]
    },
    Eclipse: {
        render: Eclipse,
        tags: "eclipse:science:design:development:accessibility:photography:lunar:solar:crescent moon:sun:earth:day:night:planet:space:mode:dark:light:toggle:switch:color:css:styles:display:accessibility:contrast:brightness:blend:shade",
        categories: [
            "science",
            "design",
            "development",
            "accessibility",
            "photography"
        ]
    },
    EggFried: {
        render: EggFried,
        tags: "egg fried:food beverage:food:breakfast",
        categories: [
            "food-beverage"
        ]
    },
    EggOff: {
        render: EggOff,
        tags: "egg off:food beverage:egg free:vegan:hatched:bad egg",
        categories: [
            "food-beverage"
        ]
    },
    Egg: {
        render: Egg,
        tags: "egg:food beverage:animals:bird:chicken:nest:hatch:shell:incubate:soft boiled:hard:breakfast:brunch:morning:easter",
        categories: [
            "food-beverage",
            "animals"
        ]
    },
    EqualNot: {
        render: EqualNot,
        tags: "equal not:maths:development:calculate:off:maths:operator:code:≠",
        categories: [
            "maths",
            "development"
        ]
    },
    EqualSquare: {
        render: EqualSquare,
        tags: "equal square:maths:shapes:calculate:=",
        categories: [
            "maths",
            "shapes"
        ]
    },
    Equal: {
        render: Equal,
        tags: "equal:maths:development:calculate:maths:operator:assignment:code:=",
        categories: [
            "maths",
            "development"
        ]
    },
    Eraser: {
        render: Eraser,
        tags: "eraser:text:pencil:drawing:undo:delete:clear",
        categories: [
            "text"
        ]
    },
    Euro: {
        render: Euro,
        tags: "euro:currency:money:currency:money:payment",
        categories: [
            "currency",
            "money"
        ]
    },
    Expand: {
        render: Expand,
        tags: "expand:text:scale:fullscreen",
        categories: [
            "text"
        ]
    },
    ExternalLink: {
        render: ExternalLink,
        tags: "external link:arrows:text:social:outbound:open:share",
        categories: [
            "arrows",
            "text",
            "social"
        ]
    },
    EyeOff: {
        render: EyeOff,
        tags: "eye off:accessibility:photography:view:watch:hide:hidden",
        categories: [
            "accessibility",
            "photography"
        ]
    },
    Eye: {
        render: Eye,
        tags: "eye:accessibility:photography:view:watch",
        categories: [
            "accessibility",
            "photography"
        ]
    },
    Facebook: {
        render: Facebook,
        tags: "facebook:account:social:brands:logo:social",
        categories: [
            "account",
            "social",
            "brands"
        ]
    },
    Factory: {
        render: Factory,
        tags: "factory:buildings:building:business:energy:industry:manufacture:sector",
        categories: [
            "buildings"
        ]
    },
    Fan: {
        render: Fan,
        tags: "fan:home:air:cooler:ventilation:ventilator:blower",
        categories: [
            "home"
        ]
    },
    FastForward: {
        render: FastForward,
        tags: "fast forward:multimedia:arrows:music",
        categories: [
            "multimedia",
            "arrows"
        ]
    },
    Feather: {
        render: Feather,
        tags: "feather:gaming:logo",
        categories: [
            "gaming"
        ]
    },
    Fence: {
        render: Fence,
        tags: "fence:home:buildings:picket:panels:woodwork:diy:materials:suburban:garden:property:territory",
        categories: [
            "home",
            "buildings"
        ]
    },
    FerrisWheel: {
        render: FerrisWheel,
        tags: "ferris wheel:maps:big wheel:daisy wheel:observation:attraction:entertainment:amusement park:theme park:funfair",
        categories: [
            "maps"
        ]
    },
    Figma: {
        render: Figma,
        tags: "figma:brands:design:logo:design:tool",
        categories: [
            "brands",
            "design"
        ]
    },
    FileArchive: {
        render: FileArchive,
        tags: "file archive:files:zip:package:archive",
        categories: [
            "files"
        ]
    },
    FileAudio2: {
        render: FileAudio2,
        tags: "file audio 2:files:music:audio:sound:headphones",
        categories: [
            "files"
        ]
    },
    FileAudio: {
        render: FileAudio,
        tags: "file audio:files:music:audio:sound:headphones",
        categories: [
            "files"
        ]
    },
    FileAxis3D: {
        render: FileAxis3D,
        tags: "file axis 3 d:design:files:model:3d:axis:coordinates",
        categories: [
            "design",
            "files"
        ]
    },
    FileBadge2: {
        render: FileBadge2,
        tags: "file badge 2:files:award:achievement:badge:rosette:prize:winner",
        categories: [
            "files"
        ]
    },
    FileBadge: {
        render: FileBadge,
        tags: "file badge:files:award:achievement:badge:rosette:prize:winner",
        categories: [
            "files"
        ]
    },
    FileBarChart2: {
        render: FileBarChart2,
        tags: "file bar chart 2:files:statistics:diagram:graph:presentation",
        categories: [
            "files"
        ]
    },
    FileBarChart: {
        render: FileBarChart,
        tags: "file bar chart:files:statistics:diagram:graph:presentation",
        categories: [
            "files"
        ]
    },
    FileBox: {
        render: FileBox,
        tags: "file box:files:box:package:model",
        categories: [
            "files"
        ]
    },
    FileCheck2: {
        render: FileCheck2,
        tags: "file check 2:files:done:document:todo:tick:complete:task",
        categories: [
            "files"
        ]
    },
    FileCheck: {
        render: FileCheck,
        tags: "file check:files:done:document:todo:tick:complete:task",
        categories: [
            "files"
        ]
    },
    FileClock: {
        render: FileClock,
        tags: "file clock:files:time:history:log:clock",
        categories: [
            "files",
            "time"
        ]
    },
    FileCode2: {
        render: FileCode2,
        tags: "file code 2:files:development:script:document:html:xml:property list:plist",
        categories: [
            "files",
            "development"
        ]
    },
    FileCode: {
        render: FileCode,
        tags: "file code:files:development:script:document:gist:html:xml:property list:plist",
        categories: [
            "files",
            "development"
        ]
    },
    FileCog: {
        render: FileCog,
        tags: "file cog:files:executable:settings:cog:edit:gear",
        categories: [
            "files"
        ]
    },
    FileDiff: {
        render: FileDiff,
        tags: "file diff:files:development:diff:patch",
        categories: [
            "files",
            "development"
        ]
    },
    FileDigit: {
        render: FileDigit,
        tags: "file digit:files:development:number:document",
        categories: [
            "files",
            "development"
        ]
    },
    FileDown: {
        render: FileDown,
        tags: "file down:files:arrows:download:import:export",
        categories: [
            "files",
            "arrows"
        ]
    },
    FileHeart: {
        render: FileHeart,
        tags: "file heart:files:heart:favourite:bookmark:quick link",
        categories: [
            "files"
        ]
    },
    FileImage: {
        render: FileImage,
        tags: "file image:files:image:graphics:photo:picture",
        categories: [
            "files"
        ]
    },
    FileInput: {
        render: FileInput,
        tags: "file input:files:arrows:document",
        categories: [
            "files",
            "arrows"
        ]
    },
    FileJson2: {
        render: FileJson2,
        tags: "file json 2:files:development:code:json:curly braces:curly brackets",
        categories: [
            "files",
            "development"
        ]
    },
    FileJson: {
        render: FileJson,
        tags: "file json:files:development:code:json:curly braces:curly brackets",
        categories: [
            "files",
            "development"
        ]
    },
    FileKey2: {
        render: FileKey2,
        tags: "file key 2:files:security:key:private:public:security",
        categories: [
            "files",
            "security"
        ]
    },
    FileKey: {
        render: FileKey,
        tags: "file key:files:security:key:private:public:security",
        categories: [
            "files",
            "security"
        ]
    },
    FileLineChart: {
        render: FileLineChart,
        tags: "file line chart:files:statistics:diagram:graph:presentation",
        categories: [
            "files"
        ]
    },
    FileLock2: {
        render: FileLock2,
        tags: "file lock 2:files:security:lock:password:security",
        categories: [
            "files",
            "security"
        ]
    },
    FileLock: {
        render: FileLock,
        tags: "file lock:files:security:lock:password:security",
        categories: [
            "files",
            "security"
        ]
    },
    FileMinus2: {
        render: FileMinus2,
        tags: "file minus 2:files:document",
        categories: [
            "files"
        ]
    },
    FileMinus: {
        render: FileMinus,
        tags: "file minus:files:delete:remove:erase:document",
        categories: [
            "files"
        ]
    },
    FileMusic: {
        render: FileMusic,
        tags: "file music:files:multimedia:audio:sound:noise:track:digital:recording:playback:piano:keyboard:keys:notes:chord:midi:octave",
        categories: [
            "files",
            "multimedia"
        ]
    },
    FileOutput: {
        render: FileOutput,
        tags: "file output:files:arrows:document",
        categories: [
            "files",
            "arrows"
        ]
    },
    FilePenLine: {
        render: FilePenLine,
        tags: "file pen line:files:edit",
        categories: [
            "files"
        ]
    },
    FilePen: {
        render: FilePen,
        tags: "file pen:files:signature",
        categories: [
            "files"
        ]
    },
    FilePieChart: {
        render: FilePieChart,
        tags: "file pie chart:files:statistics:diagram:graph:presentation",
        categories: [
            "files"
        ]
    },
    FilePlus2: {
        render: FilePlus2,
        tags: "file plus 2:files:add:create:new:document",
        categories: [
            "files"
        ]
    },
    FilePlus: {
        render: FilePlus,
        tags: "file plus:files:add:create:new:document",
        categories: [
            "files"
        ]
    },
    FileQuestion: {
        render: FileQuestion,
        tags: "file question:files:readme:help:question",
        categories: [
            "files"
        ]
    },
    FileScan: {
        render: FileScan,
        tags: "file scan:files:scan:code:qr-code",
        categories: [
            "files"
        ]
    },
    FileSearch2: {
        render: FileSearch2,
        tags: "file search 2:files:lost:document:find:browser",
        categories: [
            "files"
        ]
    },
    FileSearch: {
        render: FileSearch,
        tags: "file search:files:lost:document:find:browser",
        categories: [
            "files"
        ]
    },
    FileSliders: {
        render: FileSliders,
        tags: "file sliders:files:development:cogged:gear:mechanical:machinery:configuration:controls:preferences:settings:system:admin:edit:executable",
        categories: [
            "files",
            "development"
        ]
    },
    FileSpreadsheet: {
        render: FileSpreadsheet,
        tags: "file spreadsheet:files:spreadsheet:sheet:table",
        categories: [
            "files"
        ]
    },
    FileStack: {
        render: FileStack,
        tags: "file stack:files:development:versions:multiple:copy:documents:revisions:version control:history",
        categories: [
            "files",
            "development"
        ]
    },
    FileSymlink: {
        render: FileSymlink,
        tags: "file symlink:files:symlink:symbolic:link",
        categories: [
            "files"
        ]
    },
    FileTerminal: {
        render: FileTerminal,
        tags: "file terminal:files:development:terminal:bash:script:executable",
        categories: [
            "files",
            "development"
        ]
    },
    FileText: {
        render: FileText,
        tags: "file text:files:text:data:txt:pdf:document",
        categories: [
            "files",
            "text"
        ]
    },
    FileType2: {
        render: FileType2,
        tags: "file type 2:files:text:font:text:typography:type",
        categories: [
            "files",
            "text"
        ]
    },
    FileType: {
        render: FileType,
        tags: "file type:files:text:font:text:typography:type",
        categories: [
            "files",
            "text"
        ]
    },
    FileUp: {
        render: FileUp,
        tags: "file up:files:arrows:upload:import:export",
        categories: [
            "files",
            "arrows"
        ]
    },
    FileVideo2: {
        render: FileVideo2,
        tags: "file video 2:files:movie:video:film",
        categories: [
            "files"
        ]
    },
    FileVideo: {
        render: FileVideo,
        tags: "file video:files:movie:video:film",
        categories: [
            "files"
        ]
    },
    FileVolume2: {
        render: FileVolume2,
        tags: "file volume 2:files:audio:music:volume",
        categories: [
            "files"
        ]
    },
    FileVolume: {
        render: FileVolume,
        tags: "file volume:files:audio:music:volume",
        categories: [
            "files"
        ]
    },
    FileWarning: {
        render: FileWarning,
        tags: "file warning:files:notifications:hidden:warning:alert:danger:protected:exclamation mark",
        categories: [
            "files",
            "notifications"
        ]
    },
    FileX2: {
        render: FileX2,
        tags: "file x 2:files:lost:delete:remove:document",
        categories: [
            "files"
        ]
    },
    FileX: {
        render: FileX,
        tags: "file x:files:lost:delete:remove:document",
        categories: [
            "files"
        ]
    },
    File: {
        render: File,
        tags: "file:files:document",
        categories: [
            "files"
        ]
    },
    Files: {
        render: Files,
        tags: "files:files:multiple:copy:documents",
        categories: [
            "files"
        ]
    },
    Film: {
        render: Film,
        tags: "film:photography:multimedia:movie:video:reel:camera:cinema:entertainment",
        categories: [
            "photography",
            "multimedia"
        ]
    },
    FilterX: {
        render: FilterX,
        tags: "filter x:layout:funnel:hopper",
        categories: [
            "layout"
        ]
    },
    Filter: {
        render: Filter,
        tags: "filter:layout:funnel:hopper",
        categories: [
            "layout"
        ]
    },
    Fingerprint: {
        render: Fingerprint,
        tags: "fingerprint:account:security:medical:devices:2fa:authentication:biometric:identity:security",
        categories: [
            "account",
            "security",
            "medical",
            "devices"
        ]
    },
    FireExtinguisher: {
        render: FireExtinguisher,
        tags: "fire extinguisher:home:tools:travel:flames:smoke:foam:water:spray:hose:firefighter:fireman:department:brigade:station:emergency:suppress:compressed:tank:cylinder:safety:equipment:amenities",
        categories: [
            "home",
            "tools",
            "travel"
        ]
    },
    FishOff: {
        render: FishOff,
        tags: "fish off:food beverage:animals:food:dish:restaurant:course:meal:seafood:animal:pet:sea:marine:allergy:intolerance:diet",
        categories: [
            "food-beverage",
            "animals"
        ]
    },
    FishSymbol: {
        render: FishSymbol,
        tags: "fish symbol:food beverage:animals:dish:restaurant:course:meal:seafood:pet:sea:marine",
        categories: [
            "food-beverage",
            "animals"
        ]
    },
    Fish: {
        render: Fish,
        tags: "fish:food beverage:animals:dish:restaurant:course:meal:seafood:pet:sea:marine",
        categories: [
            "food-beverage",
            "animals"
        ]
    },
    FlagOff: {
        render: FlagOff,
        tags: "flag off:account:social:unflag",
        categories: [
            "account",
            "social"
        ]
    },
    FlagTriangleLeft: {
        render: FlagTriangleLeft,
        tags: "flag triangle left:development:report:timeline",
        categories: [
            "development"
        ]
    },
    FlagTriangleRight: {
        render: FlagTriangleRight,
        tags: "flag triangle right:development:report:timeline",
        categories: [
            "development"
        ]
    },
    Flag: {
        render: Flag,
        tags: "flag:account:social:report",
        categories: [
            "account",
            "social"
        ]
    },
    FlameKindling: {
        render: FlameKindling,
        tags: "flame kindling:nature:social:gaming:campfire:camping:wilderness:outdoors:lit:warmth:wood:twigs:sticks",
        categories: [
            "nature",
            "social",
            "gaming"
        ]
    },
    Flame: {
        render: Flame,
        tags: "flame:weather:social:gaming:fire:lit:burning:spark:embers:smoke:firefighter:fireman:department:brigade:station:emergency",
        categories: [
            "weather",
            "social",
            "gaming"
        ]
    },
    FlashlightOff: {
        render: FlashlightOff,
        tags: "flashlight off:photography:devices:torch",
        categories: [
            "photography",
            "devices"
        ]
    },
    Flashlight: {
        render: Flashlight,
        tags: "flashlight:photography:devices:torch",
        categories: [
            "photography",
            "devices"
        ]
    },
    FlaskConicalOff: {
        render: FlaskConicalOff,
        tags: "flask conical off:science:gaming:beaker:erlenmeyer:non toxic:lab:chemistry:experiment:test",
        categories: [
            "science",
            "gaming"
        ]
    },
    FlaskConical: {
        render: FlaskConical,
        tags: "flask conical:science:gaming:beaker:erlenmeyer:lab:chemistry:experiment:test",
        categories: [
            "science",
            "gaming"
        ]
    },
    FlaskRound: {
        render: FlaskRound,
        tags: "flask round:science:gaming:beaker:lab:chemistry:experiment:test",
        categories: [
            "science",
            "gaming"
        ]
    },
    FlipHorizontal2: {
        render: FlipHorizontal2,
        tags: "flip horizontal 2:design:photography:reflect:mirror:alignment:dashed",
        categories: [
            "design",
            "photography"
        ]
    },
    FlipHorizontal: {
        render: FlipHorizontal,
        tags: "flip horizontal:design:photography:reflect:mirror:alignment:dashed",
        categories: [
            "design",
            "photography"
        ]
    },
    FlipVertical2: {
        render: FlipVertical2,
        tags: "flip vertical 2:design:photography:reflect:mirror:alignment:dashed",
        categories: [
            "design",
            "photography"
        ]
    },
    FlipVertical: {
        render: FlipVertical,
        tags: "flip vertical:design:photography:reflect:mirror:alignment:dashed",
        categories: [
            "design",
            "photography"
        ]
    },
    Flower2: {
        render: Flower2,
        tags: "flower 2:nature:sustainability:seasons:sustainability:nature:plant",
        categories: [
            "nature",
            "sustainability",
            "seasons"
        ]
    },
    Flower: {
        render: Flower,
        tags: "flower:nature:gaming:sustainability:sustainability:nature:plant:spring",
        categories: [
            "nature",
            "gaming",
            "sustainability"
        ]
    },
    Focus: {
        render: Focus,
        tags: "focus:photography:camera:lens:photo:dashed",
        categories: [
            "photography"
        ]
    },
    FoldHorizontal: {
        render: FoldHorizontal,
        tags: "fold horizontal:arrows:layout:arrow:collapse:fold:vertical:dashed",
        categories: [
            "arrows",
            "layout"
        ]
    },
    FoldVertical: {
        render: FoldVertical,
        tags: "fold vertical:arrows:layout:arrow:collapse:fold:vertical:dashed",
        categories: [
            "arrows",
            "layout"
        ]
    },
    FolderArchive: {
        render: FolderArchive,
        tags: "folder archive:files:archive:zip:package",
        categories: [
            "files"
        ]
    },
    FolderCheck: {
        render: FolderCheck,
        tags: "folder check:files:done:directory:todo:tick:complete:task",
        categories: [
            "files"
        ]
    },
    FolderClock: {
        render: FolderClock,
        tags: "folder clock:files:time:history:directory:clock",
        categories: [
            "files",
            "time"
        ]
    },
    FolderClosed: {
        render: FolderClosed,
        tags: "folder closed:files:directory:closed",
        categories: [
            "files"
        ]
    },
    FolderCog: {
        render: FolderCog,
        tags: "folder cog:files:directory:settings:control:preferences:cog:edit:gear",
        categories: [
            "files"
        ]
    },
    FolderDot: {
        render: FolderDot,
        tags: "folder dot:files:development:directory:root:project:pinned:active:current:cogged:gear:mechanical:machinery:configuration:controls:preferences:settings:system:admin:edit",
        categories: [
            "files",
            "development"
        ]
    },
    FolderDown: {
        render: FolderDown,
        tags: "folder down:files:arrows:directory:download:import:export",
        categories: [
            "files",
            "arrows"
        ]
    },
    FolderGit2: {
        render: FolderGit2,
        tags: "folder git 2:files:directory:root:project:git:repo",
        categories: [
            "files"
        ]
    },
    FolderGit: {
        render: FolderGit,
        tags: "folder git:files:directory:root:project:git:repo",
        categories: [
            "files"
        ]
    },
    FolderHeart: {
        render: FolderHeart,
        tags: "folder heart:files:directory:heart:favourite:bookmark:quick link",
        categories: [
            "files"
        ]
    },
    FolderInput: {
        render: FolderInput,
        tags: "folder input:files:arrows:directory:import:export",
        categories: [
            "files",
            "arrows"
        ]
    },
    FolderKanban: {
        render: FolderKanban,
        tags: "folder kanban:charts:development:design:files:projects:manage:overview:board:tickets:issues:roadmap:plan:intentions:productivity:work:agile:code:coding:directory:project:root",
        categories: [
            "charts",
            "development",
            "design",
            "files"
        ]
    },
    FolderKey: {
        render: FolderKey,
        tags: "folder key:files:security:directory:key:private:security:protected",
        categories: [
            "files",
            "security"
        ]
    },
    FolderLock: {
        render: FolderLock,
        tags: "folder lock:files:security:directory:lock:private:security:protected",
        categories: [
            "files",
            "security"
        ]
    },
    FolderMinus: {
        render: FolderMinus,
        tags: "folder minus:files:directory:remove:delete",
        categories: [
            "files"
        ]
    },
    FolderOpenDot: {
        render: FolderOpenDot,
        tags: "folder open dot:files:development:directory:root:project:active:current:pinned",
        categories: [
            "files",
            "development"
        ]
    },
    FolderOpen: {
        render: FolderOpen,
        tags: "folder open:files:directory",
        categories: [
            "files"
        ]
    },
    FolderOutput: {
        render: FolderOutput,
        tags: "folder output:files:arrows:directory:import:export",
        categories: [
            "files",
            "arrows"
        ]
    },
    FolderPen: {
        render: FolderPen,
        tags: "folder pen:files:directory:rename",
        categories: [
            "files"
        ]
    },
    FolderPlus: {
        render: FolderPlus,
        tags: "folder plus:files:directory:add:create:new",
        categories: [
            "files"
        ]
    },
    FolderRoot: {
        render: FolderRoot,
        tags: "folder root:files:development:directory:root:project:git:repo",
        categories: [
            "files",
            "development"
        ]
    },
    FolderSearch2: {
        render: FolderSearch2,
        tags: "folder search 2:files:directory:search:find:lost:browser",
        categories: [
            "files"
        ]
    },
    FolderSearch: {
        render: FolderSearch,
        tags: "folder search:files:directory:search:find:lost:browser",
        categories: [
            "files"
        ]
    },
    FolderSymlink: {
        render: FolderSymlink,
        tags: "folder symlink:files:directory:symlink:symbolic:link",
        categories: [
            "files"
        ]
    },
    FolderSync: {
        render: FolderSync,
        tags: "folder sync:files:arrows:directory:synchronize:synchronise:refresh:reconnect:transfer:backup",
        categories: [
            "files",
            "arrows"
        ]
    },
    FolderTree: {
        render: FolderTree,
        tags: "folder tree:files:directory:tree:browser",
        categories: [
            "files"
        ]
    },
    FolderUp: {
        render: FolderUp,
        tags: "folder up:files:arrows:directory:upload:import:export",
        categories: [
            "files",
            "arrows"
        ]
    },
    FolderX: {
        render: FolderX,
        tags: "folder x:files:directory:remove:delete",
        categories: [
            "files"
        ]
    },
    Folder: {
        render: Folder,
        tags: "folder:files:directory",
        categories: [
            "files"
        ]
    },
    Folders: {
        render: Folders,
        tags: "folders:files:multiple:copy:directories",
        categories: [
            "files"
        ]
    },
    Footprints: {
        render: Footprints,
        tags: "footprints:maps:steps:walking:foot:feet:trail:shoe",
        categories: [
            "maps"
        ]
    },
    Forklift: {
        render: Forklift,
        tags: "forklift:transportation:vehicle:transport:logistics",
        categories: [
            "transportation"
        ]
    },
    FormInput: {
        render: FormInput,
        tags: "form input:text:2fa:authenticate:login:field:text",
        categories: [
            "text"
        ]
    },
    Forward: {
        render: Forward,
        tags: "forward:mail:send:share:email",
        categories: [
            "mail"
        ]
    },
    Frame: {
        render: Frame,
        tags: "frame:design:photography:logo:design:tool",
        categories: [
            "design",
            "photography"
        ]
    },
    Framer: {
        render: Framer,
        tags: "framer:brands:design:logo:design:tool",
        categories: [
            "brands",
            "design"
        ]
    },
    Frown: {
        render: Frown,
        tags: "frown:emoji:account:emoji:face:bad:sad:emotion",
        categories: [
            "emoji",
            "account"
        ]
    },
    Fuel: {
        render: Fuel,
        tags: "fuel:transportation:maps:filling-station:gas:petrol:tank",
        categories: [
            "transportation",
            "maps"
        ]
    },
    Fullscreen: {
        render: Fullscreen,
        tags: "fullscreen:layout:multimedia:design:photography:expand:zoom:preview:focus:camera:lens:image",
        categories: [
            "layout",
            "multimedia",
            "design",
            "photography"
        ]
    },
    FunctionSquare: {
        render: FunctionSquare,
        tags: "function square:development:shapes:maths:programming:code:automation:maths",
        categories: [
            "development",
            "shapes",
            "maths"
        ]
    },
    GalleryHorizontalEnd: {
        render: GalleryHorizontalEnd,
        tags: "gallery horizontal end:layout:design:development:photography:multimedia:files:carousel:pictures:images:scroll:swipe:album:portfolio:history:versions:backup:time machine",
        categories: [
            "layout",
            "design",
            "development",
            "photography",
            "multimedia",
            "files"
        ]
    },
    GalleryHorizontal: {
        render: GalleryHorizontal,
        tags: "gallery horizontal:layout:design:development:photography:multimedia:carousel:pictures:images:scroll:swipe:album:portfolio",
        categories: [
            "layout",
            "design",
            "development",
            "photography",
            "multimedia"
        ]
    },
    GalleryThumbnails: {
        render: GalleryThumbnails,
        tags: "gallery thumbnails:layout:design:development:photography:multimedia:carousel:pictures:images:album:portfolio:preview",
        categories: [
            "layout",
            "design",
            "development",
            "photography",
            "multimedia"
        ]
    },
    GalleryVerticalEnd: {
        render: GalleryVerticalEnd,
        tags: "gallery vertical end:layout:design:development:photography:multimedia:files:carousel:pictures:images:scroll:swipe:album:portfolio:history:versions:backup:time machine",
        categories: [
            "layout",
            "design",
            "development",
            "photography",
            "multimedia",
            "files"
        ]
    },
    GalleryVertical: {
        render: GalleryVertical,
        tags: "gallery vertical:layout:design:development:photography:multimedia:carousel:pictures:images:scroll:swipe:album:portfolio",
        categories: [
            "layout",
            "design",
            "development",
            "photography",
            "multimedia"
        ]
    },
    Gamepad2: {
        render: Gamepad2,
        tags: "gamepad 2:gaming:devices:console",
        categories: [
            "gaming",
            "devices"
        ]
    },
    Gamepad: {
        render: Gamepad,
        tags: "gamepad:gaming:devices:console",
        categories: [
            "gaming",
            "devices"
        ]
    },
    GanttChartSquare: {
        render: GanttChartSquare,
        tags: "gantt chart square:charts:time:development:design:projects:manage:overview:roadmap:plan:intentions:timeline:deadline:date:event:range:period:productivity:work:agile:code:coding:toolbar:button",
        categories: [
            "charts",
            "time",
            "development",
            "design"
        ]
    },
    GanttChart: {
        render: GanttChart,
        tags: "gantt chart:charts:time:development:design:projects:manage:overview:roadmap:plan:intentions:timeline:deadline:date:event:range:period:productivity:work:agile:code:coding",
        categories: [
            "charts",
            "time",
            "development",
            "design"
        ]
    },
    GaugeCircle: {
        render: GaugeCircle,
        tags: "gauge circle:account:transportation:sports:science:dashboard:dial:meter:speed:pressure:measure:level",
        categories: [
            "account",
            "transportation",
            "sports",
            "science"
        ]
    },
    Gauge: {
        render: Gauge,
        tags: "gauge:account:transportation:sports:science:dashboard:dial:meter:speed:pressure:measure:level",
        categories: [
            "account",
            "transportation",
            "sports",
            "science"
        ]
    },
    Gavel: {
        render: Gavel,
        tags: "gavel:maps:tools:hammer:mallet",
        categories: [
            "maps",
            "tools"
        ]
    },
    Gem: {
        render: Gem,
        tags: "gem:gaming:money:development:diamond:crystal:ruby:jewellery:price:special:present:gift:ring:wedding:proposal:marriage:rubygems",
        categories: [
            "gaming",
            "money",
            "development"
        ]
    },
    Ghost: {
        render: Ghost,
        tags: "ghost:gaming:pac-man:spooky",
        categories: [
            "gaming"
        ]
    },
    Gift: {
        render: Gift,
        tags: "gift:gaming:account:present:box:birthday:party",
        categories: [
            "gaming",
            "account"
        ]
    },
    GitBranchPlus: {
        render: GitBranchPlus,
        tags: "git branch plus:development:add:create:+",
        categories: [
            "development"
        ]
    },
    GitBranch: {
        render: GitBranch,
        tags: "git branch:development:code:version control",
        categories: [
            "development"
        ]
    },
    GitCommitHorizontal: {
        render: GitCommitHorizontal,
        tags: "git commit horizontal:development:maps:navigation:code:version control:waypoint:stop:station",
        categories: [
            "development",
            "maps",
            "navigation"
        ]
    },
    GitCommitVertical: {
        render: GitCommitVertical,
        tags: "git commit vertical:development:maps:navigation:code:version control:waypoint:stop:station",
        categories: [
            "development",
            "maps",
            "navigation"
        ]
    },
    GitCompareArrows: {
        render: GitCompareArrows,
        tags: "git compare arrows:development:arrows:code:version control:diff",
        categories: [
            "development",
            "arrows"
        ]
    },
    GitCompare: {
        render: GitCompare,
        tags: "git compare:development:arrows:code:version control:diff",
        categories: [
            "development",
            "arrows"
        ]
    },
    GitFork: {
        render: GitFork,
        tags: "git fork:development:code:version control",
        categories: [
            "development"
        ]
    },
    GitGraph: {
        render: GitGraph,
        tags: "git graph:development:code:version control:commit graph:commits:gitlens",
        categories: [
            "development"
        ]
    },
    GitMerge: {
        render: GitMerge,
        tags: "git merge:development:code:version control",
        categories: [
            "development"
        ]
    },
    GitPullRequestArrow: {
        render: GitPullRequestArrow,
        tags: "git pull request arrow:development:arrows:code:version control:open",
        categories: [
            "development",
            "arrows"
        ]
    },
    GitPullRequestClosed: {
        render: GitPullRequestClosed,
        tags: "git pull request closed:development:code:version control:rejected:closed:cancelled:x",
        categories: [
            "development"
        ]
    },
    GitPullRequestCreateArrow: {
        render: GitPullRequestCreateArrow,
        tags: "git pull request create arrow:development:arrows:code:version control:open:plus:add:+",
        categories: [
            "development",
            "arrows"
        ]
    },
    GitPullRequestCreate: {
        render: GitPullRequestCreate,
        tags: "git pull request create:development:arrows:code:version control:open:plus:add:+",
        categories: [
            "development",
            "arrows"
        ]
    },
    GitPullRequestDraft: {
        render: GitPullRequestDraft,
        tags: "git pull request draft:development:code:version control:open:draft:dashed",
        categories: [
            "development"
        ]
    },
    GitPullRequest: {
        render: GitPullRequest,
        tags: "git pull request:development:arrows:code:version control:open",
        categories: [
            "development",
            "arrows"
        ]
    },
    Github: {
        render: Github,
        tags: "github:brands:development:logo:version control",
        categories: [
            "brands",
            "development"
        ]
    },
    Gitlab: {
        render: Gitlab,
        tags: "gitlab:brands:development:logo:version control",
        categories: [
            "brands",
            "development"
        ]
    },
    GlassWater: {
        render: GlassWater,
        tags: "glass water:food beverage:beverage:drink:glass:water",
        categories: [
            "food-beverage"
        ]
    },
    Glasses: {
        render: Glasses,
        tags: "glasses:accessibility:glasses:spectacles",
        categories: [
            "accessibility"
        ]
    },
    Globe2: {
        render: Globe2,
        tags: "globe 2:maps:navigation:world:browser:language:translate",
        categories: [
            "maps",
            "navigation"
        ]
    },
    Globe: {
        render: Globe,
        tags: "globe:maps:navigation:world:browser:language:translate",
        categories: [
            "maps",
            "navigation"
        ]
    },
    Goal: {
        render: Goal,
        tags: "goal:gaming:flag:bullseye",
        categories: [
            "gaming"
        ]
    },
    Grab: {
        render: Grab,
        tags: "grab:cursors:design:layout:hand",
        categories: [
            "cursors",
            "design",
            "layout"
        ]
    },
    GraduationCap: {
        render: GraduationCap,
        tags: "graduation cap:buildings:maps:school:university:learn:study:mortarboard:education:ceremony:academic:hat:diploma:bachlor's:master's:doctorate",
        categories: [
            "buildings",
            "maps"
        ]
    },
    Grape: {
        render: Grape,
        tags: "grape:food beverage:fruit:wine:food",
        categories: [
            "food-beverage"
        ]
    },
    Grid2X2: {
        render: Grid2X2,
        tags: "grid 2 x 2:text:layout:design:shapes:maths:table:rows:columns:blocks:plot:land:geometry:measure:size:width:height:distance:surface area:square meter:acre",
        categories: [
            "text",
            "layout",
            "design",
            "shapes",
            "maths"
        ]
    },
    Grid3X3: {
        render: Grid3X3,
        tags: "grid 3 x 3:text:layout:design:table:rows:columns",
        categories: [
            "text",
            "layout",
            "design"
        ]
    },
    GripHorizontal: {
        render: GripHorizontal,
        tags: "grip horizontal:layout:grab:dots:handle:move:drag",
        categories: [
            "layout"
        ]
    },
    GripVertical: {
        render: GripVertical,
        tags: "grip vertical:layout:grab:dots:handle:move:drag",
        categories: [
            "layout"
        ]
    },
    Grip: {
        render: Grip,
        tags: "grip:layout:grab:dots:handle:move:drag",
        categories: [
            "layout"
        ]
    },
    Group: {
        render: Group,
        tags: "group:shapes:files:cubes:packages:parts:units:collection:cluster:gather:dashed",
        categories: [
            "shapes",
            "files"
        ]
    },
    Guitar: {
        render: Guitar,
        tags: "guitar:multimedia:acoustic:instrument:strings:riff:rock:band:country:concert:performance:play:lead:loud:music:audio:sound:noise",
        categories: [
            "multimedia"
        ]
    },
    Hammer: {
        render: Hammer,
        tags: "hammer:tools:home:mallet:nails:diy:toolbox:build:construction",
        categories: [
            "tools",
            "home"
        ]
    },
    HandCoins: {
        render: HandCoins,
        tags: "hand coins:money:account:savings:banking:money:finance:offers:mortgage:payment:received:wage:payroll:allowance:pocket money:handout:pennies",
        categories: [
            "money",
            "account"
        ]
    },
    HandHeart: {
        render: HandHeart,
        tags: "hand heart:social:love:like:emotion",
        categories: [
            "social"
        ]
    },
    HandHelping: {
        render: HandHelping,
        tags: "hand helping:emoji:agreement:help:proposal:charity:begging:terms",
        categories: [
            "emoji"
        ]
    },
    HandMetal: {
        render: HandMetal,
        tags: "hand metal:emoji:multimedia:rock",
        categories: [
            "emoji",
            "multimedia"
        ]
    },
    HandPlatter: {
        render: HandPlatter,
        tags: "hand platter:food beverage:people:waiter:waitress:restaurant:table service:served:dinner:dining:meal:course:luxury",
        categories: [
            "food-beverage",
            "people"
        ]
    },
    Hand: {
        render: Hand,
        tags: "hand:cursors:accessibility:wave:move:mouse:grab",
        categories: [
            "cursors",
            "accessibility"
        ]
    },
    Handshake: {
        render: Handshake,
        tags: "handshake:account:social:communication:money:security:agreement:partnership:deal:business:assistance:cooperation:friendship:union:terms",
        categories: [
            "account",
            "social",
            "communication",
            "money",
            "security"
        ]
    },
    HardDriveDownload: {
        render: HardDriveDownload,
        tags: "hard drive download:development:devices:arrows:files:computer:server:memory:data:ssd:disk:hard disk:save",
        categories: [
            "development",
            "devices",
            "arrows",
            "files"
        ]
    },
    HardDriveUpload: {
        render: HardDriveUpload,
        tags: "hard drive upload:development:devices:arrows:files:computer:server:memory:data:ssd:disk:hard disk:save",
        categories: [
            "development",
            "devices",
            "arrows",
            "files"
        ]
    },
    HardDrive: {
        render: HardDrive,
        tags: "hard drive:development:devices:computer:server:memory:data:ssd:disk:hard disk",
        categories: [
            "development",
            "devices"
        ]
    },
    HardHat: {
        render: HardHat,
        tags: "hard hat:tools:helmet:construction:safety:savety",
        categories: [
            "tools"
        ]
    },
    Hash: {
        render: Hash,
        tags: "hash:text:social:hashtag:number:pound",
        categories: [
            "text",
            "social"
        ]
    },
    Haze: {
        render: Haze,
        tags: "haze:weather:mist:fog",
        categories: [
            "weather"
        ]
    },
    HdmiPort: {
        render: HdmiPort,
        tags: "hdmi port:devices:multimedia:gaming:socket:plug:slot:controller:connector:interface:console:signal:audio:video:visual:av:data:input:output",
        categories: [
            "devices",
            "multimedia",
            "gaming"
        ]
    },
    Heading1: {
        render: Heading1,
        tags: "heading 1:text:development:h1:html:markup:markdown",
        categories: [
            "text",
            "development"
        ]
    },
    Heading2: {
        render: Heading2,
        tags: "heading 2:text:development:h2:html:markup:markdown",
        categories: [
            "text",
            "development"
        ]
    },
    Heading3: {
        render: Heading3,
        tags: "heading 3:text:development:h3:html:markup:markdown",
        categories: [
            "text",
            "development"
        ]
    },
    Heading4: {
        render: Heading4,
        tags: "heading 4:text:development:h4:html:markup:markdown",
        categories: [
            "text",
            "development"
        ]
    },
    Heading5: {
        render: Heading5,
        tags: "heading 5:text:development:h5:html:markup:markdown",
        categories: [
            "text",
            "development"
        ]
    },
    Heading6: {
        render: Heading6,
        tags: "heading 6:text:development:h6:html:markup:markdown",
        categories: [
            "text",
            "development"
        ]
    },
    Heading: {
        render: Heading,
        tags: "heading:text:development:h1:html:markup:markdown",
        categories: [
            "text",
            "development"
        ]
    },
    Headphones: {
        render: Headphones,
        tags: "headphones:multimedia:connectivity:devices:files:gaming:music:audio:sound",
        categories: [
            "multimedia",
            "connectivity",
            "devices",
            "files",
            "gaming"
        ]
    },
    Headset: {
        render: Headset,
        tags: "headset:multimedia:connectivity:devices:files:gaming:music:audio:sound:gaming:headphones:headset:call:center:phone:telephone:voip:video",
        categories: [
            "multimedia",
            "connectivity",
            "devices",
            "files",
            "gaming"
        ]
    },
    HeartCrack: {
        render: HeartCrack,
        tags: "heart crack:emoji:heartbreak:sadness:emotion",
        categories: [
            "emoji"
        ]
    },
    HeartHandshake: {
        render: HeartHandshake,
        tags: "heart handshake:emoji:account:security:agreement:charity:help:deal:terms:emotion:together:handshake",
        categories: [
            "emoji",
            "account",
            "security"
        ]
    },
    HeartOff: {
        render: HeartOff,
        tags: "heart off:social:multimedia:unlike:dislike:hate:emotion",
        categories: [
            "social",
            "multimedia"
        ]
    },
    HeartPulse: {
        render: HeartPulse,
        tags: "heart pulse:medical:heartbeat:pulse:health:medical:blood pressure:cardiac:systole:diastole",
        categories: [
            "medical"
        ]
    },
    Heart: {
        render: Heart,
        tags: "heart:medical:social:multimedia:emoji:gaming:shapes:like:love:emotion:suit:playing:cards",
        categories: [
            "medical",
            "social",
            "multimedia",
            "emoji",
            "gaming",
            "shapes"
        ]
    },
    Heater: {
        render: Heater,
        tags: "heater:home:devices:travel:heating:warmth:comfort:fire:stove:electric:electronics:amenities",
        categories: [
            "home",
            "devices",
            "travel"
        ]
    },
    HelpCircle: {
        render: HelpCircle,
        tags: "help circle:accessibility:text:shapes:notifications:question mark",
        categories: [
            "accessibility",
            "text",
            "shapes",
            "notifications"
        ]
    },
    Hexagon: {
        render: Hexagon,
        tags: "hexagon:shapes:brands:development:shape:node.js:logo",
        categories: [
            "shapes",
            "brands",
            "development"
        ]
    },
    Highlighter: {
        render: Highlighter,
        tags: "highlighter:text:design:mark:text",
        categories: [
            "text",
            "design"
        ]
    },
    History: {
        render: History,
        tags: "history:arrows:time:time:redo:undo:rewind:timeline:version:time machine:backup:rotate:ccw",
        categories: [
            "arrows",
            "time"
        ]
    },
    Home: {
        render: Home,
        tags: "home:account:house:living",
        categories: [
            "account"
        ]
    },
    HopOff: {
        render: HopOff,
        tags: "hop off:food beverage:beer:brewery:drink:hop free:allergy:intolerance:diet",
        categories: [
            "food-beverage"
        ]
    },
    Hop: {
        render: Hop,
        tags: "hop:food beverage:beer:brewery:drink",
        categories: [
            "food-beverage"
        ]
    },
    Hotel: {
        render: Hotel,
        tags: "hotel:buildings:maps:travel:building:hostel:motel:inn",
        categories: [
            "buildings",
            "maps",
            "travel"
        ]
    },
    Hourglass: {
        render: Hourglass,
        tags: "hourglass:time:gaming:timer:time:sandglass",
        categories: [
            "time",
            "gaming"
        ]
    },
    IceCream2: {
        render: IceCream2,
        tags: "ice cream 2:food beverage:gelato:food:dessert:dish:restaurant:course:meal",
        categories: [
            "food-beverage"
        ]
    },
    IceCream: {
        render: IceCream,
        tags: "ice cream:food beverage:gelato:food",
        categories: [
            "food-beverage"
        ]
    },
    ImageDown: {
        render: ImageDown,
        tags: "image down:photography:text:multimedia:files:picture:photo:download:save:export",
        categories: [
            "photography",
            "text",
            "multimedia",
            "files"
        ]
    },
    ImageMinus: {
        render: ImageMinus,
        tags: "image minus:photography:multimedia:files:remove:delete",
        categories: [
            "photography",
            "multimedia",
            "files"
        ]
    },
    ImageOff: {
        render: ImageOff,
        tags: "image off:photography:multimedia:files:picture:photo",
        categories: [
            "photography",
            "multimedia",
            "files"
        ]
    },
    ImagePlus: {
        render: ImagePlus,
        tags: "image plus:photography:multimedia:files:add:create",
        categories: [
            "photography",
            "multimedia",
            "files"
        ]
    },
    ImageUp: {
        render: ImageUp,
        tags: "image up:photography:text:multimedia:files:picture:photo:upload:import",
        categories: [
            "photography",
            "text",
            "multimedia",
            "files"
        ]
    },
    Image: {
        render: Image,
        tags: "image:photography:text:multimedia:files:picture:photo",
        categories: [
            "photography",
            "text",
            "multimedia",
            "files"
        ]
    },
    Images: {
        render: Images,
        tags: "images:photography:text:multimedia:files:picture:photo:multiple:copy:gallery:album:collection:slideshow:showcase",
        categories: [
            "photography",
            "text",
            "multimedia",
            "files"
        ]
    },
    Import: {
        render: Import,
        tags: "import:arrows:files:save",
        categories: [
            "arrows",
            "files"
        ]
    },
    Inbox: {
        render: Inbox,
        tags: "inbox:account:mail:email",
        categories: [
            "account",
            "mail"
        ]
    },
    Indent: {
        render: Indent,
        tags: "indent:text:development:text:tab",
        categories: [
            "text",
            "development"
        ]
    },
    IndianRupee: {
        render: IndianRupee,
        tags: "indian rupee:currency:money:currency:money:payment",
        categories: [
            "currency",
            "money"
        ]
    },
    Infinity: {
        render: Infinity,
        tags: "infinity:multimedia:unlimited:forever:loop:maths",
        categories: [
            "multimedia"
        ]
    },
    Info: {
        render: Info,
        tags: "info:accessibility:notifications:help",
        categories: [
            "accessibility",
            "notifications"
        ]
    },
    InspectionPanel: {
        render: InspectionPanel,
        tags: "inspection panel:tools:access:cover:tile:metal:materials:screws",
        categories: [
            "tools"
        ]
    },
    Instagram: {
        render: Instagram,
        tags: "instagram:brands:social:photography:logo:camera:social",
        categories: [
            "brands",
            "social",
            "photography"
        ]
    },
    Italic: {
        render: Italic,
        tags: "italic:text:oblique:text:format",
        categories: [
            "text"
        ]
    },
    IterationCcw: {
        render: IterationCcw,
        tags: "iteration ccw:arrows:design:arrow:right",
        categories: [
            "arrows",
            "design"
        ]
    },
    IterationCw: {
        render: IterationCw,
        tags: "iteration cw:arrows:design:arrow:left",
        categories: [
            "arrows",
            "design"
        ]
    },
    JapaneseYen: {
        render: JapaneseYen,
        tags: "japanese yen:currency:money:currency:money:payment",
        categories: [
            "currency",
            "money"
        ]
    },
    Joystick: {
        render: Joystick,
        tags: "joystick:gaming:devices:game:console:control stick",
        categories: [
            "gaming",
            "devices"
        ]
    },
    KanbanSquareDashed: {
        render: KanbanSquareDashed,
        tags: "kanban square dashed:charts:development:design:projects:manage:overview:board:tickets:issues:roadmap:plan:intentions:productivity:work:agile:draft:template:boilerplate:code:coding",
        categories: [
            "charts",
            "development",
            "design"
        ]
    },
    KanbanSquare: {
        render: KanbanSquare,
        tags: "kanban square:charts:development:design:projects:manage:overview:board:tickets:issues:roadmap:plan:intentions:productivity:work:agile:code:coding:toolbar:button",
        categories: [
            "charts",
            "development",
            "design"
        ]
    },
    Kanban: {
        render: Kanban,
        tags: "kanban:charts:development:design:projects:manage:overview:board:tickets:issues:roadmap:plan:intentions:productivity:work:agile:code:coding",
        categories: [
            "charts",
            "development",
            "design"
        ]
    },
    KeyRound: {
        render: KeyRound,
        tags: "key round:security:account:password:login:authentication:secure:unlock",
        categories: [
            "security",
            "account"
        ]
    },
    KeySquare: {
        render: KeySquare,
        tags: "key square:security:account:password:login:authentication:secure:unlock:car key",
        categories: [
            "security",
            "account"
        ]
    },
    Key: {
        render: Key,
        tags: "key:security:account:password:login:authentication:secure:unlock:keychain:key ring:fob",
        categories: [
            "security",
            "account"
        ]
    },
    KeyboardMusic: {
        render: KeyboardMusic,
        tags: "keyboard music:multimedia:devices:music:audio:sound:noise:notes:keys:chord:octave:midi:controller:instrument:electric:signal:digital:studio:production:producer:pianist:piano:play:performance:concert",
        categories: [
            "multimedia",
            "devices"
        ]
    },
    Keyboard: {
        render: Keyboard,
        tags: "keyboard:text:devices:development:layout:spell:settings:mouse",
        categories: [
            "text",
            "devices",
            "development"
        ]
    },
    LampCeiling: {
        render: LampCeiling,
        tags: "lamp ceiling:furniture:lighting:household:home:furniture",
        categories: [
            "furniture"
        ]
    },
    LampDesk: {
        render: LampDesk,
        tags: "lamp desk:furniture:lighting:household:office:desk:home:furniture",
        categories: [
            "furniture"
        ]
    },
    LampFloor: {
        render: LampFloor,
        tags: "lamp floor:furniture:lighting:household:floor:home:furniture",
        categories: [
            "furniture"
        ]
    },
    LampWallDown: {
        render: LampWallDown,
        tags: "lamp wall down:furniture:lighting:household:wall:home:furniture",
        categories: [
            "furniture"
        ]
    },
    LampWallUp: {
        render: LampWallUp,
        tags: "lamp wall up:furniture:lighting:household:wall:home:furniture",
        categories: [
            "furniture"
        ]
    },
    Lamp: {
        render: Lamp,
        tags: "lamp:furniture:lighting:household:home:furniture",
        categories: [
            "furniture"
        ]
    },
    LandPlot: {
        render: LandPlot,
        tags: "land plot:shapes:design:tools:maths:sports:gaming:area:surface:square metres:allotment:parcel:property:plane:acres:measure:distance:isometric:flag:golf course:hole",
        categories: [
            "shapes",
            "design",
            "tools",
            "maths",
            "sports",
            "gaming"
        ]
    },
    Landmark: {
        render: Landmark,
        tags: "landmark:money:maps:buildings:bank:building:capitol:finance:money",
        categories: [
            "money",
            "maps",
            "buildings"
        ]
    },
    Languages: {
        render: Languages,
        tags: "languages:text:translate",
        categories: [
            "text"
        ]
    },
    Laptop2: {
        render: Laptop2,
        tags: "laptop 2:devices:computer:screen:remote",
        categories: [
            "devices"
        ]
    },
    Laptop: {
        render: Laptop,
        tags: "laptop:devices:computer:screen:remote",
        categories: [
            "devices"
        ]
    },
    LassoSelect: {
        render: LassoSelect,
        tags: "lasso select:arrows:design:cursors:select:cursor",
        categories: [
            "arrows",
            "design",
            "cursors"
        ]
    },
    Lasso: {
        render: Lasso,
        tags: "lasso:design:cursors:select:cursor",
        categories: [
            "design",
            "cursors"
        ]
    },
    Laugh: {
        render: Laugh,
        tags: "laugh:emoji:emoji:face:happy:good:emotion",
        categories: [
            "emoji"
        ]
    },
    Layers2: {
        render: Layers2,
        tags: "layers 2:design:layout:stack:pile:pages:sheets:paperwork:copies:copy:duplicate:double:shortcuts",
        categories: [
            "design",
            "layout"
        ]
    },
    Layers3: {
        render: Layers3,
        tags: "layers 3:design:layout:stack:pile:pages:sheets:paperwork:copies:copy:duplicate:triple",
        categories: [
            "design",
            "layout"
        ]
    },
    Layers: {
        render: Layers,
        tags: "layers:design:layout:stack:pile:pages:sheets:paperwork:copies:copy",
        categories: [
            "design",
            "layout"
        ]
    },
    LayoutDashboard: {
        render: LayoutDashboard,
        tags: "layout dashboard:design:layout:masonry:brick",
        categories: [
            "design",
            "layout"
        ]
    },
    LayoutGrid: {
        render: LayoutGrid,
        tags: "layout grid:design:layout:app:home:start",
        categories: [
            "design",
            "layout"
        ]
    },
    LayoutList: {
        render: LayoutList,
        tags: "layout list:design:layout:photography:text:todo:tasks:items:pending:image:photo",
        categories: [
            "design",
            "layout",
            "photography",
            "text"
        ]
    },
    LayoutPanelLeft: {
        render: LayoutPanelLeft,
        tags: "layout panel left:design:layout:app:home:start:grid",
        categories: [
            "design",
            "layout"
        ]
    },
    LayoutPanelTop: {
        render: LayoutPanelTop,
        tags: "layout panel top:layout:window:webpage:block:section:grid:template:structure",
        categories: [
            "layout"
        ]
    },
    LayoutTemplate: {
        render: LayoutTemplate,
        tags: "layout template:layout:window:webpage:block:section",
        categories: [
            "layout"
        ]
    },
    Leaf: {
        render: Leaf,
        tags: "leaf:nature:sustainability:seasons:sustainability:nature:energy:plant:autumn",
        categories: [
            "nature",
            "sustainability",
            "seasons"
        ]
    },
    LeafyGreen: {
        render: LeafyGreen,
        tags: "leafy green:food beverage:emoji:salad:lettuce:vegetable:chard:cabbage:bok choy",
        categories: [
            "food-beverage",
            "emoji"
        ]
    },
    LibraryBig: {
        render: LibraryBig,
        tags: "library big:text:photography:multimedia:maps:development:books:reading:written:authors:stories:fiction:novels:information:knowledge:education:high school:university:college:academy:learning:study:research:collection:vinyl:records:albums:music:package",
        categories: [
            "text",
            "photography",
            "multimedia",
            "maps",
            "development"
        ]
    },
    LibrarySquare: {
        render: LibrarySquare,
        tags: "library square:text:photography:multimedia:maps:development:books:reading:written:authors:stories:fiction:novels:information:knowledge:education:high school:university:college:academy:learning:study:research:collection:vinyl:records:albums:music:package",
        categories: [
            "text",
            "photography",
            "multimedia",
            "maps",
            "development"
        ]
    },
    Library: {
        render: Library,
        tags: "library:text:photography:multimedia:maps:development:books:reading:written:authors:stories:fiction:novels:information:knowledge:education:high school:university:college:academy:learning:study:research:collection:vinyl:records:albums:music:package",
        categories: [
            "text",
            "photography",
            "multimedia",
            "maps",
            "development"
        ]
    },
    LifeBuoy: {
        render: LifeBuoy,
        tags: "life buoy:accessibility:medical:preserver:life belt:lifesaver:help:rescue:ship:ring:raft:inflatable:wheel:donut",
        categories: [
            "accessibility",
            "medical"
        ]
    },
    Ligature: {
        render: Ligature,
        tags: "ligature:text:text:font:typography:alternates:alternatives",
        categories: [
            "text"
        ]
    },
    LightbulbOff: {
        render: LightbulbOff,
        tags: "lightbulb off:photography:lights",
        categories: [
            "photography"
        ]
    },
    Lightbulb: {
        render: Lightbulb,
        tags: "lightbulb:photography:idea:bright:lights",
        categories: [
            "photography"
        ]
    },
    LineChart: {
        render: LineChart,
        tags: "line chart:charts:statistics:diagram:graph",
        categories: [
            "charts"
        ]
    },
    Link2Off: {
        render: Link2Off,
        tags: "link 2 off:text:unchain:chain",
        categories: [
            "text"
        ]
    },
    Link2: {
        render: Link2,
        tags: "link 2:text:account:chain:url",
        categories: [
            "text",
            "account"
        ]
    },
    Link: {
        render: Link,
        tags: "link:text:account:chain:url",
        categories: [
            "text",
            "account"
        ]
    },
    Linkedin: {
        render: Linkedin,
        tags: "linkedin:account:social:brands:logo:social media:social",
        categories: [
            "account",
            "social",
            "brands"
        ]
    },
    ListChecks: {
        render: ListChecks,
        tags: "list checks:text:todo:done:check:tick:complete:tasks:items:pending",
        categories: [
            "text"
        ]
    },
    ListCollapse: {
        render: ListCollapse,
        tags: "list collapse:text:items:collapse:expand:details:disclosure:show:hide:toggle:accordion:more:less:fold:unfold",
        categories: [
            "text"
        ]
    },
    ListEnd: {
        render: ListEnd,
        tags: "list end:multimedia:text:queue:bottom:end:playlist",
        categories: [
            "multimedia",
            "text"
        ]
    },
    ListFilter: {
        render: ListFilter,
        tags: "list filter:text:options",
        categories: [
            "text"
        ]
    },
    ListMinus: {
        render: ListMinus,
        tags: "list minus:multimedia:text:playlist:remove:song:subtract:delete:unqueue",
        categories: [
            "multimedia",
            "text"
        ]
    },
    ListMusic: {
        render: ListMusic,
        tags: "list music:multimedia:playlist:queue:music:audio:playback",
        categories: [
            "multimedia"
        ]
    },
    ListOrdered: {
        render: ListOrdered,
        tags: "list ordered:text:number:order:queue",
        categories: [
            "text"
        ]
    },
    ListPlus: {
        render: ListPlus,
        tags: "list plus:multimedia:text:playlist:add:song:track:new",
        categories: [
            "multimedia",
            "text"
        ]
    },
    ListRestart: {
        render: ListRestart,
        tags: "list restart:multimedia:text:reset:refresh:reload:playlist:replay",
        categories: [
            "multimedia",
            "text"
        ]
    },
    ListStart: {
        render: ListStart,
        tags: "list start:multimedia:text:queue:top:start:next:playlist",
        categories: [
            "multimedia",
            "text"
        ]
    },
    ListTodo: {
        render: ListTodo,
        tags: "list todo:text:todo:done:check:tick:complete:tasks:items:pending",
        categories: [
            "text"
        ]
    },
    ListTree: {
        render: ListTree,
        tags: "list tree:files:text:layout:tree:browser",
        categories: [
            "files",
            "text",
            "layout"
        ]
    },
    ListVideo: {
        render: ListVideo,
        tags: "list video:multimedia:playlist:video:playback",
        categories: [
            "multimedia"
        ]
    },
    ListX: {
        render: ListX,
        tags: "list x:multimedia:text:playlist:subtract:remove:delete:unqueue",
        categories: [
            "multimedia",
            "text"
        ]
    },
    List: {
        render: List,
        tags: "list:text:options",
        categories: [
            "text"
        ]
    },
    Loader2: {
        render: Loader2,
        tags: "loader 2:multimedia:layout:load",
        categories: [
            "multimedia",
            "layout"
        ]
    },
    Loader: {
        render: Loader,
        tags: "loader:multimedia:layout:load:wait",
        categories: [
            "multimedia",
            "layout"
        ]
    },
    LocateFixed: {
        render: LocateFixed,
        tags: "locate fixed:navigation:maps:map:gps:location:cross",
        categories: [
            "navigation",
            "maps"
        ]
    },
    LocateOff: {
        render: LocateOff,
        tags: "locate off:navigation:maps:map:gps:location:cross",
        categories: [
            "navigation",
            "maps"
        ]
    },
    Locate: {
        render: Locate,
        tags: "locate:navigation:maps:map:gps:location:cross",
        categories: [
            "navigation",
            "maps"
        ]
    },
    LockKeyhole: {
        render: LockKeyhole,
        tags: "lock keyhole:security:security:password:secure:admin",
        categories: [
            "security"
        ]
    },
    Lock: {
        render: Lock,
        tags: "lock:security:security:password:secure:admin",
        categories: [
            "security"
        ]
    },
    LogIn: {
        render: LogIn,
        tags: "log in:arrows:account:sign in:arrow:enter:auth",
        categories: [
            "arrows",
            "account"
        ]
    },
    LogOut: {
        render: LogOut,
        tags: "log out:arrows:account:sign out:arrow:exit:auth",
        categories: [
            "arrows",
            "account"
        ]
    },
    Lollipop: {
        render: Lollipop,
        tags: "lollipop:food beverage:lolly:candy:sugar:food:sweet:dessert:spiral",
        categories: [
            "food-beverage"
        ]
    },
    Luggage: {
        render: Luggage,
        tags: "luggage:travel:transportation:baggage:luggage:travel:suitcase",
        categories: [
            "travel",
            "transportation"
        ]
    },
    MSquare: {
        render: MSquare,
        tags: "m square:transportation:maps:navigation:metro:subway:underground:track:line",
        categories: [
            "transportation",
            "maps",
            "navigation"
        ]
    },
    Magnet: {
        render: Magnet,
        tags: "magnet:design:horseshoe:lock:science:snap",
        categories: [
            "design"
        ]
    },
    MailCheck: {
        render: MailCheck,
        tags: "mail check:mail:email:message:letter:subscribe:delivered:success:read:done:todo:tick:complete:task",
        categories: [
            "mail"
        ]
    },
    MailMinus: {
        render: MailMinus,
        tags: "mail minus:mail:email:message:letter:remove:delete",
        categories: [
            "mail"
        ]
    },
    MailOpen: {
        render: MailOpen,
        tags: "mail open:mail:email:message:letter:read",
        categories: [
            "mail"
        ]
    },
    MailPlus: {
        render: MailPlus,
        tags: "mail plus:mail:email:message:letter:add:create:new:compose",
        categories: [
            "mail"
        ]
    },
    MailQuestion: {
        render: MailQuestion,
        tags: "mail question:mail:email:message:letter:delivery:undelivered",
        categories: [
            "mail"
        ]
    },
    MailSearch: {
        render: MailSearch,
        tags: "mail search:mail:email:message:letter:search",
        categories: [
            "mail"
        ]
    },
    MailWarning: {
        render: MailWarning,
        tags: "mail warning:mail:email:message:letter:delivery error:exclamation mark",
        categories: [
            "mail"
        ]
    },
    MailX: {
        render: MailX,
        tags: "mail x:mail:email:message:letter:remove:delete",
        categories: [
            "mail"
        ]
    },
    Mail: {
        render: Mail,
        tags: "mail:text:account:mail:email:message:letter:unread",
        categories: [
            "text",
            "account",
            "mail"
        ]
    },
    Mailbox: {
        render: Mailbox,
        tags: "mailbox:mail:emails:messages:letters:mailing list:newsletter",
        categories: [
            "mail"
        ]
    },
    Mails: {
        render: Mails,
        tags: "mails:mail:emails:messages:letters:multiple:mailing list:newsletter:copy",
        categories: [
            "mail"
        ]
    },
    MapPinOff: {
        render: MapPinOff,
        tags: "map pin off:maps:navigation:travel:location:waypoint:marker:remove",
        categories: [
            "maps",
            "navigation",
            "travel"
        ]
    },
    MapPin: {
        render: MapPin,
        tags: "map pin:maps:navigation:travel:account:location:waypoint:marker:drop",
        categories: [
            "maps",
            "navigation",
            "travel",
            "account"
        ]
    },
    MapPinned: {
        render: MapPinned,
        tags: "map pinned:maps:navigation:travel:account:location:waypoint:marker:drop",
        categories: [
            "maps",
            "navigation",
            "travel",
            "account"
        ]
    },
    Map: {
        render: Map,
        tags: "map:text:maps:location:navigation:travel",
        categories: [
            "text",
            "maps"
        ]
    },
    Martini: {
        render: Martini,
        tags: "martini:food beverage:cocktail:alcohol:beverage:bar:drink:glass",
        categories: [
            "food-beverage"
        ]
    },
    Maximize2: {
        render: Maximize2,
        tags: "maximize 2:arrows:layout:design:fullscreen:arrows:expand",
        categories: [
            "arrows",
            "layout",
            "design"
        ]
    },
    Maximize: {
        render: Maximize,
        tags: "maximize:layout:design:fullscreen:expand:dashed",
        categories: [
            "layout",
            "design"
        ]
    },
    Medal: {
        render: Medal,
        tags: "medal:sports:gaming:prize:sports:winner:trophy:award:achievement",
        categories: [
            "sports",
            "gaming"
        ]
    },
    MegaphoneOff: {
        render: MegaphoneOff,
        tags: "megaphone off:multimedia:notifications:advertisement:attention:alert:notification:disable:silent",
        categories: [
            "multimedia",
            "notifications"
        ]
    },
    Megaphone: {
        render: Megaphone,
        tags: "megaphone:multimedia:notifications:advertisement:attention:alert:notification",
        categories: [
            "multimedia",
            "notifications"
        ]
    },
    Meh: {
        render: Meh,
        tags: "meh:emoji:emoji:face:neutral:emotion",
        categories: [
            "emoji"
        ]
    },
    MemoryStick: {
        render: MemoryStick,
        tags: "memory stick:devices:development:gaming:ram:random access:technology:computer:chip:circuit:specs:capacity:gigabytes:gb",
        categories: [
            "devices",
            "development",
            "gaming"
        ]
    },
    MenuSquare: {
        render: MenuSquare,
        tags: "menu square:layout:account:bars:navigation:hamburger:options:menu bar:panel",
        categories: [
            "layout",
            "account"
        ]
    },
    Menu: {
        render: Menu,
        tags: "menu:layout:account:bars:navigation:hamburger:options",
        categories: [
            "layout",
            "account"
        ]
    },
    Merge: {
        render: Merge,
        tags: "merge:development:arrows:combine:join:unite",
        categories: [
            "development",
            "arrows"
        ]
    },
    MessageCircleCode: {
        render: MessageCircleCode,
        tags: "message circle code:development:account:social:comment:chat:conversation:dialog:feedback:speech bubble:code review:coding",
        categories: [
            "development",
            "account",
            "social"
        ]
    },
    MessageCircleDashed: {
        render: MessageCircleDashed,
        tags: "message circle dashed:account:social:comment:chat:conversation:dialog:feedback:speech bubble:draft",
        categories: [
            "account",
            "social"
        ]
    },
    MessageCircleHeart: {
        render: MessageCircleHeart,
        tags: "message circle heart:social:comment:chat:conversation:dialog:feedback:positive:like:love:interest:valentine:dating:date:speech bubble",
        categories: [
            "social"
        ]
    },
    MessageCircleMore: {
        render: MessageCircleMore,
        tags: "message circle more:account:social:comment:chat:conversation:dialog:feedback:speech bubble:typing:writing:responding:ellipsis:etc:et cetera:...:…",
        categories: [
            "account",
            "social"
        ]
    },
    MessageCircleOff: {
        render: MessageCircleOff,
        tags: "message circle off:account:social:comment:chat:conversation:dialog:feedback:speech bubble:clear:close:delete:remove:cancel:silence:mute:moderate",
        categories: [
            "account",
            "social"
        ]
    },
    MessageCirclePlus: {
        render: MessageCirclePlus,
        tags: "message circle plus:account:social:comment:chat:conversation:dialog:feedback:speech bubble:add",
        categories: [
            "account",
            "social"
        ]
    },
    MessageCircleQuestion: {
        render: MessageCircleQuestion,
        tags: "message circle question:account:social:comment:chat:conversation:dialog:feedback:speech bubble:help",
        categories: [
            "account",
            "social"
        ]
    },
    MessageCircleReply: {
        render: MessageCircleReply,
        tags: "message circle reply:account:social:comment:chat:conversation:dialog:feedback:speech bubble:reply:response",
        categories: [
            "account",
            "social"
        ]
    },
    MessageCircleWarning: {
        render: MessageCircleWarning,
        tags: "message circle warning:account:social:notifications:comment:chat:conversation:dialog:feedback:speech bubble:report:abuse:offense:alert:danger:caution:protected:exclamation mark",
        categories: [
            "account",
            "social",
            "notifications"
        ]
    },
    MessageCircleX: {
        render: MessageCircleX,
        tags: "message circle x:account:social:comment:chat:conversation:dialog:feedback:speech bubble:clear:close:delete:remove:cancel:silence:mute:moderate",
        categories: [
            "account",
            "social"
        ]
    },
    MessageCircle: {
        render: MessageCircle,
        tags: "message circle:account:social:comment:chat:conversation:dialog:feedback:speech bubble",
        categories: [
            "account",
            "social"
        ]
    },
    MessageSquareCode: {
        render: MessageSquareCode,
        tags: "message square code:development:account:social:comment:chat:conversation:dialog:feedback:speech bubble:code review:coding",
        categories: [
            "development",
            "account",
            "social"
        ]
    },
    MessageSquareDashed: {
        render: MessageSquareDashed,
        tags: "message square dashed:account:social:comment:chat:conversation:dialog:feedback:speech bubble:draft",
        categories: [
            "account",
            "social"
        ]
    },
    MessageSquareDiff: {
        render: MessageSquareDiff,
        tags: "message square diff:development:files:account:social:comment:chat:conversation:dialog:feedback:speech bubble:add:patch:difference:plus:minus:plus-minus:maths:code review:coding:version control:git",
        categories: [
            "development",
            "files",
            "account",
            "social"
        ]
    },
    MessageSquareDot: {
        render: MessageSquareDot,
        tags: "message square dot:account:social:notifications:unread:unresolved:comment:chat:conversation:dialog:feedback:speech bubble",
        categories: [
            "account",
            "social",
            "notifications"
        ]
    },
    MessageSquareHeart: {
        render: MessageSquareHeart,
        tags: "message square heart:social:comment:chat:conversation:dialog:feedback:positive:like:love:interest:valentine:dating:date:speech bubble",
        categories: [
            "social"
        ]
    },
    MessageSquareMore: {
        render: MessageSquareMore,
        tags: "message square more:account:social:comment:chat:conversation:dialog:feedback:speech bubble:typing:writing:responding:ellipsis:etc:et cetera:...:…",
        categories: [
            "account",
            "social"
        ]
    },
    MessageSquareOff: {
        render: MessageSquareOff,
        tags: "message square off:account:social:comment:chat:conversation:dialog:feedback:speech bubble:clear:close:delete:remove:cancel:silence:mute:moderate",
        categories: [
            "account",
            "social"
        ]
    },
    MessageSquarePlus: {
        render: MessageSquarePlus,
        tags: "message square plus:account:social:comment:chat:conversation:dialog:feedback:speech bubble:add",
        categories: [
            "account",
            "social"
        ]
    },
    MessageSquareQuote: {
        render: MessageSquareQuote,
        tags: "message square quote:account:social:text:comment:chat:conversation:dialog:feedback:speech bubble:blockquote:quotation:indent:reply:response",
        categories: [
            "account",
            "social",
            "text"
        ]
    },
    MessageSquareReply: {
        render: MessageSquareReply,
        tags: "message square reply:account:social:comment:chat:conversation:dialog:feedback:speech bubble:reply:response",
        categories: [
            "account",
            "social"
        ]
    },
    MessageSquareShare: {
        render: MessageSquareShare,
        tags: "message square share:account:social:comment:chat:conversation:dialog:feedback:speech bubble:network:forward",
        categories: [
            "account",
            "social"
        ]
    },
    MessageSquareText: {
        render: MessageSquareText,
        tags: "message square text:account:social:comment:chat:conversation:dialog:feedback:speech bubble",
        categories: [
            "account",
            "social"
        ]
    },
    MessageSquareWarning: {
        render: MessageSquareWarning,
        tags: "message square warning:account:social:notifications:comment:chat:conversation:dialog:feedback:speech bubble:report:abuse:offense:alert:danger:caution:protected:exclamation mark",
        categories: [
            "account",
            "social",
            "notifications"
        ]
    },
    MessageSquareX: {
        render: MessageSquareX,
        tags: "message square x:account:social:comment:chat:conversation:dialog:feedback:speech bubble:clear:close:delete:remove:cancel:silence:mute:moderate",
        categories: [
            "account",
            "social"
        ]
    },
    MessageSquare: {
        render: MessageSquare,
        tags: "message square:account:social:comment:chat:conversation:dialog:feedback:speech bubble",
        categories: [
            "account",
            "social"
        ]
    },
    MessagesSquare: {
        render: MessagesSquare,
        tags: "messages square:account:social:comment:chat:conversation:dialog:feedback:speech bubbles:copy:multiple",
        categories: [
            "account",
            "social"
        ]
    },
    Mic2: {
        render: Mic2,
        tags: "mic 2:devices:multimedia:lyrics:voice:listen:sound:music:radio:podcast:karaoke:singing:microphone",
        categories: [
            "devices",
            "multimedia"
        ]
    },
    MicOff: {
        render: MicOff,
        tags: "mic off:devices:communication:connectivity:multimedia:record:sound:mute:microphone",
        categories: [
            "devices",
            "communication",
            "connectivity",
            "multimedia"
        ]
    },
    Mic: {
        render: Mic,
        tags: "mic:devices:communication:connectivity:multimedia:record:sound:listen:radio:podcast:microphone",
        categories: [
            "devices",
            "communication",
            "connectivity",
            "multimedia"
        ]
    },
    Microscope: {
        render: Microscope,
        tags: "microscope:science:medical:medical:education:science:imaging:research",
        categories: [
            "science",
            "medical"
        ]
    },
    Microwave: {
        render: Microwave,
        tags: "microwave:food beverage:home:oven:cooker:toaster oven:bake",
        categories: [
            "food-beverage",
            "home"
        ]
    },
    Milestone: {
        render: Milestone,
        tags: "milestone:arrows:navigation:development:gaming:signpost:direction:right:east:forward:version control",
        categories: [
            "arrows",
            "navigation",
            "development",
            "gaming"
        ]
    },
    MilkOff: {
        render: MilkOff,
        tags: "milk off:food beverage:lactose free:bottle:beverage:drink:water:allergy:intolerance:diet",
        categories: [
            "food-beverage"
        ]
    },
    Milk: {
        render: Milk,
        tags: "milk:food beverage:lactose:bottle:beverage:drink:water:diet",
        categories: [
            "food-beverage"
        ]
    },
    Minimize2: {
        render: Minimize2,
        tags: "minimize 2:arrows:layout:design:exit fullscreen:arrows:close:shrink",
        categories: [
            "arrows",
            "layout",
            "design"
        ]
    },
    Minimize: {
        render: Minimize,
        tags: "minimize:layout:design:exit fullscreen:close:shrink",
        categories: [
            "layout",
            "design"
        ]
    },
    MinusCircle: {
        render: MinusCircle,
        tags: "minus circle:maths:shapes:subtract:remove:decrease:reduce:calculate:line:operator:code:coding:minimum:downgrade:-",
        categories: [
            "maths",
            "shapes"
        ]
    },
    MinusSquare: {
        render: MinusSquare,
        tags: "minus square:maths:development:text:tools:devices:shapes:subtract:remove:decrease:reduce:calculator:button:keyboard:line:divider:separator:horizontal rule:hr:html:markup:markdown:---:toolbar:operator:code:coding:minimum:downgrade",
        categories: [
            "maths",
            "development",
            "text",
            "tools",
            "devices",
            "shapes"
        ]
    },
    Minus: {
        render: Minus,
        tags: "minus:maths:development:text:tools:shapes:subtract:remove:decrease:decrement:reduce:negative:calculate:line:divider:separator:horizontal rule:hr:html:markup:markdown:---:toolbar:operator:code:coding:minimum:downgrade",
        categories: [
            "maths",
            "development",
            "text",
            "tools",
            "shapes"
        ]
    },
    MonitorCheck: {
        render: MonitorCheck,
        tags: "monitor check:connectivity:devices:development:tv:screen:display:desktop:running:active:virtual machine:vm",
        categories: [
            "connectivity",
            "devices",
            "development"
        ]
    },
    MonitorDot: {
        render: MonitorDot,
        tags: "monitor dot:connectivity:devices:development:tv:screen:display:desktop:running:active:virtual machine:vm",
        categories: [
            "connectivity",
            "devices",
            "development"
        ]
    },
    MonitorDown: {
        render: MonitorDown,
        tags: "monitor down:connectivity:devices:tv:screen:display:desktop:download",
        categories: [
            "connectivity",
            "devices"
        ]
    },
    MonitorOff: {
        render: MonitorOff,
        tags: "monitor off:connectivity:devices:share",
        categories: [
            "connectivity",
            "devices"
        ]
    },
    MonitorPause: {
        render: MonitorPause,
        tags: "monitor pause:connectivity:devices:multimedia:development:tv:screen:display:desktop:video:movie:film:suspend:hibernate:boot:virtual machine:vm",
        categories: [
            "connectivity",
            "devices",
            "multimedia",
            "development"
        ]
    },
    MonitorPlay: {
        render: MonitorPlay,
        tags: "monitor play:connectivity:devices:multimedia:development:tv:screen:display:desktop:video:movie:film:running:start:boot:virtual machine:vm",
        categories: [
            "connectivity",
            "devices",
            "multimedia",
            "development"
        ]
    },
    MonitorSmartphone: {
        render: MonitorSmartphone,
        tags: "monitor smartphone:connectivity:devices:smartphone:phone:cellphone:device:mobile:desktop:monitor:responsive:screens",
        categories: [
            "connectivity",
            "devices"
        ]
    },
    MonitorSpeaker: {
        render: MonitorSpeaker,
        tags: "monitor speaker:connectivity:devices:devices:connect:cast",
        categories: [
            "connectivity",
            "devices"
        ]
    },
    MonitorStop: {
        render: MonitorStop,
        tags: "monitor stop:connectivity:devices:multimedia:development:tv:screen:display:desktop:video:movie:film:stop:shutdown:virtual machine:vm",
        categories: [
            "connectivity",
            "devices",
            "multimedia",
            "development"
        ]
    },
    MonitorUp: {
        render: MonitorUp,
        tags: "monitor up:connectivity:devices:tv:screen:display:upload:connect:remote:screen share",
        categories: [
            "connectivity",
            "devices"
        ]
    },
    MonitorX: {
        render: MonitorX,
        tags: "monitor x:connectivity:devices:development:tv:screen:display:desktop:virtual machine:vm:close:stop:suspend:remove:delete",
        categories: [
            "connectivity",
            "devices",
            "development"
        ]
    },
    Monitor: {
        render: Monitor,
        tags: "monitor:connectivity:devices:development:tv:screen:display:virtual machine:vm",
        categories: [
            "connectivity",
            "devices",
            "development"
        ]
    },
    MoonStar: {
        render: MoonStar,
        tags: "moon star:accessibility:weather:dark:night:star",
        categories: [
            "accessibility",
            "weather"
        ]
    },
    Moon: {
        render: Moon,
        tags: "moon:accessibility:dark:night",
        categories: [
            "accessibility"
        ]
    },
    MoreHorizontal: {
        render: MoreHorizontal,
        tags: "more horizontal:layout:development:ellipsis:menu:options:loading:loader:throber:etc:et cetera:operator:code:coding:spread:rest:…:...",
        categories: [
            "layout",
            "development"
        ]
    },
    MoreVertical: {
        render: MoreVertical,
        tags: "more vertical:layout:ellipsis:menu:options",
        categories: [
            "layout"
        ]
    },
    MountainSnow: {
        render: MountainSnow,
        tags: "mountain snow:nature:alpine:climb:snow",
        categories: [
            "nature"
        ]
    },
    Mountain: {
        render: Mountain,
        tags: "mountain:nature:gaming:climb:hike:rock",
        categories: [
            "nature",
            "gaming"
        ]
    },
    MousePointer2: {
        render: MousePointer2,
        tags: "mouse pointer 2:arrows:cursors:arrow:cursor:click",
        categories: [
            "arrows",
            "cursors"
        ]
    },
    MousePointerClick: {
        render: MousePointerClick,
        tags: "mouse pointer click:arrows:cursors:arrow:cursor:click",
        categories: [
            "arrows",
            "cursors"
        ]
    },
    MousePointerSquareDashed: {
        render: MousePointerSquareDashed,
        tags: "mouse pointer square dashed:arrows:cursors:development:tools:inspector:element:mouse:click:pointer:box:browser:selector:target:dom:node",
        categories: [
            "arrows",
            "cursors",
            "development",
            "tools"
        ]
    },
    MousePointerSquare: {
        render: MousePointerSquare,
        tags: "mouse pointer square:arrows:cursors:development:tools:inspector:element:mouse:click:pointer:box:browser:selector:target:dom:node",
        categories: [
            "arrows",
            "cursors",
            "development",
            "tools"
        ]
    },
    MousePointer: {
        render: MousePointer,
        tags: "mouse pointer:arrows:cursors:arrow:cursor:click",
        categories: [
            "arrows",
            "cursors"
        ]
    },
    Mouse: {
        render: Mouse,
        tags: "mouse:devices:device:scroll:click",
        categories: [
            "devices"
        ]
    },
    Move3D: {
        render: Move3D,
        tags: "move 3 d:design:arrows:axis:gizmo:coordinates:transform:translate",
        categories: [
            "design"
        ]
    },
    MoveDiagonal2: {
        render: MoveDiagonal2,
        tags: "move diagonal 2:arrows:cursors:double:arrow",
        categories: [
            "arrows",
            "cursors"
        ]
    },
    MoveDiagonal: {
        render: MoveDiagonal,
        tags: "move diagonal:arrows:cursors:double:arrow",
        categories: [
            "arrows",
            "cursors"
        ]
    },
    MoveDownLeft: {
        render: MoveDownLeft,
        tags: "move down left:arrows:arrow:direction",
        categories: [
            "arrows"
        ]
    },
    MoveDownRight: {
        render: MoveDownRight,
        tags: "move down right:arrows:arrow:direction",
        categories: [
            "arrows"
        ]
    },
    MoveDown: {
        render: MoveDown,
        tags: "move down:arrows:arrow:direction:downwards:south",
        categories: [
            "arrows"
        ]
    },
    MoveHorizontal: {
        render: MoveHorizontal,
        tags: "move horizontal:arrows:cursors:double:arrow",
        categories: [
            "arrows",
            "cursors"
        ]
    },
    MoveLeft: {
        render: MoveLeft,
        tags: "move left:arrows:arrow:direction:back:west",
        categories: [
            "arrows"
        ]
    },
    MoveRight: {
        render: MoveRight,
        tags: "move right:arrows:arrow:direction:trend flat:east",
        categories: [
            "arrows"
        ]
    },
    MoveUpLeft: {
        render: MoveUpLeft,
        tags: "move up left:arrows:arrow:direction",
        categories: [
            "arrows"
        ]
    },
    MoveUpRight: {
        render: MoveUpRight,
        tags: "move up right:arrows:arrow:direction",
        categories: [
            "arrows"
        ]
    },
    MoveUp: {
        render: MoveUp,
        tags: "move up:arrows:arrow:direction:upwards:north",
        categories: [
            "arrows"
        ]
    },
    MoveVertical: {
        render: MoveVertical,
        tags: "move vertical:arrows:cursors:double:arrow",
        categories: [
            "arrows",
            "cursors"
        ]
    },
    Move: {
        render: Move,
        tags: "move:arrows:cursors:arrows",
        categories: [
            "arrows",
            "cursors"
        ]
    },
    Music2: {
        render: Music2,
        tags: "music 2:multimedia:files:quaver:eighth note:note",
        categories: [
            "multimedia",
            "files"
        ]
    },
    Music3: {
        render: Music3,
        tags: "music 3:multimedia:files:crotchet:minim:quarter note:half note:note",
        categories: [
            "multimedia",
            "files"
        ]
    },
    Music4: {
        render: Music4,
        tags: "music 4:multimedia:files:semiquaver:sixteenth note:note",
        categories: [
            "multimedia",
            "files"
        ]
    },
    Music: {
        render: Music,
        tags: "music:multimedia:files:note:quaver:eighth note",
        categories: [
            "multimedia",
            "files"
        ]
    },
    Navigation2Off: {
        render: Navigation2Off,
        tags: "navigation 2 off:navigation:maps:location:travel",
        categories: [
            "navigation",
            "maps"
        ]
    },
    Navigation2: {
        render: Navigation2,
        tags: "navigation 2:navigation:maps:location:travel",
        categories: [
            "navigation",
            "maps"
        ]
    },
    NavigationOff: {
        render: NavigationOff,
        tags: "navigation off:navigation:maps:location:travel",
        categories: [
            "navigation",
            "maps"
        ]
    },
    Navigation: {
        render: Navigation,
        tags: "navigation:navigation:maps:location:travel",
        categories: [
            "navigation",
            "maps"
        ]
    },
    Network: {
        render: Network,
        tags: "network:development:tree",
        categories: [
            "development"
        ]
    },
    Newspaper: {
        render: Newspaper,
        tags: "newspaper:multimedia:communication:news:feed:home:magazine:article:headline",
        categories: [
            "multimedia",
            "communication"
        ]
    },
    Nfc: {
        render: Nfc,
        tags: "nfc:communication:money:devices:contactless:payment:near-field communication",
        categories: [
            "communication",
            "money",
            "devices"
        ]
    },
    NotebookPen: {
        render: NotebookPen,
        tags: "notebook pen:text:social:pencil:notepad:notes:noted:stationery:sketchbook:organizer:organiser:planner:diary:journal:writing:write:written:reading:high school:university:college:academy:student:study:research:homework:eraser:rubber",
        categories: [
            "text",
            "social"
        ]
    },
    NotebookTabs: {
        render: NotebookTabs,
        tags: "notebook tabs:account:connectivity:communication:social:notepad:notes:people:family:friends:acquaintances:contacts:details:addresses:phone numbers:directory:listing:networking:alphabetical:a-z:organizer:organiser:planner:diary:stationery",
        categories: [
            "account",
            "connectivity",
            "communication",
            "social"
        ]
    },
    NotebookText: {
        render: NotebookText,
        tags: "notebook text:text:social:notepad:notes:pages:paper:stationery:sketchbook:organizer:organiser:planner:diary:journal:writing:write:written:reading:high school:university:college:academy:student:study:research:homework:lines:opened",
        categories: [
            "text",
            "social"
        ]
    },
    Notebook: {
        render: Notebook,
        tags: "notebook:text:communication:social:design:notepad:notes:stationery:sketchbook:moleskine:closure:strap:band:elastic:organizer:organiser:planner:diary:journal:writing:written:writer:reading:high school:university:college:academy:student:study:homework:research",
        categories: [
            "text",
            "communication",
            "social",
            "design"
        ]
    },
    NotepadTextDashed: {
        render: NotepadTextDashed,
        tags: "notepad text dashed:text:social:notebook:notes:pages:paper:stationery:diary:journal:writing:write:written:draft:template:lines",
        categories: [
            "text",
            "social"
        ]
    },
    NotepadText: {
        render: NotepadText,
        tags: "notepad text:text:social:notebook:notes:pages:paper:stationery:sketchbook:organizer:organiser:planner:diary:journal:writing:write:written:reading:high school:university:college:academy:student:study:homework:research:lines:opened",
        categories: [
            "text",
            "social"
        ]
    },
    NutOff: {
        render: NutOff,
        tags: "nut off:food beverage:hazelnut:acorn:food:allergy:intolerance:diet",
        categories: [
            "food-beverage"
        ]
    },
    Nut: {
        render: Nut,
        tags: "nut:food beverage:hazelnut:acorn:food:diet",
        categories: [
            "food-beverage"
        ]
    },
    Octagon: {
        render: Octagon,
        tags: "octagon:shapes:stop:shape",
        categories: [
            "shapes"
        ]
    },
    Option: {
        render: Option,
        tags: "option:development:keyboard:key:mac:alt:button",
        categories: [
            "development"
        ]
    },
    Orbit: {
        render: Orbit,
        tags: "orbit:science:planet:space:physics:satellites:moons",
        categories: [
            "science"
        ]
    },
    Outdent: {
        render: Outdent,
        tags: "outdent:text:development:text:tab",
        categories: [
            "text",
            "development"
        ]
    },
    Package2: {
        render: Package2,
        tags: "package 2:files:development:box:container:storage:sealed:packed:unopened:undelivered:archive:zip",
        categories: [
            "files",
            "development"
        ]
    },
    PackageCheck: {
        render: PackageCheck,
        tags: "package check:development:confirm:verified:done:todo:tick:complete:task:delivered",
        categories: [
            "development"
        ]
    },
    PackageMinus: {
        render: PackageMinus,
        tags: "package minus:development:delete:remove",
        categories: [
            "development"
        ]
    },
    PackageOpen: {
        render: PackageOpen,
        tags: "package open:files:development:box:container:storage:unpack:unarchive:unzip:opened:delivered",
        categories: [
            "files",
            "development"
        ]
    },
    PackagePlus: {
        render: PackagePlus,
        tags: "package plus:development:new:add:create",
        categories: [
            "development"
        ]
    },
    PackageSearch: {
        render: PackageSearch,
        tags: "package search:files:development:find:product process",
        categories: [
            "files",
            "development"
        ]
    },
    PackageX: {
        render: PackageX,
        tags: "package x:development:delete:remove",
        categories: [
            "development"
        ]
    },
    Package: {
        render: Package,
        tags: "package:files:development:box:container:storage:sealed:delivery:undelivered:unopened:packed:archive:zip:module",
        categories: [
            "files",
            "development"
        ]
    },
    PaintBucket: {
        render: PaintBucket,
        tags: "paint bucket:design:tools:fill:paint:bucket:color:colour",
        categories: [
            "design",
            "tools"
        ]
    },
    PaintRoller: {
        render: PaintRoller,
        tags: "paint roller:text:design:home:tools:brush:color:colour:decoration:diy",
        categories: [
            "text",
            "design",
            "home",
            "tools"
        ]
    },
    Paintbrush2: {
        render: Paintbrush2,
        tags: "paintbrush 2:text:design:photography:home:tools:brush:paintbrush:design:color:colour:decoration:diy",
        categories: [
            "text",
            "design",
            "photography",
            "home",
            "tools"
        ]
    },
    Paintbrush: {
        render: Paintbrush,
        tags: "paintbrush:text:design:photography:home:tools:brush:paintbrush:design:color:colour:decoration:diy",
        categories: [
            "text",
            "design",
            "photography",
            "home",
            "tools"
        ]
    },
    Palette: {
        render: Palette,
        tags: "palette:text:design:photography:colors:colours:theme:scheme:paint:watercolor:watercolour:artist",
        categories: [
            "text",
            "design",
            "photography"
        ]
    },
    Palmtree: {
        render: Palmtree,
        tags: "palmtree:nature:vacation:leisure:island",
        categories: [
            "nature"
        ]
    },
    PanelBottomClose: {
        render: PanelBottomClose,
        tags: "panel bottom close:layout:arrows:drawer:dock:hide:chevron:down",
        categories: [
            "layout",
            "arrows"
        ]
    },
    PanelBottomDashed: {
        render: PanelBottomDashed,
        tags: "panel bottom dashed:layout:drawer:dock:show:reveal",
        categories: [
            "layout"
        ]
    },
    PanelBottomOpen: {
        render: PanelBottomOpen,
        tags: "panel bottom open:layout:arrows:drawer:dock:show:reveal:chevron:up",
        categories: [
            "layout",
            "arrows"
        ]
    },
    PanelBottom: {
        render: PanelBottom,
        tags: "panel bottom:layout:drawer:dock",
        categories: [
            "layout"
        ]
    },
    PanelLeftClose: {
        render: PanelLeftClose,
        tags: "panel left close:layout:arrows:primary:drawer:hide:chevron:<",
        categories: [
            "layout",
            "arrows"
        ]
    },
    PanelLeftDashed: {
        render: PanelLeftDashed,
        tags: "panel left dashed:layout:sidebar:primary:drawer:show:reveal",
        categories: [
            "layout"
        ]
    },
    PanelLeftOpen: {
        render: PanelLeftOpen,
        tags: "panel left open:layout:arrows:primary:drawer:show:reveal:chevron:right:>",
        categories: [
            "layout",
            "arrows"
        ]
    },
    PanelLeft: {
        render: PanelLeft,
        tags: "panel left:layout:primary:drawer",
        categories: [
            "layout"
        ]
    },
    PanelRightClose: {
        render: PanelRightClose,
        tags: "panel right close:layout:arrows:sidebar:secondary:drawer:hide:chevron:>",
        categories: [
            "layout",
            "arrows"
        ]
    },
    PanelRightDashed: {
        render: PanelRightDashed,
        tags: "panel right dashed:layout:sidebar:secondary:drawer:show:reveal",
        categories: [
            "layout"
        ]
    },
    PanelRightOpen: {
        render: PanelRightOpen,
        tags: "panel right open:layout:arrows:sidebar:secondary:drawer:show:reveal:chevron:left:<",
        categories: [
            "layout",
            "arrows"
        ]
    },
    PanelRight: {
        render: PanelRight,
        tags: "panel right:layout:sidebar:secondary:drawer",
        categories: [
            "layout"
        ]
    },
    PanelTopClose: {
        render: PanelTopClose,
        tags: "panel top close:layout:arrows:menu bar:drawer:hide:chevron:up",
        categories: [
            "layout",
            "arrows"
        ]
    },
    PanelTopDashed: {
        render: PanelTopDashed,
        tags: "panel top dashed:layout:menu bar:drawer:show:reveal",
        categories: [
            "layout"
        ]
    },
    PanelTopOpen: {
        render: PanelTopOpen,
        tags: "panel top open:layout:arrows:menu bar:drawer:show:reveal:chevron:down",
        categories: [
            "layout",
            "arrows"
        ]
    },
    PanelTop: {
        render: PanelTop,
        tags: "panel top:layout:design:development:drawer:browser:webpage",
        categories: [
            "layout",
            "design",
            "development"
        ]
    },
    PanelsLeftBottom: {
        render: PanelsLeftBottom,
        tags: "panels left bottom:layout:drawers:sidebar:primary",
        categories: [
            "layout"
        ]
    },
    PanelsRightBottom: {
        render: PanelsRightBottom,
        tags: "panels right bottom:layout:drawers:sidebar:secondary",
        categories: [
            "layout"
        ]
    },
    PanelsTopLeft: {
        render: PanelsTopLeft,
        tags: "panels top left:layout:design:development:charts:menu bar:sidebar:primary:drawers:window:webpage:projects:overview",
        categories: [
            "layout",
            "design",
            "development",
            "charts"
        ]
    },
    Paperclip: {
        render: Paperclip,
        tags: "paperclip:text:design:files:mail:attachment:file",
        categories: [
            "text",
            "design",
            "files",
            "mail"
        ]
    },
    Parentheses: {
        render: Parentheses,
        tags: "parentheses:development:files:maths:code:token:parenthesis:parens:brackets:parameters:arguments:args:input:call:maths:formula:function:(:)",
        categories: [
            "development",
            "files",
            "maths"
        ]
    },
    ParkingCircleOff: {
        render: ParkingCircleOff,
        tags: "parking circle off:transportation:maps:parking lot:car park:no parking",
        categories: [
            "transportation",
            "maps"
        ]
    },
    ParkingCircle: {
        render: ParkingCircle,
        tags: "parking circle:transportation:maps:parking lot:car park",
        categories: [
            "transportation",
            "maps"
        ]
    },
    ParkingMeter: {
        render: ParkingMeter,
        tags: "parking meter:transportation:maps:driving:car park:pay:sidewalk:pavement",
        categories: [
            "transportation",
            "maps"
        ]
    },
    ParkingSquareOff: {
        render: ParkingSquareOff,
        tags: "parking square off:transportation:maps:parking lot:car park:no parking",
        categories: [
            "transportation",
            "maps"
        ]
    },
    ParkingSquare: {
        render: ParkingSquare,
        tags: "parking square:transportation:maps:parking lot:car park",
        categories: [
            "transportation",
            "maps"
        ]
    },
    PartyPopper: {
        render: PartyPopper,
        tags: "party popper:emoji:emoji:congratulations:celebration:party:tada:🎉:🎊:excitement:exciting:excites:confetti",
        categories: [
            "emoji"
        ]
    },
    PauseCircle: {
        render: PauseCircle,
        tags: "pause circle:multimedia:shapes:music:audio:stop",
        categories: [
            "multimedia",
            "shapes"
        ]
    },
    PauseOctagon: {
        render: PauseOctagon,
        tags: "pause octagon:multimedia:shapes:music:audio:stop",
        categories: [
            "multimedia",
            "shapes"
        ]
    },
    Pause: {
        render: Pause,
        tags: "pause:multimedia:music:stop",
        categories: [
            "multimedia"
        ]
    },
    PawPrint: {
        render: PawPrint,
        tags: "paw print:animals:pets:vets:veterinarian:domesticated:cat:dog:bear",
        categories: [
            "animals"
        ]
    },
    PcCase: {
        render: PcCase,
        tags: "pc case:devices:gaming:computer:chassis",
        categories: [
            "devices",
            "gaming"
        ]
    },
    PenLine: {
        render: PenLine,
        tags: "pen line:text:design:tools:pencil:change:create:draw:writer:writing:biro:ink:marker:felt tip:stationery:artist",
        categories: [
            "text",
            "design",
            "tools"
        ]
    },
    PenTool: {
        render: PenTool,
        tags: "pen tool:text:design:cursors:vector:drawing:path",
        categories: [
            "text",
            "design",
            "cursors"
        ]
    },
    Pen: {
        render: Pen,
        tags: "pen:text:design:tools:pencil:change:create:draw:writer:writing:biro:ink:marker:felt tip:stationery:artist",
        categories: [
            "text",
            "design",
            "tools"
        ]
    },
    PencilLine: {
        render: PencilLine,
        tags: "pencil line:text:design:tools:pencil:change:create:draw:sketch:draft:writer:writing:biro:ink:marker:felt tip:stationery:artist",
        categories: [
            "text",
            "design",
            "tools"
        ]
    },
    PencilRuler: {
        render: PencilRuler,
        tags: "pencil ruler:tools:design:layout:text:edit:create:draw:sketch:draft:writer:writing:stationery:artist:measurements:centimeters:cm:millimeters:mm:metre:foot:feet:inches:units:size:length:width:height:dimensions:depth:breadth:extent",
        categories: [
            "tools",
            "design",
            "layout",
            "text"
        ]
    },
    Pencil: {
        render: Pencil,
        tags: "pencil:design:cursors:tools:text:rubber:edit:create:draw:sketch:draft:writer:writing:stationery:artist",
        categories: [
            "design",
            "cursors",
            "tools",
            "text"
        ]
    },
    Pentagon: {
        render: Pentagon,
        tags: "pentagon:shapes:shape",
        categories: [
            "shapes"
        ]
    },
    PercentCircle: {
        render: PercentCircle,
        tags: "percent circle:account:social:money:shopping:maths:shapes:verified:unverified:sale:discount:offer:marketing:sticker:price tag",
        categories: [
            "account",
            "social",
            "money",
            "shopping",
            "maths",
            "shapes"
        ]
    },
    PercentDiamond: {
        render: PercentDiamond,
        tags: "percent diamond:account:social:money:shopping:maths:shapes:verified:unverified:sale:discount:offer:marketing:sticker:price tag",
        categories: [
            "account",
            "social",
            "money",
            "shopping",
            "maths",
            "shapes"
        ]
    },
    PercentSquare: {
        render: PercentSquare,
        tags: "percent square:account:social:money:shopping:maths:shapes:verified:unverified:sale:discount:offer:marketing:sticker:price tag",
        categories: [
            "account",
            "social",
            "money",
            "shopping",
            "maths",
            "shapes"
        ]
    },
    Percent: {
        render: Percent,
        tags: "percent:maths:development:money:shopping:percentage:modulo:modulus:remainder:%:sale:discount:offer:marketing",
        categories: [
            "maths",
            "development",
            "money",
            "shopping"
        ]
    },
    PersonStanding: {
        render: PersonStanding,
        tags: "person standing:accessibility:people:people:human:accessibility:stick figure",
        categories: [
            "accessibility",
            "people"
        ]
    },
    PhoneCall: {
        render: PhoneCall,
        tags: "phone call:connectivity:devices:communication:ring",
        categories: [
            "connectivity",
            "devices",
            "communication"
        ]
    },
    PhoneForwarded: {
        render: PhoneForwarded,
        tags: "phone forwarded:arrows:connectivity:devices:communication:call",
        categories: [
            "arrows",
            "connectivity",
            "devices",
            "communication"
        ]
    },
    PhoneIncoming: {
        render: PhoneIncoming,
        tags: "phone incoming:arrows:connectivity:devices:communication:call",
        categories: [
            "arrows",
            "connectivity",
            "devices",
            "communication"
        ]
    },
    PhoneMissed: {
        render: PhoneMissed,
        tags: "phone missed:connectivity:devices:communication:call",
        categories: [
            "connectivity",
            "devices",
            "communication"
        ]
    },
    PhoneOff: {
        render: PhoneOff,
        tags: "phone off:connectivity:devices:communication:call:mute",
        categories: [
            "connectivity",
            "devices",
            "communication"
        ]
    },
    PhoneOutgoing: {
        render: PhoneOutgoing,
        tags: "phone outgoing:arrows:connectivity:devices:communication:call",
        categories: [
            "arrows",
            "connectivity",
            "devices",
            "communication"
        ]
    },
    Phone: {
        render: Phone,
        tags: "phone:text:connectivity:devices:communication:call",
        categories: [
            "text",
            "connectivity",
            "devices",
            "communication"
        ]
    },
    PiSquare: {
        render: PiSquare,
        tags: "pi square:development:maths:shapes:constant:code:coding:programming:symbol:trigonometry:geometry:formula",
        categories: [
            "development",
            "maths",
            "shapes"
        ]
    },
    Pi: {
        render: Pi,
        tags: "pi:development:maths:shapes:constant:code:coding:programming:symbol:trigonometry:geometry:formula",
        categories: [
            "development",
            "maths",
            "shapes"
        ]
    },
    Piano: {
        render: Piano,
        tags: "piano:multimedia:devices:music:audio:sound:noise:notes:chord:keys:octave:acoustic:instrument:play:pianist:performance:concert",
        categories: [
            "multimedia",
            "devices"
        ]
    },
    Pickaxe: {
        render: Pickaxe,
        tags: "pickaxe:tools:maps:gaming:mining:mine:land worker:extraction:labor:construction:progress:advancement:crafting:building:creation",
        categories: [
            "tools",
            "maps",
            "gaming"
        ]
    },
    PictureInPicture2: {
        render: PictureInPicture2,
        tags: "picture in picture 2:multimedia:display:play:video:pop out:always on top:window:inset:multitask",
        categories: [
            "multimedia"
        ]
    },
    PictureInPicture: {
        render: PictureInPicture,
        tags: "picture in picture:multimedia:display:play:video:pop out:always on top:window:inset:multitask",
        categories: [
            "multimedia"
        ]
    },
    PieChart: {
        render: PieChart,
        tags: "pie chart:charts:files:statistics:diagram:presentation",
        categories: [
            "charts",
            "files"
        ]
    },
    PiggyBank: {
        render: PiggyBank,
        tags: "piggy bank:money:money:savings",
        categories: [
            "money"
        ]
    },
    PilcrowSquare: {
        render: PilcrowSquare,
        tags: "pilcrow square:text:paragraph:mark:paraph:blind:typography:type:text:prose:symbol",
        categories: [
            "text"
        ]
    },
    Pilcrow: {
        render: Pilcrow,
        tags: "pilcrow:text:paragraph:mark:paraph:blind:typography:type:text:prose:symbol",
        categories: [
            "text"
        ]
    },
    Pill: {
        render: Pill,
        tags: "pill:medical:medicine:medication:drug:prescription:tablet:pharmacy",
        categories: [
            "medical"
        ]
    },
    PinOff: {
        render: PinOff,
        tags: "pin off:maps:unpin:map:unlock:unfix:unsave:remove",
        categories: [
            "maps"
        ]
    },
    Pin: {
        render: Pin,
        tags: "pin:maps:account:save:map:lock:fix",
        categories: [
            "maps",
            "account"
        ]
    },
    Pipette: {
        render: Pipette,
        tags: "pipette:text:design:science:eye dropper:color picker:lab:chemistry",
        categories: [
            "text",
            "design",
            "science"
        ]
    },
    Pizza: {
        render: Pizza,
        tags: "pizza:food beverage:pie:quiche:food",
        categories: [
            "food-beverage"
        ]
    },
    PlaneLanding: {
        render: PlaneLanding,
        tags: "plane landing:transportation:travel:arrival:plane:trip:airplane:landing",
        categories: [
            "transportation",
            "travel"
        ]
    },
    PlaneTakeoff: {
        render: PlaneTakeoff,
        tags: "plane takeoff:transportation:travel:departure:plane:trip:airplane:takeoff",
        categories: [
            "transportation",
            "travel"
        ]
    },
    Plane: {
        render: Plane,
        tags: "plane:transportation:travel:plane:trip:airplane",
        categories: [
            "transportation",
            "travel"
        ]
    },
    PlayCircle: {
        render: PlayCircle,
        tags: "play circle:shapes:multimedia:music:start:run",
        categories: [
            "shapes",
            "multimedia"
        ]
    },
    PlaySquare: {
        render: PlaySquare,
        tags: "play square:arrows:multimedia:music:audio:video:start:run",
        categories: [
            "arrows",
            "multimedia"
        ]
    },
    Play: {
        render: Play,
        tags: "play:arrows:multimedia:music:audio:video:start:run",
        categories: [
            "arrows",
            "multimedia"
        ]
    },
    Plug2: {
        render: Plug2,
        tags: "plug 2:devices:development:electricity:energy:socket:outlet",
        categories: [
            "devices",
            "development"
        ]
    },
    PlugZap2: {
        render: PlugZap2,
        tags: "plug zap 2:devices:electricity:energy:electronics:charge:charging:battery:connect",
        categories: [
            "devices"
        ]
    },
    PlugZap: {
        render: PlugZap,
        tags: "plug zap:devices:electricity:energy:electronics:charge:charging:battery:connect",
        categories: [
            "devices"
        ]
    },
    Plug: {
        render: Plug,
        tags: "plug:devices:development:electricity:energy:electronics:socket:outlet",
        categories: [
            "devices",
            "development"
        ]
    },
    PlusCircle: {
        render: PlusCircle,
        tags: "plus circle:maths:development:shapes:cursors:gaming:add:new:increase:increment:positive:calculate:crosshair:aim:target:scope:sight:reticule:maximum:upgrade:extra:operator:join:concatenate:code:coding:+",
        categories: [
            "maths",
            "development",
            "shapes",
            "cursors",
            "gaming"
        ]
    },
    PlusSquare: {
        render: PlusSquare,
        tags: "plus square:maths:tools:development:text:shapes:add:new:increase:increment:positive:calculate:calculator:button:keyboard:toolbar:maximum:upgrade:extra:operator:join:concatenate:code:coding:+",
        categories: [
            "maths",
            "tools",
            "development",
            "text",
            "shapes"
        ]
    },
    Plus: {
        render: Plus,
        tags: "plus:maths:tools:development:text:cursors:gaming:add:new:increase:increment:positive:calculate:toolbar:crosshair:aim:target:scope:sight:reticule:maximum:upgrade:extra:+",
        categories: [
            "maths",
            "tools",
            "development",
            "text",
            "cursors",
            "gaming"
        ]
    },
    PocketKnife: {
        render: PocketKnife,
        tags: "pocket knife:tools:swiss army knife:penknife:multi-tool:multitask:blade:cutter:gadget:corkscrew",
        categories: [
            "tools"
        ]
    },
    Pocket: {
        render: Pocket,
        tags: "pocket:brands:development:logo:save",
        categories: [
            "brands",
            "development"
        ]
    },
    Podcast: {
        render: Podcast,
        tags: "podcast:multimedia:social:mic:music",
        categories: [
            "multimedia",
            "social"
        ]
    },
    PointerOff: {
        render: PointerOff,
        tags: "pointer off:cursors:mouse",
        categories: [
            "cursors"
        ]
    },
    Pointer: {
        render: Pointer,
        tags: "pointer:cursors:mouse",
        categories: [
            "cursors"
        ]
    },
    Popcorn: {
        render: Popcorn,
        tags: "popcorn:food beverage:multimedia:cinema:movies:films:salted:sweet:sugar:candy:snack",
        categories: [
            "food-beverage",
            "multimedia"
        ]
    },
    Popsicle: {
        render: Popsicle,
        tags: "popsicle:food beverage:ice lolly:ice cream:sweet:food",
        categories: [
            "food-beverage"
        ]
    },
    PoundSterling: {
        render: PoundSterling,
        tags: "pound sterling:currency:money:currency:money:payment",
        categories: [
            "currency",
            "money"
        ]
    },
    PowerCircle: {
        render: PowerCircle,
        tags: "power circle:connectivity:on:off:device:switch:toggle:binary:boolean:reboot:restart:button:keyboard:troubleshoot",
        categories: [
            "connectivity"
        ]
    },
    PowerOff: {
        render: PowerOff,
        tags: "power off:connectivity:on:off:device:switch",
        categories: [
            "connectivity"
        ]
    },
    PowerSquare: {
        render: PowerSquare,
        tags: "power square:connectivity:on:off:device:switch:toggle:binary:boolean:reboot:restart:button:keyboard:troubleshoot",
        categories: [
            "connectivity"
        ]
    },
    Power: {
        render: Power,
        tags: "power:connectivity:on:off:device:switch:toggle:binary:boolean:reboot:restart:button:keyboard:troubleshoot",
        categories: [
            "connectivity"
        ]
    },
    Presentation: {
        render: Presentation,
        tags: "presentation:multimedia:photography:devices:communication:design:screen:whiteboard:marker pens:markers:blackboard:chalk:easel:school:learning:lesson:office:meeting:project:planning",
        categories: [
            "multimedia",
            "photography",
            "devices",
            "communication",
            "design"
        ]
    },
    Printer: {
        render: Printer,
        tags: "printer:devices:account:fax:office:device",
        categories: [
            "devices",
            "account"
        ]
    },
    Projector: {
        render: Projector,
        tags: "projector:multimedia:photography:devices:communication:cinema:film:movie:home video:presentation:slideshow:office:meeting:project:planning",
        categories: [
            "multimedia",
            "photography",
            "devices",
            "communication"
        ]
    },
    Puzzle: {
        render: Puzzle,
        tags: "puzzle:development:gaming:component:module:part:piece",
        categories: [
            "development",
            "gaming"
        ]
    },
    Pyramid: {
        render: Pyramid,
        tags: "pyramid:shapes:maths:travel:prism:triangle:triangular:hierarchy:structure:geometry:ancient:egyptian:landmark:tourism",
        categories: [
            "shapes",
            "maths",
            "travel"
        ]
    },
    QrCode: {
        render: QrCode,
        tags: "qr code:development:social:barcode:scan:link:url:information:digital",
        categories: [
            "development",
            "social"
        ]
    },
    Quote: {
        render: Quote,
        tags: "quote:text:quotation",
        categories: [
            "text"
        ]
    },
    Rabbit: {
        render: Rabbit,
        tags: "rabbit:animals:animal:rodent:pet:pest:bunny:hare:fast:speed:hop",
        categories: [
            "animals"
        ]
    },
    Radar: {
        render: Radar,
        tags: "radar:navigation:maps:security:communication:scan:sonar:detect:find:locate",
        categories: [
            "navigation",
            "maps",
            "security",
            "communication"
        ]
    },
    Radiation: {
        render: Radiation,
        tags: "radiation:science:radioactive:nuclear:fallout:waste:atomic:physics:particle:element:molecule",
        categories: [
            "science"
        ]
    },
    Radical: {
        render: Radical,
        tags: "radical:development:maths:calculate:formula:maths:operator:root:square:symbol",
        categories: [
            "development",
            "maths"
        ]
    },
    RadioReceiver: {
        render: RadioReceiver,
        tags: "radio receiver:devices:device:music:connect",
        categories: [
            "devices"
        ]
    },
    RadioTower: {
        render: RadioTower,
        tags: "radio tower:devices:multimedia:social:signal:broadcast:connectivity:live:frequency",
        categories: [
            "devices",
            "multimedia",
            "social"
        ]
    },
    Radio: {
        render: Radio,
        tags: "radio:devices:multimedia:social:signal:broadcast:connectivity:live:frequency",
        categories: [
            "devices",
            "multimedia",
            "social"
        ]
    },
    Radius: {
        render: Radius,
        tags: "radius:shapes:maths:design:tools:shape:circle:geometry:trigonometry:radii:calculate:measure:size",
        categories: [
            "shapes",
            "maths",
            "design",
            "tools"
        ]
    },
    RailSymbol: {
        render: RailSymbol,
        tags: "rail symbol:transportation:maps:railway:train:track:line",
        categories: [
            "transportation",
            "maps"
        ]
    },
    Rainbow: {
        render: Rainbow,
        tags: "rainbow:weather:colors:colours:spectrum:light:prism:arc:clear:sunshine",
        categories: [
            "weather"
        ]
    },
    Rat: {
        render: Rat,
        tags: "rat:animals:mouse:mice:gerbil:rodent:pet:pest:plague:disease",
        categories: [
            "animals"
        ]
    },
    Ratio: {
        render: Ratio,
        tags: "ratio:connectivity:devices:design:photography:screens:rotate:rotation:aspect ratio:proportions:16:9:widescreen:4:3:responsive:mobile:desktop:monitor:orientation:portrait:landscape",
        categories: [
            "connectivity",
            "devices",
            "design",
            "photography"
        ]
    },
    ReceiptCent: {
        render: ReceiptCent,
        tags: "receipt cent:money:currency:travel:bill:voucher:slip:check:counterfoil:currency:cents:dollar:usd:$:¢",
        categories: [
            "money",
            "currency",
            "travel"
        ]
    },
    ReceiptEuro: {
        render: ReceiptEuro,
        tags: "receipt euro:money:currency:travel:bill:voucher:slip:check:counterfoil:currency:€",
        categories: [
            "money",
            "currency",
            "travel"
        ]
    },
    ReceiptIndianRupee: {
        render: ReceiptIndianRupee,
        tags: "receipt indian rupee:money:currency:travel:bill:voucher:slip:check:counterfoil:inr:₹",
        categories: [
            "money",
            "currency",
            "travel"
        ]
    },
    ReceiptJapaneseYen: {
        render: ReceiptJapaneseYen,
        tags: "receipt japanese yen:money:currency:travel:bill:voucher:slip:check:counterfoil:jpy:¥",
        categories: [
            "money",
            "currency",
            "travel"
        ]
    },
    ReceiptPoundSterling: {
        render: ReceiptPoundSterling,
        tags: "receipt pound sterling:money:currency:travel:bill:voucher:slip:check:counterfoil:british:gbp:£",
        categories: [
            "money",
            "currency",
            "travel"
        ]
    },
    ReceiptRussianRuble: {
        render: ReceiptRussianRuble,
        tags: "receipt russian ruble:money:currency:travel:bill:voucher:slip:check:counterfoil:rub:₽",
        categories: [
            "money",
            "currency",
            "travel"
        ]
    },
    ReceiptSwissFranc: {
        render: ReceiptSwissFranc,
        tags: "receipt swiss franc:money:currency:travel:bill:voucher:slip:check:counterfoil:chf:₣",
        categories: [
            "money",
            "currency",
            "travel"
        ]
    },
    ReceiptText: {
        render: ReceiptText,
        tags: "receipt text:money:travel:bill:voucher:slip:check:counterfoil:details:small print:terms:conditions:contract",
        categories: [
            "money",
            "travel"
        ]
    },
    Receipt: {
        render: Receipt,
        tags: "receipt:money:currency:travel:bill:voucher:slip:check:counterfoil:currency:dollar:usd:$",
        categories: [
            "money",
            "currency",
            "travel"
        ]
    },
    RectangleHorizontal: {
        render: RectangleHorizontal,
        tags: "rectangle horizontal:shapes:design:rectangle:aspect ratio:16:9:horizontal:shape",
        categories: [
            "shapes",
            "design"
        ]
    },
    RectangleVertical: {
        render: RectangleVertical,
        tags: "rectangle vertical:shapes:design:rectangle:aspect ratio:9:16:vertical:shape",
        categories: [
            "shapes",
            "design"
        ]
    },
    Recycle: {
        render: Recycle,
        tags: "recycle:sustainability:sustainability:salvage:arrows",
        categories: [
            "sustainability"
        ]
    },
    Redo2: {
        render: Redo2,
        tags: "redo 2:text:arrows:undo:rerun:history",
        categories: [
            "text",
            "arrows"
        ]
    },
    RedoDot: {
        render: RedoDot,
        tags: "redo dot:text:arrows:redo:history:step:over:forward",
        categories: [
            "text",
            "arrows"
        ]
    },
    Redo: {
        render: Redo,
        tags: "redo:text:arrows:undo:rerun:history",
        categories: [
            "text",
            "arrows"
        ]
    },
    RefreshCcwDot: {
        render: RefreshCcwDot,
        tags: "refresh ccw dot:arrows:development:shapes:arrows:rotate:reload:synchronise:synchronize:circular:cycle:issue:code:coding:version control",
        categories: [
            "arrows",
            "development",
            "shapes"
        ]
    },
    RefreshCcw: {
        render: RefreshCcw,
        tags: "refresh ccw:arrows:arrows:rotate:reload:rerun:synchronise:synchronize:circular:cycle",
        categories: [
            "arrows"
        ]
    },
    RefreshCwOff: {
        render: RefreshCwOff,
        tags: "refresh cw off:arrows:rotate:reload:rerun:synchronise:synchronize:arrows:circular:cycle:cancel:no:stop:error:disconnect:ignore",
        categories: [
            "arrows"
        ]
    },
    RefreshCw: {
        render: RefreshCw,
        tags: "refresh cw:arrows:rotate:reload:rerun:synchronise:synchronize:arrows:circular:cycle",
        categories: [
            "arrows"
        ]
    },
    Refrigerator: {
        render: Refrigerator,
        tags: "refrigerator:food beverage:home:frigerator:fridge:freezer:cooler:icebox:chiller:cold storage",
        categories: [
            "food-beverage",
            "home"
        ]
    },
    Regex: {
        render: Regex,
        tags: "regex:text:development:search:text:code",
        categories: [
            "text",
            "development"
        ]
    },
    RemoveFormatting: {
        render: RemoveFormatting,
        tags: "remove formatting:text:text:font:typography:format:x:remove:delete:times:clear",
        categories: [
            "text"
        ]
    },
    Repeat1: {
        render: Repeat1,
        tags: "repeat 1:multimedia:replay",
        categories: [
            "multimedia"
        ]
    },
    Repeat2: {
        render: Repeat2,
        tags: "repeat 2:arrows:social:multimedia:arrows:retweet:repost:share:repeat:loop",
        categories: [
            "arrows",
            "social",
            "multimedia"
        ]
    },
    Repeat: {
        render: Repeat,
        tags: "repeat:arrows:multimedia:loop:arrows",
        categories: [
            "arrows",
            "multimedia"
        ]
    },
    ReplaceAll: {
        render: ReplaceAll,
        tags: "replace all:text:search:substitute:swap:change",
        categories: [
            "text"
        ]
    },
    Replace: {
        render: Replace,
        tags: "replace:text:search:substitute:swap:change",
        categories: [
            "text"
        ]
    },
    ReplyAll: {
        render: ReplyAll,
        tags: "reply all:mail:email",
        categories: [
            "mail"
        ]
    },
    Reply: {
        render: Reply,
        tags: "reply:mail:email",
        categories: [
            "mail"
        ]
    },
    Rewind: {
        render: Rewind,
        tags: "rewind:arrows:multimedia:music",
        categories: [
            "arrows",
            "multimedia"
        ]
    },
    Ribbon: {
        render: Ribbon,
        tags: "ribbon:social:medical:emoji:awareness:strip:band:tape:strap:cordon",
        categories: [
            "social",
            "medical",
            "emoji"
        ]
    },
    Rocket: {
        render: Rocket,
        tags: "rocket:gaming:development:release:boost:launch:space:version",
        categories: [
            "gaming",
            "development"
        ]
    },
    RockingChair: {
        render: RockingChair,
        tags: "rocking chair:furniture:chair:furniture:seat",
        categories: [
            "furniture"
        ]
    },
    RollerCoaster: {
        render: RollerCoaster,
        tags: "roller coaster:maps:attraction:entertainment:amusement park:theme park:funfair",
        categories: [
            "maps"
        ]
    },
    Rotate3D: {
        render: Rotate3D,
        tags: "rotate 3 d:design:gizmo:transform:orientation:orbit",
        categories: [
            "design"
        ]
    },
    RotateCcw: {
        render: RotateCcw,
        tags: "rotate ccw:arrows:design:photography:arrow:left:counter-clockwise:restart:reload:rerun:refresh:backup:undo",
        categories: [
            "arrows",
            "design",
            "photography"
        ]
    },
    RotateCw: {
        render: RotateCw,
        tags: "rotate cw:arrows:design:photography:arrow:right:clockwise:refresh:reload:rerun:redo",
        categories: [
            "arrows",
            "design",
            "photography"
        ]
    },
    RouteOff: {
        render: RouteOff,
        tags: "route off:maps:navigation:path:journey:planner:points:stops:stations:reset:clear:cancelled:closed:blocked",
        categories: [
            "maps",
            "navigation"
        ]
    },
    Route: {
        render: Route,
        tags: "route:maps:navigation:path:journey:planner:points:stops:stations",
        categories: [
            "maps",
            "navigation"
        ]
    },
    Router: {
        render: Router,
        tags: "router:development:devices:connectivity:home:computer:server:cloud",
        categories: [
            "development",
            "devices",
            "connectivity",
            "home"
        ]
    },
    Rows2: {
        render: Rows2,
        tags: "rows 2:layout:design:text:lines:list:queue:preview:panel:paragraphs:parallel:series:split:vertical:horizontal:half:center:middle:even:drawer",
        categories: [
            "layout",
            "design",
            "text"
        ]
    },
    Rows3: {
        render: Rows3,
        tags: "rows 3:layout:design:text:lines:list:queue:preview:paragraphs:parallel:series:split:vertical:horizontal:half:center:middle:even:drawers",
        categories: [
            "layout",
            "design",
            "text"
        ]
    },
    Rows4: {
        render: Rows4,
        tags: "rows 4:layout:design:text:lines:list:queue:preview:paragraphs:parallel:series:split:vertical:horizontal:half:center:middle:even:drawers:grill",
        categories: [
            "layout",
            "design",
            "text"
        ]
    },
    Rss: {
        render: Rss,
        tags: "rss:development:social:feed:subscribe:news:updates:notifications:content:blog:articles:broadcast:syndication:reader:channels:posts:publishing:digest:alert:following:inbox:newsletter:weblog:podcast",
        categories: [
            "development",
            "social"
        ]
    },
    Ruler: {
        render: Ruler,
        tags: "ruler:tools:design:layout:measurements:centimeters:cm:millimeters:mm:metre:foot:feet:inches:units:size:length:width:height:dimensions:depth:breadth:extent:stationery",
        categories: [
            "tools",
            "design",
            "layout"
        ]
    },
    RussianRuble: {
        render: RussianRuble,
        tags: "russian ruble:currency:money:currency:money:payment",
        categories: [
            "currency",
            "money"
        ]
    },
    Sailboat: {
        render: Sailboat,
        tags: "sailboat:transportation:travel:ship:boat:harbor:harbour:dock",
        categories: [
            "transportation",
            "travel"
        ]
    },
    Salad: {
        render: Salad,
        tags: "salad:food beverage:emoji:food:vegetarian:dish:restaurant:course:meal:side:vegetables:health",
        categories: [
            "food-beverage",
            "emoji"
        ]
    },
    Sandwich: {
        render: Sandwich,
        tags: "sandwich:food beverage:food:snack:dish:restaurant:lunch:meal",
        categories: [
            "food-beverage"
        ]
    },
    SatelliteDish: {
        render: SatelliteDish,
        tags: "satellite dish:connectivity:devices:multimedia:antenna:receiver:dish aerial:saucer",
        categories: [
            "connectivity",
            "devices",
            "multimedia"
        ]
    },
    Satellite: {
        render: Satellite,
        tags: "satellite:connectivity:science:space station:orbit:transmitter",
        categories: [
            "connectivity",
            "science"
        ]
    },
    SaveAll: {
        render: SaveAll,
        tags: "save all:text:files:floppy disks:copy",
        categories: [
            "text",
            "files"
        ]
    },
    Save: {
        render: Save,
        tags: "save:text:files:floppy disk",
        categories: [
            "text",
            "files"
        ]
    },
    Scale3D: {
        render: Scale3D,
        tags: "scale 3 d:design:gizmo:transform:size",
        categories: [
            "design"
        ]
    },
    Scale: {
        render: Scale,
        tags: "scale:maps:balance:legal:license:right:rule:law",
        categories: [
            "maps"
        ]
    },
    Scaling: {
        render: Scaling,
        tags: "scaling:design:scale:resize:design",
        categories: [
            "design"
        ]
    },
    ScanBarcode: {
        render: ScanBarcode,
        tags: "scan barcode:shopping:devices:checkout:till:cart:transaction:purchase:buy:product:packaging:retail:consumer",
        categories: [
            "shopping",
            "devices"
        ]
    },
    ScanEye: {
        render: ScanEye,
        tags: "scan eye:photography:multimedia:layout:accessibility:security:devices:account:preview:zoom:expand:fullscreen:gallery:image:camera:watch:surveillance:retina:focus:lens:biometric:identification:authentication:access:login",
        categories: [
            "photography",
            "multimedia",
            "layout",
            "accessibility",
            "security",
            "devices",
            "account"
        ]
    },
    ScanFace: {
        render: ScanFace,
        tags: "scan face:account:security:devices:social:face:biometric:identification:authentication:2fa:access:login:dashed",
        categories: [
            "account",
            "security",
            "devices",
            "social"
        ]
    },
    ScanLine: {
        render: ScanLine,
        tags: "scan line:devices:shopping:checkout:till:cart:transaction:purchase:buy:product:packaging:retail:consumer:qr-code:dashed",
        categories: [
            "devices",
            "shopping"
        ]
    },
    ScanSearch: {
        render: ScanSearch,
        tags: "scan search:photography:multimedia:layout:accessibility:preview:zoom:expand:fullscreen:gallery:image:focus:lens",
        categories: [
            "photography",
            "multimedia",
            "layout",
            "accessibility"
        ]
    },
    ScanText: {
        render: ScanText,
        tags: "scan text:text:devices:recognition:read:translate:copy:lines",
        categories: [
            "text",
            "devices"
        ]
    },
    Scan: {
        render: Scan,
        tags: "scan:devices:shopping:security:social:gaming:qr-code:barcode:checkout:augmented reality:ar:target:surveillance:camera:lens:focus:frame:select:box:boundary:bounds:area:square:dashed",
        categories: [
            "devices",
            "shopping",
            "security",
            "social",
            "gaming"
        ]
    },
    ScatterChart: {
        render: ScatterChart,
        tags: "scatter chart:charts:statistics:diagram:graph",
        categories: [
            "charts"
        ]
    },
    School2: {
        render: School2,
        tags: "school 2:buildings:maps:building:education:childhood:university",
        categories: [
            "buildings",
            "maps"
        ]
    },
    School: {
        render: School,
        tags: "school:buildings:maps:building:education:childhood:university:learning:campus:scholar:student:lecture:degree:course:academia:study:knowledge:classroom:research:diploma:graduation:professor:tutorial:homework:assignment:exam",
        categories: [
            "buildings",
            "maps"
        ]
    },
    ScissorsLineDashed: {
        render: ScissorsLineDashed,
        tags: "scissors line dashed:design:tools:cut here:along:snip:chop:stationery:crafts:instructions:diagram",
        categories: [
            "design",
            "tools"
        ]
    },
    ScissorsSquareDashedBottom: {
        render: ScissorsSquareDashedBottom,
        tags: "scissors square dashed bottom:text:design:tools:files:development:cut:snippet:chop:stationery:crafts",
        categories: [
            "text",
            "design",
            "tools",
            "files",
            "development"
        ]
    },
    ScissorsSquare: {
        render: ScissorsSquare,
        tags: "scissors square:text:design:tools:files:development:cut:snippet:chop:stationery:crafts:toolbar:button",
        categories: [
            "text",
            "design",
            "tools",
            "files",
            "development"
        ]
    },
    Scissors: {
        render: Scissors,
        tags: "scissors:text:design:tools:cut:snip:chop:stationery:crafts",
        categories: [
            "text",
            "design",
            "tools"
        ]
    },
    ScreenShareOff: {
        render: ScreenShareOff,
        tags: "screen share off:connectivity:devices:communication:desktop:disconnect:monitor",
        categories: [
            "connectivity",
            "devices",
            "communication"
        ]
    },
    ScreenShare: {
        render: ScreenShare,
        tags: "screen share:connectivity:devices:communication:host:desktop:monitor",
        categories: [
            "connectivity",
            "devices",
            "communication"
        ]
    },
    ScrollText: {
        render: ScrollText,
        tags: "scroll text:gaming:development:text:paper:log:scripture:document:notes:parchment:list:long:script:story:code:coding",
        categories: [
            "gaming",
            "development",
            "text"
        ]
    },
    Scroll: {
        render: Scroll,
        tags: "scroll:gaming:development:text:paper:log:scripture:document:notes:parchment:list:long:script:story:code:coding",
        categories: [
            "gaming",
            "development",
            "text"
        ]
    },
    SearchCheck: {
        render: SearchCheck,
        tags: "search check:text:account:social:find:scan:magnifier:magnifying glass:found:correct:complete:tick",
        categories: [
            "text",
            "account",
            "social"
        ]
    },
    SearchCode: {
        render: SearchCode,
        tags: "search code:text:account:social:development:find:scan:magnifier:magnifying glass:grep:chevrons:<>",
        categories: [
            "text",
            "account",
            "social",
            "development"
        ]
    },
    SearchSlash: {
        render: SearchSlash,
        tags: "search slash:text:account:social:find:scan:magnifier:magnifying glass:stop:clear:cancel:abort:/",
        categories: [
            "text",
            "account",
            "social"
        ]
    },
    SearchX: {
        render: SearchX,
        tags: "search x:text:account:social:find:scan:magnifier:magnifying glass:stop:clear:cancel:abort",
        categories: [
            "text",
            "account",
            "social"
        ]
    },
    Search: {
        render: Search,
        tags: "search:text:account:social:find:scan:magnifier:magnifying glass",
        categories: [
            "text",
            "account",
            "social"
        ]
    },
    SendHorizontal: {
        render: SendHorizontal,
        tags: "send horizontal:mail:communication:connectivity:email:message:mail:paper airplane:paper aeroplane:submit",
        categories: [
            "mail",
            "communication",
            "connectivity"
        ]
    },
    SendToBack: {
        render: SendToBack,
        tags: "send to back:design:layout:bring:send:move:under:back:backwards:overlap:layer:order",
        categories: [
            "design",
            "layout"
        ]
    },
    Send: {
        render: Send,
        tags: "send:mail:communication:connectivity:email:message:mail:paper airplane:paper aeroplane:submit",
        categories: [
            "mail",
            "communication",
            "connectivity"
        ]
    },
    SeparatorHorizontal: {
        render: SeparatorHorizontal,
        tags: "separator horizontal:text:arrows:layout:move:split",
        categories: [
            "text",
            "arrows",
            "layout"
        ]
    },
    SeparatorVertical: {
        render: SeparatorVertical,
        tags: "separator vertical:text:arrows:layout:move:split",
        categories: [
            "text",
            "arrows",
            "layout"
        ]
    },
    ServerCog: {
        render: ServerCog,
        tags: "server cog:development:devices:cloud:storage:computing:cog:gear",
        categories: [
            "development",
            "devices"
        ]
    },
    ServerCrash: {
        render: ServerCrash,
        tags: "server crash:development:devices:cloud:storage:problem:error",
        categories: [
            "development",
            "devices"
        ]
    },
    ServerOff: {
        render: ServerOff,
        tags: "server off:development:devices:cloud:storage",
        categories: [
            "development",
            "devices"
        ]
    },
    Server: {
        render: Server,
        tags: "server:development:devices:cloud:storage",
        categories: [
            "development",
            "devices"
        ]
    },
    Settings2: {
        render: Settings2,
        tags: "settings 2:account:cog:edit:gear:preferences",
        categories: [
            "account"
        ]
    },
    Settings: {
        render: Settings,
        tags: "settings:account:cog:edit:gear:preferences",
        categories: [
            "account"
        ]
    },
    Shapes: {
        render: Shapes,
        tags: "shapes:shapes:gaming:triangle:equilateral:square:circle:classification:different:collection:toy:blocks:learning",
        categories: [
            "shapes",
            "gaming"
        ]
    },
    Share2: {
        render: Share2,
        tags: "share 2:account:social:network:connections",
        categories: [
            "account",
            "social"
        ]
    },
    Share: {
        render: Share,
        tags: "share:account:social:network:connections",
        categories: [
            "account",
            "social"
        ]
    },
    Sheet: {
        render: Sheet,
        tags: "sheet:text:files:spreadsheets:table:excel",
        categories: [
            "text",
            "files"
        ]
    },
    Shell: {
        render: Shell,
        tags: "shell:animals:development:nature:science:travel:food beverage:home:beach:sand:holiday:sealife:fossil:ammonite:biology:ocean:terminal:command line:session:bash:zsh:roll:wrap:chewing gum:bubble gum:sweet:sugar:hosepipe:carpet:string:spiral:spinner:hypnotise:hypnosis",
        categories: [
            "animals",
            "development",
            "nature",
            "science",
            "travel",
            "food-beverage",
            "home"
        ]
    },
    ShieldAlert: {
        render: ShieldAlert,
        tags: "shield alert:account:security:development:notifications:gaming:unshielded:cybersecurity:insecure:unsecured:safety:unsafe:protection:unprotected:guardian:unguarded:unarmored:unarmoured:defenseless:defenceless:undefended:defender:blocked:stopped:intercepted:interception:saved:thwarted:threat:prevention:unprevented:antivirus:vigilance:vigilant:detection:detected:scanned:found:exploit:vulnerability:vulnerable:weakness:infection:infected:comprimised:data leak:audited:admin:verification:unverified:uncertified:warning:emergency:attention:urgent:alarm:crest:bravery:strength:tough:attacked:damaged:injured:hit:expired:disabled:inactive:error:exclamation mark:!",
        categories: [
            "account",
            "security",
            "development",
            "notifications",
            "gaming"
        ]
    },
    ShieldBan: {
        render: ShieldBan,
        tags: "shield ban:account:security:development:gaming:unshielded:cybersecurity:insecure:unsecured:safety:unsafe:protection:unprotected:guardian:unguarded:unarmored:unarmoured:defenseless:defenceless:undefended:defender:blocked:stopped:intercepted:interception:saved:thwarted:threat:prevention:unprevented:antivirus:vigilance:vigilant:detection:detected:scanned:found:exploit:vulnerability:vulnerable:weakness:infection:infected:comprimised:data leak:audited:admin:verification:unverified:uncertified:cancel:error:crest:bravery:attacked:damaged:injured:hit:expired:eliminated:disabled:inactive:/",
        categories: [
            "account",
            "security",
            "development",
            "gaming"
        ]
    },
    ShieldCheck: {
        render: ShieldCheck,
        tags: "shield check:account:security:development:gaming:cybersecurity:secured:safety:protection:protected:guardian:guarded:armored:armoured:defense:defence:defended:blocked:threat:prevention:prevented:antivirus:vigilance:vigilant:active:activated:enabled:detection:scanned:found:strength:strong:tough:invincible:invincibility:invulnerable:undamaged:audited:admin:verification:verified:certification:certified:tested:passed:qualified:cleared:cleaned:disinfected:uninfected:task:completed:todo:done:ticked:checked:crest:bravery",
        categories: [
            "account",
            "security",
            "development",
            "gaming"
        ]
    },
    ShieldEllipsis: {
        render: ShieldEllipsis,
        tags: "shield ellipsis:account:security:development:gaming:cybersecurity:securing:protecting:guarding:armoring:armouring:defending:blocking:preventing:antivirus:detecting:scanning:finding:auditing:admin:verifying:crest:upgrading:loader:loading:throbber:progress:dots:more:etc:...:…",
        categories: [
            "account",
            "security",
            "development",
            "gaming"
        ]
    },
    ShieldHalf: {
        render: ShieldHalf,
        tags: "shield half:account:security:development:gaming:cybersecurity:secure:safety:protection:guardian:armored:armoured:defense:defence:defender:block:threat:prevention:antivirus:vigilance:vigilant:detection:scan:strength:strong:tough:invincible:invincibility:invulnerable:undamaged:audit:admin:verification:crest:logo:sigil:flag:team:faction:fraternity:university:college:academy:school:education:uniform:bravery:knight:foot soldier:infantry:trooper:pawn:battle:war:military:ranking:army:cadet:scout",
        categories: [
            "account",
            "security",
            "development",
            "gaming"
        ]
    },
    ShieldMinus: {
        render: ShieldMinus,
        tags: "shield minus:account:security:development:gaming:unshield:cybersecurity:unsecure:unguard:unblock:antivirus:clean:clear:disinfect:patch:fix:stop:cancel:remove:relax:admin:crest:bravery:weakened:damaged:hit:unarm:disable:deactivate:decommission:downgraded:minimum:-",
        categories: [
            "account",
            "security",
            "development",
            "gaming"
        ]
    },
    ShieldOff: {
        render: ShieldOff,
        tags: "shield off:account:security:development:gaming:unshielded:cybersecurity:insecure:unsecured:safety:unsafe:protection:unprotected:guardian:unguarded:unarmored:unarmoured:defenseless:defenceless:undefended:defender:interception:threat:prevention:unprevented:antivirus:detection:undetected:exploit:vulnerability:vulnerable:weakness:infected:infection:comprimised:data leak:unaudited:admin:verification:unverified:inactive:cancelled:error:crest:bravery:damaged:injured:hit:expired:eliminated",
        categories: [
            "account",
            "security",
            "development",
            "gaming"
        ]
    },
    ShieldPlus: {
        render: ShieldPlus,
        tags: "shield plus:account:security:development:gaming:medical:cybersecurity:secure:safety:protection:guardian:armored:armoured:defense:defence:defender:block:threat:prevention:antivirus:vigilance:vigilant:detection:scan:strength:strong:tough:invincible:invincibility:invulnerable:undamaged:extra:added:professional:enterprise:full:maximum:upgraded:ultra:activate:enable:audit:admin:verification:crest:medic:+",
        categories: [
            "account",
            "security",
            "development",
            "gaming",
            "medical"
        ]
    },
    ShieldQuestion: {
        render: ShieldQuestion,
        tags: "shield question:account:security:development:gaming:unshielded:cybersecurity:insecure:unsecured:safety:unsafe:protection:unprotected:guardian:unguarded:unarmored:unarmoured:defenseless:defenceless:undefended:defender:threat:prevention:unprevented:antivirus:vigilance:vigilant:detection:undetected:scan:find:exploit:vulnerability:vulnerable:weakness:infection:comprimised:data leak:audit:admin:verification:unverified:uncertified:uncertain:unknown:inactive:crest:question mark:?",
        categories: [
            "account",
            "security",
            "development",
            "gaming"
        ]
    },
    ShieldX: {
        render: ShieldX,
        tags: "shield x:account:security:development:gaming:unshielded:cybersecurity:insecure:unsecured:safety:unsafe:protection:unprotected:guardian:unguarded:unarmored:unarmoured:defenseless:defenceless:undefended:defender:blocked:stopped:intercepted:interception:saved:thwarted:threat:prevention:prevented:antivirus:vigilance:vigilant:detection:detected:scanned:found:exploit:vulnerability:vulnerable:weakness:infection:infected:comprimised:data leak:audited:admin:verification:unverified:inactive:cancel:error:wrong:false:crest:bravery:attacked:damaged:injured:hit:dead:deceased:expired:eliminated:exterminated",
        categories: [
            "account",
            "security",
            "development",
            "gaming"
        ]
    },
    Shield: {
        render: Shield,
        tags: "shield:account:security:development:gaming:shapes:cybersecurity:secure:safety:protection:guardian:armored:armoured:defense:defence:defender:block:threat:prevention:antivirus:vigilance:vigilant:detection:scan:find:strength:strong:tough:invincible:invincibility:invulnerable:undamaged:audit:admin:verification:crest:bravery:knight:foot soldier:infantry:trooper:pawn:battle:war:military:army:cadet:scout",
        categories: [
            "account",
            "security",
            "development",
            "gaming",
            "shapes"
        ]
    },
    ShipWheel: {
        render: ShipWheel,
        tags: "ship wheel:transportation:travel:maps:steering:rudder:boat:knots:nautical mile:maritime:sailing:yacht:cruise:ocean liner:tanker:vessel:navy:trip",
        categories: [
            "transportation",
            "travel",
            "maps"
        ]
    },
    Ship: {
        render: Ship,
        tags: "ship:transportation:travel:maps:boat:knots:nautical mile:maritime:sailing:yacht:cruise:ocean liner:tanker:vessel:navy:trip",
        categories: [
            "transportation",
            "travel",
            "maps"
        ]
    },
    Shirt: {
        render: Shirt,
        tags: "shirt:shopping:t-shirt:shopping:store:clothing:clothes",
        categories: [
            "shopping"
        ]
    },
    ShoppingBag: {
        render: ShoppingBag,
        tags: "shopping bag:shopping:ecommerce:cart:purchase:store",
        categories: [
            "shopping"
        ]
    },
    ShoppingBasket: {
        render: ShoppingBasket,
        tags: "shopping basket:shopping:cart:e-commerce:store:purchase:products:items:ingredients",
        categories: [
            "shopping"
        ]
    },
    ShoppingCart: {
        render: ShoppingCart,
        tags: "shopping cart:shopping:trolley:cart:basket:e-commerce:store:purchase:products:items:ingredients",
        categories: [
            "shopping"
        ]
    },
    Shovel: {
        render: Shovel,
        tags: "shovel:nature:tools:gaming:dig:spade:treasure",
        categories: [
            "nature",
            "tools",
            "gaming"
        ]
    },
    ShowerHead: {
        render: ShowerHead,
        tags: "shower head:home:travel:shower:bath:bathroom:amenities:services",
        categories: [
            "home",
            "travel"
        ]
    },
    Shrink: {
        render: Shrink,
        tags: "shrink:layout:arrows:scale:fullscreen",
        categories: [
            "layout",
            "arrows"
        ]
    },
    Shrub: {
        render: Shrub,
        tags: "shrub:nature:forest:undergrowth:park:nature",
        categories: [
            "nature"
        ]
    },
    Shuffle: {
        render: Shuffle,
        tags: "shuffle:multimedia:arrows:music:random:reorder",
        categories: [
            "multimedia",
            "arrows"
        ]
    },
    SigmaSquare: {
        render: SigmaSquare,
        tags: "sigma square:text:maths:sum:calculate:formula:maths:enumeration:enumerate",
        categories: [
            "text",
            "maths"
        ]
    },
    Sigma: {
        render: Sigma,
        tags: "sigma:text:maths:sum:calculate:formula:maths:enumeration:enumerate",
        categories: [
            "text",
            "maths"
        ]
    },
    SignalHigh: {
        render: SignalHigh,
        tags: "signal high:connectivity:connection:wireless:gsm:phone:2g:3g:4g:5g",
        categories: [
            "connectivity"
        ]
    },
    SignalLow: {
        render: SignalLow,
        tags: "signal low:connectivity:connection:wireless:gsm:phone:2g:3g:4g:5g",
        categories: [
            "connectivity"
        ]
    },
    SignalMedium: {
        render: SignalMedium,
        tags: "signal medium:connectivity:connection:wireless:gsm:phone:2g:3g:4g:5g",
        categories: [
            "connectivity"
        ]
    },
    SignalZero: {
        render: SignalZero,
        tags: "signal zero:connectivity:connection:wireless:gsm:phone:2g:3g:4g:5g:lost",
        categories: [
            "connectivity"
        ]
    },
    Signal: {
        render: Signal,
        tags: "signal:connectivity:connection:wireless:gsm:phone:2g:3g:4g:5g",
        categories: [
            "connectivity"
        ]
    },
    SignpostBig: {
        render: SignpostBig,
        tags: "signpost big:arrows:navigation:development:gaming:bidirectional:left:right:east:west",
        categories: [
            "arrows",
            "navigation",
            "development",
            "gaming"
        ]
    },
    Signpost: {
        render: Signpost,
        tags: "signpost:arrows:navigation:development:gaming:bidirectional:left:right:east:west",
        categories: [
            "arrows",
            "navigation",
            "development",
            "gaming"
        ]
    },
    Siren: {
        render: Siren,
        tags: "siren:medical:police:ambulance:emergency:security:alert:alarm:light",
        categories: [
            "medical"
        ]
    },
    SkipBack: {
        render: SkipBack,
        tags: "skip back:multimedia:arrows:arrow:previous:music",
        categories: [
            "multimedia",
            "arrows"
        ]
    },
    SkipForward: {
        render: SkipForward,
        tags: "skip forward:multimedia:arrows:arrow:skip:next:music",
        categories: [
            "multimedia",
            "arrows"
        ]
    },
    Skull: {
        render: Skull,
        tags: "skull:gaming:death:danger:bone",
        categories: [
            "gaming"
        ]
    },
    Slack: {
        render: Slack,
        tags: "slack:account:social:communication:brands:development:logo",
        categories: [
            "account",
            "social",
            "communication",
            "brands",
            "development"
        ]
    },
    SlashSquare: {
        render: SlashSquare,
        tags: "slash square:shapes:development:maths:git:diff:ignored:divide:division:shortcut:or:/",
        categories: [
            "shapes",
            "development",
            "maths"
        ]
    },
    Slash: {
        render: Slash,
        tags: "slash:development:maths:divide:division:or:/",
        categories: [
            "development",
            "maths"
        ]
    },
    Slice: {
        render: Slice,
        tags: "slice:design:cutter:scalpel:knife",
        categories: [
            "design"
        ]
    },
    SlidersHorizontal: {
        render: SlidersHorizontal,
        tags: "sliders horizontal:account:settings:filters:controls",
        categories: [
            "account"
        ]
    },
    Sliders: {
        render: Sliders,
        tags: "sliders:account:settings:controls",
        categories: [
            "account"
        ]
    },
    SmartphoneCharging: {
        render: SmartphoneCharging,
        tags: "smartphone charging:connectivity:devices:phone:cellphone:device:power:screen",
        categories: [
            "connectivity",
            "devices"
        ]
    },
    SmartphoneNfc: {
        render: SmartphoneNfc,
        tags: "smartphone nfc:communication:money:devices:contactless:payment:near-field communication:screen",
        categories: [
            "communication",
            "money",
            "devices"
        ]
    },
    Smartphone: {
        render: Smartphone,
        tags: "smartphone:connectivity:devices:phone:cellphone:device:screen",
        categories: [
            "connectivity",
            "devices"
        ]
    },
    SmilePlus: {
        render: SmilePlus,
        tags: "smile plus:emoji:social:notifications:communication:emoji:face:happy:good:emotion:react:reaction:add",
        categories: [
            "emoji",
            "social",
            "notifications",
            "communication"
        ]
    },
    Smile: {
        render: Smile,
        tags: "smile:emoji:account:emoji:face:happy:good:emotion",
        categories: [
            "emoji",
            "account"
        ]
    },
    Snail: {
        render: Snail,
        tags: "snail:animals:food beverage:animal:insect:slow:speed:delicacy:spiral",
        categories: [
            "animals",
            "food-beverage"
        ]
    },
    Snowflake: {
        render: Snowflake,
        tags: "snowflake:weather:seasons:cold:weather:freeze:snow:winter",
        categories: [
            "weather",
            "seasons"
        ]
    },
    Sofa: {
        render: Sofa,
        tags: "sofa:furniture:armchair:furniture:leisure:lounge:loveseat:couch",
        categories: [
            "furniture"
        ]
    },
    Soup: {
        render: Soup,
        tags: "soup:food beverage:food:dish:restaurant:course:meal:bowl:starter",
        categories: [
            "food-beverage"
        ]
    },
    Space: {
        render: Space,
        tags: "space:text:text:selection:letters:characters:font:typography",
        categories: [
            "text"
        ]
    },
    Spade: {
        render: Spade,
        tags: "spade:shapes:gaming:shape:suit:playing:cards",
        categories: [
            "shapes",
            "gaming"
        ]
    },
    Sparkle: {
        render: Sparkle,
        tags: "sparkle:shapes:star:effect:filter:night:magic:shiny:glitter:twinkle:celebration",
        categories: [
            "shapes"
        ]
    },
    Sparkles: {
        render: Sparkles,
        tags: "sparkles:shapes:cursors:multimedia:gaming:weather:stars:effect:filter:night:magic",
        categories: [
            "shapes",
            "cursors",
            "multimedia",
            "gaming",
            "weather"
        ]
    },
    Speaker: {
        render: Speaker,
        tags: "speaker:multimedia:devices:sound:audio:music:tweeter:subwoofer:bass:production:producer:dj",
        categories: [
            "multimedia",
            "devices"
        ]
    },
    Speech: {
        render: Speech,
        tags: "speech:accessibility:communication:disability:disabled:dda:human:accessibility:people:sound",
        categories: [
            "accessibility",
            "communication"
        ]
    },
    SpellCheck2: {
        render: SpellCheck2,
        tags: "spell check 2:text:development:spelling:error:mistake:oversight:typo:correction:code:linter:a",
        categories: [
            "text",
            "development"
        ]
    },
    SpellCheck: {
        render: SpellCheck,
        tags: "spell check:text:development:spelling:error:mistake:oversight:typo:correction:code:linter:a",
        categories: [
            "text",
            "development"
        ]
    },
    Spline: {
        render: Spline,
        tags: "spline:design:path:pen:tool:shape:curve:draw",
        categories: [
            "design"
        ]
    },
    SplitSquareHorizontal: {
        render: SplitSquareHorizontal,
        tags: "split square horizontal:layout:split:divide",
        categories: [
            "layout"
        ]
    },
    SplitSquareVertical: {
        render: SplitSquareVertical,
        tags: "split square vertical:layout:split:divide",
        categories: [
            "layout"
        ]
    },
    Split: {
        render: Split,
        tags: "split:development:arrows:break:disband:divide:separate:branch:disunite",
        categories: [
            "development",
            "arrows"
        ]
    },
    SprayCan: {
        render: SprayCan,
        tags: "spray can:design:tools:paint:color:graffiti:decoration:aerosol:deodorant:shaving foam:air freshener",
        categories: [
            "design",
            "tools"
        ]
    },
    Sprout: {
        render: Sprout,
        tags: "sprout:nature:gaming:leaf:nature:plant",
        categories: [
            "nature",
            "gaming"
        ]
    },
    SquareDashedBottomCode: {
        render: SquareDashedBottomCode,
        tags: "square dashed bottom code:shapes:development:files:rectangle:aspect ratio:1:1:shape:snippet:code:coding",
        categories: [
            "shapes",
            "development",
            "files"
        ]
    },
    SquareDashedBottom: {
        render: SquareDashedBottom,
        tags: "square dashed bottom:shapes:development:files:rectangle:aspect ratio:1:1:shape:snippet:code:coding",
        categories: [
            "shapes",
            "development",
            "files"
        ]
    },
    SquarePen: {
        render: SquarePen,
        tags: "square pen:text:pencil:change:create:draw:sketch:draft:writer:writing:biro:ink:marker:felt tip:stationery:artist",
        categories: [
            "text"
        ]
    },
    SquareRadical: {
        render: SquareRadical,
        tags: "square radical:development:maths:shapes:calculate:formula:maths:operator:root:square:symbol",
        categories: [
            "development",
            "maths",
            "shapes"
        ]
    },
    SquareStack: {
        render: SquareStack,
        tags: "square stack:text:files:development:versions:clone:copy:duplicate:multiple:revisions:version control:backup:history",
        categories: [
            "text",
            "files",
            "development"
        ]
    },
    SquareUserRound: {
        render: SquareUserRound,
        tags: "square user round:account:shapes:person:account:contact",
        categories: [
            "account",
            "shapes"
        ]
    },
    SquareUser: {
        render: SquareUser,
        tags: "square user:account:shapes:person:account:contact",
        categories: [
            "account",
            "shapes"
        ]
    },
    Square: {
        render: Square,
        tags: "square:shapes:rectangle:aspect ratio:1:1:shape",
        categories: [
            "shapes"
        ]
    },
    Squircle: {
        render: Squircle,
        tags: "squircle:shapes:shape",
        categories: [
            "shapes"
        ]
    },
    Squirrel: {
        render: Squirrel,
        tags: "squirrel:animals:animal:rodent:pet:pest:nuts:retrieve:updates:storage:stash",
        categories: [
            "animals"
        ]
    },
    Stamp: {
        render: Stamp,
        tags: "stamp:design:cursors:tools:maps:mark:print:clone:loyalty:library",
        categories: [
            "design",
            "cursors",
            "tools",
            "maps"
        ]
    },
    StarHalf: {
        render: StarHalf,
        tags: "star half:social:multimedia:bookmark:favorite:like:review:rating",
        categories: [
            "social",
            "multimedia"
        ]
    },
    StarOff: {
        render: StarOff,
        tags: "star off:multimedia:social:dislike:unlike:remove:unrate",
        categories: [
            "multimedia",
            "social"
        ]
    },
    Star: {
        render: Star,
        tags: "star:account:social:shapes:multimedia:weather:emoji:gaming:bookmark:favorite:like:review:rating",
        categories: [
            "account",
            "social",
            "shapes",
            "multimedia",
            "weather",
            "emoji",
            "gaming"
        ]
    },
    StepBack: {
        render: StepBack,
        tags: "step back:multimedia:arrows:arrow:previous:music:left:reverse",
        categories: [
            "multimedia",
            "arrows"
        ]
    },
    StepForward: {
        render: StepForward,
        tags: "step forward:multimedia:arrows:arrow:next:music:right:continue",
        categories: [
            "multimedia",
            "arrows"
        ]
    },
    Stethoscope: {
        render: Stethoscope,
        tags: "stethoscope:science:medical:phonendoscope:medical:heart:lungs:sound",
        categories: [
            "science",
            "medical"
        ]
    },
    Sticker: {
        render: Sticker,
        tags: "sticker:communication:social:reaction:emotion:smile:happy:feedback",
        categories: [
            "communication",
            "social"
        ]
    },
    StickyNote: {
        render: StickyNote,
        tags: "sticky note:communication:text:social:post-it:comment:annotation:reaction:memo:reminder:todo:task:idea:brainstorm:document:page:paper:sheet:stationary:office",
        categories: [
            "communication",
            "text",
            "social"
        ]
    },
    StopCircle: {
        render: StopCircle,
        tags: "stop circle:multimedia:shapes:media:music",
        categories: [
            "multimedia",
            "shapes"
        ]
    },
    Store: {
        render: Store,
        tags: "store:buildings:maps:shop:supermarket:stand:boutique:building",
        categories: [
            "buildings",
            "maps"
        ]
    },
    StretchHorizontal: {
        render: StretchHorizontal,
        tags: "stretch horizontal:layout:items:flex:justify:distribute",
        categories: [
            "layout"
        ]
    },
    StretchVertical: {
        render: StretchVertical,
        tags: "stretch vertical:layout:items:flex:justify:distribute",
        categories: [
            "layout"
        ]
    },
    Strikethrough: {
        render: Strikethrough,
        tags: "strikethrough:text:cross out:delete:remove:format",
        categories: [
            "text"
        ]
    },
    Subscript: {
        render: Subscript,
        tags: "subscript:text:text",
        categories: [
            "text"
        ]
    },
    SunDim: {
        render: SunDim,
        tags: "sun dim:accessibility:weather:brightness:dim:low:brightness low",
        categories: [
            "accessibility",
            "weather"
        ]
    },
    SunMedium: {
        render: SunMedium,
        tags: "sun medium:accessibility:weather:brightness:medium",
        categories: [
            "accessibility",
            "weather"
        ]
    },
    SunMoon: {
        render: SunMoon,
        tags: "sun moon:accessibility:night:dark:light:moon:sun:brightness:theme:auto theme:system theme:appearance",
        categories: [
            "accessibility"
        ]
    },
    SunSnow: {
        render: SunSnow,
        tags: "sun snow:weather:weather:air conditioning:temperature:hot:cold:seasons",
        categories: [
            "weather"
        ]
    },
    Sun: {
        render: Sun,
        tags: "sun:accessibility:weather:seasons:brightness:weather:light:summer",
        categories: [
            "accessibility",
            "weather",
            "seasons"
        ]
    },
    Sunrise: {
        render: Sunrise,
        tags: "sunrise:arrows:weather:time:weather:time:morning:day",
        categories: [
            "arrows",
            "weather",
            "time"
        ]
    },
    Sunset: {
        render: Sunset,
        tags: "sunset:arrows:weather:weather:time:evening:night",
        categories: [
            "arrows",
            "weather"
        ]
    },
    Superscript: {
        render: Superscript,
        tags: "superscript:text:text:exponent",
        categories: [
            "text"
        ]
    },
    SwatchBook: {
        render: SwatchBook,
        tags: "swatch book:design:home:furniture:photography:colors:colours:swatches:pantone:shades:tint:hue:saturation:brightness:theme:scheme:palette:samples:textile:carpet",
        categories: [
            "design",
            "home",
            "furniture",
            "photography"
        ]
    },
    SwissFranc: {
        render: SwissFranc,
        tags: "swiss franc:currency:money:currency:money:payment",
        categories: [
            "currency",
            "money"
        ]
    },
    SwitchCamera: {
        render: SwitchCamera,
        tags: "switch camera:communication:devices:photo:selfie:front:back",
        categories: [
            "communication",
            "devices"
        ]
    },
    Sword: {
        render: Sword,
        tags: "sword:gaming:tools:battle:challenge:game:war:weapon",
        categories: [
            "gaming",
            "tools"
        ]
    },
    Swords: {
        render: Swords,
        tags: "swords:gaming:tools:battle:challenge:game:war:weapon",
        categories: [
            "gaming",
            "tools"
        ]
    },
    Syringe: {
        render: Syringe,
        tags: "syringe:science:medical:medicine:medical:needle:pump:plunger:nozzle:blood",
        categories: [
            "science",
            "medical"
        ]
    },
    Table2: {
        render: Table2,
        tags: "table 2:text:files:spreadsheet:grid",
        categories: [
            "text",
            "files"
        ]
    },
    TableCellsMerge: {
        render: TableCellsMerge,
        tags: "table cells merge:text:files:spreadsheet:grid:row",
        categories: [
            "text",
            "files"
        ]
    },
    TableCellsSplit: {
        render: TableCellsSplit,
        tags: "table cells split:text:files:spreadsheet:grid:row",
        categories: [
            "text",
            "files"
        ]
    },
    TableColumnsSplit: {
        render: TableColumnsSplit,
        tags: "table columns split:text:files:spreadsheet:grid:cut:break:divide:separate:segment",
        categories: [
            "text",
            "files"
        ]
    },
    TableProperties: {
        render: TableProperties,
        tags: "table properties:text:development:files:property list:plist:spreadsheet:grid:dictionary:object:hash",
        categories: [
            "text",
            "development",
            "files"
        ]
    },
    TableRowsSplit: {
        render: TableRowsSplit,
        tags: "table rows split:text:files:spreadsheet:grid:cut:break:divide:separate:segment",
        categories: [
            "text",
            "files"
        ]
    },
    Table: {
        render: Table,
        tags: "table:text:files:spreadsheet:grid",
        categories: [
            "text",
            "files"
        ]
    },
    TabletSmartphone: {
        render: TabletSmartphone,
        tags: "tablet smartphone:devices:design:development:tools:responsive:screens:browser:testing:mobile",
        categories: [
            "devices",
            "design",
            "development",
            "tools"
        ]
    },
    Tablet: {
        render: Tablet,
        tags: "tablet:devices:device",
        categories: [
            "devices"
        ]
    },
    Tablets: {
        render: Tablets,
        tags: "tablets:medical:medicine:medication:drug:prescription:pills:pharmacy",
        categories: [
            "medical"
        ]
    },
    Tag: {
        render: Tag,
        tags: "tag:account:label:badge:ticket:mark",
        categories: [
            "account"
        ]
    },
    Tags: {
        render: Tags,
        tags: "tags:account:labels:badges:tickets:marks:copy:multiple",
        categories: [
            "account"
        ]
    },
    Tally1: {
        render: Tally1,
        tags: "tally 1:maths:gaming:count:score:enumerate:days:one:1:first:bar:prison:cell:sentence",
        categories: [
            "maths",
            "gaming"
        ]
    },
    Tally2: {
        render: Tally2,
        tags: "tally 2:maths:gaming:count:score:enumerate:days:two:2:second:double:bars:prison:cell:sentence",
        categories: [
            "maths",
            "gaming"
        ]
    },
    Tally3: {
        render: Tally3,
        tags: "tally 3:maths:gaming:count:score:enumerate:days:three:3:third:triple:bars:prison:cell:sentence",
        categories: [
            "maths",
            "gaming"
        ]
    },
    Tally4: {
        render: Tally4,
        tags: "tally 4:maths:gaming:count:score:enumerate:days:4:fourth:quadruple:bars:prison:cell:sentence",
        categories: [
            "maths",
            "gaming"
        ]
    },
    Tally5: {
        render: Tally5,
        tags: "tally 5:maths:gaming:count:score:enumerate:days:five:5:fifth:bars:prison:cell:sentence:slash:/",
        categories: [
            "maths",
            "gaming"
        ]
    },
    Tangent: {
        render: Tangent,
        tags: "tangent:shapes:maths:design:tools:tangential:shape:circle:geometry:trigonometry:bezier curve",
        categories: [
            "shapes",
            "maths",
            "design",
            "tools"
        ]
    },
    Target: {
        render: Target,
        tags: "target:brands:gaming:logo:bullseye:deadline:projects:overview:work:productivity",
        categories: [
            "brands",
            "gaming"
        ]
    },
    Telescope: {
        render: Telescope,
        tags: "telescope:science:development:tools:astronomy:space:discovery:exploration:explore:vision:perspective:focus:stargazing:observe:view",
        categories: [
            "science",
            "development",
            "tools"
        ]
    },
    TentTree: {
        render: TentTree,
        tags: "tent tree:travel:nature:camping:campsite:holiday:retreat:nomadic:wilderness:outdoors",
        categories: [
            "travel",
            "nature"
        ]
    },
    Tent: {
        render: Tent,
        tags: "tent:travel:nature:sustainability:tipi:teepee:wigwam:lodge:camping:campsite:holiday:retreat:nomadic:native american:indian:wilderness:outdoors",
        categories: [
            "travel",
            "nature",
            "sustainability"
        ]
    },
    TerminalSquare: {
        render: TerminalSquare,
        tags: "terminal square:development:shapes:code:command line:prompt:shell",
        categories: [
            "development",
            "shapes"
        ]
    },
    Terminal: {
        render: Terminal,
        tags: "terminal:development:code:command line:prompt:shell",
        categories: [
            "development"
        ]
    },
    TestTube2: {
        render: TestTube2,
        tags: "test tube 2:science:tube:vial:phial:flask:ampoule:ampule:lab:chemistry:experiment:test",
        categories: [
            "science"
        ]
    },
    TestTube: {
        render: TestTube,
        tags: "test tube:science:tube:vial:phial:flask:ampoule:ampule:lab:chemistry:experiment:test",
        categories: [
            "science"
        ]
    },
    TestTubes: {
        render: TestTubes,
        tags: "test tubes:science:tubes:vials:phials:flasks:ampoules:ampules:lab:chemistry:experiment:test",
        categories: [
            "science"
        ]
    },
    TextCursorInput: {
        render: TextCursorInput,
        tags: "text cursor input:text:layout:select",
        categories: [
            "text",
            "layout"
        ]
    },
    TextCursor: {
        render: TextCursor,
        tags: "text cursor:text:cursors:select",
        categories: [
            "text",
            "cursors"
        ]
    },
    TextQuote: {
        render: TextQuote,
        tags: "text quote:text:blockquote:quotation:indent:reply:response",
        categories: [
            "text"
        ]
    },
    TextSearch: {
        render: TextSearch,
        tags: "text search:text:find:data:copy:txt:pdf:document:scan:magnifier:magnifying glass",
        categories: [
            "text"
        ]
    },
    TextSelect: {
        render: TextSelect,
        tags: "text select:text:cursors:find:search:selection:dashed",
        categories: [
            "text",
            "cursors"
        ]
    },
    Text: {
        render: Text,
        tags: "text:text:files:cursors:find:search:data:txt:pdf:document",
        categories: [
            "text",
            "files",
            "cursors"
        ]
    },
    Theater: {
        render: Theater,
        tags: "theater:buildings:social:theater:theatre:entertainment:podium:stage:musical",
        categories: [
            "buildings",
            "social"
        ]
    },
    ThermometerSnowflake: {
        render: ThermometerSnowflake,
        tags: "thermometer snowflake:weather:temperature:celsius:fahrenheit:weather:cold:freeze:freezing",
        categories: [
            "weather"
        ]
    },
    ThermometerSun: {
        render: ThermometerSun,
        tags: "thermometer sun:weather:temperature:celsius:fahrenheit:weather:warm:hot",
        categories: [
            "weather"
        ]
    },
    Thermometer: {
        render: Thermometer,
        tags: "thermometer:weather:temperature:celsius:fahrenheit:weather",
        categories: [
            "weather"
        ]
    },
    ThumbsDown: {
        render: ThumbsDown,
        tags: "thumbs down:account:social:emoji:dislike:bad:emotion",
        categories: [
            "account",
            "social",
            "emoji"
        ]
    },
    ThumbsUp: {
        render: ThumbsUp,
        tags: "thumbs up:account:social:emoji:like:good:emotion",
        categories: [
            "account",
            "social",
            "emoji"
        ]
    },
    TicketCheck: {
        render: TicketCheck,
        tags: "ticket check:account:transportation:entry:pass:voucher:event:concert:show:booked:purchased:receipt:redeemed:validated:verified:certified:checked:used",
        categories: [
            "account",
            "transportation"
        ]
    },
    TicketMinus: {
        render: TicketMinus,
        tags: "ticket minus:account:transportation:entry:pass:voucher:event:concert:show:remove:cancel:unbook:subtract:decrease:-",
        categories: [
            "account",
            "transportation"
        ]
    },
    TicketPercent: {
        render: TicketPercent,
        tags: "ticket percent:account:transportation:shopping:discount:reduced:offer:voucher:entry:pass:event:concert:show:book:purchase:%",
        categories: [
            "account",
            "transportation",
            "shopping"
        ]
    },
    TicketPlus: {
        render: TicketPlus,
        tags: "ticket plus:account:transportation:entry:pass:voucher:event:concert:show:book:purchase:add:+",
        categories: [
            "account",
            "transportation"
        ]
    },
    TicketSlash: {
        render: TicketSlash,
        tags: "ticket slash:account:transportation:entry:pass:voucher:event:concert:show:redeemed:used:marked:checked:verified:spoiled:invalidated:void:denied:refused:banned:barred:forbidden:prohibited:cancelled:cancellation:refunded:delete:remove:clear:error",
        categories: [
            "account",
            "transportation"
        ]
    },
    TicketX: {
        render: TicketX,
        tags: "ticket x:account:transportation:entry:pass:voucher:event:concert:show:cancelled:cancellation:refunded:used:void:invalidated:spoiled:denied:refused:banned:barred:forbidden:prohibited:delete:remove:clear:error:x",
        categories: [
            "account",
            "transportation"
        ]
    },
    Ticket: {
        render: Ticket,
        tags: "ticket:account:transportation:entry:pass:voucher:event:concert:show:perforated:dashed",
        categories: [
            "account",
            "transportation"
        ]
    },
    TimerOff: {
        render: TimerOff,
        tags: "timer off:time:time:timer:stopwatch",
        categories: [
            "time"
        ]
    },
    TimerReset: {
        render: TimerReset,
        tags: "timer reset:time:time:timer:stopwatch",
        categories: [
            "time"
        ]
    },
    Timer: {
        render: Timer,
        tags: "timer:time:time:timer:stopwatch",
        categories: [
            "time"
        ]
    },
    ToggleLeft: {
        render: ToggleLeft,
        tags: "toggle left:layout:account:development:on:off:switch:boolean",
        categories: [
            "layout",
            "account",
            "development"
        ]
    },
    ToggleRight: {
        render: ToggleRight,
        tags: "toggle right:layout:account:development:on:off:switch:boolean",
        categories: [
            "layout",
            "account",
            "development"
        ]
    },
    Tornado: {
        render: Tornado,
        tags: "tornado:weather:weather:wind:storm:hurricane",
        categories: [
            "weather"
        ]
    },
    Torus: {
        render: Torus,
        tags: "torus:shapes:design:tools:food beverage:donut:doughnut:ring:hollow:3d:fast food:junk food:snack:treat:sweet:sugar:dessert",
        categories: [
            "shapes",
            "design",
            "tools",
            "food-beverage"
        ]
    },
    TouchpadOff: {
        render: TouchpadOff,
        tags: "touchpad off:devices:trackpad:cursor",
        categories: [
            "devices"
        ]
    },
    Touchpad: {
        render: Touchpad,
        tags: "touchpad:devices:trackpad:cursor",
        categories: [
            "devices"
        ]
    },
    TowerControl: {
        render: TowerControl,
        tags: "tower control:travel:transportation:airport:travel:tower:transportation:lighthouse",
        categories: [
            "travel",
            "transportation"
        ]
    },
    ToyBrick: {
        render: ToyBrick,
        tags: "toy brick:gaming:development:lego:block:addon:plugin:integration",
        categories: [
            "gaming",
            "development"
        ]
    },
    Tractor: {
        render: Tractor,
        tags: "tractor:transportation:sustainability:food beverage:farming:farmer:ranch:harvest:equipment:vehicle",
        categories: [
            "transportation",
            "sustainability",
            "food-beverage"
        ]
    },
    TrafficCone: {
        render: TrafficCone,
        tags: "traffic cone:transportation:roadworks:tarmac:safety:block",
        categories: [
            "transportation"
        ]
    },
    TrainFrontTunnel: {
        render: TrainFrontTunnel,
        tags: "train front tunnel:transportation:maps:railway:metro:subway:underground:speed:bullet:fast:track:line",
        categories: [
            "transportation",
            "maps"
        ]
    },
    TrainFront: {
        render: TrainFront,
        tags: "train front:transportation:railway:metro:subway:underground:high-speed:bullet:fast:track:line",
        categories: [
            "transportation"
        ]
    },
    TrainTrack: {
        render: TrainTrack,
        tags: "train track:transportation:maps:railway:line",
        categories: [
            "transportation",
            "maps"
        ]
    },
    TramFront: {
        render: TramFront,
        tags: "tram front:transportation:railway:metro:subway:underground:track:line:tourism",
        categories: [
            "transportation"
        ]
    },
    Trash2: {
        render: Trash2,
        tags: "trash 2:files:mail:garbage:delete:remove:bin",
        categories: [
            "files",
            "mail"
        ]
    },
    Trash: {
        render: Trash,
        tags: "trash:files:mail:garbage:delete:remove:bin",
        categories: [
            "files",
            "mail"
        ]
    },
    TreeDeciduous: {
        render: TreeDeciduous,
        tags: "tree deciduous:nature:tree:forest:park:nature",
        categories: [
            "nature"
        ]
    },
    TreePine: {
        render: TreePine,
        tags: "tree pine:nature:tree:pine:forest:park:nature",
        categories: [
            "nature"
        ]
    },
    Trees: {
        render: Trees,
        tags: "trees:nature:tree:forest:park:nature",
        categories: [
            "nature"
        ]
    },
    Trello: {
        render: Trello,
        tags: "trello:account:brands:development:logo:brand",
        categories: [
            "account",
            "brands",
            "development"
        ]
    },
    TrendingDown: {
        render: TrendingDown,
        tags: "trending down:charts:arrows:statistics",
        categories: [
            "charts",
            "arrows"
        ]
    },
    TrendingUp: {
        render: TrendingUp,
        tags: "trending up:charts:arrows:statistics",
        categories: [
            "charts",
            "arrows"
        ]
    },
    TriangleRight: {
        render: TriangleRight,
        tags: "triangle right:shapes:maths:volume:controls:controller:tv remote:geometry:delta:ramp:slope:incline:increase",
        categories: [
            "shapes",
            "maths"
        ]
    },
    Triangle: {
        render: Triangle,
        tags: "triangle:shapes:equilateral:delta:shape:pyramid:hierarchy",
        categories: [
            "shapes"
        ]
    },
    Trophy: {
        render: Trophy,
        tags: "trophy:sports:gaming:prize:sports:winner:achievement:award",
        categories: [
            "sports",
            "gaming"
        ]
    },
    Truck: {
        render: Truck,
        tags: "truck:transportation:delivery:van:shipping:haulage:lorry",
        categories: [
            "transportation"
        ]
    },
    Turtle: {
        render: Turtle,
        tags: "turtle:animals:animal:pet:tortoise:slow:speed",
        categories: [
            "animals"
        ]
    },
    Tv2: {
        render: Tv2,
        tags: "tv 2:devices:multimedia:flatscreen:television:stream:display:widescreen:high-definition:hd:1080p:4k:8k:smart:digital:video:home cinema:entertainment:showtime:channels:catchup",
        categories: [
            "devices",
            "multimedia"
        ]
    },
    Tv: {
        render: Tv,
        tags: "tv:devices:multimedia:communication:television:stream:display:widescreen:high-definition:hd:1080p:4k:8k:smart:digital:video:entertainment:showtime:channels:terrestrial:satellite:cable:broadcast:live:frequency:tune:scan:aerial:receiver:transmission:signal:connection:connectivity",
        categories: [
            "devices",
            "multimedia",
            "communication"
        ]
    },
    Twitch: {
        render: Twitch,
        tags: "twitch:brands:social:account:gaming:logo:social",
        categories: [
            "brands",
            "social",
            "account",
            "gaming"
        ]
    },
    Twitter: {
        render: Twitter,
        tags: "twitter:brands:social:account:logo:social",
        categories: [
            "brands",
            "social",
            "account"
        ]
    },
    Type: {
        render: Type,
        tags: "type:text:text:font:typography",
        categories: [
            "text"
        ]
    },
    UmbrellaOff: {
        render: UmbrellaOff,
        tags: "umbrella off:weather:rain:weather:uncovered:uninsured:antivirus:unprotected:risky",
        categories: [
            "weather"
        ]
    },
    Umbrella: {
        render: Umbrella,
        tags: "umbrella:weather:rain:weather",
        categories: [
            "weather"
        ]
    },
    Underline: {
        render: Underline,
        tags: "underline:text:text:format",
        categories: [
            "text"
        ]
    },
    Undo2: {
        render: Undo2,
        tags: "undo 2:text:arrows:redo:rerun:history:back:return:reverse:revert:direction:u-turn",
        categories: [
            "text",
            "arrows"
        ]
    },
    UndoDot: {
        render: UndoDot,
        tags: "undo dot:text:arrows:redo:history:step:back",
        categories: [
            "text",
            "arrows"
        ]
    },
    Undo: {
        render: Undo,
        tags: "undo:text:arrows:redo:rerun:history",
        categories: [
            "text",
            "arrows"
        ]
    },
    UnfoldHorizontal: {
        render: UnfoldHorizontal,
        tags: "unfold horizontal:arrows:layout:arrow:collapse:fold:vertical:dashed",
        categories: [
            "arrows",
            "layout"
        ]
    },
    UnfoldVertical: {
        render: UnfoldVertical,
        tags: "unfold vertical:arrows:layout:arrow:expand:vertical:dashed",
        categories: [
            "arrows",
            "layout"
        ]
    },
    Ungroup: {
        render: Ungroup,
        tags: "ungroup:shapes:files:cubes:packages:parts:units:collection:cluster:separate",
        categories: [
            "shapes",
            "files"
        ]
    },
    Unlink2: {
        render: Unlink2,
        tags: "unlink 2:text:url:unchain",
        categories: [
            "text"
        ]
    },
    Unlink: {
        render: Unlink,
        tags: "unlink:text:url:unchain",
        categories: [
            "text"
        ]
    },
    UnlockKeyhole: {
        render: UnlockKeyhole,
        tags: "unlock keyhole:security:security",
        categories: [
            "security"
        ]
    },
    Unlock: {
        render: Unlock,
        tags: "unlock:security:security",
        categories: [
            "security"
        ]
    },
    Unplug: {
        render: Unplug,
        tags: "unplug:devices:development:electricity:energy:electronics:socket:outlet:disconnect",
        categories: [
            "devices",
            "development"
        ]
    },
    UploadCloud: {
        render: UploadCloud,
        tags: "upload cloud:arrows:files:file",
        categories: [
            "arrows",
            "files"
        ]
    },
    Upload: {
        render: Upload,
        tags: "upload:arrows:files:file",
        categories: [
            "arrows",
            "files"
        ]
    },
    Usb: {
        render: Usb,
        tags: "usb:devices:multimedia:home:universal:serial:bus:controller:connector:interface",
        categories: [
            "devices",
            "multimedia",
            "home"
        ]
    },
    UserCheck: {
        render: UserCheck,
        tags: "user check:account:followed:subscribed:done:todo:tick:complete:task",
        categories: [
            "account"
        ]
    },
    UserCog: {
        render: UserCog,
        tags: "user cog:account:settings:edit:cog:gear",
        categories: [
            "account"
        ]
    },
    UserMinus: {
        render: UserMinus,
        tags: "user minus:account:delete:remove:unfollow:unsubscribe",
        categories: [
            "account"
        ]
    },
    UserPlus: {
        render: UserPlus,
        tags: "user plus:account:new:add:create:follow:subscribe",
        categories: [
            "account"
        ]
    },
    UserRoundCheck: {
        render: UserRoundCheck,
        tags: "user round check:account:followed:subscribed:done:todo:tick:complete:task",
        categories: [
            "account"
        ]
    },
    UserRoundCog: {
        render: UserRoundCog,
        tags: "user round cog:account:settings:edit:cog:gear",
        categories: [
            "account"
        ]
    },
    UserRoundMinus: {
        render: UserRoundMinus,
        tags: "user round minus:account:delete:remove:unfollow:unsubscribe",
        categories: [
            "account"
        ]
    },
    UserRoundPlus: {
        render: UserRoundPlus,
        tags: "user round plus:account:new:add:create:follow:subscribe",
        categories: [
            "account"
        ]
    },
    UserRoundSearch: {
        render: UserRoundSearch,
        tags: "user round search:account:social:person:account:contact:find:scan:magnifier:magnifying glass",
        categories: [
            "account",
            "social"
        ]
    },
    UserRoundX: {
        render: UserRoundX,
        tags: "user round x:account:delete:remove:unfollow:unsubscribe:unavailable",
        categories: [
            "account"
        ]
    },
    UserRound: {
        render: UserRound,
        tags: "user round:account:person:account:contact",
        categories: [
            "account"
        ]
    },
    UserSearch: {
        render: UserSearch,
        tags: "user search:account:social:person:account:contact:find:scan:magnifier:magnifying glass",
        categories: [
            "account",
            "social"
        ]
    },
    UserX: {
        render: UserX,
        tags: "user x:account:delete:remove:unfollow:unsubscribe:unavailable",
        categories: [
            "account"
        ]
    },
    User: {
        render: User,
        tags: "user:account:person:account:contact",
        categories: [
            "account"
        ]
    },
    UsersRound: {
        render: UsersRound,
        tags: "users round:account:group:people",
        categories: [
            "account"
        ]
    },
    Users: {
        render: Users,
        tags: "users:account:group:people",
        categories: [
            "account"
        ]
    },
    UtensilsCrossed: {
        render: UtensilsCrossed,
        tags: "utensils crossed:food beverage:travel:maps:food:restaurant:meal:cutlery:breakfast:dinner:supper",
        categories: [
            "food-beverage",
            "travel",
            "maps"
        ]
    },
    Utensils: {
        render: Utensils,
        tags: "utensils:food beverage:travel:maps:food:restaurant:meal:cutlery:breakfast:dinner:supper",
        categories: [
            "food-beverage",
            "travel",
            "maps"
        ]
    },
    UtilityPole: {
        render: UtilityPole,
        tags: "utility pole:buildings:home:sustainability:electricity:energy:transmission line:telegraph pole:power lines:phone",
        categories: [
            "buildings",
            "home",
            "sustainability"
        ]
    },
    Variable: {
        render: Variable,
        tags: "variable:development:maths:code:coding:programming:symbol:calculate:algebra:x:parentheses:parenthesis:brackets:parameter:(:)",
        categories: [
            "development",
            "maths"
        ]
    },
    Vault: {
        render: Vault,
        tags: "vault:security:travel:home:safe:lockbox:deposit:locker:coffer:strongbox:safety:secure:storage:valuables:bank",
        categories: [
            "security",
            "travel",
            "home"
        ]
    },
    Vegan: {
        render: Vegan,
        tags: "vegan:food beverage:sustainability:vegetarian:fruitarian:herbivorous:animal rights:diet",
        categories: [
            "food-beverage",
            "sustainability"
        ]
    },
    VenetianMask: {
        render: VenetianMask,
        tags: "venetian mask:account:gaming:mask:masquerade:impersonate:secret:incognito",
        categories: [
            "account",
            "gaming"
        ]
    },
    VibrateOff: {
        render: VibrateOff,
        tags: "vibrate off:devices:connectivity:account:smartphone:notification:rumble:haptic feedback:notifications:screen",
        categories: [
            "devices",
            "connectivity",
            "account"
        ]
    },
    Vibrate: {
        render: Vibrate,
        tags: "vibrate:devices:connectivity:account:notifications:smartphone:notification:rumble:haptic feedback:screen",
        categories: [
            "devices",
            "connectivity",
            "account",
            "notifications"
        ]
    },
    VideoOff: {
        render: VideoOff,
        tags: "video off:devices:communication:connectivity:photography:camera:movie:film",
        categories: [
            "devices",
            "communication",
            "connectivity",
            "photography"
        ]
    },
    Video: {
        render: Video,
        tags: "video:devices:communication:connectivity:photography:camera:movie:film:recording:motion picture:camcorder:reel",
        categories: [
            "devices",
            "communication",
            "connectivity",
            "photography"
        ]
    },
    Videotape: {
        render: Videotape,
        tags: "videotape:devices:communication:connectivity:photography:files:vhs:movie:film:recording:motion picture:showreel:cassette",
        categories: [
            "devices",
            "communication",
            "connectivity",
            "photography",
            "files"
        ]
    },
    View: {
        render: View,
        tags: "view:design:photography:eye:look",
        categories: [
            "design",
            "photography"
        ]
    },
    Voicemail: {
        render: Voicemail,
        tags: "voicemail:connectivity:devices:social:phone:cassette:tape:reel:recording:audio",
        categories: [
            "connectivity",
            "devices",
            "social"
        ]
    },
    Volume1: {
        render: Volume1,
        tags: "volume 1:connectivity:communication:multimedia:music:sound:speaker",
        categories: [
            "connectivity",
            "communication",
            "multimedia"
        ]
    },
    Volume2: {
        render: Volume2,
        tags: "volume 2:connectivity:communication:multimedia:music:sound:speaker",
        categories: [
            "connectivity",
            "communication",
            "multimedia"
        ]
    },
    VolumeX: {
        render: VolumeX,
        tags: "volume x:connectivity:communication:multimedia:music:sound:mute:speaker",
        categories: [
            "connectivity",
            "communication",
            "multimedia"
        ]
    },
    Volume: {
        render: Volume,
        tags: "volume:connectivity:communication:multimedia:music:sound:mute:speaker",
        categories: [
            "connectivity",
            "communication",
            "multimedia"
        ]
    },
    Vote: {
        render: Vote,
        tags: "vote:social:vote:poll:ballot:political:social:check:tick",
        categories: [
            "social"
        ]
    },
    Wallet2: {
        render: Wallet2,
        tags: "wallet 2:account:money:finance:pocket",
        categories: [
            "account",
            "money"
        ]
    },
    WalletCards: {
        render: WalletCards,
        tags: "wallet cards:account:money:money:finance:pocket:credit:purchase:payment:shopping:retail:consumer:cc",
        categories: [
            "account",
            "money"
        ]
    },
    Wallet: {
        render: Wallet,
        tags: "wallet:account:money:money:finance:pocket",
        categories: [
            "account",
            "money"
        ]
    },
    Wallpaper: {
        render: Wallpaper,
        tags: "wallpaper:account:devices:cover:lock screen",
        categories: [
            "account",
            "devices"
        ]
    },
    Wand2: {
        render: Wand2,
        tags: "wand 2:design:gaming:cursors:photography:magic:wizard",
        categories: [
            "design",
            "gaming",
            "cursors",
            "photography"
        ]
    },
    Wand: {
        render: Wand,
        tags: "wand:design:gaming:cursors:photography:magic:selection",
        categories: [
            "design",
            "gaming",
            "cursors",
            "photography"
        ]
    },
    Warehouse: {
        render: Warehouse,
        tags: "warehouse:buildings:maps:storage:logistics:building",
        categories: [
            "buildings",
            "maps"
        ]
    },
    WashingMachine: {
        render: WashingMachine,
        tags: "washing machine:home:devices:travel:tumble dryer:amenities:electronics:cycle:clothes:rinse:spin:drum",
        categories: [
            "home",
            "devices",
            "travel"
        ]
    },
    Watch: {
        render: Watch,
        tags: "watch:time:clock:time",
        categories: [
            "time"
        ]
    },
    Waves: {
        render: Waves,
        tags: "waves:weather:maps:multimedia:water:sea:sound:hertz:wavelength:vibrate",
        categories: [
            "weather",
            "maps",
            "multimedia"
        ]
    },
    Waypoints: {
        render: Waypoints,
        tags: "waypoints:security:account:maps:navigation:development:social:indirection:vpn:virtual private network:proxy:connections:bounce:reroute:path:journey:planner:stops:stations:shared:spread:viral",
        categories: [
            "security",
            "account",
            "maps",
            "navigation",
            "development",
            "social"
        ]
    },
    Webcam: {
        render: Webcam,
        tags: "webcam:connectivity:devices:communication:camera:security",
        categories: [
            "connectivity",
            "devices",
            "communication"
        ]
    },
    WebhookOff: {
        render: WebhookOff,
        tags: "webhook off:development:social:account:push api:interface:callback",
        categories: [
            "development",
            "social",
            "account"
        ]
    },
    Webhook: {
        render: Webhook,
        tags: "webhook:development:social:account:push api:interface:callback",
        categories: [
            "development",
            "social",
            "account"
        ]
    },
    Weight: {
        render: Weight,
        tags: "weight:maths:mass:heavy:lead:metal:measure:geometry:scales:balance",
        categories: [
            "maths"
        ]
    },
    WheatOff: {
        render: WheatOff,
        tags: "wheat off:food beverage:corn:cereal:grain:gluten free:allergy:intolerance:diet",
        categories: [
            "food-beverage"
        ]
    },
    Wheat: {
        render: Wheat,
        tags: "wheat:food beverage:corn:cereal:grain:gluten",
        categories: [
            "food-beverage"
        ]
    },
    WholeWord: {
        render: WholeWord,
        tags: "whole word:text:text:selection:letters:characters:font:typography",
        categories: [
            "text"
        ]
    },
    WifiOff: {
        render: WifiOff,
        tags: "wifi off:connectivity:devices:disabled",
        categories: [
            "connectivity",
            "devices"
        ]
    },
    Wifi: {
        render: Wifi,
        tags: "wifi:connectivity:devices:connection:signal:wireless",
        categories: [
            "connectivity",
            "devices"
        ]
    },
    Wind: {
        render: Wind,
        tags: "wind:weather:weather:air:blow",
        categories: [
            "weather"
        ]
    },
    WineOff: {
        render: WineOff,
        tags: "wine off:food beverage:alcohol:beverage:drink:glass:alcohol free:abstinence:abstaining:teetotalism:allergy:intolerance",
        categories: [
            "food-beverage"
        ]
    },
    Wine: {
        render: Wine,
        tags: "wine:food beverage:alcohol:beverage:bar:drink:glass:sommelier:vineyard:winery",
        categories: [
            "food-beverage"
        ]
    },
    Workflow: {
        render: Workflow,
        tags: "workflow:development:action:continuous integration:ci:automation:devops:network:node:connection",
        categories: [
            "development"
        ]
    },
    WrapText: {
        render: WrapText,
        tags: "wrap text:text:arrows:words:lines:break:paragraph",
        categories: [
            "text",
            "arrows"
        ]
    },
    Wrench: {
        render: Wrench,
        tags: "wrench:account:development:tools:home:account:settings:spanner:diy:toolbox:build:construction",
        categories: [
            "account",
            "development",
            "tools",
            "home"
        ]
    },
    XCircle: {
        render: XCircle,
        tags: "x circle:maths:shapes:development:cancel:close:delete:remove:times:clear:error:incorrect:wrong:mistake:failure:linter:multiply:multiplication",
        categories: [
            "maths",
            "shapes",
            "development"
        ]
    },
    XOctagon: {
        render: XOctagon,
        tags: "x octagon:maths:shapes:notifications:delete:stop:alert:warning:times:clear:maths",
        categories: [
            "maths",
            "shapes",
            "notifications"
        ]
    },
    XSquare: {
        render: XSquare,
        tags: "x square:maths:shapes:notifications:cancel:close:delete:remove:times:clear:maths:multiply:multiplication",
        categories: [
            "maths",
            "shapes",
            "notifications"
        ]
    },
    X: {
        render: X,
        tags: "x:notifications:maths:cancel:close:delete:remove:times:clear:maths:multiply:multiplication",
        categories: [
            "notifications",
            "maths"
        ]
    },
    Youtube: {
        render: Youtube,
        tags: "youtube:account:multimedia:social:text:brands:logo:social:video:play",
        categories: [
            "account",
            "multimedia",
            "social",
            "text",
            "brands"
        ]
    },
    ZapOff: {
        render: ZapOff,
        tags: "zap off:connectivity:devices:photography:weather:flash:camera:lightning:electricity:energy",
        categories: [
            "connectivity",
            "devices",
            "photography",
            "weather"
        ]
    },
    Zap: {
        render: Zap,
        tags: "zap:connectivity:devices:photography:weather:flash:camera:lightning:electricity:energy",
        categories: [
            "connectivity",
            "devices",
            "photography",
            "weather"
        ]
    },
    ZoomIn: {
        render: ZoomIn,
        tags: "zoom in:accessibility:layout:design:text:photography:magnifying glass:plus",
        categories: [
            "accessibility",
            "layout",
            "design",
            "text",
            "photography"
        ]
    },
    ZoomOut: {
        render: ZoomOut,
        tags: "zoom out:accessibility:layout:design:text:photography:magnifying glass:plus",
        categories: [
            "accessibility",
            "layout",
            "design",
            "text",
            "photography"
        ]
    }
};
